import { JSONString, FileUpload, FileUploadProgressCallback, ButlerCommand } from './customScalarTypes';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * An object that represents a parsed Butler command. Typing this in the schema would be very
   * expensive. Currently supported commands are typed in the butler-command-parser package,
   * but this list is not extensive. Cannot trivially use JSONString scalar because the alternative
   * type of a Butler command is a string, so passing it around as an object makes refining its type
   * dramatically easier.
   */
  ButlerCommand: ButlerCommand;
  /** Supported colors in the Palette */
  CardPaletteColor: any;
  /** CardTypeHierarchyLevelType */
  CardTypeHierarchyLevelType: any;
  /** A date scalar that accepts string values that are in yyyy-mm-dd format */
  Date: any;
  /** DateTime type */
  DateTime: any;
  /** An alias for the File type. Should be used for any mutation where we are uploading a file. */
  FileUpload: FileUpload;
  /**
   * A callback function that takes in a number and does not return anything. Should be used if
   * we have a resolver that uploads a file and its progress needs to be tracked.
   */
  FileUploadProgressCallback: FileUploadProgressCallback;
  /** A JSON scalar */
  JSON: any;
  /**
   * An object which contains unknown (user generated) keys and values serialized to a string.
   * Should only be used in scenarios where we cannot provide stricter typing, for example, the
   * custom emoji data required to render Trello Markdown. The consuming component is responsible
   * for parsing the string into JSON.
   * See https://github.com/apollographql/apollo-feature-requests/issues/2 for discussion
   */
  JSONString: JSONString;
  /** Long type */
  Long: any;
  /** SoftwareBoardFeatureKey */
  SoftwareBoardFeatureKey: any;
  /** SoftwareBoardPermission */
  SoftwareBoardPermission: any;
  /** SprintScopeChangeEventType */
  SprintScopeChangeEventType: any;
  /** A URL Scalar type */
  URL: any;
};

/** The user's Aa profile data used in AA onboarding */
export type AaOnboardingProfile = {
  __typename: 'AaOnboardingProfile';
  /** The url of the user's Aa avatar */
  avatarUrl: Scalars['String'];
  /** The name of the user */
  fullName: Scalars['String'];
};

/**
 * "
 * The lifecycle status of the account
 */
export const AccountStatus = {
  /** The account is an active account */
  Active: 'active',
  /** The account has been closed */
  Closed: 'closed',
  /** The account is no longer an active account */
  Inactive: 'inactive'
} as const;

export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];
/**
 * Actions are generated whenever an action occurs in Trello. For instance, when a user deletes a card, a
 * `deleteCard` action is generated and includes information about the deleted card.
 */
export type Action = {
  __typename: 'Action';
  /** Relevant information regarding the Action */
  data: Scalars['JSONString'];
  /** When the Action occurred */
  date: Scalars['String'];
  /** Relevant information for displaying the Action */
  display: Action_Display;
  /** The ID of the Action */
  id: Scalars['ID'];
  /** The ID of the Member who caused the Action */
  idMemberCreator: Scalars['String'];
  /** The Member who caused the Action */
  memberCreator: Member;
  /** The Reactions on the Action */
  reactions: Array<Reaction>;
  /** The type of the Action */
  type: Action_Type;
};

/** Relevant information for displaying the Action */
export type Action_Display = {
  __typename: 'Action_Display';
  /** Information about any Entities involved in the Action */
  entities: Scalars['JSONString'];
  /** The key used to translate the Action */
  translationKey?: Maybe<Scalars['String']>;
};

/** The Types of Actions */
export const Action_Type = {
  AcceptEnterpriseJoinRequest: 'acceptEnterpriseJoinRequest',
  AddAdminToEnterprise: 'addAdminToEnterprise',
  AddAttachmentToCard: 'addAttachmentToCard',
  AddChecklistToCard: 'addChecklistToCard',
  AddMemberToBoard: 'addMemberToBoard',
  AddMemberToCard: 'addMemberToCard',
  AddMemberToOrganization: 'addMemberToOrganization',
  AddOrganizationToEnterprise: 'addOrganizationToEnterprise',
  AddToEnterprisePluginWhitelist: 'addToEnterprisePluginWhitelist',
  AddToOrganizationBoard: 'addToOrganizationBoard',
  ChangeEnterprisePublicBoardVisibility: 'changeEnterprisePublicBoardVisibility',
  CommentCard: 'commentCard',
  ConvertToCardFromCheckItem: 'convertToCardFromCheckItem',
  CopyBoard: 'copyBoard',
  CopyCard: 'copyCard',
  CopyCommentCard: 'copyCommentCard',
  CreateBoard: 'createBoard',
  CreateCard: 'createCard',
  CreateCustomField: 'createCustomField',
  CreateEnterpriseJoinRequest: 'createEnterpriseJoinRequest',
  CreateList: 'createList',
  CreateOrganization: 'createOrganization',
  DeactivatedMemberInEnterprise: 'deactivatedMemberInEnterprise',
  DeactivatedMemberInOrganization: 'deactivatedMemberInOrganization',
  DeclineEnterpriseJoinRequest: 'declineEnterpriseJoinRequest',
  DeleteAttachmentFromCard: 'deleteAttachmentFromCard',
  DeleteBoardInvitation: 'deleteBoardInvitation',
  DeleteCard: 'deleteCard',
  DeleteCustomField: 'deleteCustomField',
  DeleteOrganizationInvitation: 'deleteOrganizationInvitation',
  DisableEnterprisePluginWhitelist: 'disableEnterprisePluginWhitelist',
  DisableIssuingOfConsentTokensInEnterprise: 'disableIssuingOfConsentTokensInEnterprise',
  DisablePlugin: 'disablePlugin',
  DisablePowerUp: 'disablePowerUp',
  EmailCard: 'emailCard',
  EnableEnterprisePluginWhitelist: 'enableEnterprisePluginWhitelist',
  EnableIssuingOfConsentTokensInEnterprise: 'enableIssuingOfConsentTokensInEnterprise',
  EnablePlugin: 'enablePlugin',
  EnablePowerUp: 'enablePowerUp',
  EnterpriseAdminViewedPrivateBoard: 'enterpriseAdminViewedPrivateBoard',
  GrantEnterpriseLicense: 'grantEnterpriseLicense',
  GrantOrganizationLicenses: 'grantOrganizationLicenses',
  MakeAdminOfBoard: 'makeAdminOfBoard',
  MakeNormalMemberOfBoard: 'makeNormalMemberOfBoard',
  MakeNormalMemberOfOrganization: 'makeNormalMemberOfOrganization',
  MakeObserverOfBoard: 'makeObserverOfBoard',
  MemberJoinedTrello: 'memberJoinedTrello',
  MoveCardFromBoard: 'moveCardFromBoard',
  MoveCardToBoard: 'moveCardToBoard',
  MoveListFromBoard: 'moveListFromBoard',
  MoveListToBoard: 'moveListToBoard',
  ReactivatedMemberInEnterprise: 'reactivatedMemberInEnterprise',
  ReactivatedMemberInOrganization: 'reactivatedMemberInOrganization',
  RemoveAdminFromEnterprise: 'removeAdminFromEnterprise',
  RemoveChecklistFromCard: 'removeChecklistFromCard',
  RemoveFromEnterprisePluginWhitelist: 'removeFromEnterprisePluginWhitelist',
  RemoveFromOrganizationBoard: 'removeFromOrganizationBoard',
  RemoveMemberFromCard: 'removeMemberFromCard',
  RemoveOrganizationFromEnterprise: 'removeOrganizationFromEnterprise',
  RemovedAllTokensFromOwnedMembers: 'removedAllTokensFromOwnedMembers',
  RemovedTokensFromMember: 'removedTokensFromMember',
  RevokeEnterpriseLicense: 'revokeEnterpriseLicense',
  TrelloAddAdminToEnterprise: 'trelloAddAdminToEnterprise',
  TrelloAddOrganizationToEnterprise: 'trelloAddOrganizationToEnterprise',
  TrelloRemoveAdminFromEnterprise: 'trelloRemoveAdminFromEnterprise',
  TrelloRemoveOrganizationFromEnterprise: 'trelloRemoveOrganizationFromEnterprise',
  UnconfirmedBoardInvitation: 'unconfirmedBoardInvitation',
  UnconfirmedOrganizationInvitation: 'unconfirmedOrganizationInvitation',
  UpdateBoard: 'updateBoard',
  UpdateBoardOrg: 'updateBoardOrg',
  UpdateBoardVisibility: 'updateBoardVisibility',
  UpdateCard: 'updateCard',
  UpdateCardClosed: 'updateCardClosed',
  UpdateCardDue: 'updateCardDue',
  UpdateCardDueComplete: 'updateCardDueComplete',
  UpdateCardIdList: 'updateCardIdList',
  UpdateCheckItemStateOnCard: 'updateCheckItemStateOnCard',
  UpdateChecklist: 'updateChecklist',
  UpdateCustomField: 'updateCustomField',
  UpdateCustomFieldItem: 'updateCustomFieldItem',
  UpdateEnterprise: 'updateEnterprise',
  UpdateList: 'updateList',
  UpdateListClosed: 'updateListClosed',
  UpdateMember: 'updateMember',
  UpdateOrganization: 'updateOrganization',
  WithdrawEnterpriseJoinRequest: 'withdrawEnterpriseJoinRequest'
} as const;

export type Action_Type = typeof Action_Type[keyof typeof Action_Type];
/** --------------------------------------- activity_api_v2.graphqls */
export type Activities = {
  __typename: 'Activities';
  /**
   * get all activity
   * - filters - query filters for the activity stream
   * - first - show 1st <N> items of the response
   */
  all: ActivitiesConnection;
  /** get activity for the currently logged in user */
  myActivities?: Maybe<MyActivities>;
  /**
   * get "Worked on" activity
   * - filters - query filters for the activity stream
   * - first - show 1st <N> items of the response
   */
  workedOn: ActivitiesConnection;
};


/** --------------------------------------- activity_api_v2.graphqls */
export type ActivitiesAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ActivitiesFilter>>;
  first?: InputMaybe<Scalars['Int']>;
};


/** --------------------------------------- activity_api_v2.graphqls */
export type ActivitiesWorkedOnArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ActivitiesFilter>>;
  first?: InputMaybe<Scalars['Int']>;
};

export type ActivitiesArguments = {
  /** set of Atlassian account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']>>;
  /** set of Cloud IDs */
  cloudIds?: InputMaybe<Array<Scalars['ID']>>;
  /** set of Container IDs */
  containerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The creation time of the earliest events to be included in the result */
  earliestStart?: InputMaybe<Scalars['DateTime']>;
  /** set of Event Types */
  eventTypes?: InputMaybe<Array<ActivityEventType>>;
  /** The creation time of the latest events to be included in the result */
  latestStart?: InputMaybe<Scalars['DateTime']>;
  /** set of Object Types */
  objectTypes?: InputMaybe<Array<ActivitiesObjectType>>;
  /** set of products */
  products?: InputMaybe<Array<ActivityProduct>>;
  /** arbitrary transition filters */
  transitions?: InputMaybe<Array<ActivityTransition>>;
};

/** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */
export type ActivitiesCommentedEvent = {
  __typename: 'ActivitiesCommentedEvent';
  commentId: Scalars['ID'];
};

export type ActivitiesConnection = {
  __typename: 'ActivitiesConnection';
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  nodes: Array<ActivitiesItem>;
  pageInfo: ActivityPageInfo;
};

export type ActivitiesContainer = {
  __typename: 'ActivitiesContainer';
  cloudId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['URL']>;
  /** Base64 encoded ARI of container. */
  id: Scalars['ID'];
  /** Local (in product) object ID of the corresponding object. */
  localResourceId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ActivityProduct>;
  type?: Maybe<ActivitiesContainerType>;
  url?: Maybe<Scalars['URL']>;
};

export const ActivitiesContainerType = {
  Project: 'PROJECT',
  Site: 'SITE',
  Space: 'SPACE',
  Workspace: 'WORKSPACE'
} as const;

export type ActivitiesContainerType = typeof ActivitiesContainerType[keyof typeof ActivitiesContainerType];
export type ActivitiesContributor = {
  __typename: 'ActivitiesContributor';
  /**
   * count of contributions for sorting by frequency,
   * all event types that is being ingested, except VIEWED and VIEWED_CONTENT
   * is considered to be a contribution
   */
  count?: Maybe<Scalars['Int']>;
  lastAccessedDate?: Maybe<Scalars['DateTime']>;
  profile?: Maybe<User>;
};

export type ActivitiesEvent = Node & {
  __typename: 'ActivitiesEvent';
  eventType?: Maybe<ActivityEventType>;
  extension?: Maybe<ActivitiesEventExtension>;
  /** Unique event ID */
  id: Scalars['ID'];
  timestamp?: Maybe<Scalars['DateTime']>;
  user?: Maybe<ActivitiesUser>;
};

export type ActivitiesEventExtension = ActivitiesCommentedEvent | ActivitiesTransitionedEvent;

export type ActivitiesFilter = {
  arguments?: InputMaybe<ActivitiesArguments>;
  /** Defines relationship in-between filter arguments (AND/OR) */
  type?: InputMaybe<ActivitiesFilterType>;
};

export const ActivitiesFilterType = {
  And: 'AND',
  Or: 'OR'
} as const;

export type ActivitiesFilterType = typeof ActivitiesFilterType[keyof typeof ActivitiesFilterType];
export type ActivitiesItem = Node & {
  __typename: 'ActivitiesItem';
  /** Base64 encoded ARI of the activity. */
  id: Scalars['ID'];
  object?: Maybe<ActivitiesObject>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** Extension of ActivitiesObject, is a part of ActivitiesObjectExtension union */
export type ActivitiesJiraIssue = {
  __typename: 'ActivitiesJiraIssue';
  issueKey?: Maybe<Scalars['String']>;
};

export type ActivitiesObject = Node & {
  __typename: 'ActivitiesObject';
  cloudId?: Maybe<Scalars['String']>;
  /** Hierarchy of the containers, top container comes first */
  containers?: Maybe<Array<ActivitiesContainer>>;
  contributors?: Maybe<Array<ActivitiesContributor>>;
  events?: Maybe<Array<ActivitiesEvent>>;
  extension?: Maybe<ActivitiesObjectExtension>;
  iconUrl?: Maybe<Scalars['URL']>;
  /** Base64 encoded ARI of the object. */
  id: Scalars['ID'];
  /** Local (in product) object ID of the corresponding object. */
  localResourceId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ActivitiesObjectParent>;
  product?: Maybe<ActivityProduct>;
  type?: Maybe<ActivityObjectType>;
  url?: Maybe<Scalars['URL']>;
};


export type ActivitiesObjectEventsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

export type ActivitiesObjectExtension = ActivitiesJiraIssue;

export type ActivitiesObjectParent = {
  __typename: 'ActivitiesObjectParent';
  /** Base64 encoded ARI of the object. */
  id: Scalars['ID'];
  type?: Maybe<ActivityObjectType>;
};

export const ActivitiesObjectType = {
  Blogpost: 'BLOGPOST',
  Goal: 'GOAL',
  Issue: 'ISSUE',
  Page: 'PAGE',
  /** Refers to a townsquare project (not to be confused with a jira project) */
  Project: 'PROJECT'
} as const;

export type ActivitiesObjectType = typeof ActivitiesObjectType[keyof typeof ActivitiesObjectType];
/** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */
export type ActivitiesTransitionedEvent = {
  __typename: 'ActivitiesTransitionedEvent';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type ActivitiesUser = {
  __typename: 'ActivitiesUser';
  profile?: Maybe<User>;
};

export type ActivityContributor = {
  __typename: 'ActivityContributor';
  /**
   * count of contributions for sorting by frequency,
   * all event types that is being ingested, except VIEWED and VIEWED_CONTENT
   * is considered to be a contribution
   */
  count?: Maybe<Scalars['Int']>;
  lastAccessedDate: Scalars['DateTime'];
  profile?: Maybe<User>;
};

export type ActivityEdge = {
  __typename: 'ActivityEdge';
  cursor: Scalars['String'];
  node?: Maybe<ActivitiesItem>;
};

export type ActivityEvent = {
  __typename: 'ActivityEvent';
  actor?: Maybe<User>;
  eventType: Scalars['String'];
  extension?: Maybe<ActivitiesEventExtension>;
  /** Unique event ID */
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export const ActivityEventType = {
  Assigned: 'ASSIGNED',
  Commented: 'COMMENTED',
  Created: 'CREATED',
  Edited: 'EDITED',
  Liked: 'LIKED',
  Published: 'PUBLISHED',
  Transitioned: 'TRANSITIONED',
  Unassigned: 'UNASSIGNED',
  Updated: 'UPDATED',
  Viewed: 'VIEWED'
} as const;

export type ActivityEventType = typeof ActivityEventType[keyof typeof ActivityEventType];
export type ActivityNode = Node & {
  __typename: 'ActivityNode';
  event: ActivityEvent;
  /** ARI of the activity */
  id: Scalars['ID'];
  object: ActivityObject;
};

export type ActivityObject = {
  __typename: 'ActivityObject';
  contributors?: Maybe<Array<ActivityContributor>>;
  data?: Maybe<ActivityObjectData>;
  /** ARI of the object. */
  id: Scalars['ID'];
  product: Scalars['String'];
  /** ARI of the top most container (ex: Site/Workspace) */
  rootContainerId: Scalars['ID'];
  subProduct?: Maybe<Scalars['String']>;
  /** Type of the object: ex: Issue, Blog, etc */
  type: Scalars['String'];
};

export type ActivityObjectData = AvocadoAnswer | AvocadoQuestion | ConfluenceBlogPost | ConfluenceComment | ConfluencePage | JiraIssue | JiraPlatformComment | JiraServiceManagementComment | TownsquareComment | TownsquareGoal | TownsquareProject;

export const ActivityObjectType = {
  Blogpost: 'BLOGPOST',
  Comment: 'COMMENT',
  Goal: 'GOAL',
  Issue: 'ISSUE',
  Page: 'PAGE',
  Project: 'PROJECT',
  Site: 'SITE',
  Space: 'SPACE',
  Task: 'TASK'
} as const;

export type ActivityObjectType = typeof ActivityObjectType[keyof typeof ActivityObjectType];
export type ActivityPageInfo = {
  __typename: 'ActivityPageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export const ActivityProduct = {
  Confluence: 'CONFLUENCE',
  Jira: 'JIRA',
  JiraBusiness: 'JIRA_BUSINESS',
  JiraOps: 'JIRA_OPS',
  JiraServiceDesk: 'JIRA_SERVICE_DESK',
  JiraSoftware: 'JIRA_SOFTWARE',
  Townsquare: 'TOWNSQUARE'
} as const;

export type ActivityProduct = typeof ActivityProduct[keyof typeof ActivityProduct];
/**
 * Represents arbitrary transition,
 * e.g. in case of TRANSITIONED event type it could be `from: "inprogress" to: "done"`.
 */
export type ActivityTransition = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** Price quotes for additional members */
export type AddMembersPriceQuotes = {
  __typename: 'AddMembersPriceQuotes';
  /** The price quote for the remainder of the current subscription period */
  prorated: PriceQuote;
  /** The price quote for the next renewal */
  renewal: PriceQuote;
};

/** Announcements appear in the header in the Taco component */
export type Announcement = {
  __typename: 'Announcement';
  /** The HTML content of the Announcement */
  html: Scalars['String'];
  /** The ID of the Announcement */
  id: Scalars['ID'];
  /** The locale of the Announcement */
  locale: Scalars['String'];
  /** The title of the Announcement */
  title: Scalars['String'];
  /** The type of Announcement */
  type: AnnouncementType;
  /** The url to learn more about the Announcement */
  url?: Maybe<Scalars['String']>;
};

/**
 * The types of Announcements. Most are blog posts, but there is a reserved type for announcing
 * maintenance downtime that will give the Roo component an alternate appearance
 */
export const AnnouncementType = {
  Blog: 'blog',
  Downtime: 'downtime'
} as const;

export type AnnouncementType = typeof AnnouncementType[keyof typeof AnnouncementType];
/** The response when dismissing an announcement. Just indicates success */
export type Announcement_DismissResponse = {
  __typename: 'Announcement_DismissResponse';
  success: Scalars['Boolean'];
};

/**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */
export const ApiGroup = {
  Caas: 'CAAS',
  Compass: 'COMPASS',
  Confluence: 'CONFLUENCE',
  ContentPlatformApi: 'CONTENT_PLATFORM_API',
  DevopsAriGraph: 'DEVOPS_ARI_GRAPH',
  DevopsContainerRelationship: 'DEVOPS_CONTAINER_RELATIONSHIP',
  DevopsService: 'DEVOPS_SERVICE',
  Forge: 'FORGE',
  Help: 'HELP',
  Identity: 'IDENTITY',
  Jira: 'JIRA',
  Polaris: 'POLARIS',
  Teams: 'TEAMS',
  XenLogsApi: 'XEN_LOGS_API'
} as const;

export type ApiGroup = typeof ApiGroup[keyof typeof ApiGroup];
export type AppCreator = {
  __typename: 'AppCreator';
  icon?: Maybe<AppCreator_Icon>;
  iconClass?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idPlugin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  urlSuffix?: Maybe<Scalars['String']>;
};

export type AppCreator_Icon = {
  __typename: 'AppCreator_Icon';
  url?: Maybe<Scalars['String']>;
};

export type AppInstallationContext = {
  __typename: 'AppInstallationContext';
  id: Scalars['ID'];
};

export type AppLog = FunctionInvocationMetadata & Node & {
  __typename: 'AppLog';
  /**
   * Gets up to 200 earliest log lines for this invocation.
   * For getting more log lines use appLogLines field in Query type.
   */
  appLogLines?: Maybe<AppLogLines>;
  appVersion: Scalars['String'];
  function?: Maybe<FunctionDescription>;
  id: Scalars['ID'];
  installationContext?: Maybe<AppInstallationContext>;
  moduleType?: Maybe<Scalars['String']>;
  /**
   * The start time of the invocation
   *
   * RFC-3339 formatted timestamp.
   */
  startTime?: Maybe<Scalars['String']>;
  trigger?: Maybe<FunctionTrigger>;
};


export type AppLogAppLogLinesArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

export type AppLogLine = {
  __typename: 'AppLogLine';
  /**
   * Log level of log line.  Typically one of:
   * TRACE, DEBUG, INFO, WARN, ERROR, FATAL
   */
  level?: Maybe<Scalars['String']>;
  /** The free-form textual message from the log statement. */
  message?: Maybe<Scalars['String']>;
  /**
   * We really don't know what other fields may be in the logs.
   *
   * This field may be an array or an object.
   *
   * If it's an object, it will include only fields in `includeFields`,
   * unless `includeFields` is null, in which case it will include
   * all fields that are not in `excludeFields`.
   *
   * If it's an array it will include the entire array.
   */
  other?: Maybe<Scalars['JSON']>;
  /**
   * Time the log line was issued
   *
   * RFC-3339 formatted timestamp
   */
  timestamp: Scalars['String'];
};

/** Relay-style Edge to an `AppLogLine` object. */
export type AppLogLineEdge = {
  __typename: 'AppLogLineEdge';
  cursor: Scalars['String'];
  node: AppLogLine;
};

/**
 * AppLogLines returned from AppLog query.
 *
 * Not quite a Relay-style Connection since you can't page from this query.
 */
export type AppLogLines = {
  __typename: 'AppLogLines';
  edges?: Maybe<Array<Maybe<AppLogLineEdge>>>;
  nodes?: Maybe<Array<Maybe<AppLogLine>>>;
  pageInfo: PageInfo;
};

/**
 * This does not represent a real person but rather the identity that backs an installed application
 *
 * See the documentation on the `User` for more details
 *
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */
export type AppUser = User & {
  __typename: 'AppUser';
  accountId: Scalars['ID'];
  accountStatus: AccountStatus;
  canonicalAccountId: Scalars['ID'];
  name: Scalars['String'];
  picture: Scalars['URL'];
};

/** Details of an Atlassian Account */
export type AtlassianAccount = {
  __typename: 'AtlassianAccount';
  email: Scalars['String'];
};

/**
 * This represents a real person that has an account in a wide range of Atlassian products
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */
export type AtlassianAccountUser = LocalizationContext & User & {
  __typename: 'AtlassianAccountUser';
  accountId: Scalars['ID'];
  accountStatus: AccountStatus;
  canonicalAccountId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  picture: Scalars['URL'];
  zoneinfo?: Maybe<Scalars['String']>;
};

/** An object representing an attachment belonging to a card */
export type Attachment = {
  __typename: 'Attachment';
  /** The size of the attachment in bytes */
  bytes: Scalars['Int'];
  /** The date the attachment was added */
  date: Scalars['String'];
  /** For image attachments, the extracted edge color */
  edgeColor?: Maybe<Scalars['String']>;
  /** The filename of the attachment */
  fileName: Scalars['String'];
  /** The ID of the attachment */
  id: Scalars['ID'];
  /** The ID of the member who added the attachment */
  idMember: Scalars['ID'];
  /** Whether the attachment was uploaded */
  isUpload: Scalars['Boolean'];
  /** The mimeType for the attachment */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the attachment */
  name: Scalars['String'];
  /** The position of the attachment in the attachments list */
  pos: Scalars['Float'];
  /** If the attachment is an image, an array of generated previews of the image in various sizes */
  previews?: Maybe<Array<Attachment_Preview>>;
  /** The URL to the attachment */
  url: Scalars['String'];
};

/** A filter for the Attachments being requested */
export const Attachment_Filter = {
  /** Only attachments which are Card covers */
  Cover: 'cover'
} as const;

export type Attachment_Filter = typeof Attachment_Filter[keyof typeof Attachment_Filter];
export type Attachment_Preview = {
  __typename: 'Attachment_Preview';
  /** The id of the attachment preview */
  _id: Scalars['ID'];
  /** The size of the attachment preview in bytes */
  bytes: Scalars['Int'];
  /** The height of the image */
  height: Scalars['Int'];
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'];
  /** The URL to the preview */
  url: Scalars['String'];
  /** The width of the image */
  width: Scalars['Int'];
};

export type AvailableEstimations = {
  __typename: 'AvailableEstimations';
  /** Name of the estimation. */
  name: Scalars['String'];
  /** Unique identifier of the estimation. Temporary naming until we remove "statistic" from Jira. */
  statisticFieldId: Scalars['String'];
};

export type AvocadoAnswer = Node & {
  __typename: 'AvocadoAnswer';
  iconUrl: Scalars['String'];
  /** ARI of the Answer */
  id: Scalars['ID'];
  siteName: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type AvocadoQuestion = Node & {
  __typename: 'AvocadoQuestion';
  iconUrl: Scalars['String'];
  /** ARI of the Question */
  id: Scalars['ID'];
  isAnswered: Scalars['Boolean'];
  siteName: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type Backlog = {
  __typename: 'Backlog';
  /** List of the assignees of all cards currently displayed on the backlog */
  assignees?: Maybe<Array<Maybe<User>>>;
  /**
   * Temporarily needed to support legacy write API_.  the issue list key to use when creating issue's on the board.
   * Required when creating issues on a board with backlogs
   */
  boardIssueListKey?: Maybe<Scalars['String']>;
  /** List of card types which can be created directly on the backlog or sprints */
  cardTypes: Array<Maybe<CardType>>;
  cards: Array<Maybe<SoftwareCard>>;
  /** connect add-ons information */
  extension?: Maybe<BacklogExtension>;
  /** Labels for filtering and adding to cards */
  labels: Array<Maybe<Scalars['String']>>;
  /** Whether or not to show the 'migrate this column to your backlog' prompt (set when first enabling backlogs) */
  requestColumnMigration: Scalars['Boolean'];
};


export type BacklogCardsArgs = {
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customFilterIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BacklogExtension = {
  __typename: 'BacklogExtension';
  /** list of operations that add-on can perform */
  operations?: Maybe<Array<Maybe<SoftwareOperation>>>;
};

export type BasicBoardFeatureView = Node & {
  __typename: 'BasicBoardFeatureView';
  canEnable?: Maybe<Scalars['Boolean']>;
  dependents?: Maybe<Array<Maybe<BoardFeatureView>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUri?: Maybe<Scalars['String']>;
  learnMoreArticleId?: Maybe<Scalars['String']>;
  learnMoreLink?: Maybe<Scalars['String']>;
  /** Possible states: ENABLED, DISABLED, COMING_SOON */
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Bitbucket Permission Enum */
export const BitbucketPermission = {
  /** Bitbucket admin permission */
  Admin: 'ADMIN'
} as const;

export type BitbucketPermission = typeof BitbucketPermission[keyof typeof BitbucketPermission];
export type BitbucketRepository = Node & {
  __typename: 'BitbucketRepository';
  /** The Bitbucket avatar. */
  avatar?: Maybe<BitbucketRepositoryAvatar>;
  /**
   * The connection entity for DevOps Service relationships for this Bitbucket repository, according to the specified
   * pagination, filtering and sorting.
   */
  devOpsServiceRelationships?: Maybe<DevOpsServiceAndRepositoryRelationshipConnection>;
  /** The ARI of the Bitbucket repository. */
  id: Scalars['ID'];
  /**
   * The connection entity for Jira project relationships for this Bitbucket repository, according to the specified
   * pagination, filtering and sorting.
   */
  jiraProjectRelationships?: Maybe<JiraProjectAndRepositoryRelationshipConnection>;
  /** Name of Bitbucket repository. */
  name: Scalars['String'];
  /** URI for accessing Bitbucket repository. */
  webUrl: Scalars['URL'];
  /** Bitbucket workspace the repository is part of. */
  workspace?: Maybe<BitbucketWorkspace>;
};


export type BitbucketRepositoryDevOpsServiceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DevOpsServiceAndRepositoryRelationshipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DevOpsServiceAndRepositoryRelationshipSort>;
};


export type BitbucketRepositoryJiraProjectRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  cloudId: Scalars['ID'];
  filter?: InputMaybe<JiraProjectAndRepositoryRelationshipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<JiraProjectAndRepositoryRelationshipSort>;
};

export type BitbucketRepositoryAvatar = {
  __typename: 'BitbucketRepositoryAvatar';
  /** URI for retrieving Bitbucket avatar. */
  url: Scalars['URL'];
};

export type BitbucketRepositoryConnection = {
  __typename: 'BitbucketRepositoryConnection';
  edges?: Maybe<Array<Maybe<BitbucketRepositoryEdge>>>;
  nodes?: Maybe<Array<Maybe<BitbucketRepository>>>;
  pageInfo: PageInfo;
};

export type BitbucketRepositoryEdge = {
  __typename: 'BitbucketRepositoryEdge';
  cursor: Scalars['String'];
  node?: Maybe<BitbucketRepository>;
};

export type BitbucketRepositoryIdConnection = {
  __typename: 'BitbucketRepositoryIdConnection';
  edges?: Maybe<Array<Maybe<BitbucketRepositoryIdEdge>>>;
  pageInfo: PageInfo;
};

export type BitbucketRepositoryIdEdge = {
  __typename: 'BitbucketRepositoryIdEdge';
  cursor: Scalars['String'];
  node?: Maybe<BitbucketRepository>;
};

export type BitbucketWorkspace = Node & {
  __typename: 'BitbucketWorkspace';
  /** The ARI of the Bitbucket workspace. */
  id: Scalars['ID'];
  /** Name of the Bitbucket workspace. */
  name: Scalars['String'];
  /**
   * List of Bitbucket Repositories belong to the Bitbucket Workspace
   * The returned repositories are filtered based on user permission and role-value specified by permissionFilter argument.
   * If no permissionFilter specified, the list contains all repositories that user can access.
   */
  repositories?: Maybe<BitbucketRepositoryConnection>;
};


export type BitbucketWorkspaceRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  permissionFilter?: InputMaybe<BitbucketPermission>;
};

/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type Board = {
  __typename: 'Board';
  /** The Actions taken on this Board */
  actions: Array<Action>;
  /** The ids of plugins that a board has enabled */
  boardPlugins: Array<BoardPlugin>;
  /** The limit for how many Butler buttons a board can show */
  butlerButtonLimit: Scalars['Int'];
  butlerButtonOverrides?: Maybe<Array<ButlerButtonOverrides>>;
  /** The Cards on the Board */
  cards: Array<Card>;
  /** Boolean whether the board has been closed or not */
  closed: Scalars['Boolean'];
  /** How the Board was created */
  creationMethod?: Maybe<CreationMethod>;
  /** The CustomFields configured for the Board */
  customFields: Array<CustomField>;
  dashboardViewTile?: Maybe<Board_DashboardViewTile>;
  /** The tiles configured for the board's dashboard view */
  dashboardViewTiles: Array<Board_DashboardViewTile>;
  /** The date that the last activity occured on the Board */
  dateLastActivity?: Maybe<Scalars['String']>;
  /** The date that the current Member last viewed the Board */
  dateLastView?: Maybe<Scalars['String']>;
  /** The date that plugins are scheduled to be disabled */
  datePluginDisable?: Maybe<Scalars['String']>;
  /** The description of the Board (About this Board) */
  desc: Scalars['String'];
  /** If the description includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONString']>;
  /** The Enterprise this Board belongs to */
  enterprise?: Maybe<Enterprise>;
  /** Boolean whether the board belongs to an Enterprise */
  enterpriseOwned: Scalars['Boolean'];
  /** A specific Export on this board */
  export?: Maybe<Export>;
  /** The Exports on this Board */
  exports: Array<Export>;
  /** Historical data for the board */
  history?: Maybe<Board_History>;
  /** The ID of the Board */
  id: Scalars['ID'];
  /** The ID of the Template the board was copied from */
  idBoardSource: Scalars['ID'];
  /** MongoID of the Enterprise to which the board belongs */
  idEnterprise?: Maybe<Scalars['String']>;
  /** MongoID of the organization to which the board belongs */
  idOrganization?: Maybe<Scalars['String']>;
  /** The ids for the Collections(Tags) that the Board is part of */
  idTags: Array<Scalars['String']>;
  /** Object containing color keys and the label names given for one label of each color on the board */
  labelNames: Board_LabelNames;
  /** The Labels on this Board */
  labels: Array<Label>;
  /** The limits on the Board */
  limits: Board_Limits;
  /** The Lists on the Board */
  lists: Array<List>;
  /** The Members on the Board */
  members: Array<Member>;
  /** The counts of membership types on this Board */
  membershipCounts?: Maybe<MembershipCounts>;
  /** The Memberships of the Board */
  memberships: Array<Board_Membership>;
  /** The Member's preferences specific to this Board */
  myPrefs: MyPrefs;
  /** The name of the Board */
  name: Scalars['String'];
  /** The Organization this Board belongs to */
  organization?: Maybe<Organization>;
  /** Boolean whether the board has been pinned or not */
  pinned: Scalars['Boolean'];
  /** The PluginData for this Board */
  pluginData: Array<PluginData>;
  /** The Plugins on the Board */
  plugins: Array<Plugin>;
  /** List of powerups as strings */
  powerUps?: Maybe<Array<Scalars['String']>>;
  /** Short for 'preferences', these are the settings for the board */
  prefs?: Maybe<Board_Prefs>;
  /** The premium features allowed for this board */
  premiumFeatures: Array<PremiumFeatures>;
  /** The Butler Buttons the board owns */
  privateButlerButtons: Array<ButlerButton>;
  sharedButlerButtons: Array<ButlerButton>;
  /** The shortMongoId for this Board */
  shortLink: Scalars['String'];
  /** URL for the board using only its shortMongoID */
  shortUrl: Scalars['String'];
  /** The counts for this Board being starred */
  starCounts?: Maybe<StarCounts>;
  /** Whether the board has been starred by the current user */
  starred: Scalars['Boolean'];
  /** View and copy counts for the board */
  stats?: Maybe<Board_Stats>;
  /** Whether the current Member is subscribed to the Board */
  subscribed: Scalars['Boolean'];
  /** The field that determine how a template renders in the template gallery */
  templateGallery?: Maybe<TemplateGallery>;
  /** Persistent URL for the board */
  url: Scalars['String'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardActionsArgs = {
  filter?: InputMaybe<Array<Action_Type>>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardCardsArgs = {
  filter?: InputMaybe<Card_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardDashboardViewTileArgs = {
  id: Scalars['ID'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardExportArgs = {
  id: Scalars['ID'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardExportsArgs = {
  id: Scalars['ID'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardLabelsArgs = {
  filter?: InputMaybe<Label_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardListsArgs = {
  filter?: InputMaybe<List_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardMembersArgs = {
  filter?: InputMaybe<Member_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardMembershipCountsArgs = {
  filter?: InputMaybe<MembershipCounts_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardMembershipsArgs = {
  filter?: InputMaybe<Board_Membership_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardPluginsArgs = {
  filter?: InputMaybe<Plugin_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardStatsArgs = {
  id: Scalars['ID'];
};

export type BoardAccessRequest = {
  __typename: 'BoardAccessRequest';
  allowed: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

/** Object that represents the response of requestBoardAccess mutation */
export type BoardAccessRequest_Response = {
  __typename: 'BoardAccessRequest_Response';
  /** Whether requesting access was successful */
  success: Scalars['Boolean'];
};

export type BoardAccessVerificationRequest = {
  __typename: 'BoardAccessVerificationRequest';
  success: Scalars['Boolean'];
};

export type BoardEditConfig = {
  __typename: 'BoardEditConfig';
  /** Configuration for showing inline card create */
  inlineCardCreate?: Maybe<InlineCardCreateConfig>;
  /** Configuration for showing inline column mutations */
  inlineColumnEdit?: Maybe<InlineColumnEditConfig>;
};

export type BoardEntity = {
  __typename: 'BoardEntity';
  id?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BoardFeature = {
  __typename: 'BoardFeature';
  category: Scalars['String'];
  key?: Maybe<Scalars['SoftwareBoardFeatureKey']>;
  prerequisites?: Maybe<Array<Maybe<BoardFeature>>>;
  status?: Maybe<BoardFeatureStatus>;
  toggle?: Maybe<BoardFeatureToggleStatus>;
};

/** Relay connection definition for a list of board features */
export type BoardFeatureConnection = {
  __typename: 'BoardFeatureConnection';
  edges?: Maybe<Array<Maybe<BoardFeatureEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

/** Relay edge definition for a board feature */
export type BoardFeatureEdge = {
  __typename: 'BoardFeatureEdge';
  /** The cursor position of this edge. Used for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The feature group of the edge */
  node?: Maybe<BoardFeatureView>;
};

export type BoardFeatureGroup = Node & {
  __typename: 'BoardFeatureGroup';
  /** The board features in this group */
  features?: Maybe<BoardFeatureConnection>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};


export type BoardFeatureGroupFeaturesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** Relay connection definition for a list of board feature groups */
export type BoardFeatureGroupConnection = {
  __typename: 'BoardFeatureGroupConnection';
  /** The list of edges of this connection */
  edges?: Maybe<Array<Maybe<BoardFeatureGroupEdge>>>;
  /** Page detail for pagination */
  pageInfo?: Maybe<PageInfo>;
};

/** Relay edge definition for a board feature group */
export type BoardFeatureGroupEdge = {
  __typename: 'BoardFeatureGroupEdge';
  /** The cursor position of this edge. Used for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The board feature group of the edge */
  node?: Maybe<BoardFeatureGroup>;
};

export const BoardFeatureStatus = {
  ComingSoon: 'COMING_SOON',
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type BoardFeatureStatus = typeof BoardFeatureStatus[keyof typeof BoardFeatureStatus];
export const BoardFeatureToggleStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type BoardFeatureToggleStatus = typeof BoardFeatureToggleStatus[keyof typeof BoardFeatureToggleStatus];
export type BoardFeatureView = BasicBoardFeatureView | EstimationBoardFeatureView;

/** Board invitation secret */
export type BoardInviteSecret = {
  __typename: 'BoardInviteSecret';
  secret: Scalars['String'];
  type: Scalars['String'];
};

/** An object representing the response from the disableBoardInvitationSecret mutation */
export type BoardInviteSecret_DeleteResponse = {
  __typename: 'BoardInviteSecret_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

export type BoardNotificationData = {
  __typename: 'BoardNotificationData';
  closed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
};

/** Board Plugin schema */
export type BoardPlugin = {
  __typename: 'BoardPlugin';
  id: Scalars['ID'];
  idPlugin: Scalars['ID'];
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScope = Node & {
  __typename: 'BoardScope';
  /** Null if there's no backlog */
  backlog?: Maybe<Backlog>;
  board?: Maybe<SoftwareBoard>;
  /** Card parents (AKA Epics) for filtering and adding to cards */
  cardParents: Array<Maybe<CardParent>>;
  /** Cards in the board scope with given card IDs */
  cards: Array<Maybe<SoftwareCard>>;
  /** Information about the user making this request. */
  currentUser: CurrentUser;
  /**
   * Custom filters for this board scope
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: customFilters` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  customFilters?: Maybe<Array<Maybe<CustomFilter>>>;
  /** Estimation type currently configured for the board. */
  estimation?: Maybe<EstimationConfig>;
  /**
   * List of all feature groups on the board. This is similar to the list of features, but support groupings for the frontend to render
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: featureGroups` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  featureGroups?: Maybe<BoardFeatureGroupConnection>;
  /** List of all features on the board, and their state. */
  features: Array<Maybe<BoardFeature>>;
  /**
   * Return filtered card Ids on applying custom filters
   * This mutation is currently in BETA
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: filteredCardIds` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  filteredCardIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Id of the board. Maps to the boardId in Jira. */
  id: Scalars['ID'];
  /**
   * -- FIELDS BELOW ONLY SUPPORTED WITH softwareBoards QUERY -- DO NOT USE OTHERWISE --
   * Name of the board.
   */
  name?: Maybe<Scalars['String']>;
  /** The project location for this board scope */
  projectLocation: SoftwareProject;
  /** List of reports on this board.  null if reports are not enabled on this board. */
  reports?: Maybe<SoftwareReports>;
  /** Request sprint by Id. */
  sprint?: Maybe<Sprint>;
  /** Null if sprints are disabled (empty if there are no sprints) */
  sprints?: Maybe<Array<Maybe<Sprint>>>;
  /**
   * Request sprint prototype by Id to be used with start sprint modal.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: startSprintPrototype` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  startSprintPrototype?: Maybe<Sprint>;
  /** Current user's swimlane-strategy, NONE if SWAG was unable to retrieve it */
  userSwimlaneStrategy?: Maybe<SwimlaneStrategy>;
};


/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeCardsArgs = {
  cardIds: Array<InputMaybe<Scalars['ID']>>;
  customFilterIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeFilteredCardIdsArgs = {
  customFilterIds: Array<InputMaybe<Scalars['ID']>>;
  issueIds: Array<InputMaybe<Scalars['ID']>>;
};


/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeSprintArgs = {
  sprintId: Scalars['ID'];
};


/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeSprintsArgs = {
  state?: InputMaybe<Array<InputMaybe<SprintState>>>;
};


/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeStartSprintPrototypeArgs = {
  sprintId: Scalars['ID'];
};

export type BoardScopeConnection = {
  __typename: 'BoardScopeConnection';
  edges?: Maybe<Array<Maybe<BoardScopeEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type BoardScopeEdge = {
  __typename: 'BoardScopeEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<BoardScope>;
};

/** A starred Board for a Member */
export type BoardStar = {
  __typename: 'BoardStar';
  /** The ID of the BoardStar relationship */
  id: Scalars['ID'];
  /** The ID of the Board */
  idBoard: Scalars['String'];
  /** The relative position of the starred Board */
  pos: Scalars['Int'];
};

export type Board_DashboardViewTile = {
  __typename: 'Board_DashboardViewTile';
  /** The date this tile was last modified */
  dateLastActivity: Scalars['String'];
  /** The start of the timeframe for historical charts */
  from?: Maybe<Board_DashboardViewTile_From>;
  /** The configuration of this tile's graph */
  graph: Board_DashboardViewTile_Graph;
  id: Scalars['ID'];
  /** The position of this tile in the dashboard */
  pos: Scalars['Int'];
  /** The type of this tile */
  type: Scalars['String'];
};

export type Board_DashboardViewTile_From = {
  __typename: 'Board_DashboardViewTile_From';
  /** Either absolute or relative */
  dateType: Scalars['String'];
  /**
   * Either a unix timestamp (ms) for an absolute date, or an offset (ms)
   * for relative dates
   */
  value: Scalars['Int'];
};

export type Board_DashboardViewTile_Graph = {
  __typename: 'Board_DashboardViewTile_Graph';
  /** The type of graph (bar, pie, ...) */
  type: Scalars['String'];
};

/** A filter for the Boards being requested */
export const Board_Filter = {
  /** Returns all boards that are closed */
  Closed: 'closed',
  /** Returns all boards that have visibility set to Private */
  Members: 'members',
  /** Returns all boards that are open */
  Open: 'open',
  /** Returns all boards that have visibility set to Team */
  Organization: 'organization',
  /** Returns all boards that have visibility set to Public. */
  Public: 'public',
  /** Returns all boards that have been starred (avoid using). Note: Currently this filter is not updating in real-time. */
  Starred: 'starred',
  /** Returns all boards that are templates. */
  Template: 'template'
} as const;

export type Board_Filter = typeof Board_Filter[keyof typeof Board_Filter];
/** A board's historical data */
export type Board_History = {
  __typename: 'Board_History';
  /** Data for the # of cards whose due date is in each of the different due date states */
  cardsPerDueDateStatus: Board_History_CardsPerDueDateStatus;
  /** Data for the # of cards assigned to each of the board's labels over time */
  cardsPerLabel: Board_History_CardsPerLabel;
  /** Data for the # of cards in each of the board's lists over time */
  cardsPerList: Board_History_CardsPerList;
  /** Data for the # of cards assigned to each of the board's members over time */
  cardsPerMember: Board_History_CardsPerMember;
  /** The id of the board the history is for. */
  id: Scalars['ID'];
};


/** A board's historical data */
export type Board_HistoryCardsPerDueDateStatusArgs = {
  from?: InputMaybe<Scalars['String']>;
};


/** A board's historical data */
export type Board_HistoryCardsPerLabelArgs = {
  from?: InputMaybe<Scalars['String']>;
};


/** A board's historical data */
export type Board_HistoryCardsPerListArgs = {
  from?: InputMaybe<Scalars['String']>;
};


/** A board's historical data */
export type Board_HistoryCardsPerMemberArgs = {
  from?: InputMaybe<Scalars['String']>;
};

/** A board's cardsPerDueDateStatus history */
export type Board_History_CardsPerDueDateStatus = {
  __typename: 'Board_History_CardsPerDueDateStatus';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each due date status */
  series: Board_History_CardsPerDueDateStatus_Series;
};

/** A set of series for each different due date status */
export type Board_History_CardsPerDueDateStatus_Series = {
  __typename: 'Board_History_CardsPerDueDateStatus_Series';
  done: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  dueLater: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  dueSoon: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  noDueDate: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  overdue: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
};

export type Board_History_CardsPerDueDateStatus_Series_DataPoint = {
  __typename: 'Board_History_CardsPerDueDateStatus_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the DueDateStatus */
  value: Scalars['Int'];
};

/** A board's cardsPerLabel history */
export type Board_History_CardsPerLabel = {
  __typename: 'Board_History_CardsPerLabel';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each of the board's Labels */
  series: Array<Board_History_CardsPerLabel_Series>;
};

/** A Label history timeseries */
export type Board_History_CardsPerLabel_Series = {
  __typename: 'Board_History_CardsPerLabel_Series';
  /** The data points of the timeseries */
  dataPoints: Array<Board_History_CardsPerLabel_Series_DataPoint>;
  /** The id of the Label the history is for */
  idLabel: Scalars['ID'];
};

export type Board_History_CardsPerLabel_Series_DataPoint = {
  __typename: 'Board_History_CardsPerLabel_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the Label */
  value: Scalars['Int'];
};

/** A board's cardsPerList history */
export type Board_History_CardsPerList = {
  __typename: 'Board_History_CardsPerList';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each of the board's lists */
  series: Array<Board_History_CardsPerList_Series>;
};

/** A list history timeseries */
export type Board_History_CardsPerList_Series = {
  __typename: 'Board_History_CardsPerList_Series';
  /** The data points of the timeseries */
  dataPoints: Array<Board_History_CardsPerList_Series_DataPoint>;
  /** The id of the list the history is for */
  idList: Scalars['ID'];
};

export type Board_History_CardsPerList_Series_DataPoint = {
  __typename: 'Board_History_CardsPerList_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the list */
  value: Scalars['Int'];
};

/** A board's cardsPerMember history */
export type Board_History_CardsPerMember = {
  __typename: 'Board_History_CardsPerMember';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each of the board's Members */
  series: Array<Board_History_CardsPerMember_Series>;
};

/** A Member history timeseries */
export type Board_History_CardsPerMember_Series = {
  __typename: 'Board_History_CardsPerMember_Series';
  /** The data points of the timeseries */
  dataPoints: Array<Board_History_CardsPerMember_Series_DataPoint>;
  /** The id of the Member the history is for */
  idMember: Scalars['ID'];
};

export type Board_History_CardsPerMember_Series_DataPoint = {
  __typename: 'Board_History_CardsPerMember_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the Member */
  value: Scalars['Int'];
};

/** The type of board membership a board invite link will give a member */
export const Board_Invite_MemberType = {
  /** A normal member */
  Normal: 'normal',
  /** An observer (no write permissions) */
  Observer: 'observer'
} as const;

export type Board_Invite_MemberType = typeof Board_Invite_MemberType[keyof typeof Board_Invite_MemberType];
/**
 * An object containing each of the Label colors used on a board, with their
 * corresponding names. If there are multiple labels using the same color, the first
 * name will be used.
 */
export type Board_LabelNames = {
  __typename: 'Board_LabelNames';
  /** The first black label's name */
  black: Scalars['String'];
  /** The first blue label's name */
  blue: Scalars['String'];
  /** The first green label's name */
  green: Scalars['String'];
  /** The first lime label's name */
  lime: Scalars['String'];
  /** The first orange label's name */
  orange: Scalars['String'];
  /** The first pink label's name */
  pink: Scalars['String'];
  /** The first purple label's name */
  purple: Scalars['String'];
  /** The first red label's name */
  red: Scalars['String'];
  /** The first sky label's name */
  sky: Scalars['String'];
  /** The first yellow label's name */
  yellow: Scalars['String'];
};

/** The limits on the Board */
export type Board_Limits = {
  __typename: 'Board_Limits';
  /** The board-attachment limits */
  attachments: Board_Limits_Attachments;
  /** The board limits */
  boards: Board_Limits_Boards;
  /** The board-card limits */
  cards: Board_Limits_Cards;
  /** The board-checkItem limits */
  checkItems: Board_Limits_CheckItems;
  /** The board-checklist limits */
  checklists: Board_Limits_Checklists;
  /** The board-customFieldOption limits */
  customFieldOptions: Board_Limits_CustomFieldOptions;
  /** The board-customField limits */
  customFields: Board_Limits_CustomFields;
  /** The board-label limits */
  labels: Board_Limits_Labels;
  /** The board-list limits */
  lists: Board_Limits_Lists;
  /** The board-reaction limits */
  reactions: Board_Limits_Reactions;
  /** The board-stickers limits */
  stickers: Board_Limits_Stickers;
};

/** The board-attachment limits */
export type Board_Limits_Attachments = {
  __typename: 'Board_Limits_Attachments';
  /** Attachments per Board limit */
  perBoard: Limit;
  /** Attachments per Card limit */
  perCard: Limit;
};

/** The board limits */
export type Board_Limits_Boards = {
  __typename: 'Board_Limits_Boards';
  /** Total Access Requests per Board limit */
  totalAccessRequestsPerBoard: Limit;
  /** Total Members per Board limit */
  totalMembersPerBoard: Limit;
};

/** The board-card limits */
export type Board_Limits_Cards = {
  __typename: 'Board_Limits_Cards';
  /** Open Cards per Board limit */
  openPerBoard: Limit;
  /** Open Cards per List limit */
  openPerList: Limit;
  /** Total Cards per Board limit */
  totalPerBoard: Limit;
  /** Total Cards per List limit */
  totalPerList: Limit;
};

/** The board-checkItem limits */
export type Board_Limits_CheckItems = {
  __typename: 'Board_Limits_CheckItems';
  /** CheckItems per Checklist Limit */
  perChecklist: Limit;
};

/** The board-checklist limits */
export type Board_Limits_Checklists = {
  __typename: 'Board_Limits_Checklists';
  /** Checklists per Board limit */
  perBoard: Limit;
  /** Checklists per Card limit */
  perCard: Limit;
};

/** The board-customFieldOptions limits */
export type Board_Limits_CustomFieldOptions = {
  __typename: 'Board_Limits_CustomFieldOptions';
  /** CustomFieldOptions per CustomField limit */
  perField: Limit;
};

/** The board-customField limits */
export type Board_Limits_CustomFields = {
  __typename: 'Board_Limits_CustomFields';
  /** CustomFields per Board limit */
  perBoard: Limit;
};

/** The board-labeljj limits */
export type Board_Limits_Labels = {
  __typename: 'Board_Limits_Labels';
  /** Labels per Board limit */
  perBoard: Limit;
};

/** The board-list limits */
export type Board_Limits_Lists = {
  __typename: 'Board_Limits_Lists';
  /** Open Lists per Board limit */
  openPerBoard: Limit;
  /** Total Lists per Board limit */
  totalPerBoard: Limit;
};

/** The board-reaction limits */
export type Board_Limits_Reactions = {
  __typename: 'Board_Limits_Reactions';
  /** Reactions per Action limit */
  perAction: Limit;
  /** Unique Reactions per Action limit */
  uniquePerAction: Limit;
};

/** The board-sticker limits */
export type Board_Limits_Stickers = {
  __typename: 'Board_Limits_Stickers';
  /** Stickers per Card limit */
  perCard: Limit;
};

/** An object representing the response from the removeMemberFromBoard mutation */
export type Board_Member_DeleteResponse = {
  __typename: 'Board_Member_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** An association between a Member and a Board */
export type Board_Membership = {
  __typename: 'Board_Membership';
  /** Whether the Member has been deactivated */
  deactivated: Scalars['Boolean'];
  /** The ID of the Membership */
  id: Scalars['String'];
  /** The ID of the Member */
  idMember: Scalars['String'];
  /** The Member this membership is for */
  member: Member;
  /** The type of Membership this is */
  memberType: Board_Membership_MemberType;
  /** The organization membership type */
  orgMemberType: Organization_Membership_MemberType;
  /** Whether the Member has confirmed their email address */
  unconfirmed: Scalars['Boolean'];
};

/** A filter for the board memberships */
export const Board_Membership_Filter = {
  /** Get the members that are active */
  Active: 'active',
  /** Get the admins */
  Admin: 'admin',
  /** Get the members that are deactivated */
  Deactivated: 'deactivated',
  /** Only get the membership for the active member from the board */
  Me: 'me',
  /** Get the memberType normal memberships */
  Normal: 'normal'
} as const;

export type Board_Membership_Filter = typeof Board_Membership_Filter[keyof typeof Board_Membership_Filter];
/** The type of membership a member has on a Board */
export const Board_Membership_MemberType = {
  /** An admin */
  Admin: 'admin',
  /** A normal member */
  Normal: 'normal',
  /** An observer (no write permissions) */
  Observer: 'observer'
} as const;

export type Board_Membership_MemberType = typeof Board_Membership_MemberType[keyof typeof Board_Membership_MemberType];
/** The preferences for a Board */
export type Board_Prefs = {
  __typename: 'Board_Prefs';
  /** The Board background (can be a color like 'orange' or an ID */
  background: Scalars['String'];
  /** Hex color for the bottom of the background */
  backgroundBottomColor: Scalars['String'];
  /** Whether the background is considered 'dark' or 'light' or 'unknown' */
  backgroundBrightness: Board_Prefs_BackgroundBrightness;
  /** Hex color for the Board background */
  backgroundColor?: Maybe<Scalars['String']>;
  /** The Board background (can be a color like 'orange' or an ID) */
  backgroundImage?: Maybe<Scalars['String']>;
  /** Pre-scaled background images for the Board */
  backgroundImageScaled?: Maybe<Array<Board_Prefs_BackgroundImageScaled>>;
  /** Whether the background should tile */
  backgroundTile: Scalars['Boolean'];
  /** Hex color for the tope of the background */
  backgroundTopColor: Scalars['String'];
  /** Whether a calendar feed is enabled for the Board */
  calendarFeedEnabled: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Enterprise */
  canBeEnterprise: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Organization */
  canBeOrg: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Private */
  canBePrivate: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Public */
  canBePublic: Scalars['Boolean'];
  /** Whether invitations are enabled for the Board */
  canInvite: Scalars['Boolean'];
  /** The Card aging mode */
  cardAging: Board_Prefs_CardAging;
  /** Whether Card covers are enabled */
  cardCovers: Scalars['Boolean'];
  /** The comment permissions for the Board */
  comments: Board_Prefs_Comments;
  /** List of board buttons to not show on header */
  hiddenPluginBoardButtons: Array<Scalars['String']>;
  /** Whether votes from other members are hidden on this Board */
  hideVotes: Scalars['Boolean'];
  /** The invite permissions for the Board */
  invitations: Board_Prefs_Invitations;
  /** Whether this Board is a Template */
  isTemplate: Scalars['Boolean'];
  /** The permission level (visibility) of the Board */
  permissionLevel: Board_Prefs_PermissionLevel;
  /** Whether users are allowed to join the Board without invite */
  selfJoin: Scalars['Boolean'];
  /** Permission level for voting */
  voting: Board_Voting_Permission;
};

/** The brightness of the Board background */
export const Board_Prefs_BackgroundBrightness = {
  Dark: 'dark',
  Light: 'light',
  Unknown: 'unknown'
} as const;

export type Board_Prefs_BackgroundBrightness = typeof Board_Prefs_BackgroundBrightness[keyof typeof Board_Prefs_BackgroundBrightness];
/** A pre-scaled version of the Board background */
export type Board_Prefs_BackgroundImageScaled = {
  __typename: 'Board_Prefs_BackgroundImageScaled';
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

/** The card aging mode of the Board */
export const Board_Prefs_CardAging = {
  /** Cards age in Lists */
  Pirate: 'pirate',
  /** Cards don't age */
  Regular: 'regular'
} as const;

export type Board_Prefs_CardAging = typeof Board_Prefs_CardAging[keyof typeof Board_Prefs_CardAging];
/** Board commenting permissions */
export const Board_Prefs_Comments = {
  /** Comments are disabled */
  Disabled: 'disabled',
  /** Board members can comment */
  Members: 'members',
  /** Obververs can comment */
  Observers: 'observers',
  /** Organization members can comment */
  Org: 'org',
  /** Anyone can comment */
  Public: 'public'
} as const;

export type Board_Prefs_Comments = typeof Board_Prefs_Comments[keyof typeof Board_Prefs_Comments];
/** Board invitation permissions */
export const Board_Prefs_Invitations = {
  /** Only admins can invite more Members */
  Admins: 'admins',
  /** All Board Members can invite more Members */
  Members: 'members'
} as const;

export type Board_Prefs_Invitations = typeof Board_Prefs_Invitations[keyof typeof Board_Prefs_Invitations];
/** The permission level (visibility) of an Board */
export const Board_Prefs_PermissionLevel = {
  /** Visible to to Enterprise members */
  Enterprise: 'enterprise',
  /** Visible to the Organization members */
  Org: 'org',
  /** Only visible to Board members */
  Private: 'private',
  /** Visible to everyone */
  Public: 'public'
} as const;

export type Board_Prefs_PermissionLevel = typeof Board_Prefs_PermissionLevel[keyof typeof Board_Prefs_PermissionLevel];
/** View and Copy counts of the Board */
export type Board_Stats = {
  __typename: 'Board_Stats';
  /** Number of copy actions on the board */
  copyCount: Scalars['Int'];
  /** Number of logged in views of the board */
  viewCount: Scalars['Int'];
};

/** Permission level for voting on Board */
export const Board_Voting_Permission = {
  Disabled: 'disabled',
  Private: 'private',
  Public: 'public'
} as const;

export type Board_Voting_Permission = typeof Board_Voting_Permission[keyof typeof Board_Voting_Permission];
/** A sort for the boards being requested */
export const Boards_SortBy = {
  /** sorts by date of the last activity */
  DateLastActivity: 'dateLastActivity'
} as const;

export type Boards_SortBy = typeof Boards_SortBy[keyof typeof Boards_SortBy];
/** A sort direction for the boards being requested */
export const Boards_SortOrder = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type Boards_SortOrder = typeof Boards_SortOrder[keyof typeof Boards_SortOrder];
/** Burndown chart focuses on remaining scope over time */
export type BurndownChart = {
  __typename: 'BurndownChart';
  /** Burndown charts are graphing the remaining over time */
  chart: BurndownChartData;
  /** Filters for the report */
  filters: SprintReportsFilters;
};


/** Burndown chart focuses on remaining scope over time */
export type BurndownChartChartArgs = {
  estimation?: InputMaybe<SprintReportsEstimationStatisticType>;
  sprintId?: InputMaybe<Scalars['ID']>;
};

export type BurndownChartData = {
  __typename: 'BurndownChartData';
  /** the set end time of the sprint, not when the sprint completed */
  endTime?: Maybe<Scalars['DateTime']>;
  /**
   * data for a sprint scope change
   * each point are assumed to be scope change during a sprint
   */
  scopeChangeEvents: Array<Maybe<SprintScopeChangeData>>;
  /**
   * data for sprint end event
   * can be null if sprint has not been completed yet
   */
  sprintEndEvent?: Maybe<SprintEndData>;
  /** data for sprint start event */
  sprintStartEvent: SprintStartData;
  /** the start time of the sprint */
  startTime?: Maybe<Scalars['DateTime']>;
  /** data for the table */
  table?: Maybe<BurndownChartDataTable>;
  /** the current user's timezone */
  timeZone?: Maybe<Scalars['String']>;
};

export type BurndownChartDataTable = {
  __typename: 'BurndownChartDataTable';
  completedIssues: Array<Maybe<BurndownChartDataTableIssueRow>>;
  completedIssuesOutsideOfSprint: Array<Maybe<BurndownChartDataTableIssueRow>>;
  incompleteIssues: Array<Maybe<BurndownChartDataTableIssueRow>>;
  issuesRemovedFromSprint: Array<Maybe<BurndownChartDataTableIssueRow>>;
  scopeChanges: Array<Maybe<BurndownChartDataTableScopeChangeRow>>;
};

export type BurndownChartDataTableIssueRow = {
  __typename: 'BurndownChartDataTableIssueRow';
  assignee?: Maybe<User>;
  cardParent?: Maybe<CardParent>;
  cardStatus?: Maybe<CardStatus>;
  cardType?: Maybe<CardType>;
  estimate?: Maybe<Scalars['Float']>;
  issueKey: Scalars['String'];
  issueSummary: Scalars['String'];
};

export type BurndownChartDataTableScopeChangeRow = {
  __typename: 'BurndownChartDataTableScopeChangeRow';
  cardParent?: Maybe<CardParent>;
  cardType?: Maybe<CardType>;
  sprintScopeChange: SprintScopeChangeData;
  timestamp: Scalars['DateTime'];
};

/** Butler Buttons schema */
export type ButlerButton = {
  __typename: 'ButlerButton';
  close?: Maybe<Scalars['Boolean']>;
  /**
   * Scalar representing `object`; today this is really just a string,
   * but eventually should represent a full Butler command.
   */
  cmd: Scalars['ButlerCommand'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  idMemberOwner: Scalars['ID'];
  image: Scalars['String'];
  label: Scalars['String'];
  pos: Scalars['Int'];
  type: Scalars['String'];
};

/** Butler Buttons overrides schema */
export type ButlerButtonOverrides = {
  __typename: 'ButlerButtonOverrides';
  idBoard: Scalars['ID'];
  idButton: Scalars['ID'];
  idMember: Scalars['ID'];
  overrideTime: Scalars['Int'];
  overrides: ButlerButtonOverrides_Overrides;
};

/** Butler Buttons override options */
export type ButlerButtonOverrides_Overrides = {
  __typename: 'ButlerButtonOverrides_Overrides';
  enabled: Scalars['Boolean'];
};

/**
 * Report pagination
 * -----------------
 */
export type CfdChartConnection = {
  __typename: 'CFDChartConnection';
  edges: Array<Maybe<CfdChartEdge>>;
  pageInfo: PageInfo;
};

/**
 * Report data
 * -----------------
 */
export type CfdChartData = {
  __typename: 'CFDChartData';
  changes: Array<Maybe<CfdIssueColumnChangeEntry>>;
  columnCounts: Array<Maybe<CfdColumnCount>>;
  timestamp: Scalars['DateTime'];
};

export type CfdChartEdge = {
  __typename: 'CFDChartEdge';
  cursor: Scalars['String'];
  node: CfdChartData;
};

export type CfdColumn = {
  __typename: 'CFDColumn';
  name: Scalars['String'];
};

export type CfdColumnCount = {
  __typename: 'CFDColumnCount';
  columnIndex: Scalars['Int'];
  count: Scalars['Int'];
};

/**
 * Report filters
 * --------------
 */
export type CfdFilters = {
  __typename: 'CFDFilters';
  columns: Array<Maybe<CfdColumn>>;
};

export type CfdIssueColumnChangeEntry = {
  __typename: 'CFDIssueColumnChangeEntry';
  columnFrom?: Maybe<Scalars['Int']>;
  columnTo?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['ID']>;
  point?: Maybe<TimeSeriesPoint>;
  statusTo?: Maybe<Scalars['ID']>;
  /** in ISO 8601 format */
  timestamp: Scalars['String'];
};

export const CalendarView_TimeHorizons = {
  Day: 'day',
  Month: 'month',
  Week: 'week'
} as const;

export type CalendarView_TimeHorizons = typeof CalendarView_TimeHorizons[keyof typeof CalendarView_TimeHorizons];
/** Ad Campaigns in Trello */
export type Campaign = {
  __typename: 'Campaign';
  currentStep: Scalars['String'];
  dateDismissed?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type Card = {
  __typename: 'Card';
  /** Address of card location. */
  address?: Maybe<Scalars['String']>;
  /** The Attachments belonging to the card */
  attachments: Array<Attachment>;
  /** Pieces of information about the card that are displayed on the front of the card. */
  badges: Card_Badges;
  /** The Board the Card is on */
  board: Board;
  /** The role/type of the card */
  cardRole?: Maybe<CardRole>;
  /** The states of CheckItems on this card */
  checkItemStates: Array<Card_CheckItem_State>;
  /** The Checklists belonging to the Card */
  checklists: Array<Checklist>;
  /** Whether the card is closed (archived). Note: Archived lists and boards do not cascade archives to cards. A card can have closed: false but be on an archived board. */
  closed: Scalars['Boolean'];
  /** An object containing keys for latitude and longitude whose values are numbers between -180 and 180. */
  coordinates?: Maybe<Card_Coordinates>;
  /** An object containing the cover information of the card. */
  cover?: Maybe<Card_Cover>;
  /** How the Card was created */
  creationMethod?: Maybe<CreationMethod>;
  /** The CustomFieldItems on this Card */
  customFieldItems: Array<CustomFieldItem>;
  /** The CustomFields configured for the Board */
  customFields: Array<CustomField>;
  /** The datetime of the last activity on the card. Note: There are activities that update dateLastActivity that do not create a corresponding action. For instance, updating the name field of a checklist item on a card does not create an action but does update the card and board's dateLastActivity value. */
  dateLastActivity: Scalars['String'];
  /** The description for the card. Up to 16384 chars. */
  desc: Scalars['String'];
  /** If the description includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONString']>;
  /** The due date on the card, if one exists. */
  due?: Maybe<Scalars['String']>;
  /** Whether the due date has been marked complete. */
  dueComplete: Scalars['Boolean'];
  /** The number of minutes before the due date that the Member should be notified. No value indicates the default (5 minutes). */
  dueReminder?: Maybe<Scalars['String']>;
  /** The email address of the Card, emails sent to this address will appear as a comment by the current Member on the Card */
  email?: Maybe<Scalars['String']>;
  /** The ID of the card. */
  id: Scalars['ID'];
  /** The id of the attachment selected as the cover image, if one exists. */
  idAttachmentCover?: Maybe<Scalars['ID']>;
  /** The ID of the board the card is on. */
  idBoard: Scalars['ID'];
  /** An array of checklist IDs that are on this card. */
  idChecklists: Array<Scalars['ID']>;
  /** An array of label IDs that are on this card. */
  idLabels: Array<Scalars['ID']>;
  /** The ID of the list the card is in. */
  idList: Scalars['ID'];
  /** An array of member IDs that are on this card. */
  idMembers: Array<Scalars['ID']>;
  /** An array of member IDs who have voted on this card. */
  idMembersVoted: Array<Scalars['ID']>;
  /** Numeric ID for the card on this board. Only unique to the board, and subject to change as the card moves. */
  idShort: Scalars['Int'];
  /** Whether this Card is a Template */
  isTemplate: Scalars['Boolean'];
  /** The Labels on this Card */
  labels: Array<Label>;
  /** The limits on the Card */
  limits: Card_Limits;
  /** The List the Card is on */
  list: List;
  /** Name of card location. */
  locationName?: Maybe<Scalars['String']>;
  /** Whether the card cover image was selected automatically by Trello, or manually by the user. */
  manualCoverAttachment: Scalars['Boolean'];
  /** The members on this card */
  members: Array<Member>;
  /** Name of the card. */
  name: Scalars['String'];
  /** The PluginData for this Card */
  pluginData: Array<PluginData>;
  /** Position of the card in the list. */
  pos: Scalars['Float'];
  /** The role/type whose criteria are met by the card */
  possibleCardRole?: Maybe<CardRole>;
  /** The 8 character shortened ID for the card. */
  shortLink: Scalars['String'];
  /** URL to the card without the name slug. */
  shortUrl: Scalars['String'];
  /** Start date of the card */
  start: Scalars['String'];
  /** A string containing the signed static map URL for google API */
  staticMapUrl?: Maybe<Scalars['String']>;
  /** The Stickers on the card */
  stickers: Array<Sticker>;
  /** Whether this member is subscribed to the card. */
  subscribed: Scalars['Boolean'];
  /** Full URL to the card, with the name slug. */
  url: Scalars['String'];
};


/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type CardAttachmentsArgs = {
  filter?: InputMaybe<Attachment_Filter>;
};


/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type CardChecklistsArgs = {
  filter?: InputMaybe<Checklist_Filter>;
};

export type CardCoverMedia = {
  __typename: 'CardCoverMedia';
  attachmentId?: Maybe<Scalars['Long']>;
  attachmentMediaApiId?: Maybe<Scalars['ID']>;
  clientId?: Maybe<Scalars['String']>;
  /** endpoint to retrieve the media from */
  endpointUrl?: Maybe<Scalars['String']>;
  /** true if this card has media, but it's explicity been hidden by the user */
  hiddenByUser: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type CardEntity = {
  __typename: 'CardEntity';
  due?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Advanced date for representing relative and absolute dates in views */
export type CardFilter_AdvancedDate = {
  __typename: 'CardFilter_AdvancedDate';
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

export const CardFilter_AdvancedDate_DateType = {
  Absolute: 'absolute',
  Relative: 'relative'
} as const;

export type CardFilter_AdvancedDate_DateType = typeof CardFilter_AdvancedDate_DateType[keyof typeof CardFilter_AdvancedDate_DateType];
/** A Date Range for Workspace Views */
export type CardFilter_Criteria_DateRange = {
  __typename: 'CardFilter_Criteria_DateRange';
  end?: Maybe<CardFilter_AdvancedDate>;
  special?: Maybe<CardFilter_Criteria_DateRange_Special>;
  start?: Maybe<CardFilter_AdvancedDate>;
};

export const CardFilter_Criteria_DateRange_Special = {
  Any: 'any',
  None: 'none'
} as const;

export type CardFilter_Criteria_DateRange_Special = typeof CardFilter_Criteria_DateRange_Special[keyof typeof CardFilter_Criteria_DateRange_Special];
export const CardHierarchyLevelEnumType = {
  Base: 'BASE',
  Child: 'CHILD',
  Parent: 'PARENT'
} as const;

export type CardHierarchyLevelEnumType = typeof CardHierarchyLevelEnumType[keyof typeof CardHierarchyLevelEnumType];
export type CardMediaConfig = {
  __typename: 'CardMediaConfig';
  /** Whether or not to show card media on this board */
  enabled: Scalars['Boolean'];
};

export type CardNotificationData = {
  __typename: 'CardNotificationData';
  id?: Maybe<Scalars['String']>;
  idShort?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
};

export type CardParent = {
  __typename: 'CardParent';
  /** Card type */
  cardType: CardType;
  /** Some info about its children */
  childrenInfo?: Maybe<SoftwareCardChildrenInfo>;
  /** The color for this card */
  color?: Maybe<Scalars['CardPaletteColor']>;
  /** The due date set on the issue parent */
  dueDate?: Maybe<Scalars['String']>;
  /** Card id */
  id: Scalars['ID'];
  /** Card key */
  key: Scalars['String'];
  /** The start date set on the issue parent */
  startDate?: Maybe<Scalars['String']>;
  /** Card status */
  status?: Maybe<CardStatus>;
  /** Card summary */
  summary: Scalars['String'];
};

export type CardPriority = {
  __typename: 'CardPriority';
  iconUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const CardRole = {
  Board: 'board',
  Link: 'link',
  Mirror: 'mirror',
  Separator: 'separator'
} as const;

export type CardRole = typeof CardRole[keyof typeof CardRole];
export type CardStatus = {
  __typename: 'CardStatus';
  /** Which status category this statue belongs to.  Values:  "undefined" | "new" (ie todo) | "indeterminate" (aka "in progress") | "done" */
  category?: Maybe<Scalars['String']>;
  /** Card status id */
  id?: Maybe<Scalars['ID']>;
  /** Card status name */
  name?: Maybe<Scalars['String']>;
};

export type CardType = {
  __typename: 'CardType';
  /**
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: SoftwareCardTypeExternalId` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  externalId?: Maybe<Scalars['ID']>;
  /** The type of hierarchy level that card type belongs to */
  hierarchyLevelType?: Maybe<Scalars['CardTypeHierarchyLevelType']>;
  /** URL to the icon to show for this card type */
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** The configuration for creating cards with this type inline. */
  inlineCardCreate?: Maybe<InlineCardCreateConfig>;
  name?: Maybe<Scalars['String']>;
};

/** An object containing values necessary to render the front of a card */
export type Card_Badges = {
  __typename: 'Card_Badges';
  /** The number of attachments on the card */
  attachments: Scalars['Int'];
  /** An object containing more granular attachment counts */
  attachmentsByType: Card_Badges_AttachmentsByType;
  /** The count of checkItems on the card */
  checkItems: Scalars['Int'];
  /** The count of checkItems on the card in the 'complete' state */
  checkItemsChecked: Scalars['Int'];
  /** The date of the earliest checkItem due date */
  checkItemsEarliestDue?: Maybe<Scalars['String']>;
  /** The count of comments on the card */
  comments: Scalars['Int'];
  /** A boolean indicating whether the card has a description */
  description: Scalars['Boolean'];
  /** The due date of the Card, if one has been set */
  due?: Maybe<Scalars['String']>;
  /** Whether the due date has been marked as 'complete' */
  dueComplete: Scalars['Boolean'];
  /** Whether the location badge is visible */
  location: Scalars['Boolean'];
  /** The start date of the Card, if one has been set */
  start?: Maybe<Scalars['String']>;
  /** Whether the user is subscribed to the card */
  subscribed: Scalars['Boolean'];
  /** Whether the user has voted on the card */
  viewingMemberVoted: Scalars['Boolean'];
  /** The count of votes on the card */
  votes: Scalars['Int'];
};

/** An object containing counts of attachments by type */
export type Card_Badges_AttachmentsByType = {
  __typename: 'Card_Badges_AttachmentsByType';
  /** The trello-specific attachment counts on the Card */
  trello: Card_Badges_AttachmentsByType_Trello;
};

/** An object containing counts of trello attachments */
export type Card_Badges_AttachmentsByType_Trello = {
  __typename: 'Card_Badges_AttachmentsByType_Trello';
  /** The count of Board attachments on the Card */
  board: Scalars['Int'];
  /** The count of Card attachments on the Card */
  card: Scalars['Int'];
};

export type Card_CheckItem_State = {
  __typename: 'Card_CheckItem_State';
  /** The ID of the CheckItem */
  idCheckItem?: Maybe<Scalars['String']>;
  /** The state of the CheckItem */
  state?: Maybe<CheckItem_State>;
};

/** An object containing keys for latitude and longitude whose values are numbers between -180 and 180 */
export type Card_Coordinates = {
  __typename: 'Card_Coordinates';
  /** The latitude (between -180 and 180) */
  latitude: Scalars['Float'];
  /** The longitude (between -180 and 180) */
  longitude: Scalars['Float'];
};

export type Card_Cover = {
  __typename: 'Card_Cover';
  /** The brightness for the card cover. It is either dark or light. */
  brightness?: Maybe<Card_Cover_Brightness>;
  /** The color that is used as the card cover. */
  color?: Maybe<Card_Cover_Color>;
  /** For image covers, the extracted edge color */
  edgeColor?: Maybe<Scalars['String']>;
  /** The ID of the image attachment used as the card cover. */
  idAttachment?: Maybe<Scalars['String']>;
  /** The ID of the Power-Up that provided the current card cover. */
  idPlugin?: Maybe<Scalars['String']>;
  /** The ID of the uploaded background used as the card cover. */
  idUploadedBackground?: Maybe<Scalars['String']>;
  /** If the cover is an image, an array of generated previews of the image in various sizes */
  scaled?: Maybe<Array<Card_Cover_Scaled>>;
  /** For shared uploaded backgrounds, the url that the image was downloaded from */
  sharedSourceUrl?: Maybe<Scalars['String']>;
  /** The size of the card cover. It is either normal or full. */
  size?: Maybe<Card_Cover_Size>;
};

export const Card_Cover_Brightness = {
  Dark: 'dark',
  Light: 'light'
} as const;

export type Card_Cover_Brightness = typeof Card_Cover_Brightness[keyof typeof Card_Cover_Brightness];
export const Card_Cover_Color = {
  Black: 'black',
  Blue: 'blue',
  Green: 'green',
  Lime: 'lime',
  Orange: 'orange',
  Pink: 'pink',
  Purple: 'purple',
  Red: 'red',
  Sky: 'sky',
  Yellow: 'yellow'
} as const;

export type Card_Cover_Color = typeof Card_Cover_Color[keyof typeof Card_Cover_Color];
export type Card_Cover_Scaled = {
  __typename: 'Card_Cover_Scaled';
  _id: Scalars['String'];
  /** The size of the cover preview in bytes */
  bytes: Scalars['Int'];
  /** The height of the image */
  height: Scalars['Int'];
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'];
  /** The URL to the preview */
  url: Scalars['String'];
  /** The width of the image */
  width: Scalars['Int'];
};

export const Card_Cover_Size = {
  Full: 'full',
  Normal: 'normal'
} as const;

export type Card_Cover_Size = typeof Card_Cover_Size[keyof typeof Card_Cover_Size];
/** An object representing the response from the deleteCard mutation */
export type Card_DeleteResponse = {
  __typename: 'Card_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the Cards being requested */
export const Card_Filter = {
  /** Returns all cards that have at least one checkItem assigned to the member. Currently only supported if `member(id: 'me')` is the top-level query. */
  CheckItemsAssigned: 'checkItemsAssigned',
  /** Returns all cards that are closed or in lists that have been archived */
  Closed: 'closed',
  /** Returns all cards that are open in lists that have not been archived */
  Open: 'open',
  /** Returns all template cards */
  Template: 'template',
  /** Returns all open cards in lists that are not closed */
  Visible: 'visible'
} as const;

export type Card_Filter = typeof Card_Filter[keyof typeof Card_Filter];
/** The limits on the Card */
export type Card_Limits = {
  __typename: 'Card_Limits';
  /** The card-attachment limits */
  attachments: Card_Limits_Attachments;
  /** The card-checklist limits */
  checklists: Card_Limits_Checklists;
  /** The card-sticker limits */
  stickers: Card_Limits_Stickers;
};

/** The card-attachment limits */
export type Card_Limits_Attachments = {
  __typename: 'Card_Limits_Attachments';
  /** Attachments per Card limit */
  perCard: Card_Limits_Attachments_PerCard;
};

/** Attachments per Card limit */
export type Card_Limits_Attachments_PerCard = {
  __typename: 'Card_Limits_Attachments_PerCard';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** The card-checklist limits */
export type Card_Limits_Checklists = {
  __typename: 'Card_Limits_Checklists';
  /** Checklists per Card limit */
  perCard: Card_Limits_Checklists_PerCard;
};

/** Checklists per Card limit */
export type Card_Limits_Checklists_PerCard = {
  __typename: 'Card_Limits_Checklists_PerCard';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** The card-sticker limits */
export type Card_Limits_Stickers = {
  __typename: 'Card_Limits_Stickers';
  /** Stickers per Card limit */
  perCard: Card_Limits_Stickers_PerCard;
};

/** Stickers per Card limit */
export type Card_Limits_Stickers_PerCard = {
  __typename: 'Card_Limits_Stickers_PerCard';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** An object representing the response from the removeMemberFromCard mutation */
export type Card_Member_DeleteResponse = {
  __typename: 'Card_Member_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Authentication for Avalara CertCapture tax integration in the client */
export type CertCaptureToken = {
  __typename: 'CertCaptureToken';
  /** Auth token */
  token: Scalars['String'];
};

/** The information about the channel (stable/beta/alpha) the Member is on and what they have access to */
export type Channels = {
  __typename: 'Channels';
  /** The channel the Member is currently using */
  active: Scalars['String'];
  /** The channels the Member is allowed to use */
  allowed: Array<Scalars['String']>;
  /** Whether the Member is allowed to pick releases from the Channel Switcher */
  dev: Scalars['Boolean'];
};

export type CheckDomainClaim_Enterprise = {
  __typename: 'CheckDomainClaim_Enterprise';
  displayName: Scalars['String'];
};

export type CheckDomainClaim_Response = {
  __typename: 'CheckDomainClaim_Response';
  enterprise?: Maybe<CheckDomainClaim_Enterprise>;
};

/**
 * CheckItems in Trello are contained within Checklists on a Card. They represent a single
 * task to be done and can be in an 'incomplete' or 'complete' state
 */
export type CheckItem = {
  __typename: 'CheckItem';
  /** The due date of the check item */
  due?: Maybe<Scalars['String']>;
  /** The ID of the check item. */
  id: Scalars['ID'];
  /** The ID of the checklist the check item is on. */
  idChecklist: Scalars['ID'];
  /** The id of the member assigned to the check item. */
  idMember?: Maybe<Scalars['ID']>;
  /** The name of the check item. */
  name: Scalars['String'];
  /** If the name includes custom emoji, this object will contain the information necessary to display them. */
  nameData?: Maybe<Scalars['JSONString']>;
  /** The position of the check item on the checklist (relative to any other check items on the checklist). */
  pos: Scalars['Float'];
  /** The state of the check item. */
  state: CheckItem_State;
  /** A temporary ID that is returned when creating a new check item */
  temporaryId?: Maybe<Scalars['String']>;
};

/** An object representing the response from the deleteCheckItem mutation */
export type CheckItem_DeleteResponse = {
  __typename: 'CheckItem_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the CardItems being requested */
export const CheckItem_Filter = {
  /** Returns all checkItems */
  All: 'all',
  /** Returns all checkItems assigned to the member. Currently only supported if `member(id: 'me')` is the top-level query. */
  Assigned: 'assigned',
  /** Returns no checkItems */
  None: 'none'
} as const;

export type CheckItem_Filter = typeof CheckItem_Filter[keyof typeof CheckItem_Filter];
/** The completion state of a CheckItem */
export const CheckItem_State = {
  Complete: 'complete',
  Incomplete: 'incomplete'
} as const;

export type CheckItem_State = typeof CheckItem_State[keyof typeof CheckItem_State];
/** CheckLists are a container for CheckItems on a Card */
export type Checklist = {
  __typename: 'Checklist';
  /** The cards the Checklist is on */
  cards: Array<Card>;
  /** The list of CheckItems contained within this Checklist */
  checkItems: Array<CheckItem>;
  /** The ID of the checklist. */
  id: Scalars['ID'];
  /** The ID of the board the checklist is on. */
  idBoard: Scalars['ID'];
  /** The ID of the card the checklist is on. */
  idCard: Scalars['ID'];
  /** The name of the checklist. */
  name: Scalars['String'];
  /** The position of the checklist on the card (relative to any other checklists on the card). */
  pos: Scalars['Float'];
  /** A temporary ID that is returned when creating a new checklist */
  temporaryId?: Maybe<Scalars['String']>;
};


/** CheckLists are a container for CheckItems on a Card */
export type ChecklistCheckItemsArgs = {
  filter?: InputMaybe<CheckItem_Filter>;
};

/** An object representing the response from the deleteChecklist mutation */
export type Checklist_DeleteResponse = {
  __typename: 'Checklist_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the Cardlists being requested */
export const Checklist_Filter = {
  /** Returns all checklists */
  All: 'all',
  /** Returns all checklists that have at least one checkItem assigned to the member. Currently only supported if `member(id: 'me')` is the top-level query. */
  CheckItemsAssigned: 'checkItemsAssigned',
  /** Return no checklists */
  None: 'none'
} as const;

export type Checklist_Filter = typeof Checklist_Filter[keyof typeof Checklist_Filter];
/** Children metadata for cards */
export type ChildCardsMetadata = {
  __typename: 'ChildCardsMetadata';
  complete?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/**
 * An organization owned by a managed member of an enterprise. This is not a model, but rather just a set
 * of fields of an Organization that is solely used for the enteprise dashboard.
 */
export type ClaimableOrganization = {
  __typename: 'ClaimableOrganization';
  activeMembershipCount: Scalars['Int'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  idActiveAdmins: Array<Scalars['ID']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products: Array<Scalars['Int']>;
};

/**
 * The list of claimable organizations (see below), as well as the total count (the endpoint does not return
 * all of them)
 */
export type ClaimableOrganizations = {
  __typename: 'ClaimableOrganizations';
  count: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  organizations: Array<ClaimableOrganization>;
};

/** A column on the board */
export type Column = {
  __typename: 'Column';
  /** The cards contained in the column */
  cards: Array<Maybe<SoftwareCard>>;
  /** The statuses mapped to this column */
  columnStatus: Array<ColumnStatus>;
  /** Column's id */
  id?: Maybe<Scalars['ID']>;
  /** Whether this column is the done column.  Each board has exactly one done column. */
  isDone: Scalars['Boolean'];
  /** Whether this column is the inital column.  Each board has exactly one initial column. */
  isInitial: Scalars['Boolean'];
  /** Number of cards allowed in this column before displaying a warning,  null if no limit */
  maxCardCount?: Maybe<Scalars['Int']>;
  /** Column's name */
  name?: Maybe<Scalars['String']>;
};


/** A column on the board */
export type ColumnCardsArgs = {
  customFilterIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ColumnConfigSwimlane = {
  __typename: 'ColumnConfigSwimlane';
  /** UUID to identify the swimlane */
  id?: Maybe<Scalars['ID']>;
  /** All issue types belong to the swimlane */
  issueTypes?: Maybe<Array<Maybe<CardType>>>;
  /** Ghost statuses belong to the swimlane */
  sharedStatuses?: Maybe<Array<Maybe<RawStatus>>>;
  /** Original statuses belong to the swimlane */
  uniqueStatuses?: Maybe<Array<Maybe<RawStatus>>>;
};

/** Represents a column inside a swimlane.  Each swimlane gets a ColumnInSwimlane for each column. */
export type ColumnInSwimlane = {
  __typename: 'ColumnInSwimlane';
  /** The cards contained in this column in the given swimlane */
  cards: Array<Maybe<SoftwareCard>>;
  /** The details of the column */
  columnDetails?: Maybe<Column>;
};


/** Represents a column inside a swimlane.  Each swimlane gets a ColumnInSwimlane for each column. */
export type ColumnInSwimlaneCardsArgs = {
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customFilterIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** A status associated with a column, along with its transitions */
export type ColumnStatus = {
  __typename: 'ColumnStatus';
  /**
   * Possible card transitions with a certain card type into this status
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: SoftwareCardTypeTransitions` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  cardTypeTransitions?: Maybe<Array<SoftwareCardTypeTransition>>;
  /** The status */
  status: CardStatus;
  /** Possible transitions into this status */
  transitions: Array<SoftwareCardTransition>;
};

export type ColumnsConfig = {
  __typename: 'ColumnsConfig';
  columnConfigSwimlanes?: Maybe<Array<Maybe<ColumnConfigSwimlane>>>;
  isUpdating?: Maybe<Scalars['Boolean']>;
  unmappedStatuses?: Maybe<Array<Maybe<RawStatus>>>;
};

export type CommentEntity = {
  __typename: 'CommentEntity';
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CompassAlertEvent = CompassEvent & {
  __typename: 'CompassAlertEvent';
  /** Alert Properties */
  alertProperties: CompassAlertEventProperties;
  /** The description of the event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the event. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * ###################################################################################################################
 *  COMPASS ALERT EVENT
 * ###################################################################################################################
 */
export type CompassAlertEventProperties = {
  __typename: 'CompassAlertEventProperties';
  /** The ID of the alert. */
  id: Scalars['ID'];
};

/** An announcement communicates news or updates relating to a component. */
export type CompassAnnouncement = {
  __typename: 'CompassAnnouncement';
  /** The list of acknowledgements that are required for this announcement. */
  acknowledgements?: Maybe<Array<CompassAnnouncementAcknowledgement>>;
  /**
   * The component that posted the announcement.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:component:compass__
   */
  component?: Maybe<CompassComponent>;
  /** The description of the announcement. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the announcement. */
  id: Scalars['ID'];
  /** The date on which the updates in the announcement will take effect. */
  targetDate?: Maybe<Scalars['DateTime']>;
  /** The title of the announcement. */
  title?: Maybe<Scalars['String']>;
};

/** Tracks whether or not a component has acknowledged an announcement. */
export type CompassAnnouncementAcknowledgement = {
  __typename: 'CompassAnnouncementAcknowledgement';
  /**
   * The component that needs to acknowledge.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:component:compass__
   */
  component?: Maybe<CompassComponent>;
  /** Whether the component has acknowledged the announcement or not. */
  hasAcknowledged?: Maybe<Scalars['Boolean']>;
};

export type CompassBuildEvent = CompassEvent & {
  __typename: 'CompassBuildEvent';
  /** Build Properties */
  buildProperties: CompassBuildEventProperties;
  /** The description of the build event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the build event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the build event. */
  url?: Maybe<Scalars['URL']>;
};

export type CompassBuildEventPipeline = {
  __typename: 'CompassBuildEventPipeline';
  /** The name of the build event pipeline. */
  displayName: Scalars['String'];
  /** The ID of the build event pipeline. */
  pipelineId: Scalars['String'];
  /** The URL to the build event pipeline. */
  url: Scalars['String'];
};

export type CompassBuildEventProperties = {
  __typename: 'CompassBuildEventProperties';
  /** Time the build completed. */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The build event pipeline */
  pipeline?: Maybe<CompassBuildEventPipeline>;
  /** Time the build started. */
  startedAt: Scalars['DateTime'];
  /** The state of the build */
  state: CompassBuildEventState;
};

/**
 * ###################################################################################################################
 *  COMPASS BUILD EVENT
 * ###################################################################################################################
 */
export const CompassBuildEventState = {
  Cancelled: 'CANCELLED',
  Error: 'ERROR',
  Failed: 'FAILED',
  InProgress: 'IN_PROGRESS',
  Successful: 'SUCCESSFUL',
  TimedOut: 'TIMED_OUT',
  Unknown: 'UNKNOWN'
} as const;

export type CompassBuildEventState = typeof CompassBuildEventState[keyof typeof CompassBuildEventState];
/** Metadata about who created or updated the object and when. */
export type CompassChangeMetadata = {
  __typename: 'CompassChangeMetadata';
  /** The date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The user who created the object. */
  createdBy?: Maybe<User>;
  /** The date and time when the object was last updated. */
  lastUserModificationAt?: Maybe<Scalars['DateTime']>;
  /** The user who last updated the object. */
  lastUserModificationBy?: Maybe<User>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponent = Node & {
  __typename: 'CompassComponent';
  /**
   * A collection of announcements posted by the component.
   * Note that the 'X-ExperimentalApi: compass-prototype' HTTP header below is required in addition to the 'X-ExperimentalApi: compass-beta' HTTP header. Set both the headers for this field.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: compass-prototype` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  announcements?: Maybe<Array<CompassAnnouncement>>;
  /**
   * A collection of scorecards applicable to a component.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:scorecard:compass__
   */
  applicableScorecards?: Maybe<Array<CompassScorecard>>;
  /** Metadata about who created the component and when. */
  changeMetadata: CompassChangeMetadata;
  /**
   * A collection of custom fields for storing data about the component.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: compass-prototype` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  customFields?: Maybe<Array<CompassCustomField>>;
  /** The external integration that manages data for this component. */
  dataManager?: Maybe<CompassComponentDataManager>;
  /** The description of the component. */
  description?: Maybe<Scalars['String']>;
  /**
   * The event sources associated to the component.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: compass-prototype` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:event:compass__
   */
  eventSources?: Maybe<Array<EventSource>>;
  /**
   * The events associated to the component.
   * Note that the 'X-ExperimentalApi: compass-prototype' HTTP header below is required in addition to the 'X-ExperimentalApi: compass-beta' HTTP header. Set both the headers for this field.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: compass-prototype` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:event:compass__
   */
  events?: Maybe<CompassEventsQueryResult>;
  /** A collection of aliases that represent the component in external systems. */
  externalAliases?: Maybe<Array<CompassExternalAlias>>;
  /** A collection of fields for storing data about the component. */
  fields?: Maybe<Array<CompassField>>;
  /** The unique identifier (ID) of the component. */
  id: Scalars['ID'];
  /** A collection of labels that provide additional contextual information about the component. */
  labels?: Maybe<Array<CompassComponentLabel>>;
  /** A collection of links to other entities on the internet. */
  links?: Maybe<Array<CompassLink>>;
  /**
   * A collection of metric sources, which contain values providing numerical data about the component.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: compass-prototype` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:metric:compass__
   */
  metricSources?: Maybe<CompassComponentMetricSourcesQueryResult>;
  /** The name of the component. */
  name: Scalars['String'];
  /** The unique identifier (ID) of the team that owns the component. */
  ownerId?: Maybe<Scalars['ID']>;
  /** A collection of relationships between the component and other entities in Compass. */
  relationships?: Maybe<CompassRelationshipConnectionResult>;
  /** Returns the calculated total score for a given scorecard applied to this component. */
  scorecardScore?: Maybe<CompassScorecardScore>;
  /**
   * A collection of scorecard scores applied to a component.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:scorecard:compass__
   */
  scorecardScores?: Maybe<Array<CompassScorecardScore>>;
  /**
   * A collection of scorecards applied to a component.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:scorecard:compass__
   */
  scorecards?: Maybe<Array<CompassScorecard>>;
  /** The type of component. */
  type: CompassComponentType;
};


/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentEventsArgs = {
  query?: InputMaybe<CompassEventsQuery>;
};


/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentMetricSourcesArgs = {
  query?: InputMaybe<CompassComponentMetricSourcesQuery>;
};


/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentRelationshipsArgs = {
  query?: InputMaybe<CompassRelationshipQuery>;
};


/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentScorecardScoreArgs = {
  query?: InputMaybe<CompassComponentScorecardScoreQuery>;
};

/** An external integration that manages data for a particular component. */
export type CompassComponentDataManager = {
  __typename: 'CompassComponentDataManager';
  /** The unique identifier (ID) of the ecosystem app acting as a component data manager. */
  ecosystemAppId: Scalars['ID'];
  /** An URL of the external source. */
  externalSourceURL?: Maybe<Scalars['URL']>;
  /** Details about the last sync event to this component. */
  lastSyncEvent?: Maybe<ComponentSyncEvent>;
};

/** A label provides additional contextual information about a component. */
export type CompassComponentLabel = {
  __typename: 'CompassComponentLabel';
  /** The name of the label. */
  name?: Maybe<Scalars['String']>;
};

/** A connection that returns a paginated collection of metric sources. */
export type CompassComponentMetricSourcesConnection = {
  __typename: 'CompassComponentMetricSourcesConnection';
  /** A list of edges which contain a metric source and a cursor. */
  edges?: Maybe<Array<CompassMetricSourceEdge>>;
  /** A list of metric sources. */
  nodes?: Maybe<Array<CompassMetricSource>>;
  /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
  pageInfo: PageInfo;
};

/** The query to get the metric sources of a component. */
export type CompassComponentMetricSourcesQuery = {
  /** Returns results after the specified cursor. */
  after?: InputMaybe<Scalars['String']>;
  /** The number of results to return in the query. The default is 10. */
  first?: InputMaybe<Scalars['Int']>;
};

export type CompassComponentMetricSourcesQueryResult = CompassComponentMetricSourcesConnection | QueryError;

/** Scorecard score on a component for a scorecard. */
export type CompassComponentScorecardScoreQuery = {
  /** The unique identifier (ID) of the scorecard. */
  scorecardId: Scalars['ID'];
};

/** Identifies the type of component. */
export const CompassComponentType = {
  /** A standalone software artifact that is directly consumable by an end-user. */
  Application: 'APPLICATION',
  /** A standalone software artifact that provides some functionality for other software via embedding. */
  Library: 'LIBRARY',
  /** A software artifact that does not fit into the pre-defined categories. */
  Other: 'OTHER',
  /** A software artifact that provides some functionality for other software over the network. */
  Service: 'SERVICE'
} as const;

export type CompassComponentType = typeof CompassComponentType[keyof typeof CompassComponentType];
export const CompassCriteriaNumberComparatorOptions = {
  Equals: 'EQUALS',
  GreaterThan: 'GREATER_THAN',
  GreaterThanOrEqualTo: 'GREATER_THAN_OR_EQUAL_TO',
  LessThan: 'LESS_THAN',
  LessThanOrEqualTo: 'LESS_THAN_OR_EQUAL_TO'
} as const;

export type CompassCriteriaNumberComparatorOptions = typeof CompassCriteriaNumberComparatorOptions[keyof typeof CompassCriteriaNumberComparatorOptions];
export type CompassCustomBooleanField = CompassCustomField & {
  __typename: 'CompassCustomBooleanField';
  /** The value of the field. */
  booleanValue?: Maybe<Scalars['Boolean']>;
  /** The definition of the field. */
  definition?: Maybe<CompassCustomBooleanFieldDefinition>;
};

/** The schema of a custom boolean field. */
export type CompassCustomBooleanFieldDefinition = CompassCustomFieldDefinition & Node & {
  __typename: 'CompassCustomBooleanFieldDefinition';
  /** The component types the field applies to. */
  componentTypes?: Maybe<Array<CompassComponentType>>;
  /** The description of the field. */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier (ID) of the field definition. */
  id: Scalars['ID'];
  /** The name of the field. */
  name?: Maybe<Scalars['String']>;
};

export type CompassCustomEvent = CompassEvent & {
  __typename: 'CompassCustomEvent';
  /** Custom Event Properties */
  customEventProperties: CompassCustomEventProperties;
  /** The description of the event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the event. */
  url?: Maybe<Scalars['URL']>;
};

export const CompassCustomEventIcon = {
  Checkpoint: 'CHECKPOINT',
  Info: 'INFO',
  Warning: 'WARNING'
} as const;

export type CompassCustomEventIcon = typeof CompassCustomEventIcon[keyof typeof CompassCustomEventIcon];
/**
 * ###################################################################################################################
 *  COMPASS CUSTOM EVENT
 * ###################################################################################################################
 */
export type CompassCustomEventProperties = {
  __typename: 'CompassCustomEventProperties';
  /** The icon for the custom event. */
  icon?: Maybe<CompassCustomEventIcon>;
  /** The ID of the custom event. */
  id: Scalars['ID'];
};

/** A custom field represents data about a component. */
export type CompassCustomField = {
  definition?: Maybe<CompassCustomFieldDefinition>;
};

/** The schema of a custom field. */
export type CompassCustomFieldDefinition = {
  /** The component types the field applies to. */
  componentTypes?: Maybe<Array<CompassComponentType>>;
  /** The description of the field. */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier (ID) of the field definition. */
  id: Scalars['ID'];
  /** The name of the field. */
  name?: Maybe<Scalars['String']>;
};

export type CompassCustomNumberField = CompassCustomField & {
  __typename: 'CompassCustomNumberField';
  /** The definition of the field. */
  definition?: Maybe<CompassCustomNumberFieldDefinition>;
  /** The value of the field. */
  numberValue?: Maybe<Scalars['Float']>;
};

/** The schema of a custom number field. */
export type CompassCustomNumberFieldDefinition = CompassCustomFieldDefinition & Node & {
  __typename: 'CompassCustomNumberFieldDefinition';
  /** The component types the field applies to. */
  componentTypes?: Maybe<Array<CompassComponentType>>;
  /** The description of the field. */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier (ID) of the field definition. */
  id: Scalars['ID'];
  /** The name of the field. */
  name?: Maybe<Scalars['String']>;
};

export type CompassCustomTextField = CompassCustomField & {
  __typename: 'CompassCustomTextField';
  /** The definition of the field. */
  definition?: Maybe<CompassCustomTextFieldDefinition>;
  /** The value of the field. */
  textValue?: Maybe<Scalars['String']>;
};

/** The schema of a custom text field. */
export type CompassCustomTextFieldDefinition = CompassCustomFieldDefinition & Node & {
  __typename: 'CompassCustomTextFieldDefinition';
  /** The component types the field applies to. */
  componentTypes?: Maybe<Array<CompassComponentType>>;
  /** The description of the field. */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier (ID) of the field definition. */
  id: Scalars['ID'];
  /** The name of the field. */
  name?: Maybe<Scalars['String']>;
};

export type CompassDeploymentEvent = CompassEvent & {
  __typename: 'CompassDeploymentEvent';
  /** Deployment Properties */
  deploymentProperties: CompassDeploymentEventProperties;
  /**
   * The sequence number for the deployment.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use the properties in deploymentEventProperties instead
   */
  deploymentSequenceNumber?: Maybe<Scalars['Long']>;
  /** The description of the deployment event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the deployment event. */
  displayName: Scalars['String'];
  /**
   * The environment where the deployment event has occurred.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use the properties in deploymentEventProperties instead
   */
  environment?: Maybe<CompassDeploymentEventEnvironment>;
  /** The type of the event. */
  eventType: CompassEventType;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /**
   * The deployment event pipeline.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use the properties in deploymentEventProperties instead
   */
  pipeline?: Maybe<CompassDeploymentEventPipeline>;
  /**
   * The state of the deployment.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use the properties in deploymentEventProperties instead
   */
  state?: Maybe<CompassDeploymentEventState>;
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the deployment event. */
  url?: Maybe<Scalars['URL']>;
};

export type CompassDeploymentEventEnvironment = {
  __typename: 'CompassDeploymentEventEnvironment';
  /** The type of environment where the deployment event occurred. */
  category?: Maybe<CompassDeploymentEventEnvironmentCategory>;
  /** The display name of the environment where the deployment event occurred. */
  displayName?: Maybe<Scalars['String']>;
  /** The ID of the environment where the deployment event occurred. */
  environmentId?: Maybe<Scalars['String']>;
};

export const CompassDeploymentEventEnvironmentCategory = {
  Development: 'DEVELOPMENT',
  Production: 'PRODUCTION',
  Staging: 'STAGING',
  Testing: 'TESTING',
  Unmapped: 'UNMAPPED'
} as const;

export type CompassDeploymentEventEnvironmentCategory = typeof CompassDeploymentEventEnvironmentCategory[keyof typeof CompassDeploymentEventEnvironmentCategory];
export type CompassDeploymentEventPipeline = {
  __typename: 'CompassDeploymentEventPipeline';
  /** The name of the deployment event pipeline. */
  displayName?: Maybe<Scalars['String']>;
  /** The ID of the deployment event pipeline. */
  pipelineId?: Maybe<Scalars['String']>;
  /** The URL of the deployment event pipeline. */
  url?: Maybe<Scalars['String']>;
};

export type CompassDeploymentEventProperties = {
  __typename: 'CompassDeploymentEventProperties';
  /** The environment where the deployment event has occurred. */
  environment?: Maybe<CompassDeploymentEventEnvironment>;
  /** The deployment event pipeline. */
  pipeline?: Maybe<CompassDeploymentEventPipeline>;
  /** The sequence number for the deployment. */
  sequenceNumber?: Maybe<Scalars['Long']>;
  /** The state of the deployment. */
  state?: Maybe<CompassDeploymentEventState>;
};

/** Compass Deployment Event */
export const CompassDeploymentEventState = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  InProgress: 'IN_PROGRESS',
  Pending: 'PENDING',
  RolledBack: 'ROLLED_BACK',
  Successful: 'SUCCESSFUL',
  Unknown: 'UNKNOWN'
} as const;

export type CompassDeploymentEventState = typeof CompassDeploymentEventState[keyof typeof CompassDeploymentEventState];
export type CompassEnumField = CompassField & {
  __typename: 'CompassEnumField';
  /** The definition of the field. */
  definition?: Maybe<CompassFieldDefinition>;
  /** The value of the field. */
  value?: Maybe<Array<Scalars['String']>>;
};

export type CompassEnumFieldDefinitionOptions = {
  __typename: 'CompassEnumFieldDefinitionOptions';
  /** The default option for field definition. If null, the field is not required. */
  default?: Maybe<Array<Scalars['String']>>;
  /** Possible values of the field definition. */
  values?: Maybe<Array<Scalars['String']>>;
};

export type CompassEvent = {
  /** The description of the event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the event. */
  url?: Maybe<Scalars['URL']>;
};

export type CompassEventConnection = {
  __typename: 'CompassEventConnection';
  edges?: Maybe<Array<Maybe<CompassEventEdge>>>;
  nodes?: Maybe<Array<CompassEvent>>;
  pageInfo: PageInfo;
};

export type CompassEventEdge = {
  __typename: 'CompassEventEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompassEvent>;
};

export type CompassEventTimeParameters = {
  /** The time to end querying for event data. */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** The time to begin querying for event data. */
  startFrom?: InputMaybe<Scalars['DateTime']>;
};

export const CompassEventType = {
  Alert: 'ALERT',
  Build: 'BUILD',
  Custom: 'CUSTOM',
  Deployment: 'DEPLOYMENT',
  Flag: 'FLAG',
  Incident: 'INCIDENT',
  Lifecycle: 'LIFECYCLE'
} as const;

export type CompassEventType = typeof CompassEventType[keyof typeof CompassEventType];
export type CompassEventsInEventSourceQuery = {
  /** Returns the events after the specified cursor position. */
  after?: InputMaybe<Scalars['String']>;
  /** The first N number of events to return in the query. */
  first?: InputMaybe<Scalars['Int']>;
  /** Returns the events after that match the CompassEventTimeParameters. */
  timeParameters?: InputMaybe<CompassEventTimeParameters>;
};

export type CompassEventsQuery = {
  /** Returns the events after the specified cursor position. */
  after?: InputMaybe<Scalars['String']>;
  /** The list of event types. */
  eventTypes?: InputMaybe<Array<CompassEventType>>;
  /** The first N number of events to return in the query. */
  first?: InputMaybe<Scalars['Int']>;
  /** Returns the events after that match the CompassEventTimeParameters. */
  timeParameters?: InputMaybe<CompassEventTimeParameters>;
};

export type CompassEventsQueryResult = CompassEventConnection | QueryError;

/** An alias of the component in an external system. */
export type CompassExternalAlias = {
  __typename: 'CompassExternalAlias';
  /** The ID of the component in an external system. */
  externalAliasId: Scalars['ID'];
  /** The external system hosting the component. */
  externalSource?: Maybe<Scalars['ID']>;
};

/** A field represents data about a component. */
export type CompassField = {
  /** The definition of the field. */
  definition?: Maybe<CompassFieldDefinition>;
};

/** The schema of a field. */
export type CompassFieldDefinition = {
  __typename: 'CompassFieldDefinition';
  /** The description of the field. */
  description: Scalars['String'];
  /** The unique identifier (ID) of the field definition. */
  id: Scalars['ID'];
  /** The name of the field. */
  name: Scalars['String'];
  /** The options for the field definition. */
  options: CompassFieldDefinitionOptions;
  /** The type of field. */
  type: CompassFieldType;
};

export type CompassFieldDefinitionOptions = CompassEnumFieldDefinitionOptions;

/** Specifies the type of value for a field. */
export const CompassFieldType = {
  Date: 'DATE',
  Enum: 'ENUM',
  Number: 'NUMBER',
  Text: 'TEXT'
} as const;

export type CompassFieldType = typeof CompassFieldType[keyof typeof CompassFieldType];
export type CompassFlagEvent = CompassEvent & {
  __typename: 'CompassFlagEvent';
  /** The description of the event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** Flag Properties */
  flagProperties: CompassFlagEventProperties;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the event. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * ###################################################################################################################
 *  COMPASS FLAG EVENT
 * ###################################################################################################################
 */
export type CompassFlagEventProperties = {
  __typename: 'CompassFlagEventProperties';
  /** The ID of the flag. */
  id: Scalars['ID'];
  /** Status of the flag */
  status?: Maybe<Scalars['String']>;
};

/** The configuration for a scorecard criterion representing the presence of a description. */
export type CompassHasDescriptionScorecardCriteria = CompassScorecardCriteria & {
  __typename: 'CompassHasDescriptionScorecardCriteria';
  id: Scalars['ID'];
  /** Returns the calculated score for a given component */
  scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
  weight: Scalars['Int'];
};


/** The configuration for a scorecard criterion representing the presence of a description. */
export type CompassHasDescriptionScorecardCriteriaScorecardCriteriaScoreArgs = {
  query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */
export type CompassHasFieldScorecardCriteria = CompassScorecardCriteria & {
  __typename: 'CompassHasFieldScorecardCriteria';
  /** The target of a relationship, for example, 'Owner' if 'Has Owner'. */
  fieldDefinition: CompassFieldDefinition;
  /** The ID of the scorecard criterion. */
  id: Scalars['ID'];
  /** Returns the calculated score for a component. */
  scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
  /** The weight that will be used in determining the aggregate score. */
  weight: Scalars['Int'];
};


/** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */
export type CompassHasFieldScorecardCriteriaScorecardCriteriaScoreArgs = {
  query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */
export type CompassHasLinkScorecardCriteria = CompassScorecardCriteria & {
  __typename: 'CompassHasLinkScorecardCriteria';
  /** The ID of the scorecard criterion. */
  id: Scalars['ID'];
  /** The type of link, for example 'Repository' if 'Has Repository'. */
  linkType: CompassLinkType;
  /** Returns the calculated score for a component. */
  scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
  /** The weight that will be used in determining the aggregate score. */
  weight: Scalars['Int'];
};


/** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */
export type CompassHasLinkScorecardCriteriaScorecardCriteriaScoreArgs = {
  query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a scorecard criterion checking the value of a specified metric name. */
export type CompassHasMetricValueScorecardCriteria = CompassScorecardCriteria & {
  __typename: 'CompassHasMetricValueScorecardCriteria';
  /** The comparison operation to be performed between the metric and comparator value. */
  comparator: CompassCriteriaNumberComparatorOptions;
  /** The threshold value that the metric is compared to. */
  comparatorValue: Scalars['Float'];
  /** The ID of the scorecard criterion. */
  id: Scalars['ID'];
  /** Returns the metric definition this criteria uses. */
  metricDefinition?: Maybe<CompassMetricDefinition>;
  /** The ID of the component metric to check the value of. */
  metricDefinitionId: Scalars['ID'];
  /** Returns the calculated score for a component. */
  scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
  /** The weight that will be used in determining the aggregate score. */
  weight: Scalars['Int'];
};


/** The configuration for a scorecard criterion checking the value of a specified metric name. */
export type CompassHasMetricValueScorecardCriteriaScorecardCriteriaScoreArgs = {
  query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** Configuration for a scorecard criteria representing the presence of an owner */
export type CompassHasOwnerScorecardCriteria = CompassScorecardCriteria & {
  __typename: 'CompassHasOwnerScorecardCriteria';
  /** The ID of the scorecard criterion. */
  id: Scalars['ID'];
  /** Returns the calculated score for a component. */
  scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
  /** The weight that will be used in determining the aggregate score. */
  weight: Scalars['Int'];
};


/** Configuration for a scorecard criteria representing the presence of an owner */
export type CompassHasOwnerScorecardCriteriaScorecardCriteriaScoreArgs = {
  query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

export type CompassIncidentEvent = CompassEvent & {
  __typename: 'CompassIncidentEvent';
  /** The description of the event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** Incident Properties */
  incidentProperties: CompassIncidentEventProperties;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the event. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * ###################################################################################################################
 *  COMPASS INCIDENT EVENT
 * ###################################################################################################################
 */
export type CompassIncidentEventProperties = {
  __typename: 'CompassIncidentEventProperties';
  /** The ID of the incident. */
  id: Scalars['ID'];
  /** The state of the incident. */
  state?: Maybe<CompassIncidentEventState>;
};

export const CompassIncidentEventState = {
  Closed: 'CLOSED',
  Deleted: 'DELETED',
  Open: 'OPEN',
  Resolved: 'RESOLVED'
} as const;

export type CompassIncidentEventState = typeof CompassIncidentEventState[keyof typeof CompassIncidentEventState];
export type CompassLifecycleEvent = CompassEvent & {
  __typename: 'CompassLifecycleEvent';
  /** The description of the event. */
  description?: Maybe<Scalars['String']>;
  /** The name of the event. */
  displayName: Scalars['String'];
  /** The type of the event. */
  eventType: CompassEventType;
  /** The last time this event was updated. */
  lastUpdated: Scalars['DateTime'];
  /** The lifecycle properties. */
  lifecycleProperties: CompassLifecycleEventProperties;
  /** A number specifying the order of the update to the event. */
  updateSequenceNumber: Scalars['Long'];
  /** The URL of the event. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * ###################################################################################################################
 *  COMPASS LIFECYCLE EVENT
 * ###################################################################################################################
 */
export type CompassLifecycleEventProperties = {
  __typename: 'CompassLifecycleEventProperties';
  /** The ID of the lifecycle. */
  id: Scalars['ID'];
  /** The stage of the lifecycle event. */
  stage?: Maybe<CompassLifecycleEventStage>;
};

export const CompassLifecycleEventStage = {
  Deprecation: 'DEPRECATION',
  EndOfLife: 'END_OF_LIFE',
  PreRelease: 'PRE_RELEASE',
  Production: 'PRODUCTION'
} as const;

export type CompassLifecycleEventStage = typeof CompassLifecycleEventStage[keyof typeof CompassLifecycleEventStage];
/** A link to an entity or resource on the internet. */
export type CompassLink = {
  __typename: 'CompassLink';
  /** The unique identifier (ID) of the link. */
  id: Scalars['ID'];
  /** An user-provided name of the link. */
  name?: Maybe<Scalars['String']>;
  /** The type of link. */
  type: CompassLinkType;
  /** An URL to the entity or resource on the internet. */
  url: Scalars['URL'];
};

/** The types used to identify the intent of the link. */
export const CompassLinkType = {
  /** Chat Channels for contacting the owners/support of the component */
  ChatChannel: 'CHAT_CHANNEL',
  /** A link to the dashboard of the component. */
  Dashboard: 'DASHBOARD',
  /** A link to the documentation of the component. */
  Document: 'DOCUMENT',
  /** A link to the on-call schedule of the component. */
  OnCall: 'ON_CALL',
  /** Other link for a Component. */
  OtherLink: 'OTHER_LINK',
  /** A link to the Jira or third-party project of the component. */
  Project: 'PROJECT',
  /** A link to the source code repository of the component. */
  Repository: 'REPOSITORY'
} as const;

export type CompassLinkType = typeof CompassLinkType[keyof typeof CompassLinkType];
/** A metric definition defines a metric across multiple components. */
export type CompassMetricDefinition = {
  __typename: 'CompassMetricDefinition';
  /** The description of the metric definition. */
  description?: Maybe<Scalars['String']>;
  /** The format option for applying to the display of metric values. */
  format?: Maybe<CompassMetricDefinitionFormat>;
  /** The unique identifier (ID) of the metric definition. */
  id: Scalars['ID'];
  /** A collection of metrics which contain values that provide numerical data. */
  metricSources?: Maybe<CompassMetricSourcesQueryResult>;
  /** The name of the metric definition. */
  name?: Maybe<Scalars['String']>;
  /** The type of the metric definition based on where the definition originated */
  type: CompassMetricDefinitionType;
};


/** A metric definition defines a metric across multiple components. */
export type CompassMetricDefinitionMetricSourcesArgs = {
  query?: InputMaybe<CompassMetricSourcesQuery>;
};

export type CompassMetricDefinitionFormat = CompassMetricDefinitionFormatSuffix;

/** The format option to append a plain-text suffix to metric values. */
export type CompassMetricDefinitionFormatSuffix = {
  __typename: 'CompassMetricDefinitionFormatSuffix';
  /** A plain-text suffix appended to the metric value when displayed, for example, 'MB/s'. */
  suffix?: Maybe<Scalars['String']>;
};

/** Used to identify the type for the metric */
export const CompassMetricDefinitionType = {
  /** Predefined metrics built in to Compass */
  BuiltIn: 'BUILT_IN',
  /** Metrics defined by the individual user */
  Custom: 'CUSTOM'
} as const;

export type CompassMetricDefinitionType = typeof CompassMetricDefinitionType[keyof typeof CompassMetricDefinitionType];
/** A metric source contains values that provide numerical data about the component. */
export type CompassMetricSource = {
  __typename: 'CompassMetricSource';
  /** Compass component associated with this metric source. */
  component?: Maybe<CompassComponent>;
  /** The unique identifier (ID) of the metric source that is external to the Compass site, for example, a Bitbucket repository ID. */
  externalMetricSourceId?: Maybe<Scalars['ID']>;
  /** The unique identifier (ID) of the metric source on the Compass site. */
  id: Scalars['ID'];
  /** The metric definition that defines the metric source. */
  metricDefinition?: Maybe<CompassMetricDefinition>;
  /** The URL of the metric source. */
  url?: Maybe<Scalars['String']>;
  /** A collection of values which store historical data points about the component. */
  values?: Maybe<CompassMetricSourceValuesQueryResult>;
};


/** A metric source contains values that provide numerical data about the component. */
export type CompassMetricSourceValuesArgs = {
  query?: InputMaybe<CompassMetricSourceValuesQuery>;
};

/** An edge that contains a metric source and a cursor. */
export type CompassMetricSourceEdge = {
  __typename: 'CompassMetricSourceEdge';
  /** The cursor of the metric source. */
  cursor: Scalars['String'];
  /** The metric source. */
  node?: Maybe<CompassMetricSource>;
};

/** A connection that returns a paginated collection of metric values. */
export type CompassMetricSourceValuesConnection = {
  __typename: 'CompassMetricSourceValuesConnection';
  /** A list of edges which contain a metric values and a cursor. */
  edges?: Maybe<Array<CompassMetricValueEdge>>;
  /** A list of metric values. */
  nodes?: Maybe<Array<CompassMetricValue>>;
  /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
  pageInfo: PageInfo;
};

/** The query to get the metric values from a component's metric source. */
export type CompassMetricSourceValuesQuery = {
  /** Returns the values after the specified cursor position. */
  after?: InputMaybe<Scalars['String']>;
  /** The number of results to return in the query. The default is 10. */
  first?: InputMaybe<Scalars['Int']>;
};

export type CompassMetricSourceValuesQueryResult = CompassMetricSourceValuesConnection | QueryError;

export type CompassMetricSourcesConnection = {
  __typename: 'CompassMetricSourcesConnection';
  edges?: Maybe<Array<CompassMetricSourceEdge>>;
  nodes?: Maybe<Array<CompassMetricSource>>;
  pageInfo: PageInfo;
};

export type CompassMetricSourcesQuery = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CompassMetricSourcesQueryResult = CompassMetricSourcesConnection | QueryError;

/** A metric value stores the numerical data relating to the component. */
export type CompassMetricValue = {
  __typename: 'CompassMetricValue';
  /** The time the metric value was collected. */
  timestamp?: Maybe<Scalars['DateTime']>;
  /** The value of the metric. */
  value?: Maybe<Scalars['Float']>;
};

/** An edge that contains a metric value and a cursor. */
export type CompassMetricValueEdge = {
  __typename: 'CompassMetricValueEdge';
  /** The cursor of the metric value. */
  cursor: Scalars['String'];
  /** The metric value. */
  node?: Maybe<CompassMetricValue>;
};

/** A relationship between two components. */
export type CompassRelationship = {
  __typename: 'CompassRelationship';
  changeMetadata?: Maybe<CompassChangeMetadata>;
  /**
   * The ending node of the relationship.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:component:compass__
   */
  endNode?: Maybe<CompassComponent>;
  /**
   * The starting node of the relationship.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __read:component:compass__
   */
  startNode?: Maybe<CompassComponent>;
  /** The type of relationship. */
  type: CompassRelationshipType;
};

export type CompassRelationshipConnection = {
  __typename: 'CompassRelationshipConnection';
  edges?: Maybe<Array<CompassRelationshipEdge>>;
  nodes?: Maybe<Array<CompassRelationship>>;
  pageInfo: PageInfo;
};

export type CompassRelationshipConnectionResult = CompassRelationshipConnection | QueryError;

/** Defines the possible relationship directions between components. */
export const CompassRelationshipDirection = {
  /** Going from the other component to this component. */
  Inward: 'INWARD',
  /** Going from this component to the other component. */
  Outward: 'OUTWARD'
} as const;

export type CompassRelationshipDirection = typeof CompassRelationshipDirection[keyof typeof CompassRelationshipDirection];
export type CompassRelationshipEdge = {
  __typename: 'CompassRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompassRelationship>;
};

/** Accepts input for finding component relationships. */
export type CompassRelationshipQuery = {
  /** The relationships to be returned after the specified cursor position. */
  after?: InputMaybe<Scalars['String']>;
  /** The direction of relationships to be searched for. */
  direction?: CompassRelationshipDirection;
  /** The filters for the relationships to be searched for. */
  filters?: InputMaybe<CompassRelationshipQueryFilters>;
  /** The number of relationships to return in the query. */
  first?: InputMaybe<Scalars['Int']>;
};

export type CompassRelationshipQueryFilters = {
  /** OR'd set of relationship types. */
  types?: InputMaybe<Array<CompassRelationshipType>>;
};

/** Defines the relationship types. A relationship must be one of these types. */
export const CompassRelationshipType = {
  DependsOn: 'DEPENDS_ON'
} as const;

export type CompassRelationshipType = typeof CompassRelationshipType[keyof typeof CompassRelationshipType];
/** The configuration for a scorecard that can be used by components. */
export type CompassScorecard = Node & {
  __typename: 'CompassScorecard';
  /** Returns a list of components to which this scorecard is applied. */
  appliedToComponents?: Maybe<CompassScorecardAppliedToComponentsQueryResult>;
  /** Contains change metadata for the scorecard. */
  changeMetadata: CompassChangeMetadata;
  /** A collection of component labels used to filter what components the scorecard applies to. */
  componentLabels?: Maybe<Array<CompassComponentLabel>>;
  /** The type of component to which this scorecard is restricted. */
  componentType: CompassComponentType;
  /** The criteria used for calculating the score. */
  criterias?: Maybe<Array<CompassScorecardCriteria>>;
  /** The description of the scorecard. */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier (ID) of the scorecard. */
  id: Scalars['ID'];
  /** Determines how the scorecard will be applied by default. */
  importance: CompassScorecardImportance;
  /** The name of the scorecard. */
  name: Scalars['String'];
  /** The unique identifier (ID) of the scorecard's owner. */
  owner?: Maybe<User>;
  /** Returns the calculated total score for a given component. */
  scorecardScore?: Maybe<CompassScorecardScore>;
};


/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardAppliedToComponentsArgs = {
  query?: InputMaybe<CompassScorecardAppliedToComponentsQuery>;
};


/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardScorecardScoreArgs = {
  query?: InputMaybe<CompassScorecardScoreQuery>;
};

export type CompassScorecardAppliedToComponentsConnection = {
  __typename: 'CompassScorecardAppliedToComponentsConnection';
  edges?: Maybe<Array<CompassScorecardAppliedToComponentsEdge>>;
  nodes?: Maybe<Array<CompassComponent>>;
  pageInfo: PageInfo;
};

export type CompassScorecardAppliedToComponentsEdge = {
  __typename: 'CompassScorecardAppliedToComponentsEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompassComponent>;
};

/** Accepts input to find components a scorecard is applied to and their scores */
export type CompassScorecardAppliedToComponentsQuery = {
  /** Returns the components after the specified cursor position. */
  after?: InputMaybe<Scalars['String']>;
  /** Returns only components whose attributes match those in the filters specified */
  filter?: InputMaybe<CompassScorecardAppliedToComponentsQueryFilter>;
  /** The first N number of components to return in the query. */
  first?: InputMaybe<Scalars['Int']>;
};

export type CompassScorecardAppliedToComponentsQueryFilter = {
  score: CompassScorecardAppliedToComponentsThresholdFilter;
};

export type CompassScorecardAppliedToComponentsQueryResult = CompassScorecardAppliedToComponentsConnection | QueryError;

export type CompassScorecardAppliedToComponentsThresholdFilter = {
  lt: Scalars['Int'];
};

/** The configuration for a scorecard criterion that can be shared across components. */
export type CompassScorecardCriteria = {
  /** The ID of the scorecard criterion. */
  id: Scalars['ID'];
  /** Returns the calculated score for a component. */
  scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
  /** The weight that will be used in determining the aggregate score. */
  weight: Scalars['Int'];
};


/** The configuration for a scorecard criterion that can be shared across components. */
export type CompassScorecardCriteriaScorecardCriteriaScoreArgs = {
  query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** Contains the calculated score for each scorecard criteria that is associated with a specific component. */
export type CompassScorecardCriteriaScore = {
  __typename: 'CompassScorecardCriteriaScore';
  /** The maximum score value for the criterion. The value is used in calculating the aggregate score as a percentage. */
  maxScore: Scalars['Int'];
  /** The calculated score value for the criterion. */
  score: Scalars['Int'];
};

export type CompassScorecardCriteriaScoreQuery = {
  /** The unique identifier (ID) of the component. */
  componentId: Scalars['ID'];
};

/** The types used to identify the importance of the scorecard. */
export const CompassScorecardImportance = {
  /** Recommended to the component's owner when they select a scorecard to apply to their component. */
  Recommended: 'RECOMMENDED',
  /** Automatically applied to all components of the specified type or types and cannot be removed. */
  Required: 'REQUIRED',
  /** Custom scorecard, focused on specific use cases within teams or departments. */
  UserDefined: 'USER_DEFINED'
} as const;

export type CompassScorecardImportance = typeof CompassScorecardImportance[keyof typeof CompassScorecardImportance];
/** Contains the calculated score for a component. Each component has one calculated score per scorecard. */
export type CompassScorecardScore = {
  __typename: 'CompassScorecardScore';
  /** Returns the scores for individual criterion. */
  criteriaScores?: Maybe<Array<CompassScorecardCriteriaScore>>;
  /** The maximum possible total score value. */
  maxTotalScore: Scalars['Int'];
  /** The total calculated score value. */
  totalScore: Scalars['Int'];
};

/** Scorecard score on a scorecard for a component. */
export type CompassScorecardScoreQuery = {
  /** The unique identifier (ID) of the component. */
  componentId: Scalars['ID'];
};

/** Event data corresponding to a dataManager updating a component. */
export type ComponentSyncEvent = {
  __typename: 'ComponentSyncEvent';
  /** Error messages explaining why the last sync event may have failed. */
  lastSyncErrors?: Maybe<Array<Scalars['String']>>;
  /** Status of the last sync event. */
  status: ComponentSyncEventStatus;
  /** Timestamp when the last sync event occurred. */
  time: Scalars['DateTime'];
};

/** Status types of a data manager sync event. */
export const ComponentSyncEventStatus = {
  /** A Compass internal server issue prevented the sync from occurring. */
  ServerError: 'SERVER_ERROR',
  /** The component updates were successfully synced to Compass. */
  Success: 'SUCCESS',
  /** An issue with the calling app or user input prevented the component from syncing to Compass. */
  UserError: 'USER_ERROR'
} as const;

export type ComponentSyncEventStatus = typeof ComponentSyncEventStatus[keyof typeof ComponentSyncEventStatus];
/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 */
export type ConfluenceBlogPost = {
  __typename: 'ConfluenceBlogPost';
  /** Content ID of the BlogPost. */
  blogPostId: Scalars['ID'];
  /** ARI of the BlogPost, ConfluencePageARI format. */
  id: Scalars['ID'];
  /** Links associated with the BlogPost. */
  links?: Maybe<ConfluenceBlogPostLinks>;
  /** Metadata of the BlogPost. */
  metadata?: Maybe<ConfluenceContentMetadata>;
  /** Space that contains the BlogPost. */
  space?: Maybe<ConfluenceSpace>;
  /** Content status of the BlogPost. */
  status?: Maybe<ConfluenceBlogPostStatus>;
  /** Title of the BlogPost. */
  title?: Maybe<Scalars['String']>;
  /** Content type of the page. Will always be \"BLOG_POST\". */
  type?: Maybe<ConfluenceContentType>;
};

export type ConfluenceBlogPostLinks = {
  __typename: 'ConfluenceBlogPostLinks';
  /** The base URL of the site. */
  base?: Maybe<Scalars['String']>;
  /** The web UI URL associated with the BlogPost. */
  webUi?: Maybe<Scalars['String']>;
};

export const ConfluenceBlogPostStatus = {
  Archived: 'ARCHIVED',
  Current: 'CURRENT',
  Deleted: 'DELETED',
  Draft: 'DRAFT',
  Historical: 'HISTORICAL',
  Trashed: 'TRASHED'
} as const;

export type ConfluenceBlogPostStatus = typeof ConfluenceBlogPostStatus[keyof typeof ConfluenceBlogPostStatus];
/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 */
export type ConfluenceComment = {
  __typename: 'ConfluenceComment';
  /** UserInfo of the author of the Comment. */
  author?: Maybe<ConfluenceUserInfo>;
  /** Content ID of the Comment. */
  commentId?: Maybe<Scalars['ID']>;
  /** Entity that contains Comment. */
  container?: Maybe<ConfluenceCommentContainer>;
  /** ARI of the Comment, ConfluenceCommentARI format. */
  id: Scalars['ID'];
  /** Links associated with the Comment. */
  links?: Maybe<ConfluenceCommentLinks>;
  /** Title of the Comment. */
  name?: Maybe<Scalars['String']>;
  /** Status of the Comment. */
  status?: Maybe<ConfluenceCommentStatus>;
};

export type ConfluenceCommentContainer = ConfluenceBlogPost | ConfluencePage;

export type ConfluenceCommentLinks = {
  __typename: 'ConfluenceCommentLinks';
  /** The base URL of the site. */
  base?: Maybe<Scalars['String']>;
  /** The web UI URL associated with the Comment. */
  webUi?: Maybe<Scalars['String']>;
};

export const ConfluenceCommentStatus = {
  Current: 'CURRENT',
  Draft: 'DRAFT'
} as const;

export type ConfluenceCommentStatus = typeof ConfluenceCommentStatus[keyof typeof ConfluenceCommentStatus];
export type ConfluenceContentMetadata = {
  __typename: 'ConfluenceContentMetadata';
  /** Emoji metadata associated with draft Content. */
  titleEmojiDraft?: Maybe<ConfluenceContentTitleEmoji>;
  /** Emoji metadata associated with published Content. */
  titleEmojiPublished?: Maybe<ConfluenceContentTitleEmoji>;
};

export type ConfluenceContentTitleEmoji = {
  __typename: 'ConfluenceContentTitleEmoji';
  /** It is ID of the emoji property. */
  id?: Maybe<Scalars['String']>;
  /** It is Key of the emoji property. */
  key?: Maybe<Scalars['String']>;
  /** It is Value of the emoji property. */
  value?: Maybe<Scalars['String']>;
};

export const ConfluenceContentType = {
  Attachment: 'ATTACHMENT',
  BlogPost: 'BLOG_POST',
  Comment: 'COMMENT',
  Page: 'PAGE'
} as const;

export type ConfluenceContentType = typeof ConfluenceContentType[keyof typeof ConfluenceContentType];
/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:label:confluence__
 */
export type ConfluenceLabel = {
  __typename: 'ConfluenceLabel';
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

export type ConfluenceOperationCheck = {
  __typename: 'ConfluenceOperationCheck';
  operation?: Maybe<ConfluenceOperationName>;
  target?: Maybe<ConfluenceOperationTarget>;
};

export const ConfluenceOperationName = {
  Administer: 'ADMINISTER',
  Archive: 'ARCHIVE',
  Copy: 'COPY',
  Create: 'CREATE',
  CreateSpace: 'CREATE_SPACE',
  Delete: 'DELETE',
  Export: 'EXPORT',
  Move: 'MOVE',
  Purge: 'PURGE',
  PurgeVersion: 'PURGE_VERSION',
  Read: 'READ',
  Restore: 'RESTORE',
  RestrictContent: 'RESTRICT_CONTENT',
  Update: 'UPDATE',
  Use: 'USE'
} as const;

export type ConfluenceOperationName = typeof ConfluenceOperationName[keyof typeof ConfluenceOperationName];
export const ConfluenceOperationTarget = {
  Application: 'APPLICATION',
  Attachment: 'ATTACHMENT',
  BlogPost: 'BLOG_POST',
  Comment: 'COMMENT',
  Page: 'PAGE',
  Space: 'SPACE',
  UserProfile: 'USER_PROFILE'
} as const;

export type ConfluenceOperationTarget = typeof ConfluenceOperationTarget[keyof typeof ConfluenceOperationTarget];
/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 */
export type ConfluencePage = {
  __typename: 'ConfluencePage';
  /** ARI of the Page, ConfluencePageARI format. */
  id: Scalars['ID'];
  /** Links associated with the Page. */
  links?: Maybe<ConfluencePageLinks>;
  /** Metadata of the Page. */
  metadata?: Maybe<ConfluenceContentMetadata>;
  /** Content ID of the Page. */
  pageId: Scalars['ID'];
  /** Space that contains the Page. */
  space?: Maybe<ConfluenceSpace>;
  /** Content status of the Page. */
  status?: Maybe<ConfluencePageStatus>;
  /** Title of the Page. */
  title?: Maybe<Scalars['String']>;
  /** Content type of the page. Will always be \"PAGE\". */
  type?: Maybe<ConfluenceContentType>;
};

export type ConfluencePageLinks = {
  __typename: 'ConfluencePageLinks';
  /** The base URL of the site. */
  base?: Maybe<Scalars['String']>;
  /** The web UI URL path associated with the Page. */
  webUi?: Maybe<Scalars['String']>;
};

export const ConfluencePageStatus = {
  Archived: 'ARCHIVED',
  Current: 'CURRENT',
  Deleted: 'DELETED',
  Draft: 'DRAFT',
  Historical: 'HISTORICAL',
  Trashed: 'TRASHED'
} as const;

export type ConfluencePageStatus = typeof ConfluencePageStatus[keyof typeof ConfluencePageStatus];
/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 */
export type ConfluenceSpace = {
  __typename: 'ConfluenceSpace';
  /** The creator of the Space. */
  createdBy?: Maybe<ConfluenceUserInfo>;
  /** The date on which Space was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** The description of the Space. */
  description?: Maybe<ConfluenceSpaceDescription>;
  /** The homepage of the Space. */
  homepage?: Maybe<ConfluencePage>;
  /** The icon associated with the Space. */
  icon?: Maybe<ConfluenceSpaceIcon>;
  /** The ARI of the Space, ConfluenceSpaceARI format. */
  id: Scalars['ID'];
  /** Key of the Space. */
  key?: Maybe<Scalars['String']>;
  /** Links associated with the Space. */
  links?: Maybe<ConfluenceSpaceLinks>;
  /** The metadata of the Space. */
  metadata?: Maybe<ConfluenceSpaceMetadata>;
  /** Name of the Space. */
  name?: Maybe<Scalars['String']>;
  /** The operations allowed on the Space. */
  operations?: Maybe<Array<Maybe<ConfluenceOperationCheck>>>;
  /** ID of the Space. */
  spaceId: Scalars['ID'];
  /** Status of the Space. */
  status?: Maybe<ConfluenceSpaceStatus>;
  /** Type of the Space. Can be \"GLOBAL\" or \"PERSONAL\". */
  type?: Maybe<ConfluenceSpaceType>;
};

export type ConfluenceSpaceDescription = {
  __typename: 'ConfluenceSpaceDescription';
  plain?: Maybe<Scalars['String']>;
  view?: Maybe<Scalars['String']>;
};

export type ConfluenceSpaceIcon = {
  __typename: 'ConfluenceSpaceIcon';
  height?: Maybe<Scalars['Int']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ConfluenceSpaceLinks = {
  __typename: 'ConfluenceSpaceLinks';
  /** The base URL of the site. */
  base?: Maybe<Scalars['String']>;
  /** The web UI URL associated with the Space. */
  webUi?: Maybe<Scalars['String']>;
};

export type ConfluenceSpaceMetadata = {
  __typename: 'ConfluenceSpaceMetadata';
  /** A collection of Labels on the Space. */
  labels?: Maybe<Array<Maybe<ConfluenceLabel>>>;
  /** A collection of the recent commenters within the Space. */
  recentCommenters?: Maybe<Array<Maybe<ConfluenceUserInfo>>>;
  /** A collection of the recent watchers of the Space. */
  recentWatchers?: Maybe<Array<Maybe<ConfluenceUserInfo>>>;
  /** The total number of commenters in the Space. */
  totalCommenters?: Maybe<Scalars['Int']>;
  /** The total number of current pages in the Space. */
  totalCurrentPages?: Maybe<Scalars['Int']>;
  /** The total number of watchers of the Space. */
  totalWatchers?: Maybe<Scalars['Int']>;
};

export const ConfluenceSpaceStatus = {
  Archived: 'ARCHIVED',
  Current: 'CURRENT'
} as const;

export type ConfluenceSpaceStatus = typeof ConfluenceSpaceStatus[keyof typeof ConfluenceSpaceStatus];
export const ConfluenceSpaceType = {
  Global: 'GLOBAL',
  Personal: 'PERSONAL'
} as const;

export type ConfluenceSpaceType = typeof ConfluenceSpaceType[keyof typeof ConfluenceSpaceType];
/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:user:confluence__
 */
export type ConfluenceUserInfo = {
  __typename: 'ConfluenceUserInfo';
  /** Personal space of the User. */
  personalSpace?: Maybe<ConfluenceSpace>;
  /** ARI of the User, IdentityUserARI format. */
  user?: Maybe<User>;
};

/** Configuration for creating a CustomField */
export type CreateCustomField_Display = {
  /** Whether the CustomField should be displayed on the card front */
  cardFront: Scalars['Boolean'];
};

export type CreateCustomField_Option = {
  /** The color of the CustomField option (can be 'none') */
  color: Scalars['String'];
  /** The value for the CustomField option */
  value: CreateCustomField_Option_Value;
};

export type CreateCustomField_Option_Value = {
  /** The text value for a CustomField option */
  text: Scalars['String'];
};

export type CreateDashboardViewTile = {
  from?: InputMaybe<CreateDashboardViewTile_From>;
  graph: CreateDashboardViewTile_Graph;
  pos: Scalars['Int'];
  type: Scalars['String'];
};

export type CreateDashboardViewTile_From = {
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

export type CreateDashboardViewTile_Graph = {
  type: Scalars['String'];
};

/** How an item was created */
export const CreationMethod = {
  /** Item was generated automatically, but with some member input. eg. Cards created through the onboarding flow */
  Assisted: 'assisted',
  /** Item was generated without the member input, eg. the ToDo board created for new users */
  Automatic: 'automatic',
  /** Item was created to demonstrate Trello features. eg. Cards on the welcome board */
  Demo: 'demo'
} as const;

export type CreationMethod = typeof CreationMethod[keyof typeof CreationMethod];
/** A Credit indicates a 'free reward' (typically free bc or gold membership) */
export type Credit = {
  __typename: 'Credit';
  /** Whether the credits have been applied */
  applied: Scalars['Boolean'];
  /** The count of credits */
  count: Scalars['Int'];
  /** The type of count */
  countType: Scalars['String'];
  /** The ID of the credit */
  id: Scalars['String'];
  /** The ID of the member that was invited to earn these credits */
  idMemberInvited?: Maybe<Scalars['String']>;
  /** The ID of the model these credits are for */
  idModel: Scalars['String'];
  /** The member that was invited to earn these credits */
  memberInvited?: Maybe<Member>;
  /** The type of entity these credits are for (Member or Organization) */
  modelType: Scalars['String'];
  /** The reward for the Credit (gold or bc) */
  reward?: Maybe<Credit_Reward>;
  /** The type of Credit this is */
  type: Credit_Type;
  /** A description of how the Credit was rewarded */
  via?: Maybe<Scalars['String']>;
};

/** A reward applicable to a Credit */
export const Credit_Reward = {
  Bc: 'bc',
  Gold: 'gold'
} as const;

export type Credit_Reward = typeof Credit_Reward[keyof typeof Credit_Reward];
/** The type of the Credit */
export const Credit_Type = {
  FreeTrial: 'freeTrial',
  Invitation: 'invitation',
  PromoCode: 'promoCode',
  Support: 'support'
} as const;

export type Credit_Type = typeof Credit_Type[keyof typeof Credit_Type];
/** Node for querying the Cumulative Flow Diagram report */
export type CumulativeFlowDiagram = {
  __typename: 'CumulativeFlowDiagram';
  chart: CfdChartConnection;
  filters: CfdFilters;
};


/** Node for querying the Cumulative Flow Diagram report */
export type CumulativeFlowDiagramChartArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CurrentEstimation = {
  __typename: 'CurrentEstimation';
  /** Custom field configured as the estimation type. Null when estimation feature is disabled. */
  customFieldId?: Maybe<Scalars['String']>;
  /** Name of the custom field. */
  name?: Maybe<Scalars['String']>;
};

/** Information about the current user. Different users will see different results. */
export type CurrentUser = {
  __typename: 'CurrentUser';
  /** List of permissions the *user making the request* has for this board. */
  permissions: Array<Maybe<Scalars['SoftwareBoardPermission']>>;
};

/** A configurable field that can be added to a Card, and optionally shown on the Card Front */
export type CustomField = {
  __typename: 'CustomField';
  /** The display options for the CustomField */
  display: CustomField_Display;
  /** The computed has of the name and type fields of this CustomField (sometimes used for grouping) */
  fieldGroup: Scalars['String'];
  /** The ID of the CustomField */
  id: Scalars['ID'];
  /** The ID of the model that the CustomField is configured for */
  idModel: Scalars['String'];
  /** Whether the custom field is a suggested field */
  isSuggestedField: Scalars['Boolean'];
  /** The type of the model that the CustomField is on (currently only Board) */
  modelType: Scalars['String'];
  /** The name of this Custom Field */
  name: Scalars['String'];
  /** The list of options available to a 'list' CustomField */
  options?: Maybe<Array<CustomField_Option>>;
  /** The position (on the Card back and Card front) of the CustomField relative to others */
  pos: Scalars['Int'];
  /** The type of CustomField this is */
  type: CustomField_Type;
};

/** An item representing a value for a particular CustomField on a Card */
export type CustomFieldItem = {
  __typename: 'CustomFieldItem';
  /** The ID of the CustomFieldItem */
  id: Scalars['ID'];
  /** The ID of the CustomField that this item holds a value for */
  idCustomField: Scalars['String'];
  /** The ID of the model this CustomFieldItem is on (the Card ID) */
  idModel: Scalars['String'];
  /** The id for the CustomField list option */
  idValue: Scalars['String'];
  /** The type of model this CustomFieldItem is on (only Cards are supported) */
  modelType: CustomFieldItem_ModelType;
  /** The value for this CustomFieldItem, the shape of this data depends on the type of CustomField this is for */
  value: Scalars['JSONString'];
};

/** The type of model a CustomFieldItem is on (only Cards are supported) */
export const CustomFieldItem_ModelType = {
  Card: 'card'
} as const;

export type CustomFieldItem_ModelType = typeof CustomFieldItem_ModelType[keyof typeof CustomFieldItem_ModelType];
/** Configuration for displaying a CustomField */
export type CustomField_Display = {
  __typename: 'CustomField_Display';
  /** Whether the CustomField should be displayed on the card front */
  cardFront: Scalars['Boolean'];
};

/** An option in the 'list' CustomField */
export type CustomField_Option = {
  __typename: 'CustomField_Option';
  /** The color of the CustomField option (can be 'none') */
  color: Scalars['String'];
  /** The ID of the CustomField option */
  id: Scalars['ID'];
  /** The ID of the CustomField this option belongs to */
  idCustomField: Scalars['String'];
  /** An integer indicating the position of the CustomField Option in its list */
  pos: Scalars['Int'];
  /** The value for the CustomField option */
  value: CustomField_Option_Value;
};

/** The value for a CustomField option */
export type CustomField_Option_Value = {
  __typename: 'CustomField_Option_Value';
  /** The text value for a CustomField option */
  text: Scalars['String'];
};

/** The type of a CustomField */
export const CustomField_Type = {
  Checkbox: 'checkbox',
  Date: 'date',
  List: 'list',
  Number: 'number',
  Text: 'text'
} as const;

export type CustomField_Type = typeof CustomField_Type[keyof typeof CustomField_Type];
export type CustomFilter = {
  __typename: 'CustomFilter';
  description?: Maybe<Scalars['String']>;
  filterQuery?: Maybe<FilterQuery>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * This represents a real person that has an free account within the Jira Service Desk product
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */
export type CustomerUser = LocalizationContext & User & {
  __typename: 'CustomerUser';
  accountId: Scalars['ID'];
  accountStatus: AccountStatus;
  canonicalAccountId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  picture: Scalars['URL'];
  zoneinfo?: Maybe<Scalars['String']>;
};

/**
 * This object models the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of multiple stages)
 * for getting software from version control right through to the production environment.
 */
export type DeploymentPipeline = {
  __typename: 'DeploymentPipeline';
  /** The name of the pipeline to present to the user. */
  displayName?: Maybe<Scalars['String']>;
  /** A URL users can use to link to this deployment pipeline. */
  url?: Maybe<Scalars['String']>;
};

/** The state that a code deployment can be in (think of a deployment in Bitbucket Pipelines, CircleCI, etc). */
export const DeploymentState = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  InProgress: 'IN_PROGRESS',
  Pending: 'PENDING',
  RolledBack: 'ROLLED_BACK',
  Successful: 'SUCCESSFUL',
  Unknown: 'UNKNOWN'
} as const;

export type DeploymentState = typeof DeploymentState[keyof typeof DeploymentState];
/**
 * This object models a deployment in the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of
 * multiple stages) for getting software from version control right through to the production environment.
 */
export type DeploymentSummary = Node & {
  __typename: 'DeploymentSummary';
  /**
   * This is the identifier for the deployment.
   *
   * It must be unique for the specified pipeline and environment. It must be a monotonically
   * increasing number, as this is used to sequence the deployments.
   */
  deploymentSequenceNumber?: Maybe<Scalars['Long']>;
  /** A short description of the deployment. */
  description?: Maybe<Scalars['String']>;
  /** The human-readable name for the deployment. Will be shown in the UI. */
  displayName?: Maybe<Scalars['String']>;
  /** The environment that the deployment is present in. */
  environment?: Maybe<DevOpsEnvironment>;
  id: Scalars['ID'];
  /**
   * IDs of the issues that are included in the deployment.
   *
   * At least one of the commits in the deployment must be associated with an issue for it
   * to appear here (meaning the issue key is mentioned in the commit message).
   */
  issueIds?: Maybe<Array<Scalars['ID']>>;
  /** The last-updated timestamp to present to the user as a summary of the state of the deployment. */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /**
   * This object models the Continuous Delivery (CD) Pipeline concept, an automated process
   * (usually comprised of multiple stages) for getting software from version control right through
   * to the production environment.
   */
  pipeline?: Maybe<DeploymentPipeline>;
  /**
   * This is the DevOps provider for the deployment.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: DevOpsProvider` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  provider?: Maybe<DevOpsProvider>;
  /**
   * Services associated with the deployment.
   *
   * At least one of the commits in the deployment must be associated with a service ID for it
   * to appear here.
   */
  serviceAssociations?: Maybe<Array<Maybe<DevOpsService>>>;
  /** The state of the deployment. */
  state?: Maybe<DeploymentState>;
  /**
   * A number used to apply an order to the updates to the deployment, as identified by the
   * `deploymentSequenceNumber`, in the case of out-of-order receipt of update requests.
   *
   * It must be a monotonically increasing number. For example, epoch time could be one
   * way to generate the `updateSequenceNumber`.
   */
  updateSequenceNumber?: Maybe<Scalars['Long']>;
  /** A URL users can use to link to this deployment, in this environment. */
  url?: Maybe<Scalars['String']>;
};

export type DevOpsAvatar = {
  __typename: 'DevOpsAvatar';
  /** The description of the avatar. */
  description?: Maybe<Scalars['String']>;
  /** The URL of the avatar. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * An environment that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */
export type DevOpsEnvironment = {
  __typename: 'DevOpsEnvironment';
  /** The type of the environment. */
  category?: Maybe<DevOpsEnvironmentCategory>;
  /** The name of the environment to present to the user. */
  displayName?: Maybe<Scalars['String']>;
};

/**
 * The types of environments that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */
export const DevOpsEnvironmentCategory = {
  Development: 'DEVELOPMENT',
  Production: 'PRODUCTION',
  Staging: 'STAGING',
  Testing: 'TESTING',
  Unmapped: 'UNMAPPED'
} as const;

export type DevOpsEnvironmentCategory = typeof DevOpsEnvironmentCategory[keyof typeof DevOpsEnvironmentCategory];
export const DevOpsJiraProjectType = {
  JiraCore: 'JIRA_CORE',
  JiraServicedesk: 'JIRA_SERVICEDESK',
  JiraSoftware: 'JIRA_SOFTWARE'
} as const;

export type DevOpsJiraProjectType = typeof DevOpsJiraProjectType[keyof typeof DevOpsJiraProjectType];
/** A provider that a deployment has been done with. */
export type DevOpsProvider = {
  __typename: 'DevOpsProvider';
  /** Links associated with the DevOpsProvider. Currently contains documentation, home and listDeploymentsTemplate URLs. */
  links?: Maybe<DevOpsProviderLinks>;
  /**
   * The logo to display for the Provider within the UI. This should be a 32x32 (or similar) favicon style image.
   * In the future this may be extended to support multi-resolution logos.
   */
  logo?: Maybe<Scalars['URL']>;
  /**
   * The display name to use for the Provider. May be rendered in the UI. Example: 'Github'.
   * In the future this may be extended to support an I18nString for localized names.
   */
  name?: Maybe<Scalars['String']>;
};

/** A type to group various URLs of Provider */
export type DevOpsProviderLinks = {
  __typename: 'DevOpsProviderLinks';
  /** Documentation URL of the provider */
  documentation?: Maybe<Scalars['URL']>;
  /** Home URL of the provider */
  home?: Maybe<Scalars['URL']>;
  /** List deployments URL for the provider */
  listDeploymentsTemplate?: Maybe<Scalars['URL']>;
};

export const DevOpsRelationshipCertainty = {
  /** The relationship was created by a user. */
  Explicit: 'EXPLICIT',
  /** The relationship was inferred by a system. */
  Implicit: 'IMPLICIT'
} as const;

export type DevOpsRelationshipCertainty = typeof DevOpsRelationshipCertainty[keyof typeof DevOpsRelationshipCertainty];
export const DevOpsRelationshipCertaintyFilter = {
  /** Return all relationships. */
  All: 'ALL',
  /** Return only relationships created by a user. */
  Explicit: 'EXPLICIT',
  /** Return only relationships inferred by a system. */
  Implicit: 'IMPLICIT'
} as const;

export type DevOpsRelationshipCertaintyFilter = typeof DevOpsRelationshipCertaintyFilter[keyof typeof DevOpsRelationshipCertaintyFilter];
export const DevOpsRepositoryHostingProviderFilter = {
  All: 'ALL',
  BitbucketCloud: 'BITBUCKET_CLOUD',
  ThirdParty: 'THIRD_PARTY'
} as const;

export type DevOpsRepositoryHostingProviderFilter = typeof DevOpsRepositoryHostingProviderFilter[keyof typeof DevOpsRepositoryHostingProviderFilter];
export type DevOpsService = Node & {
  __typename: 'DevOpsService';
  /**
   * Bitbucket repositories that are available to be linked with via createDevOpsServiceAndRepositoryRelationship
   * If nameFilter is provided, only repositories with names containing this case-insensitive string will be returned.
   * For case of creating a new service (that has not been created), consumer can use `bitbucketRepositoriesAvailableToLinkWithNewDevOpsService` query
   */
  bitbucketRepositoriesAvailableToLinkWith?: Maybe<BitbucketRepositoryIdConnection>;
  /** The cloud ID of the DevOps Service */
  cloudId: Scalars['String'];
  /** Relationship with a DevOps Service that contains this DevOps service */
  containedByDevOpsServiceRelationship?: Maybe<DevOpsServiceRelationship>;
  /** Relationships with DevOps Services that this DevOps Service contains */
  containsDevOpsServiceRelationships?: Maybe<DevOpsServiceRelationshipConnection>;
  /** The datetime when the DevOps Service was created */
  createdAt: Scalars['DateTime'];
  /** The user who created the DevOps Service */
  createdBy: Scalars['String'];
  /** Relationships with DevOps Services that are depend on this DevOps Service */
  dependedOnByDevOpsServiceRelationships?: Maybe<DevOpsServiceRelationshipConnection>;
  /** Relationships with DevOps Services that this DevOps Service depends on */
  dependsOnDevOpsServiceRelationships?: Maybe<DevOpsServiceRelationshipConnection>;
  /** The description of the DevOps Service */
  description?: Maybe<Scalars['String']>;
  /** The DevOps Service ARI */
  id: Scalars['ID'];
  /** Relationships with Jira projects associated to this DevOps Service. */
  jiraProjects?: Maybe<DevOpsServiceAndJiraProjectRelationshipConnection>;
  /** The most recent datetime when the DevOps Service was updated */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The last user who updated the DevOps Service */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** The name of the DevOps Service */
  name: Scalars['String'];
  /** The relationship between this Service and an Opsgenie team */
  opsgenieTeamRelationship?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
  /** Opsgenie teams that are available to be linked with via createDevOpsServiceAndOpsgenieTeamRelationship */
  opsgenieTeamsAvailableToLinkWith?: Maybe<OpsgenieTeamConnection>;
  /** The organisation ID of the DevOps Service */
  organizationId: Scalars['String'];
  /** Look up JSON properties of the DevOps Service by keys */
  properties?: Maybe<Scalars['JSON']>;
  /** Relationships with VCS repositories associated to this DevOps Service */
  repositoryRelationships?: Maybe<DevOpsServiceAndRepositoryRelationshipConnection>;
  /**
   * The revision that must be provided when updating a DevOps Service to prevent
   * simultaneous updates from overwriting each other
   */
  revision: Scalars['ID'];
  /** Tier assigned to the DevOps Service */
  serviceTier?: Maybe<DevOpsServiceTier>;
  /** Services that are available to be linked with via createDevOpsServiceRelationship */
  servicesAvailableToLinkWith?: Maybe<DevOpsServiceConnection>;
};


export type DevOpsServiceBitbucketRepositoriesAvailableToLinkWithArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
};


export type DevOpsServiceContainsDevOpsServiceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type DevOpsServiceDependedOnByDevOpsServiceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type DevOpsServiceDependsOnDevOpsServiceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type DevOpsServiceJiraProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DevOpsServiceAndJiraProjectRelationshipFilter>;
  first?: InputMaybe<Scalars['Int']>;
};


export type DevOpsServiceOpsgenieTeamsAvailableToLinkWithArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type DevOpsServicePropertiesArgs = {
  keys: Array<Scalars['String']>;
};


export type DevOpsServiceRepositoryRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DevOpsServiceAndRepositoryRelationshipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DevOpsServiceAndRepositoryRelationshipSort>;
};


export type DevOpsServiceServicesAvailableToLinkWithArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DevOpsServicesFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
};

/** A relationship between DevOps Service and Jira Project Team */
export type DevOpsServiceAndJiraProjectRelationship = Node & {
  __typename: 'DevOpsServiceAndJiraProjectRelationship';
  /** When the relationship was created. */
  createdAt: Scalars['DateTime'];
  /** Who created the relationship. */
  createdBy: Scalars['String'];
  /** An optional description of the relationship. */
  description?: Maybe<Scalars['String']>;
  /** The details of DevOps Service in the relationship. */
  devOpsService?: Maybe<DevOpsService>;
  /** The ARI of this relationship. */
  id: Scalars['ID'];
  /** The Jira project related to the repository. */
  jiraProject?: Maybe<JiraProject>;
  /** When the relationship was updated last.  Only present for relationships that have been updated. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Who updated the relationship last. Only present for relationships that have been updated. */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** Look up JSON properties of the relationship by keys. */
  properties?: Maybe<Scalars['JSON']>;
  /** The type of the relationship. */
  relationshipType: DevOpsServiceAndJiraProjectRelationshipType;
  /**
   * The revision must be provided when updating a relationship to prevent
   * simultaneous updates from overwriting each other.
   */
  revision: Scalars['ID'];
};


/** A relationship between DevOps Service and Jira Project Team */
export type DevOpsServiceAndJiraProjectRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

export type DevOpsServiceAndJiraProjectRelationshipConnection = {
  __typename: 'DevOpsServiceAndJiraProjectRelationshipConnection';
  edges?: Maybe<Array<Maybe<DevOpsServiceAndJiraProjectRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsServiceAndJiraProjectRelationship>>>;
  pageInfo: PageInfo;
};

export type DevOpsServiceAndJiraProjectRelationshipEdge = {
  __typename: 'DevOpsServiceAndJiraProjectRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsServiceAndJiraProjectRelationship>;
};

export type DevOpsServiceAndJiraProjectRelationshipFilter = {
  /** Include only relationships with the specified certainty */
  certainty?: InputMaybe<DevOpsRelationshipCertaintyFilter>;
  /** Include only relationships with the specified relationship type */
  relationshipTypeIn?: InputMaybe<Array<DevOpsServiceAndJiraProjectRelationshipType>>;
};

export const DevOpsServiceAndJiraProjectRelationshipType = {
  /** A relationship created for the change management feature */
  ChangeManagement: 'CHANGE_MANAGEMENT',
  /** A standard relationship */
  Default: 'DEFAULT'
} as const;

export type DevOpsServiceAndJiraProjectRelationshipType = typeof DevOpsServiceAndJiraProjectRelationshipType[keyof typeof DevOpsServiceAndJiraProjectRelationshipType];
/** A relationship between DevOps Service and Opsgenie Team */
export type DevOpsServiceAndOpsgenieTeamRelationship = Node & {
  __typename: 'DevOpsServiceAndOpsgenieTeamRelationship';
  /** The datetime when the relationship was created */
  createdAt: Scalars['DateTime'];
  /** The user who created the relationship */
  createdBy: Scalars['String'];
  /** An optional description of the relationship. */
  description?: Maybe<Scalars['String']>;
  /** The details of DevOps Service in the relationship. */
  devOpsService?: Maybe<DevOpsService>;
  /** The ARI of this relationship. */
  id: Scalars['ID'];
  /** The most recent datetime when the relationship was updated */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The last user who updated the relationship */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** The Opsgenie team details related to the service. */
  opsgenieTeam?: Maybe<OpsgenieTeam>;
  /**
   * The id (Opsgenie team ARI) of the Opsgenie team related to the service.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated use field opsgenieTeam to retrieve team details
   */
  opsgenieTeamId: Scalars['ID'];
  /** Look up JSON properties of the relationship by keys. */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * The revision must be provided when updating a relationship to prevent
   * simultaneous updates from overwriting each other.
   */
  revision: Scalars['ID'];
};


/** A relationship between DevOps Service and Opsgenie Team */
export type DevOpsServiceAndOpsgenieTeamRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

export type DevOpsServiceAndOpsgenieTeamRelationshipConnection = {
  __typename: 'DevOpsServiceAndOpsgenieTeamRelationshipConnection';
  edges?: Maybe<Array<Maybe<DevOpsServiceAndOpsgenieTeamRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsServiceAndOpsgenieTeamRelationship>>>;
  pageInfo: PageInfo;
};

export type DevOpsServiceAndOpsgenieTeamRelationshipEdge = {
  __typename: 'DevOpsServiceAndOpsgenieTeamRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
};

/** A relationship between a DevOps Service and a Repository */
export type DevOpsServiceAndRepositoryRelationship = Node & {
  __typename: 'DevOpsServiceAndRepositoryRelationship';
  /**
   * If the repository provider is Bitbucket, this will contain the Bitbucket repository details,
   * otherwise null.
   */
  bitbucketRepository?: Maybe<BitbucketRepository>;
  /** The time when the relationship was created */
  createdAt: Scalars['DateTime'];
  /** The user who created the relationship */
  createdBy: Scalars['String'];
  /** An optional description of the relationship. */
  description?: Maybe<Scalars['String']>;
  /** The details of DevOps Service in the relationship. */
  devOpsService?: Maybe<DevOpsService>;
  /** The ARI of this Relationship. */
  id: Scalars['ID'];
  /** The latest time when the relationship was updated */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The latest user who updated the relationship */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** Look up JSON properties of the relationship by keys. */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * The revision must be provided when updating a relationship to prevent
   * multiple simultaneous updates from overwriting each other.
   */
  revision: Scalars['ID'];
  /** If the repository provider is a third party, this will contain the repository details, otherwise null. */
  thirdPartyRepository?: Maybe<DevOpsThirdPartyRepository>;
};


/** A relationship between a DevOps Service and a Repository */
export type DevOpsServiceAndRepositoryRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

export type DevOpsServiceAndRepositoryRelationshipConnection = {
  __typename: 'DevOpsServiceAndRepositoryRelationshipConnection';
  edges?: Maybe<Array<Maybe<DevOpsServiceAndRepositoryRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsServiceAndRepositoryRelationship>>>;
  pageInfo: PageInfo;
};

export type DevOpsServiceAndRepositoryRelationshipEdge = {
  __typename: 'DevOpsServiceAndRepositoryRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsServiceAndRepositoryRelationship>;
};

export type DevOpsServiceAndRepositoryRelationshipFilter = {
  /** Include only relationships with the specified certainty */
  certainty?: InputMaybe<DevOpsRelationshipCertaintyFilter>;
  /** Include only relationships with the specified repository hosting provider type */
  hostingProvider?: InputMaybe<DevOpsRepositoryHostingProviderFilter>;
  /**
   * Include only relationships with all of the specified property keys.
   * If this is omitted, no filtering by 'all property keys' is applied.
   */
  withAllPropertyKeys?: InputMaybe<Array<Scalars['String']>>;
};

export type DevOpsServiceAndRepositoryRelationshipSort = {
  /** The field to apply sorting on */
  by: DevOpsServiceAndRepositoryRelationshipSortBy;
  /** The direction of sorting */
  order?: SortDirection;
};

export const DevOpsServiceAndRepositoryRelationshipSortBy = {
  LastInferredAt: 'LAST_INFERRED_AT'
} as const;

export type DevOpsServiceAndRepositoryRelationshipSortBy = typeof DevOpsServiceAndRepositoryRelationshipSortBy[keyof typeof DevOpsServiceAndRepositoryRelationshipSortBy];
/** The connection object for a collection of Services. */
export type DevOpsServiceConnection = {
  __typename: 'DevOpsServiceConnection';
  edges?: Maybe<Array<Maybe<DevOpsServiceEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsService>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DevOpsServiceEdge = {
  __typename: 'DevOpsServiceEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsService>;
};

export type DevOpsServiceRelationship = Node & {
  __typename: 'DevOpsServiceRelationship';
  /** The cloud ID of the DevOps Service Relationship */
  cloudId: Scalars['String'];
  /** The datetime when the DevOps Service Relationship was created */
  createdAt: Scalars['DateTime'];
  /** The user who created the DevOps Service Relationship */
  createdBy: Scalars['String'];
  /** The description of the DevOps Service Relationship */
  description?: Maybe<Scalars['String']>;
  /** The end service of the DevOps Service Relationship */
  endService?: Maybe<DevOpsService>;
  /** The DevOps Service Relationship ARI */
  id: Scalars['ID'];
  /** The most recent datetime when the DevOps Service Relationship was updated */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The last user who updated the DevOps Service Relationship */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** The organization ID of the DevOps Service Relationship */
  organizationId: Scalars['String'];
  /** Look up JSON properties of the DevOps Service by keys */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * The revision that must be provided when updating a DevOps Service relationship to prevent
   * simultaneous updates from overwriting each other
   */
  revision: Scalars['ID'];
  /** The start service of the DevOps Service Relationship */
  startService?: Maybe<DevOpsService>;
  /** The inter-service relationship type of the DevOps Service Relationship */
  type: DevOpsServiceRelationshipType;
};


export type DevOpsServiceRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

/** The connection object for a collection of DevOps Service relationships. */
export type DevOpsServiceRelationshipConnection = {
  __typename: 'DevOpsServiceRelationshipConnection';
  edges?: Maybe<Array<Maybe<DevOpsServiceRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsServiceRelationship>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DevOpsServiceRelationshipEdge = {
  __typename: 'DevOpsServiceRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsServiceRelationship>;
};

/** #################### Enums ##################### */
export const DevOpsServiceRelationshipType = {
  Contains: 'CONTAINS',
  DependsOn: 'DEPENDS_ON'
} as const;

export type DevOpsServiceRelationshipType = typeof DevOpsServiceRelationshipType[keyof typeof DevOpsServiceRelationshipType];
export type DevOpsServiceTier = {
  __typename: 'DevOpsServiceTier';
  /** Description of the tier level and the standards that a DevOps Service at this tier should meet */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The level of the tier. Lower numbers are more important */
  level: Scalars['Int'];
  /** The name of the tier, if set by the user */
  name?: Maybe<Scalars['String']>;
  /** The translation key for the name. Only present when name is null */
  nameKey?: Maybe<Scalars['String']>;
};

/** The filtering input for retrieving services. tierLevelIn must not be empty if provided. */
export type DevOpsServicesFilterInput = {
  /** Case insensitive string to filter service names with */
  nameContains?: InputMaybe<Scalars['String']>;
  /** Integer numbers to filter service tier levels with */
  tierLevelIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type DevOpsSummarisedDeployments = {
  __typename: 'DevOpsSummarisedDeployments';
  /** The total count of deployments from all providers */
  count?: Maybe<Scalars['Int']>;
  /** The most relevant deployment environment for this entity as there could be multiple deployments */
  deploymentEnvironment?: Maybe<DevOpsEnvironment>;
  /** The most relevant deployment state for this entity as there could be multiple deployments */
  deploymentState?: Maybe<DeploymentState>;
  /** The id of the Atlassian entity which is associated with the deployment summary */
  entityId: Scalars['ID'];
  /** The last-updated timestamp of any deployment that is part of the summary item. */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** The total number of most relevant deployments. Count of deployments that could be appeared on deploymentState field. (Priority order is based on deployment environment comparison followed by deployment state) */
  mostRelevantCount?: Maybe<Scalars['Int']>;
  /** The last-updated timestamp of the most relevant deployment summary. Use this for the last-updated timestamp of the deployment for the deploymentState field (Priority order is based on deployment environment comparison followed by deployment state) */
  mostRelevantLastUpdated?: Maybe<Scalars['DateTime']>;
};

/** #################### Supporting Types ##################### */
export type DevOpsThirdPartyRepository = {
  __typename: 'DevOpsThirdPartyRepository';
  /** Avatar details for the third party repository. */
  avatar?: Maybe<DevOpsAvatar>;
  /** The ID of the third party repository. */
  id: Scalars['ID'];
  /** The name of the third party repository. */
  name?: Maybe<Scalars['String']>;
  /** The URL of the third party repository. */
  webUrl?: Maybe<Scalars['URL']>;
};

export type DevOpsTool = Node & {
  __typename: 'DevOpsTool';
  avatar?: Maybe<DevOpsToolAvatar>;
  containerIntegration?: Maybe<DevOpsToolContainerIntegration>;
  group: DevOpsToolGroup;
  id: Scalars['ID'];
  integration?: Maybe<DevOpsToolIntegration>;
  name: Scalars['String'];
  namespaces?: Maybe<DevOpsToolNamespaceConnection>;
  productKey: Scalars['String'];
  supportsContainers: Scalars['Boolean'];
};


export type DevOpsToolNamespacesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type DevOpsToolAvatar = {
  __typename: 'DevOpsToolAvatar';
  url: Scalars['URL'];
};

export type DevOpsToolContainer = Node & {
  __typename: 'DevOpsToolContainer';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  productKey: Scalars['String'];
  underlyingId: Scalars['String'];
  url: Scalars['String'];
};

export type DevOpsToolContainerConnection = {
  __typename: 'DevOpsToolContainerConnection';
  edges?: Maybe<Array<Maybe<DevOpsToolContainerEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsToolContainer>>>;
  pageInfo: PageInfo;
};

export type DevOpsToolContainerEdge = {
  __typename: 'DevOpsToolContainerEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsToolContainer>;
};

export type DevOpsToolContainerIntegration = {
  containerType: Scalars['String'];
};

export type DevOpsToolContainerIntegrationApp = DevOpsToolContainerIntegration & {
  __typename: 'DevOpsToolContainerIntegrationApp';
  appKey: Scalars['String'];
  containerType: Scalars['String'];
  installed: Scalars['Boolean'];
  oauthUrl?: Maybe<Scalars['String']>;
};

export type DevOpsToolContainerIntegrationProduct = DevOpsToolContainerIntegration & {
  __typename: 'DevOpsToolContainerIntegrationProduct';
  available: Scalars['Boolean'];
  containerType: Scalars['String'];
  productKey: Scalars['String'];
};

export type DevOpsToolGroup = {
  __typename: 'DevOpsToolGroup';
  groupId: Scalars['String'];
  groupName: Scalars['String'];
};

export type DevOpsToolIntegration = DevOpsToolIntegrationApp | DevOpsToolIntegrationProduct;

export type DevOpsToolIntegrationApp = {
  __typename: 'DevOpsToolIntegrationApp';
  appKey: Scalars['String'];
  appName: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  installed: Scalars['Boolean'];
};

export type DevOpsToolIntegrationProduct = {
  __typename: 'DevOpsToolIntegrationProduct';
  available: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  productKey: Scalars['String'];
  productName: Scalars['String'];
};

export type DevOpsToolNamespace = Node & {
  __typename: 'DevOpsToolNamespace';
  canCreateContainer: Scalars['Boolean'];
  containers?: Maybe<DevOpsToolContainerConnection>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  productKey: Scalars['String'];
  underlyingId: Scalars['String'];
};


export type DevOpsToolNamespaceContainersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  projectAri?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type DevOpsToolNamespaceConnection = {
  __typename: 'DevOpsToolNamespaceConnection';
  edges?: Maybe<Array<Maybe<DevOpsToolNamespaceEdge>>>;
  nodes?: Maybe<Array<Maybe<DevOpsToolNamespace>>>;
  pageInfo: PageInfo;
};

export type DevOpsToolNamespaceEdge = {
  __typename: 'DevOpsToolNamespaceEdge';
  cursor: Scalars['String'];
  node?: Maybe<DevOpsToolNamespace>;
};

/** Dev status context */
export type DevStatus = {
  __typename: 'DevStatus';
  activity: DevStatusActivity;
  count?: Maybe<Scalars['Int']>;
};

export const DevStatusActivity = {
  BranchOpen: 'BRANCH_OPEN',
  Commit: 'COMMIT',
  PrDeclined: 'PR_DECLINED',
  PrMerged: 'PR_MERGED',
  PrOpen: 'PR_OPEN'
} as const;

export type DevStatusActivity = typeof DevStatusActivity[keyof typeof DevStatusActivity];
/**
 * Organization within this block refers to the conceptional container for a
 * real world entity and is either represented as the users Enterprise or
 * implicitly from the domain that the user belongs to through their email
 * address.
 */
export type DomainOrganization = {
  __typename: 'DomainOrganization';
  /**
   * The Enterprise's displayName. If the Enterprise is backed by an
   * actual Enterprise entity in Mongo, this will be an actual Organization
   * name like "Nike". If the Enterprise is not represented by an actual DB
   * entity, it will be a domain, like "nike.com".
   */
  displayName: Scalars['String'];
  /**
   * The domains that are assigned to the organization, if there is an
   * Enterprise there may be more that one, if this is implicit then it
   * will only contain a single domain.
   */
  domains: Array<Maybe<Scalars['String']>>;
  /** The enterprise id for this organization. */
  idEnterprise?: Maybe<Scalars['ID']>;
  /** This is the "Workspaces" that belong to this "Organization" entity. */
  organizations: Array<Organization>;
  /** A map of extra meta data about the "Workspaces" within this "Organization" entity. */
  organizationsInfo: Array<Maybe<DomainOrganizationInformation>>;
};


/**
 * Organization within this block refers to the conceptional container for a
 * real world entity and is either represented as the users Enterprise or
 * implicitly from the domain that the user belongs to through their email
 * address.
 */
export type DomainOrganizationOrganizationsArgs = {
  filter?: InputMaybe<Organization_Filter>;
};

export type DomainOrganizationAdmin = {
  __typename: 'DomainOrganizationAdmin';
  /** Avatar hash of the Admin */
  avatarHash?: Maybe<Scalars['String']>;
  /** Name of the Admin */
  fullName: Scalars['String'];
  /** id of the Admin */
  id: Scalars['ID'];
};

/** Extra meta data about the "Workspace" within this "Organization" entity. */
export type DomainOrganizationInformation = {
  __typename: 'DomainOrganizationInformation';
  /** Details of the admins of this "Workspace" */
  admins: Array<Maybe<DomainOrganizationAdmin>>;
  /** id of the "Workspace" */
  id: Scalars['ID'];
  /** The membership type of the current member */
  memberType: Organization_Membership_MemberType;
  /** Number of boards in this "Workspace" */
  orgBoardsCount: Scalars['Int'];
  /** Number of members in this "Workspace" */
  orgMembersCount: Scalars['Int'];
};

export type DueEntity = {
  __typename: 'DueEntity';
  current?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** The name and url of a given email provider that is retrieved from the MX records for a given email address */
export type EmailProvider = {
  __typename: 'EmailProvider';
  /** Name of the email provider e.g. Gmail */
  name: Scalars['String'];
  /** Url to the providers inbox */
  url: Scalars['String'];
};

/** An Enterprise in Trello is made up of many Organizations (teams) */
export type Enterprise = {
  __typename: 'Enterprise';
  /** The timestamp of when Atlassian Access was enabled for the enterprise */
  accessEnabled?: Maybe<Scalars['String']>;
  /** The display name of the associated Atlassian organization, if one exists */
  atlOrgDisplayName?: Maybe<Scalars['String']>;
  /** The parent organization in Atlassian */
  atlOrgId?: Maybe<Scalars['ID']>;
  /** The Auditlog for Enterprises actions */
  auditlog: Array<Enterprise_Auditlog>;
  /** A list of teams that can be claimed by an enterprise */
  claimableOrganizations: ClaimableOrganizations;
  /** The display name of the Enterprise */
  displayName: Scalars['String'];
  /** Domains claimed by the Enterprise */
  enterpriseDomains: Array<Scalars['String']>;
  /** Most recent export for this enterprise */
  export?: Maybe<Export>;
  /** The Exports on this Enterprise */
  exports: Array<Export>;
  /** Whether this Enterprise has Atlassian Access */
  hasAtlassianAccess: Scalars['Boolean'];
  /** Whether this Enterprise has any claimed domains */
  hasClaimedDomains: Scalars['Boolean'];
  /** The ID of the Enterprise */
  id: Scalars['ID'];
  /** The ids of the admins in the enterprise */
  idAdmins: Array<Scalars['String']>;
  /** The ids of the plugins allowed on the Enterprise */
  idPluginsAllowed: Array<Scalars['String']>;
  /** Whether this Enterprise is associated with an Atlassian organization */
  isAtlassianOrg: Scalars['Boolean'];
  isEnterpriseWithoutSSO: Scalars['Boolean'];
  /** Whether this Enterprise is really an Enterprise, or a Business Class Purchase Order (BCPO) 'Enterprise' */
  isRealEnterprise: Scalars['Boolean'];
  /** Data regarding the Enterprise's licenses */
  licenses: Enterprise_Licenses;
  /** The hash of the custom logo for the Enterprise */
  logoHash?: Maybe<Scalars['String']>;
  /** The URL of the custom logo for the Enterprise */
  logoUrl?: Maybe<Scalars['String']>;
  /** A list of the enterprise's members who have issues consent tokens for third-party apps */
  managedMembersWithTokens: Array<Member>;
  /** The name of the Enterprise */
  name: Scalars['String'];
  /** The overridden prefs for individual Organizations owned by the Enterprise */
  organizationPrefs: Organization_Prefs;
  /** Information about the paid account of Enterprise */
  paidAccount?: Maybe<PaidAccount>;
  /** Whether the Enterprise has enabled plugin whitelisting restrictions */
  pluginWhitelistingEnabled: Scalars['Boolean'];
  /** The preferences for the Enterprise */
  prefs?: Maybe<Enterprise_Prefs>;
  /** The product code (SKU) that the enterprise is billed under */
  products: Array<Scalars['Int']>;
  /** Boolean for whether the max attempts for sso activation was reached */
  ssoActivationFailed: Scalars['Boolean'];
  ssoDateDelayed?: Maybe<Scalars['String']>;
  /** Data used to represent the effects of transferring an organization to an enterprise */
  transferrableData: TransferrableData;
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseClaimableOrganizationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseExportArgs = {
  idEnterprise: Scalars['ID'];
  idExport: Scalars['ID'];
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseExportsArgs = {
  id: Scalars['ID'];
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseManagedMembersWithTokensArgs = {
  filter?: InputMaybe<Scalars['String']>;
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseTransferrableDataArgs = {
  idOrganization: Scalars['ID'];
};

/** Describing the items inside the audit log */
export type Enterprise_Auditlog = {
  __typename: 'Enterprise_Auditlog';
  board?: Maybe<Board>;
  date: Scalars['String'];
  idAction: Scalars['ID'];
  member?: Maybe<Member>;
  memberCreator?: Maybe<Member>;
  organization?: Maybe<Organization>;
  plugin?: Maybe<Plugin>;
  type: Action_Type;
};

/** An object representing the response from the deleteAllManagedMemberTokens mutation */
export type Enterprise_DeleteAllManagedMemberTokensResponse = {
  __typename: 'Enterprise_DeleteAllManagedMemberTokensResponse';
  success: Scalars['Boolean'];
};

/** An object representing the response from the deleteManagedMemberTokens mutation */
export type Enterprise_DeleteManagedMemberTokensResponse = {
  __typename: 'Enterprise_DeleteManagedMemberTokensResponse';
  success: Scalars['Boolean'];
};

/** A filter for the Enterprises being requested */
export const Enterprise_Filter = {
  Member: 'member',
  MemberUnconfirmed: 'memberUnconfirmed',
  /** Only Enterprises that 'own' the Member */
  Owned: 'owned',
  Saml: 'saml'
} as const;

export type Enterprise_Filter = typeof Enterprise_Filter[keyof typeof Enterprise_Filter];
export type Enterprise_Licenses = {
  __typename: 'Enterprise_Licenses';
  /** The maximum number of members allowed in the Enterprise without purchasing additional seats */
  maxMembers?: Maybe<Scalars['Int']>;
  /** The number of members in the Enterprise */
  totalMembers: Scalars['Int'];
};

/** An object representing the response from the linkEnterpriseWithAtlassianOrganization mutation */
export type Enterprise_LinkAtlassianOrganizationResponse = {
  __typename: 'Enterprise_LinkAtlassianOrganizationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/** Represents the preferences of an Enterprise */
export type Enterprise_Prefs = {
  __typename: 'Enterprise_Prefs';
  /** The custom branding color for the Enterprise */
  brandingColor?: Maybe<Scalars['String']>;
  /** Whether managed members of the enterprise can issue consent tokens for third-party apps */
  canIssueManagedConsentTokens: Scalars['Boolean'];
  /** Whether SSO login is enforced for managed users */
  ssoOnly: Scalars['Boolean'];
};

/** Estimate object which contains an estimate for a card when it exists */
export type Estimate = {
  __typename: 'Estimate';
  originalEstimate?: Maybe<OriginalEstimate>;
  storyPoints?: Maybe<Scalars['Float']>;
};

export type EstimationBoardFeatureView = Node & {
  __typename: 'EstimationBoardFeatureView';
  canEnable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUri?: Maybe<Scalars['String']>;
  learnMoreArticleId?: Maybe<Scalars['String']>;
  learnMoreLink?: Maybe<Scalars['String']>;
  permissibleEstimationTypes?: Maybe<Array<Maybe<PermissibleEstimationType>>>;
  selectedEstimationType?: Maybe<PermissibleEstimationType>;
  /** Possible states: ENABLED, DISABLED, COMING_SOON */
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type EstimationConfig = {
  __typename: 'EstimationConfig';
  /** All available estimation types that can be used in the project. */
  available: Array<AvailableEstimations>;
  /** Currently configured estimation. */
  current: CurrentEstimation;
};

/** Compass Events */
export type EventSource = {
  __typename: 'EventSource';
  /** The type of the event. */
  eventType: CompassEventType;
  /** The events stored on the event source */
  events?: Maybe<CompassEventsQueryResult>;
  /** The ID of the external event source. */
  externalEventSourceId: Scalars['ID'];
  /**
   * The Forge App Id used to construct event sources.
   * This is automatically inferred from the HTTP Header of the requesting Forge App.
   */
  forgeAppId?: Maybe<Scalars['ID']>;
  /** The ID of the event source. */
  id: Scalars['ID'];
};


/** Compass Events */
export type EventSourceEventsArgs = {
  query?: InputMaybe<CompassEventsInEventSourceQuery>;
};

/** Self Serve Expansion Price Estimate */
export type ExpansionPriceEstimate = {
  __typename: 'ExpansionPriceEstimate';
  dtEnd: Scalars['String'];
  dtStart: Scalars['String'];
  nLicenseSeats: Scalars['Int'];
  nTotal: Scalars['Float'];
};

export type Export = {
  __typename: 'Export';
  exportUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  size?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['String']>;
  status: ExportStatus;
};

export const ExportStage = {
  CreatingArchive: 'Creating_archive',
  ExportCompleted: 'Export_completed',
  ExportFailed: 'Export_failed',
  ExportQueued: 'Export_queued',
  FetchingBoardData: 'Fetching_board_data',
  PreparingToExport: 'Preparing_to_export'
} as const;

export type ExportStage = typeof ExportStage[keyof typeof ExportStage];
export type ExportStatus = {
  __typename: 'ExportStatus';
  attempts: Scalars['Int'];
  finished: Scalars['Boolean'];
  stage: ExportStage;
};

export type FilterQuery = {
  __typename: 'FilterQuery';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  sanitisedJql: Scalars['String'];
};

export type FunctionDescription = {
  __typename: 'FunctionDescription';
  key: Scalars['String'];
};

/** The data describing a function invocation. */
export type FunctionInvocationMetadata = {
  appVersion: Scalars['String'];
  /** Metadata about the function of the app that was called */
  function?: Maybe<FunctionDescription>;
  /** The invocation ID */
  id: Scalars['ID'];
  /** The context in which the app is installed */
  installationContext?: Maybe<AppInstallationContext>;
  /** Metadata about module type */
  moduleType?: Maybe<Scalars['String']>;
  /** Metadata about what caused the function to run */
  trigger?: Maybe<FunctionTrigger>;
};

export type FunctionTrigger = {
  __typename: 'FunctionTrigger';
  key?: Maybe<Scalars['String']>;
  type?: Maybe<FunctionTriggerType>;
};

/** Which type of trigger */
export const FunctionTriggerType = {
  Frontend: 'FRONTEND',
  Manual: 'MANUAL',
  Product: 'PRODUCT',
  Web: 'WEB'
} as const;

export type FunctionTriggerType = typeof FunctionTriggerType[keyof typeof FunctionTriggerType];
/** Concrete version of QueryErrorExtension that does not include any extra fields */
export type GenericQueryErrorExtension = QueryErrorExtension & {
  __typename: 'GenericQueryErrorExtension';
  errorType?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
};

export const GrantCheckProduct = {
  Compass: 'COMPASS',
  Confluence: 'CONFLUENCE',
  Jira: 'JIRA',
  JiraServicedesk: 'JIRA_SERVICEDESK',
  /** Don't check whether a user has been granted access to a specific site(cloudId) */
  NoGrantChecks: 'NO_GRANT_CHECKS'
} as const;

export type GrantCheckProduct = typeof GrantCheckProduct[keyof typeof GrantCheckProduct];
export type GuestOrganization = {
  __typename: 'GuestOrganization';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  logoHash?: Maybe<Scalars['String']>;
};

/**
 * #########################
 *  Base objects for help-center
 * #########################
 */
export type HelpCenter = Node & {
  __typename: 'HelpCenter';
  collections?: Maybe<Array<HelpCenterCollection>>;
  id: Scalars['ID'];
};

export type HelpCenterCollection = {
  __typename: 'HelpCenterCollection';
  collectionId: Scalars['ID'];
  /** Description of collection */
  description?: Maybe<Scalars['String']>;
  /** This contains all help objects of the collection. */
  items?: Maybe<HelpCenterCollectionItemConnection>;
  /** Name of collection */
  name: Scalars['String'];
  /**
   *  This includes additional properties to the collections.
   * Such as whether the collection is visible to the helpseekers on help center or not etc.
   */
  properties?: Maybe<Scalars['JSON']>;
};


export type HelpCenterCollectionItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type HelpCenterCollectionItem = {
  __typename: 'HelpCenterCollectionItem';
  /** ARI of help object */
  ari: Scalars['ID'];
};

export type HelpCenterCollectionItemConnection = {
  __typename: 'HelpCenterCollectionItemConnection';
  edges?: Maybe<Array<Maybe<HelpCenterCollectionItemEdge>>>;
  nodes?: Maybe<Array<Maybe<HelpCenterCollectionItem>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type HelpCenterCollectionItemEdge = {
  __typename: 'HelpCenterCollectionItemEdge';
  cursor: Scalars['String'];
  node?: Maybe<HelpCenterCollectionItem>;
};

export type HelpObjectStoreArticle = HelpObjectStoreHelpObject & Node & {
  __typename: 'HelpObjectStoreArticle';
  /** Description of the Article */
  description: Scalars['String'];
  /** Clickable Link of the Article */
  displayLink: Scalars['URL'];
  /** Article Id in Confluence */
  entityId?: Maybe<Scalars['String']>;
  /** project Id article belongs to */
  entityProjectId?: Maybe<Scalars['String']>;
  /** Icon of the Article */
  icon?: Maybe<HelpObjectStoreIcon>;
  /** ARI of the Article */
  id: Scalars['ID'];
  /** Title of the Article */
  title: Scalars['String'];
};

export type HelpObjectStoreHelpObject = {
  /** Description of the Help Object */
  description: Scalars['String'];
  /** Clickable Link of the Help Object */
  displayLink: Scalars['URL'];
  /** Icon of the Help Object */
  icon?: Maybe<HelpObjectStoreIcon>;
  /** ARI of the help object */
  id: Scalars['ID'];
  /** Title of the Help Object */
  title: Scalars['String'];
};

export type HelpObjectStoreIcon = {
  __typename: 'HelpObjectStoreIcon';
  /** Icon URL */
  iconUrl: Scalars['URL'];
};

export type HelpObjectStoreRequestForm = HelpObjectStoreHelpObject & Node & {
  __typename: 'HelpObjectStoreRequestForm';
  /** Description of the Request Form */
  description: Scalars['String'];
  /** Clickable Link of the Request Form */
  displayLink: Scalars['URL'];
  /** Request Form Id in JSM */
  entityId?: Maybe<Scalars['String']>;
  /** Request Form project id in JSM */
  entityProjectId?: Maybe<Scalars['String']>;
  /** Icon of the Request Form */
  icon?: Maybe<HelpObjectStoreIcon>;
  /** ARI of the Request Form */
  id: Scalars['ID'];
  /** Title of the Request Form */
  title: Scalars['String'];
};

export type Icon = {
  __typename: 'Icon';
  url?: Maybe<Scalars['String']>;
};

export type InlineCardCreateConfig = {
  __typename: 'InlineCardCreateConfig';
  /** Whether inline create is enabled */
  enabled: Scalars['Boolean'];
  /** Whether the global create should be used when creating */
  useGlobalCreate?: Maybe<Scalars['Boolean']>;
};

export type InlineColumnEditConfig = {
  __typename: 'InlineColumnEditConfig';
  enabled: Scalars['Boolean'];
};

export type InputButlerButton = {
  close?: InputMaybe<Scalars['Boolean']>;
  cmd: Scalars['ButlerCommand'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  image: Scalars['String'];
  label: Scalars['String'];
  shared?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

/** Advanced date for representing relative and absolute dates in views */
export type InputCardFilter_AdvancedDate = {
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

/** Organization View card filter criteria input */
export type InputCardFilter_Criteria = {
  due?: InputMaybe<InputCardFilter_Criteria_DateRange>;
  dueComplete?: InputMaybe<Scalars['Boolean']>;
  /** A list of board IDs whose cards will be included in the view */
  idBoards?: InputMaybe<Array<Scalars['ID']>>;
  idLists?: InputMaybe<Array<Scalars['ID']>>;
  idMembers?: InputMaybe<Array<Scalars['String']>>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<InputCardFilter_Criteria_DateRange>;
};

/** OrganizationView CardFilter DateRange */
export type InputCardFilter_Criteria_DateRange = {
  end?: InputMaybe<InputCardFilter_AdvancedDate>;
  special?: InputMaybe<CardFilter_Criteria_DateRange_Special>;
  start?: InputMaybe<InputCardFilter_AdvancedDate>;
};

export type InputCover = {
  brightness?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  idAttachment?: InputMaybe<Scalars['String']>;
  idUploadedBackground?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Top level OrganizationView model input for updating an organizationView */
export type InputOrganizationView = {
  /** The name of the organization view */
  name?: InputMaybe<Scalars['String']>;
  /** An object that describes the permission level of the organization view */
  prefs?: InputMaybe<InputOrganizationView_Prefs>;
};

/** Prefs argument for creating and updating Organization Views */
export type InputOrganizationView_Prefs = {
  /** The permission level for the organizaiton view. Currently we support 'team' and 'private' */
  permissionLevel: OrganizationView_Prefs_PermissionLevel;
};

/** A single view argument for creating and updating Organzation Views */
export type InputOrganizationView_View = {
  /** An object specifying which cards to include in the view */
  cardFilter?: InputMaybe<InputOrganizationView_View_CardFilter>;
  /** The type of visualization this view uses, such as 'table' or 'timeline' */
  defaultViewType?: InputMaybe<Scalars['String']>;
  /** Options specific to individual views */
  viewOptions?: InputMaybe<InputOrganizationView_View_ViewOptions>;
};

/** Organization View card filter input */
export type InputOrganizationView_View_CardFilter = {
  /** An object specifying the criteria that determines which cards are included in the view */
  criteria?: InputMaybe<Array<InputCardFilter_Criteria>>;
};

export type InputOrganizationView_View_ViewOptions = {
  Calendar?: InputMaybe<InputOrganizationView_View_ViewOptions_Calendar>;
};

export type InputOrganizationView_View_ViewOptions_Calendar = {
  timeHorizon: Scalars['String'];
};

export type InputPluginListing = {
  /** The description of the plugin. */
  description: Scalars['String'];
  /** The locale of the listing. */
  locale: Scalars['String'];
  /** The name of the plugin. */
  name: Scalars['String'];
  /** The overview of the plugin. */
  overview: Scalars['String'];
};

export type InputSavedSearch = {
  name: Scalars['String'];
  pos: Scalars['Int'];
  query: Scalars['String'];
};

/** Response from adding a member to a team */
export type InviteMember_Response = {
  __typename: 'InviteMember_Response';
  success: Scalars['Boolean'];
};

/** Represents the Atlassian Document Format content in JSON format. */
export type JiraAdf = {
  __typename: 'JiraADF';
  /** The content of ADF in JSON. */
  json?: Maybe<Scalars['JSON']>;
};

/**
 * Represents an affected service entity for a Jira Issue.
 * AffectedService provides context on what has been changed.
 */
export type JiraAffectedService = {
  __typename: 'JiraAffectedService';
  /** The id of the affected service. E.g. Jira. */
  serviceId?: Maybe<Scalars['String']>;
};

/** The connection type for JiraAffectedService. */
export type JiraAffectedServiceConnection = {
  __typename: 'JiraAffectedServiceConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraAffectedServiceEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraAffectedService connection. */
export type JiraAffectedServiceEdge = {
  __typename: 'JiraAffectedServiceEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraAffectedService>;
};

/** Represents Affected Services field. */
export type JiraAffectedServicesField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraAffectedServicesField';
  /**
   * Paginated list of affected services available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  affectedServices?: Maybe<JiraAffectedServiceConnection>;
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to query for all Affected Services when user interact with field. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The affected services selected on the Issue or default affected services configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedAffectedServicesConnection instead.
   */
  selectedAffectedServices?: Maybe<Array<Maybe<JiraAffectedService>>>;
  /** The affected services selected on the Issue or default affected services configured for the field. */
  selectedAffectedServicesConnection?: Maybe<JiraAffectedServiceConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents Affected Services field. */
export type JiraAffectedServicesFieldAffectedServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};


/** Represents Affected Services field. */
export type JiraAffectedServicesFieldSelectedAffectedServicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Jira application properties is effectively a key/value store scoped to a Jira instance. A JiraApplicationProperty
 * represents one of these key/value pairs, along with associated metadata about the property.
 */
export type JiraApplicationProperty = Node & {
  __typename: 'JiraApplicationProperty';
  /**
   * If the type is 'enum', then allowedValues may optionally contain a list of values which are valid for this property.
   * Otherwise the value will be null.
   */
  allowedValues?: Maybe<Array<Scalars['String']>>;
  /**
   * The default value which will be returned if there is no value stored. This might be useful for UIs which allow a
   * user to 'reset' an application property to the default value.
   */
  defaultValue: Scalars['String'];
  /** The human readable description for the application property */
  description?: Maybe<Scalars['String']>;
  /**
   * Example is mostly used for application properties which store some sort of format pattern (e.g. date formats).
   * Example will contain an example string formatted according to the format stored in the property.
   */
  example?: Maybe<Scalars['String']>;
  /** Globally unique identifier */
  id: Scalars['ID'];
  /** True if the user is allowed to edit the property, false otherwise */
  isEditable: Scalars['Boolean'];
  /** The unique key of the application property */
  key: Scalars['String'];
  /**
   * The human readable name for the application property. If no human readable name has been defined then the key will
   * be returned.
   */
  name: Scalars['String'];
  /**
   * Although all application properties are stored as strings, they notionally have a type (e.g. boolean, int, enum,
   * string). The type can be anything (for example, there is even a colour type), and there may be associated validation
   * on the server based on the property's type.
   */
  type: Scalars['String'];
  /**
   * The value of the application property, encoded as a string. If no value is stored the default value will
   * be returned.
   */
  value: Scalars['String'];
};

/** Represents a single option value for an asset field. */
export type JiraAsset = {
  __typename: 'JiraAsset';
  /**
   * The app key, which should be the Connect app key.
   * This parameter is used to scope the originId.
   */
  appKey?: Maybe<Scalars['String']>;
  /**
   * The identifier of an asset.
   * This is the same identifier for the asset in its origin (external) system.
   */
  originId?: Maybe<Scalars['String']>;
  /** The appKey + originId separated by a forward slash. */
  serializedOrigin?: Maybe<Scalars['String']>;
  /** The appKey + originId separated by a forward slash. */
  value?: Maybe<Scalars['String']>;
};

/** The connection type for JiraAsset. */
export type JiraAssetConnection = {
  __typename: 'JiraAssetConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraAssetEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraAsset connection. */
export type JiraAssetEdge = {
  __typename: 'JiraAssetEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraAsset>;
};

/** Represents the Asset field on a Jira Issue. */
export type JiraAssetField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraAssetField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch all the assets for the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The assets selected on the Issue or default assets configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedAssetsConnection instead.
   */
  selectedAssets?: Maybe<Array<Maybe<JiraAsset>>>;
  /** The assets selected on the Issue or default assets configured for the field. */
  selectedAssetsConnection?: Maybe<JiraAssetConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the Asset field on a Jira Issue. */
export type JiraAssetFieldSelectedAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Deprecated type. Please use `JiraTeamView` instead. */
export type JiraAtlassianTeam = {
  __typename: 'JiraAtlassianTeam';
  /** The avatar of the team. */
  avatar?: Maybe<JiraAvatar>;
  /** The name of the team. */
  name?: Maybe<Scalars['String']>;
  /** The UUID of team. */
  teamId?: Maybe<Scalars['String']>;
};

/** Deprecated type. */
export type JiraAtlassianTeamConnection = {
  __typename: 'JiraAtlassianTeamConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraAtlassianTeamEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Deprecated type. */
export type JiraAtlassianTeamEdge = {
  __typename: 'JiraAtlassianTeamEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraAtlassianTeam>;
};

/** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */
export type JiraAtlassianTeamField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraAtlassianTeamField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch all the teams options for the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** The team selected on the Issue or default team configured for the field. */
  selectedTeam?: Maybe<JiraAtlassianTeam>;
  /**
   * Paginated list of team options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  teams?: Maybe<JiraAtlassianTeamConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */
export type JiraAtlassianTeamFieldTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** An interface shared across all attachment types. */
export type JiraAttachment = {
  /** Identifier for the attachment. */
  attachmentId: Scalars['String'];
  /** User profile of the attachment author. */
  author?: Maybe<User>;
  /** Date the attachment was created in seconds since the epoch. */
  created: Scalars['DateTime'];
  /** Filename of the attachment. */
  fileName?: Maybe<Scalars['String']>;
  /** Size of the attachment in bytes. */
  fileSize?: Maybe<Scalars['Long']>;
  /** Media Services file id of this Attachment, May be absent if the attachment has not yet been migrated to Media Services. */
  mediaApiFileId?: Maybe<Scalars['String']>;
  /** The mimetype (also called content type) of the attachment. This may be {@code null}. */
  mimeType?: Maybe<Scalars['String']>;
  /** Parent id that this attachment is contained in. */
  parentId?: Maybe<Scalars['String']>;
  /** Parent name that this attachment is contained in e.g Issue, Field, Comment, Worklog. */
  parentName?: Maybe<Scalars['String']>;
};

/** The connection type for JiraAttachment. */
export type JiraAttachmentConnection = {
  __typename: 'JiraAttachmentConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraAttachmentEdge>>>;
  /** The approximate count of items in the connection. */
  indicativeCount?: Maybe<Scalars['Int']>;
  /** The page info of the current page of results. */
  pageInfo: PageInfo;
};

/** An edge in a JiraAttachment connection. */
export type JiraAttachmentEdge = {
  __typename: 'JiraAttachmentEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the the edge. */
  node?: Maybe<JiraAttachment>;
};

/** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */
export type JiraAttachmentsField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraAttachmentsField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Paginated list of attachments available for the field or the Issue. */
  attachments?: Maybe<JiraAttachmentConnection>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Defines the maximum size limit (in bytes) of the total of all the attachments which can be associated with this field. */
  maxAllowedTotalAttachmentsSize?: Maybe<Scalars['Long']>;
  /** Contains the information needed to add a media content to this field. */
  mediaContext?: Maybe<JiraMediaContext>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Defines the permissions of the attachment collection. */
  permissions?: Maybe<Array<Maybe<JiraAttachmentsPermissions>>>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */
export type JiraAttachmentsFieldAttachmentsArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  orderDirection?: InputMaybe<JiraOrderDirection>;
  orderField?: InputMaybe<JiraAttachmentsOrderField>;
  startAt?: InputMaybe<Scalars['Int']>;
};

export type JiraAttachmentsOrderField = {
  id?: InputMaybe<Scalars['ID']>;
};

export const JiraAttachmentsPermissions = {
  /** Allows the user to create atachments on the correspondig Issue. */
  CreateAttachments: 'CREATE_ATTACHMENTS',
  /** Allows the user to delete attachments on the corresponding Issue. */
  DeleteOwnAttachments: 'DELETE_OWN_ATTACHMENTS'
} as const;

export type JiraAttachmentsPermissions = typeof JiraAttachmentsPermissions[keyof typeof JiraAttachmentsPermissions];
/** Represents the four avatar sizes' url. */
export type JiraAvatar = {
  __typename: 'JiraAvatar';
  /** A large avatar (48x48 pixels). */
  large?: Maybe<Scalars['String']>;
  /** A medium avatar (32x32 pixels). */
  medium?: Maybe<Scalars['String']>;
  /** A small avatar (24x24 pixels). */
  small?: Maybe<Scalars['String']>;
  /** An extra-small avatar (16x16 pixels). */
  xsmall?: Maybe<Scalars['String']>;
};

/** Represents a generic boolean field for an Issue. E.g. JSM alert linking. */
export type JiraBooleanField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraBooleanField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /** The value selected on the Issue or default value configured for the field. */
  value?: Maybe<Scalars['Boolean']>;
};

/** Represents CMDB (Configuration Management Database) field on a Jira Issue. */
export type JiraCmdbField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraCMDBField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /**
   * Attributes that are configured for autocomplete search.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use `attributesIncludedInAutoCompleteSearch` defined in `JiraCmdbFieldConfig`.
   */
  attributesIncludedInAutoCompleteSearch?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Attributes of a CMDB field’s configuration info. */
  cmdbFieldConfig?: Maybe<JiraCmdbFieldConfig>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Indicates whether Insight is available, allowing Jira to show error states. */
  isInsightAvailable?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the field is configured to act as single/multi select CMDB(s) field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use `multiple` defined in `JiraCmdbFieldConfig`.
   */
  isMulti?: Maybe<Scalars['Boolean']>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available cmdb options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The CMDB objects selected on the Issue or default CMDB objects configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedCmdbObjectsConnection instead.
   */
  selectedCmdbObjects?: Maybe<Array<Maybe<JiraCmdbObject>>>;
  /** The CMDB objects selected on the Issue or default CMDB objects configured for the field. */
  selectedCmdbObjectsConnection?: Maybe<JiraCmdbObjectConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents CMDB (Configuration Management Database) field on a Jira Issue. */
export type JiraCmdbFieldSelectedCmdbObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Represents the pair of values (parent & child combination) in a cascading select.
 * This type is used to represent a selected cascading field value on a Jira Issue.
 * Since this is 2 level hierarchy, it is not possible to represent the same underlying
 * type for both single cascadingOption and list of cascadingOptions. Thus, we have created different types.
 */
export type JiraCascadingOption = {
  __typename: 'JiraCascadingOption';
  /** Defines the selected single child option value for the parent. */
  childOptionValue?: Maybe<JiraOption>;
  /** Defines the parent option value. */
  parentOptionValue?: Maybe<JiraOption>;
};

/** Represents the childs options allowed values for a parent option in cascading select operation. */
export type JiraCascadingOptions = {
  __typename: 'JiraCascadingOptions';
  /** Defines all the list of child options available for the parent option. */
  childOptionValues?: Maybe<Array<Maybe<JiraOption>>>;
  /** Defines the parent option value. */
  parentOptionValue?: Maybe<JiraOption>;
};

/** The connection type for JiraCascadingOptions. */
export type JiraCascadingOptionsConnection = {
  __typename: 'JiraCascadingOptionsConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraCascadingOptionsEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraCascadingOptions connection. */
export type JiraCascadingOptionsEdge = {
  __typename: 'JiraCascadingOptionsEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraCascadingOptions>;
};

/** Represents cascading select field. Currently only handles 2 level hierarchy. */
export type JiraCascadingSelectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraCascadingSelectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** The cascading option selected on the Issue or default cascading option configured for the field. */
  cascadingOption?: Maybe<JiraCascadingOption>;
  /**
   * Paginated list of cascading options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  cascadingOptions?: Maybe<JiraCascadingOptionsConnection>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents cascading select field. Currently only handles 2 level hierarchy. */
export type JiraCascadingSelectFieldCascadingOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents the check boxes field on a Jira Issue. */
export type JiraCheckboxesField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraCheckboxesField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldOptions?: Maybe<JiraOptionConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * The options selected on the Issue or default options configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedOptions instead.
   */
  selectedFieldOptions?: Maybe<Array<Maybe<JiraOption>>>;
  /** The options selected on the Issue or default options configured for the field. */
  selectedOptions?: Maybe<JiraOptionConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the check boxes field on a Jira Issue. */
export type JiraCheckboxesFieldFieldOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents the check boxes field on a Jira Issue. */
export type JiraCheckboxesFieldSelectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * A union type representing childIssues available within a Jira Issue.
 * The *WithinLimit type is used for childIssues with a count that is within a limit specified by the server.
 * The *ExceedsLimit type is used for childIssues with a count that exceeds a limit specified by the server.
 */
export type JiraChildIssues = JiraChildIssuesExceedingLimit | JiraChildIssuesWithinLimit;

/** Represents childIssues with a count that exceeds a limit set by the server. */
export type JiraChildIssuesExceedingLimit = {
  __typename: 'JiraChildIssuesExceedingLimit';
  /** Search string to query childIssues when limit is exceeded. */
  search?: Maybe<Scalars['String']>;
};

/** Represents childIssues with a count that is within the count limit set by the server. */
export type JiraChildIssuesWithinLimit = {
  __typename: 'JiraChildIssuesWithinLimit';
  /**
   * Paginated list of childIssues within this Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  issues?: Maybe<JiraIssueConnection>;
};


/** Represents childIssues with a count that is within the count limit set by the server. */
export type JiraChildIssuesWithinLimitIssuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents the attribute associated with the CMDB object. */
export type JiraCmdbAttribute = {
  __typename: 'JiraCmdbAttribute';
  /**
   * Paginated list of attribute values present on the CMDB object.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  objectAttributeValues?: Maybe<JiraCmdbObjectAttributeValueConnection>;
  /** The object type attribute. */
  objectTypeAttribute?: Maybe<JiraCmdbObjectTypeAttribute>;
  /** The object type attribute ID. */
  objectTypeAttributeId?: Maybe<Scalars['String']>;
};


/** Represents the attribute associated with the CMDB object. */
export type JiraCmdbAttributeObjectAttributeValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for JiraCmdbAttribute. */
export type JiraCmdbAttributeConnection = {
  __typename: 'JiraCmdbAttributeConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraCmdbAttributeEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraCmdbAttribute connection. */
export type JiraCmdbAttributeEdge = {
  __typename: 'JiraCmdbAttributeEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraCmdbAttribute>;
};

/** The category of the CMDB attribute that can be created. */
export const JiraCmdbAttributeType = {
  /** Confluence attribute. */
  Confluence: 'CONFLUENCE',
  /** Default attributes, e.g. text, boolean, integer, date. */
  Default: 'DEFAULT',
  /** Group attribute. */
  Group: 'GROUP',
  /** Project attribute. */
  Project: 'PROJECT',
  /** Reference object attribute. */
  ReferencedObject: 'REFERENCED_OBJECT',
  /** Status attribute. */
  Status: 'STATUS',
  /** User attribute. */
  User: 'USER',
  /** Version attribute. */
  Version: 'VERSION'
} as const;

export type JiraCmdbAttributeType = typeof JiraCmdbAttributeType[keyof typeof JiraCmdbAttributeType];
/** Represents a CMDB avatar. */
export type JiraCmdbAvatar = {
  __typename: 'JiraCmdbAvatar';
  /** The UUID of the CMDB avatar. */
  avatarUUID?: Maybe<Scalars['String']>;
  /** The ID of the CMDB avatar. */
  id?: Maybe<Scalars['String']>;
  /** The media client config used for retrieving the CMDB Avatar. */
  mediaClientConfig?: Maybe<JiraCmdbMediaClientConfig>;
  /** The 16x16 pixel CMDB avatar. */
  url16?: Maybe<Scalars['String']>;
  /** The 48x48 pixel CMDB avatar. */
  url48?: Maybe<Scalars['String']>;
  /** The 72x72 pixel CMDB avatar. */
  url72?: Maybe<Scalars['String']>;
  /** The 144x144 pixel CMDB avatar. */
  url144?: Maybe<Scalars['String']>;
  /** The 288x288 pixel CMDB avatar. */
  url288?: Maybe<Scalars['String']>;
};

/** The connection type for CMDB config attributes. */
export type JiraCmdbConfigAttributeConnection = {
  __typename: 'JiraCmdbConfigAttributeConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraCmdbConfigAttributeEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraCmdbConfigAttributeConnection. */
export type JiraCmdbConfigAttributeEdge = {
  __typename: 'JiraCmdbConfigAttributeEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<Scalars['String']>;
};

/**
 * Represents the CMDB default type.
 * This contains information about what type of default attribute this is.
 * The possible id: name values are as follows:
 *     0: Text
 *     1: Integer
 *     2: Boolean
 *     3: Float
 *     4: Date
 *     6: DateTime
 *     7: URL
 *     8: Email
 *     9: Textarea
 *     10: Select
 *     11: IP Address
 */
export type JiraCmdbDefaultType = {
  __typename: 'JiraCmdbDefaultType';
  /** The ID of the CMDB default type. */
  id?: Maybe<Scalars['String']>;
  /** The name of the CMDB default type. */
  name?: Maybe<Scalars['String']>;
};

/** Attributes of CMDB field configuration. */
export type JiraCmdbFieldConfig = {
  __typename: 'JiraCmdbFieldConfig';
  /**
   * Paginated list of CMDB attributes displayed on issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  attributesDisplayedOnIssue?: Maybe<JiraCmdbConfigAttributeConnection>;
  /**
   * Paginated list of CMDB attributes included in autocomplete search.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  attributesIncludedInAutoCompleteSearch?: Maybe<JiraCmdbConfigAttributeConnection>;
  /** The issue scope filter query. */
  issueScopeFilterQuery?: Maybe<Scalars['String']>;
  /** Indicates whether this CMDB field should contain multiple CMDB objects or not. */
  multiple?: Maybe<Scalars['Boolean']>;
  /** The object filter query. */
  objectFilterQuery?: Maybe<Scalars['String']>;
  /** The object schema ID associated with the CMDB object. */
  objectSchemaId: Scalars['String'];
};


/** Attributes of CMDB field configuration. */
export type JiraCmdbFieldConfigAttributesDisplayedOnIssueArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Attributes of CMDB field configuration. */
export type JiraCmdbFieldConfigAttributesIncludedInAutoCompleteSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a CMDB icon. */
export type JiraCmdbIcon = {
  __typename: 'JiraCmdbIcon';
  /** The ID of the CMDB icon. */
  id: Scalars['String'];
  /** The name of the CMDB icon. */
  name?: Maybe<Scalars['String']>;
  /** The URL of the small CMDB icon. */
  url16?: Maybe<Scalars['String']>;
  /** The URL of the large CMDB icon. */
  url48?: Maybe<Scalars['String']>;
};

/** Represents the media client config used for retrieving the CMDB Avatar. */
export type JiraCmdbMediaClientConfig = {
  __typename: 'JiraCmdbMediaClientConfig';
  /** The media client ID for the CMDB avatar. */
  clientId?: Maybe<Scalars['String']>;
  /** The media file ID for the CMDB avatar. */
  fileId?: Maybe<Scalars['String']>;
  /** The ASAP issuer of the media token. */
  issuer?: Maybe<Scalars['String']>;
  /** The media base URL for the CMDB avatar. */
  mediaBaseUrl?: Maybe<Scalars['URL']>;
  /** The media JWT token for the CMDB avatar. */
  mediaJwtToken?: Maybe<Scalars['String']>;
};

/** Jira Configuration Management Database. */
export type JiraCmdbObject = Node & {
  __typename: 'JiraCmdbObject';
  /**
   * Paginated list of attributes present on the CMDB object.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  attributes?: Maybe<JiraCmdbAttributeConnection>;
  /** The avatar associated with this CMDB object. */
  avatar?: Maybe<JiraCmdbAvatar>;
  /** Global identifier for the CMDB field. */
  id: Scalars['ID'];
  /** Label of the CMDB object. */
  label?: Maybe<Scalars['String']>;
  /** Unique object id formed with `workspaceId`:`objectId`. */
  objectGlobalId?: Maybe<Scalars['String']>;
  /** Unique id in the workspace of the CMDB object. */
  objectId?: Maybe<Scalars['String']>;
  /** The key associated with the CMDB object. */
  objectKey?: Maybe<Scalars['String']>;
  /** The CMDB object type. */
  objectType?: Maybe<JiraCmdbObjectType>;
  /** The URL link for this CMDB object. */
  webUrl?: Maybe<Scalars['String']>;
  /** Workspace id of the CMDB object. */
  workspaceId?: Maybe<Scalars['String']>;
};


/** Jira Configuration Management Database. */
export type JiraCmdbObjectAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Represents the CMDB object attribute value.
 * The property values in this type will be defined depending on the attribute type.
 * E.g. the `referenceObject` property value will only be defined if the attribute type is a reference object type.
 */
export type JiraCmdbObjectAttributeValue = {
  __typename: 'JiraCmdbObjectAttributeValue';
  /** The additional value of this CMDB object attribute value. */
  additionalValue?: Maybe<Scalars['String']>;
  /** The display value of this CMDB object attribute value. */
  displayValue?: Maybe<Scalars['String']>;
  /** The group associated with this CMDB object attribute value. */
  group?: Maybe<JiraGroup>;
  /** The referenced CMDB object. */
  referencedObject?: Maybe<JiraCmdbObject>;
  /** The search value of this CMDB object attribute value. */
  searchValue?: Maybe<Scalars['String']>;
  /** The status of this CMDB object attribute value. */
  status?: Maybe<JiraCmdbStatusType>;
  /** The user associated with this CMDB object attribute value. */
  user?: Maybe<User>;
  /** The value of this CMDB object attribute value. */
  value?: Maybe<Scalars['String']>;
};

/** The connection type for JiraCmdbObjectAttributeValue. */
export type JiraCmdbObjectAttributeValueConnection = {
  __typename: 'JiraCmdbObjectAttributeValueConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraCmdbObjectAttributeValueEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraCmdbObjectAttributeValue connection. */
export type JiraCmdbObjectAttributeValueEdge = {
  __typename: 'JiraCmdbObjectAttributeValueEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraCmdbObjectAttributeValue>;
};

/** The connection type for JiraCmdbObject. */
export type JiraCmdbObjectConnection = {
  __typename: 'JiraCmdbObjectConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraCmdbObjectEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraCmdbObject connection. */
export type JiraCmdbObjectEdge = {
  __typename: 'JiraCmdbObjectEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraCmdbObject>;
};

/** Represents the CMDB object type. */
export type JiraCmdbObjectType = {
  __typename: 'JiraCmdbObjectType';
  /** The description of the CMDB object type. */
  description?: Maybe<Scalars['String']>;
  /** The icon of the CMDB object type. */
  icon?: Maybe<JiraCmdbIcon>;
  /** The name of the CMDB object type. */
  name?: Maybe<Scalars['String']>;
  /** The object schema id of the CMDB object type. */
  objectSchemaId?: Maybe<Scalars['String']>;
  /** The ID of the CMDB object type. */
  objectTypeId: Scalars['String'];
};

/** Represents the CMDB object type attribute. */
export type JiraCmdbObjectTypeAttribute = {
  __typename: 'JiraCmdbObjectTypeAttribute';
  /** The additional value of the CMDB object type attribute. */
  additionalValue?: Maybe<Scalars['String']>;
  /**
   * The default type of the CMDB object type attribute.
   * This property will be present if the `type` of the attribute is `DEFAULT`.
   */
  defaultType?: Maybe<JiraCmdbDefaultType>;
  /** The description of the CMDB object type attribute. */
  description?: Maybe<Scalars['String']>;
  /** A boolean representing whether this attribute is set as the label attribute or not. */
  label?: Maybe<Scalars['Boolean']>;
  /** The name of the CMDB object type attribute. */
  name?: Maybe<Scalars['String']>;
  /** The object type of the CMDB object type attribute. */
  objectType?: Maybe<JiraCmdbObjectType>;
  /**
   * The reference object type of the CMDB object type attribute.
   * This property will be present if the `type` of the attribute is `REFERENCED_OBJECT`.
   */
  referenceObjectType?: Maybe<JiraCmdbObjectType>;
  /**
   * The reference object type ID of the CMDB object type attribute.
   * This property will be present if the `type` of the attribute is `REFERENCED_OBJECT`.
   */
  referenceObjectTypeId?: Maybe<Scalars['String']>;
  /**
   * The reference type of the CMDB object type attribute.
   * This property will be present if the `type` of the attribute is `REFERENCED_OBJECT`.
   */
  referenceType?: Maybe<JiraCmdbReferenceType>;
  /** The suffix associated with the CMDB object type attribute. */
  suffix?: Maybe<Scalars['String']>;
  /** The category of the CMDB attribute that can be created. */
  type?: Maybe<JiraCmdbAttributeType>;
};

/**
 * Represents the CMDB reference type.
 * This describes the type of connection between one object and another.
 */
export type JiraCmdbReferenceType = {
  __typename: 'JiraCmdbReferenceType';
  /** The color of the CMDB reference type. */
  color?: Maybe<Scalars['String']>;
  /** The description of the CMDB reference type. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the CMDB reference type. */
  id?: Maybe<Scalars['String']>;
  /** The name of the CMDB reference type. */
  name?: Maybe<Scalars['String']>;
  /** The object schema ID of the CMDB reference type. */
  objectSchemaId?: Maybe<Scalars['String']>;
  /** The URL of the icon of the CMDB reference type. */
  webUrl?: Maybe<Scalars['String']>;
};

/** Represents the CMDB status type. */
export type JiraCmdbStatusType = {
  __typename: 'JiraCmdbStatusType';
  /** The category of the CMDB status type. */
  category?: Maybe<Scalars['Int']>;
  /** The description of the CMDB status type. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the CMDB status type. */
  id?: Maybe<Scalars['String']>;
  /** The name of the CMDB status type. */
  name?: Maybe<Scalars['String']>;
  /** The object schema ID associated with the CMDB status type. */
  objectSchemaId?: Maybe<Scalars['String']>;
};

/** Jira color that displays on a field. */
export type JiraColor = {
  __typename: 'JiraColor';
  /** The key associated with the color based on the field type (issue color, epic color). */
  colorKey?: Maybe<Scalars['String']>;
  /** Global identifier for the color. */
  id?: Maybe<Scalars['ID']>;
};

/** Represents color field on a Jira Issue. E.g. issue color, epic color. */
export type JiraColorField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraColorField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** The color selected on the Issue or default color configured for the field. */
  color?: Maybe<JiraColor>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** An interface shared across all comment types. */
export type JiraComment = {
  /** User profile of the original comment author. */
  author?: Maybe<User>;
  /** Identifier for the comment. */
  commentId: Scalars['ID'];
  /** Time of comment creation. */
  created: Scalars['DateTime'];
  /** The issue to which this comment is belonged. */
  issue?: Maybe<JiraIssue>;
  /**
   * Either the group or the project role associated with this comment, but not both.
   * Null means the permission level is unspecified, i.e. the comment is public.
   */
  permissionLevel?: Maybe<JiraPermissionLevel>;
  /** Comment body rich text. */
  richText?: Maybe<JiraRichText>;
  /** User profile of the author performing the comment update. */
  updateAuthor?: Maybe<User>;
  /** Time of last comment update. */
  updated?: Maybe<Scalars['DateTime']>;
  /** The browser clickable link of this comment. */
  webUrl?: Maybe<Scalars['URL']>;
};

/** The connection type for JiraComment. */
export type JiraCommentConnection = {
  __typename: 'JiraCommentConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraCommentEdge>>>;
  /** The approximate count of items in the connection. */
  indicativeCount?: Maybe<Scalars['Int']>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a JiraComment connection. */
export type JiraCommentEdge = {
  __typename: 'JiraCommentEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the the edge. */
  node?: Maybe<JiraComment>;
};

/** Jira component defines a sub-selectin of a project. */
export type JiraComponent = Node & {
  __typename: 'JiraComponent';
  /** Component id in digital format. */
  componentId: Scalars['String'];
  /** Component description. */
  description?: Maybe<Scalars['String']>;
  /** Global identifier for the color. */
  id: Scalars['ID'];
  /** The name of the component. */
  name?: Maybe<Scalars['String']>;
};

/** The connection type for JiraComponent. */
export type JiraComponentConnection = {
  __typename: 'JiraComponentConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraComponentEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraComponent connection. */
export type JiraComponentEdge = {
  __typename: 'JiraComponentEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraComponent>;
};

/** Represents components field on a Jira Issue. */
export type JiraComponentsField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraComponentsField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /**
   * Paginated list of component options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  components?: Maybe<JiraComponentConnection>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * The component selected on the Issue or default component configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedComponentsConnection instead.
   */
  selectedComponents?: Maybe<Array<Maybe<JiraComponent>>>;
  /** The component selected on the Issue or default component configured for the field. */
  selectedComponentsConnection?: Maybe<JiraComponentConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents components field on a Jira Issue. */
export type JiraComponentsFieldComponentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents components field on a Jira Issue. */
export type JiraComponentsFieldSelectedComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraConnectMultipleSelectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldOptions?: Maybe<JiraOptionConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The options selected on the Issue or default options configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedOptions instead.
   */
  selectedFieldOptions?: Maybe<Array<Maybe<JiraOption>>>;
  /** The options selected on the Issue or default options configured for the field. */
  selectedOptions?: Maybe<JiraOptionConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectFieldFieldOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectFieldSelectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a number field created by Connect App. */
export type JiraConnectNumberField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraConnectNumberField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Connected number. */
  number?: Maybe<Scalars['Float']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents rich text field on a Jira Issue. E.g. description, environment. */
export type JiraConnectRichTextField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraConnectRichTextField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Contains the information needed to add a media content to this field. */
  mediaContext?: Maybe<JiraMediaContext>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Determines what editor to render.
   * E.g. default text rendering or wiki text rendering.
   */
  renderer?: Maybe<Scalars['String']>;
  /** The rich text selected on the Issue or default rich text configured for the field. */
  richText?: Maybe<JiraRichText>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a single select field created by Connect App. */
export type JiraConnectSingleSelectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraConnectSingleSelectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** The option selected on the Issue or default option configured for the field. */
  fieldOption?: Maybe<JiraOption>;
  /**
   * Paginated list of options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldOptions?: Maybe<JiraOptionConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a single select field created by Connect App. */
export type JiraConnectSingleSelectFieldFieldOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents a text field created by Connect App. */
export type JiraConnectTextField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraConnectTextField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Content of the connect text field. */
  text?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a user generated custom filter. */
export type JiraCustomFilter = JiraFilter & Node & {
  __typename: 'JiraCustomFilter';
  /** A string containing filter description. */
  description?: Maybe<Scalars['String']>;
  /** A tenant local filterId. This value is used for interoperability with REST APIs (eg vendors). */
  filterId: Scalars['String'];
  /** An ARI value in the format `ari:cloud:jira:{siteId}:filter/activation/{activationId}/{filterId}`that encodes the filterId. */
  id: Scalars['ID'];
  /** Determines whether the filter is currently starred by the user viewing the filter. */
  isFavourite?: Maybe<Scalars['Boolean']>;
  /** JQL associated with the filter. */
  jql: Scalars['String'];
  /** A string representing the filter name. */
  name: Scalars['String'];
  /** The user that owns the filter. */
  owner?: Maybe<User>;
};

/** Represents a date picker field on an issue. E.g. due date, custom date picker, baseline start, baseline end. */
export type JiraDatePickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraDatePickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** The date selected on the Issue or default date configured for the field. */
  date?: Maybe<Scalars['Date']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a date time picker field on a Jira Issue. E.g. created, resolution date, custom date time, request-feedback-date. */
export type JiraDateTimePickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraDateTimePickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** The datetime selected on the Issue or default datetime configured for the field. */
  dateTime?: Maybe<Scalars['DateTime']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/**
 * The default grant type with only id and name to return data for grant types such as PROJECT_LEAD, APPLICATION_ROLE,
 * ANY_LOGGEDIN_USER_APPLICATION_ROLE, ANONYMOUS_ACCESS, SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS
 */
export type JiraDefaultGrantTypeValue = Node & {
  __typename: 'JiraDefaultGrantTypeValue';
  /**
   * The ARI to represent the default grant type value.
   * For example:
   * PROJECT_LEAD ari - ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:role/project-lead/activation/bd0c43a9-a23a-4302-8ffa-ca04bde7c747/project/f67c73a8-545e-455b-a6bd-3d53cb7e0524
   * APPLICATION_ROLE ari for JSM - ari:cloud:jira-servicedesk::role/123
   * ANY_LOGGEDIN_USER_APPLICATION_ROLE ari - ari:cloud:jira::role/product/member
   * ANONYMOUS_ACCESS ari - ari:cloud:identity::user/unidentified
   */
  id: Scalars['ID'];
  /** The display name of the grant type value such as GROUP. */
  name: Scalars['String'];
};

/** Details of a created SCM branch associated with a Jira issue. */
export type JiraDevOpsBranchDetails = {
  __typename: 'JiraDevOpsBranchDetails';
  /** Entity URL link to branch in its original provider */
  entityUrl?: Maybe<Scalars['URL']>;
  /** Branch name */
  name?: Maybe<Scalars['String']>;
  /** Value uniquely identify the scm branch scoped to its original provider, not ARI format */
  providerBranchId?: Maybe<Scalars['String']>;
  /** The scm repository contains the branch. */
  scmRepository?: Maybe<JiraScmRepository>;
};

/** Details of a SCM commit associated with a Jira issue. */
export type JiraDevOpsCommitDetails = {
  __typename: 'JiraDevOpsCommitDetails';
  /** Details of author who created the commit. */
  author?: Maybe<JiraDevOpsEntityAuthor>;
  /** The commit date in ISO 8601 format. */
  created?: Maybe<Scalars['DateTime']>;
  /** Shorten value of the commit-hash, used for display. */
  displayCommitId?: Maybe<Scalars['String']>;
  /** Entity URL link to commit in its original provider */
  entityUrl?: Maybe<Scalars['URL']>;
  /** Flag represents if the commit is a merge commit. */
  isMergeCommit?: Maybe<Scalars['Boolean']>;
  /** The commit message. */
  name?: Maybe<Scalars['String']>;
  /** Value uniquely identify the commit (commit-hash), not ARI format. */
  providerCommitId?: Maybe<Scalars['String']>;
  /** The scm repository contains the commit. */
  scmRepository?: Maybe<JiraScmRepository>;
};

/** Basic person information who created a SCM entity (Pull-request, Branches, or Commit) */
export type JiraDevOpsEntityAuthor = {
  __typename: 'JiraDevOpsEntityAuthor';
  /** The author's avatar. */
  avatar?: Maybe<JiraAvatar>;
  /** Author name. */
  name?: Maybe<Scalars['String']>;
};

/** Details of a SCM Pull-request associated with a Jira issue */
export type JiraDevOpsPullRequestDetails = {
  __typename: 'JiraDevOpsPullRequestDetails';
  /** Details of author who created the Pull Request. */
  author?: Maybe<JiraDevOpsEntityAuthor>;
  /** The name of the source branch of the PR. */
  branchName?: Maybe<Scalars['String']>;
  /** Entity URL link to pull request in its original provider */
  entityUrl?: Maybe<Scalars['URL']>;
  /** The timestamp of when the PR last updated in ISO 8601 format. */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** Pull request title */
  name?: Maybe<Scalars['String']>;
  /** Value uniquely identify a pull request scoped to its original scm provider, not ARI format */
  providerPullRequestId?: Maybe<Scalars['String']>;
  /**
   * List of the reviewers for this pull request and their approval status.
   * Maximum of 50 reviewers will be returned.
   */
  reviewers?: Maybe<Array<JiraPullRequestReviewer>>;
  /** Possible states for Pull Requests. */
  status?: Maybe<JiraPullRequestState>;
};

/** Represents dev summary for an issue. The identifier for this field is devSummary */
export type JiraDevSummaryField = JiraIssueField & Node & {
  __typename: 'JiraDevSummaryField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /**
   * A summary of the development information (e.g. pull requests, commits) associated with
   * this issue.
   *
   * WARNING: The data returned by this field may be stale/outdated. This field is temporary and
   * will be replaced by a `devSummary` field that returns up-to-date information.
   *
   * In the meantime, if you only need data for a single issue you can use the `JiraDevOpsQuery.devOpsIssuePanel`
   * field to get up-to-date dev summary data.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraDevSummaryIssueField` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  devSummaryCache?: Maybe<JiraIssueDevSummaryResult>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
};

/** Represents an epic. */
export type JiraEpic = {
  __typename: 'JiraEpic';
  /** Color string for the epic. */
  color?: Maybe<Scalars['String']>;
  /** Status of the epic, whether its completed or not. */
  done?: Maybe<Scalars['Boolean']>;
  /** Global identifier for the epic/issue Id. */
  id: Scalars['ID'];
  /** Issue Id for the epic. */
  issueId: Scalars['String'];
  /** Key identifier for the Issue. */
  key?: Maybe<Scalars['String']>;
  /** Name of the epic. */
  name?: Maybe<Scalars['String']>;
  /** Summary of the epic. */
  summary?: Maybe<Scalars['String']>;
};

/** The connection type for JiraEpic. */
export type JiraEpicConnection = {
  __typename: 'JiraEpicConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraEpicEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraEpic connection. */
export type JiraEpicEdge = {
  __typename: 'JiraEpicEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraEpic>;
};

/** Represents epic link field on a Jira Issue. */
export type JiraEpicLinkField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraEpicLinkField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** The epic selected on the Issue or default epic configured for the field. */
  epic?: Maybe<JiraEpic>;
  /**
   * Paginated list of epic options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  epics?: Maybe<JiraEpicConnection>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available epics options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents epic link field on a Jira Issue. */
export type JiraEpicLinkFieldEpicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  done?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents the Jira time tracking estimate type. */
export type JiraEstimate = {
  __typename: 'JiraEstimate';
  /** The estimated time in seconds. */
  timeInSeconds?: Maybe<Scalars['Long']>;
};

/** Attributes of field configuration. */
export type JiraFieldConfig = {
  __typename: 'JiraFieldConfig';
  /** Defines if a field is editable. */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Defines if a field is required on a screen. */
  isRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Explains the reason why a field is not editable on a screen.
   * E.g. cases where a field needs a licensed premium version to be editable.
   */
  nonEditableReason?: Maybe<JiraFieldNonEditableReason>;
};

/** Represents the information for a field being non-editable on Issue screens. */
export type JiraFieldNonEditableReason = {
  __typename: 'JiraFieldNonEditableReason';
  /** Message explanining why the field is non-editable (if present). */
  message?: Maybe<Scalars['String']>;
};

/** A generic interface for Jira Filter. */
export type JiraFilter = {
  /** A tenant local filterId. This value is used for interoperability with REST APIs (eg vendors). */
  filterId: Scalars['String'];
  /** An ARI value in the format `ari:cloud:jira:{siteId}:filter/activation/{activationId}/{filterId}`that encodes the filterId. */
  id: Scalars['ID'];
  /** Determines whether the filter is currently starred by the user viewing the filter. */
  isFavourite?: Maybe<Scalars['Boolean']>;
  /** JQL associated with the filter. */
  jql: Scalars['String'];
  /** A string representing the filter name. */
  name: Scalars['String'];
};

/** Represents the Jira flag. */
export type JiraFlag = {
  __typename: 'JiraFlag';
  /** Indicates whether the issue is flagged or not. */
  isFlagged?: Maybe<Scalars['Boolean']>;
};

/** Represents a flag field on a Jira Issue. E.g. flagged. */
export type JiraFlagField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraFlagField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** The flag value selected on the Issue. */
  flag?: Maybe<JiraFlag>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a date time field created by Forge App. */
export type JiraForgeDatetimeField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeDatetimeField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** The datetime selected on the issue or default datetime configured for the field. */
  dateTime?: Maybe<Scalars['DateTime']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a Group field created by Forge App. */
export type JiraForgeGroupField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeGroupField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of group options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  groups?: Maybe<JiraGroupConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Search url to fetch all available groups for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** The group selected on the Issue or default group configured for the field. */
  selectedGroup?: Maybe<JiraGroup>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a Group field created by Forge App. */
export type JiraForgeGroupFieldGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents a Groups field created by Forge App. */
export type JiraForgeGroupsField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeGroupsField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of group options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  groups?: Maybe<JiraGroupConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Search url to fetch all available groups for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The groups selected on the Issue or default group configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedGroupsConnection instead.
   */
  selectedGroups?: Maybe<Array<Maybe<JiraGroup>>>;
  /** The groups selected on the Issue or default group configured for the field. */
  selectedGroupsConnection?: Maybe<JiraGroupConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a Groups field created by Forge App. */
export type JiraForgeGroupsFieldGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents a Groups field created by Forge App. */
export type JiraForgeGroupsFieldSelectedGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a number field created by Forge App. */
export type JiraForgeNumberField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeNumberField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The number selected on the Issue or default number configured for the field. */
  number?: Maybe<Scalars['Float']>;
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a object field created by Forge App. */
export type JiraForgeObjectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeObjectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The object string selected on the issue or default datetime configured for the field. */
  object?: Maybe<Scalars['String']>;
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a string field created by Forge App. */
export type JiraForgeStringField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeStringField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** The text selected on the Issue or default text configured for the field. */
  text?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a strings field created by Forge App. */
export type JiraForgeStringsField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeStringsField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /**
   * Paginated list of label options for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  labels?: Maybe<JiraLabelConnection>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Search url to fetch all available labels options on the field or an Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The labels selected on the Issue or default labels configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedLabelsConnection instead.
   */
  selectedLabels?: Maybe<Array<Maybe<JiraLabel>>>;
  /** The labels selected on the Issue or default labels configured for the field. */
  selectedLabelsConnection?: Maybe<JiraLabelConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a strings field created by Forge App. */
export type JiraForgeStringsFieldLabelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a strings field created by Forge App. */
export type JiraForgeStringsFieldSelectedLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a User field created by Forge App. */
export type JiraForgeUserField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeUserField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** The user selected on the Issue or default user configured for the field. */
  user?: Maybe<User>;
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Represents a User field created by Forge App. */
export type JiraForgeUserFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a Users field created by Forge App. */
export type JiraForgeUsersField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraForgeUsersField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
  renderer?: Maybe<Scalars['String']>;
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The users selected on the Issue or default users configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedUsersConnection instead.
   */
  selectedUsers?: Maybe<Array<Maybe<User>>>;
  /** The users selected on the Issue or default users configured for the field. */
  selectedUsersConnection?: Maybe<JiraUserConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Represents a Users field created by Forge App. */
export type JiraForgeUsersFieldSelectedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents a Users field created by Forge App. */
export type JiraForgeUsersFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a Jira Group. */
export type JiraGroup = Node & {
  __typename: 'JiraGroup';
  /** Group Id, can be null on group creation */
  groupId: Scalars['String'];
  /** The global identifier of the group in ARI format. */
  id: Scalars['ID'];
  /** Name of the Group */
  name: Scalars['String'];
};

/** The connection type for JiraGroup. */
export type JiraGroupConnection = {
  __typename: 'JiraGroupConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraGroupEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraGroupConnection connection. */
export type JiraGroupEdge = {
  __typename: 'JiraGroupEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraGroup>;
};

/** The GROUP grant type value where group data is provided by identity service. */
export type JiraGroupGrantTypeValue = Node & {
  __typename: 'JiraGroupGrantTypeValue';
  /** The group information such as name, and description. */
  group: JiraGroup;
  /**
   * The ARI to represent the group grant type value.
   * For example: ari:cloud:identity::group/123
   */
  id: Scalars['ID'];
};

/**
 * The representation for an invalid JQL error.
 * E.g. 'project = TMP' where 'TMP' has been deleted.
 */
export type JiraInvalidJqlError = {
  __typename: 'JiraInvalidJqlError';
  /** A list of JQL validation messages. */
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The representation for JQL syntax error.
 * E.g. 'project asd = TMP'.
 */
export type JiraInvalidSyntaxError = {
  __typename: 'JiraInvalidSyntaxError';
  /** The column of the JQL where the JQL syntax error occurred. */
  column?: Maybe<Scalars['Int']>;
  /** The error type of this particular syntax error. */
  errorType?: Maybe<JiraJqlSyntaxError>;
  /** The line of the JQL where the JQL syntax error occurred. */
  line?: Maybe<Scalars['Int']>;
  /** The specific error message. */
  message?: Maybe<Scalars['String']>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssue = Node & {
  __typename: 'JiraIssue';
  /**
   * Paginated list of attachments available on this issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  attachments?: Maybe<JiraAttachmentConnection>;
  /** The childIssues within this issue. */
  childIssues?: Maybe<JiraChildIssues>;
  /**
   * Paginated list of comments available on this issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  comments?: Maybe<JiraCommentConnection>;
  /**
   * The deployments summary. Contains summary of all deployment provider data.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: DevOpsSummarisedDeployments` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  deploymentsSummary?: Maybe<DevOpsSummarisedDeployments>;
  /**
   * The SCM development-info entities (pull requests, branches, commits) associated with a Jira issue.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueDevInfoDetails` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  devInfoDetails?: Maybe<JiraIssueDevInfoDetails>;
  /**
   * The dev summary cache. This could be stale.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueDevSummaryCache` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  devSummaryCache?: Maybe<JiraIssueDevSummaryResult>;
  /**
   * Loads all field sets relevant to the current context for the Issue.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated New schema in development right now. This is incomplete.
   */
  fieldSets?: Maybe<JiraIssueFieldSetConnection>;
  /**
   * Loads all field sets for a specified JiraIssueSearchView.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  fieldSetsForIssueSearchView?: Maybe<JiraIssueFieldSetConnection>;
  /**
   * Loads the fields relevant to the current GraphQL Query, Issue and User contexts.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fields?: Maybe<JiraIssueFieldConnection>;
  /**
   * Paginated list of fields available on this issue. Allows clients to specify fields by their identifier.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldsById?: Maybe<JiraIssueFieldConnection>;
  /** Returns the hierarchy info that's directly below the current issue's hierarchy. */
  hierarchyLevelAbove?: Maybe<JiraIssueTypeHierarchyLevel>;
  /** Returns the hierarchy info that's directly below the current issue's hierarchy if the current issue's project is TMP. */
  hierarchyLevelBelow?: Maybe<JiraIssueTypeHierarchyLevel>;
  /** Unique identifier associated with this Issue. */
  id: Scalars['ID'];
  /** Issue ID in numeric format. E.g. 10000 */
  issueId: Scalars['String'];
  /**
   * Paginated list of issue links available on this issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  issueLinks?: Maybe<JiraIssueLinkConnection>;
  /** Returns the issue types within the same project and are directly above the current issue's hierarchy. */
  issueTypesForHierarchyAbove?: Maybe<JiraIssueTypeConnection>;
  /** Returns the issue types within the same project and are directly below the current issue's hierarchy if the current issue's project is TMP. */
  issueTypesForHierarchyBelow?: Maybe<JiraIssueTypeConnection>;
  /** Returns the issue types within the same project that are at the same level as the current issue's hierarchy if the current issue's project is TMP. */
  issueTypesForHierarchySame?: Maybe<JiraIssueTypeConnection>;
  /** The {projectKey}-{issueNumber} associated with this Issue. */
  key: Scalars['String'];
  /** The browser clickable link of this Issue. */
  webUrl?: Maybe<Scalars['URL']>;
  /**
   * Paginated list of worklogs available on this issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  worklogs?: Maybe<JiraWorkLogConnection>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldSetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldSetsForIssueSearchViewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  viewId?: InputMaybe<Scalars['String']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldsByIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueIssueLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueWorklogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Summary of the Branches attached to the issue */
export type JiraIssueBranchDevSummary = {
  __typename: 'JiraIssueBranchDevSummary';
  /** Total number of Branches for the issue */
  count?: Maybe<Scalars['Int']>;
  /** Date at which this summary was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
};

/** Container for the summary of the Branches attached to the issue */
export type JiraIssueBranchDevSummaryContainer = {
  __typename: 'JiraIssueBranchDevSummaryContainer';
  /** The actual summary of the Branches attached to the issue */
  overall?: Maybe<JiraIssueBranchDevSummary>;
  /** Count of Branches aggregated per provider */
  summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The container of SCM branches info associated with a Jira issue. */
export type JiraIssueBranches = {
  __typename: 'JiraIssueBranches';
  /**
   * A list of branches details from the original SCM providers.
   * Maximum of 50 branches will be returned.
   */
  details?: Maybe<Array<JiraDevOpsBranchDetails>>;
};

/** Summary of the Builds attached to the issue */
export type JiraIssueBuildDevSummary = {
  __typename: 'JiraIssueBuildDevSummary';
  /** Total number of Builds for the issue */
  count?: Maybe<Scalars['Int']>;
  /** Number of failed buids for the issue */
  failedBuildCount?: Maybe<Scalars['Int']>;
  /** Date at which this summary was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** Number of successful buids for the issue */
  successfulBuildCount?: Maybe<Scalars['Int']>;
  /** Number of buids with unknown result for the issue */
  unknownBuildCount?: Maybe<Scalars['Int']>;
};

/** Container for the summary of the Builds attached to the issue */
export type JiraIssueBuildDevSummaryContainer = {
  __typename: 'JiraIssueBuildDevSummaryContainer';
  /** The actual summary of the Builds attached to the issue */
  overall?: Maybe<JiraIssueBuildDevSummary>;
  /** Count of Builds aggregated per provider */
  summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** Summary of the Commits attached to the issue */
export type JiraIssueCommitDevSummary = {
  __typename: 'JiraIssueCommitDevSummary';
  /** Total number of Commits for the issue */
  count?: Maybe<Scalars['Int']>;
  /** Date at which this summary was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
};

/** Container for the summary of the Commits attached to the issue */
export type JiraIssueCommitDevSummaryContainer = {
  __typename: 'JiraIssueCommitDevSummaryContainer';
  /** The actual summary of the Commits attached to the issue */
  overall?: Maybe<JiraIssueCommitDevSummary>;
  /** Count of Commits aggregated per provider */
  summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The container of SCM commits info associated with a Jira issue. */
export type JiraIssueCommits = {
  __typename: 'JiraIssueCommits';
  /**
   * A list of commits details from the original SCM providers.
   * Maximum of 50 latest created commits will be returned.
   */
  details?: Maybe<Array<JiraDevOpsCommitDetails>>;
};

/** The connection type for JiraIssue. */
export type JiraIssueConnection = {
  __typename: 'JiraIssueConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraIssueEdge>>>;
  /**
   * Returns whether or not there were more issues available for a given issue search.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  isCappingIssueSearchResult?: Maybe<Scalars['Boolean']>;
  /**
   * Extra page information for the issue navigator.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  issueNavigatorPageInfo?: Maybe<JiraIssueNavigatorPageInfo>;
  /**
   * The error that occurred during an issue search.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  issueSearchError?: Maybe<JiraIssueSearchError>;
  /**
   * jql if issues are returned by jql. This field will have value only when the context has jql
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueConnectionJql` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  jql?: Maybe<Scalars['String']>;
  /**
   * Cursors to help with random access pagination.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  pageCursors?: Maybe<JiraPageCursors>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
  /**
   * The total number of issues for a given JQL search.
   * This number will be capped based on the server's configured limit.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  totalIssueSearchResultCount?: Maybe<Scalars['Int']>;
};


/** The connection type for JiraIssue. */
export type JiraIssueConnectionPageCursorsArgs = {
  maxCursors: Scalars['Int'];
};

export type JiraIssueDeploymentEnvironment = {
  __typename: 'JiraIssueDeploymentEnvironment';
  /** State of the deployment */
  status?: Maybe<JiraIssueDeploymentEnvironmentState>;
  /** Title of the deployment environment */
  title?: Maybe<Scalars['String']>;
};

/** Summary of the Deployment Environments attached to the issue */
export type JiraIssueDeploymentEnvironmentDevSummary = {
  __typename: 'JiraIssueDeploymentEnvironmentDevSummary';
  /** Total number of Reviews for the issue */
  count?: Maybe<Scalars['Int']>;
  /** Date at which this summary was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** A list of the top environment there was a deployment on */
  topEnvironments?: Maybe<Array<JiraIssueDeploymentEnvironment>>;
};

/** Container for the summary of the Deployment Environments attached to the issue */
export type JiraIssueDeploymentEnvironmentDevSummaryContainer = {
  __typename: 'JiraIssueDeploymentEnvironmentDevSummaryContainer';
  /** The actual summary of the Deployment Environments attached to the issue */
  overall?: Maybe<JiraIssueDeploymentEnvironmentDevSummary>;
  /** Count of Deployment Environments aggregated per provider */
  summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** Possible states for a deployment environment */
export const JiraIssueDeploymentEnvironmentState = {
  /** The deployment was deployed successfully */
  Deployed: 'DEPLOYED',
  /** The deployment was not deployed successfully */
  NotDeployed: 'NOT_DEPLOYED'
} as const;

export type JiraIssueDeploymentEnvironmentState = typeof JiraIssueDeploymentEnvironmentState[keyof typeof JiraIssueDeploymentEnvironmentState];
/** The SCM entities (pullrequest, branches or commits) associated with a Jira issue. */
export type JiraIssueDevInfoDetails = {
  __typename: 'JiraIssueDevInfoDetails';
  /** Created SCM branches associated with a Jira issue. */
  branches?: Maybe<JiraIssueBranches>;
  /** Created SCM commits associated with a Jira issue. */
  commits?: Maybe<JiraIssueCommits>;
  /** Created pull-requests associated with a Jira issue. */
  pullRequests?: Maybe<JiraIssuePullRequests>;
};

/** Lists the summaries available for each type of dev info, for a given issue */
export type JiraIssueDevSummary = {
  __typename: 'JiraIssueDevSummary';
  /** Summary of the Branches attached to the issue */
  branch?: Maybe<JiraIssueBranchDevSummaryContainer>;
  /** Summary of the Builds attached to the issue */
  build?: Maybe<JiraIssueBuildDevSummaryContainer>;
  /** Summary of the Commits attached to the issue */
  commit?: Maybe<JiraIssueCommitDevSummaryContainer>;
  /**
   * Summary of the deployment environments attached to some builds.
   * This is a legacy attribute only used by Bamboo builds
   */
  deploymentEnvironments?: Maybe<JiraIssueDeploymentEnvironmentDevSummaryContainer>;
  /** Summary of the Pull Requests attached to the issue */
  pullrequest?: Maybe<JiraIssuePullRequestDevSummaryContainer>;
  /** Summary of the Reviews attached to the issue */
  review?: Maybe<JiraIssueReviewDevSummaryContainer>;
};

/** Aggregates the `count` of entities for a given provider */
export type JiraIssueDevSummaryByProvider = {
  __typename: 'JiraIssueDevSummaryByProvider';
  /** Number of entities associated with that provider */
  count?: Maybe<Scalars['Int']>;
  /** Provider name */
  name?: Maybe<Scalars['String']>;
  /** UUID for a given provider, to allow aggregation */
  providerId?: Maybe<Scalars['String']>;
};

/** Error when querying the JiraIssueDevSummary */
export type JiraIssueDevSummaryError = {
  __typename: 'JiraIssueDevSummaryError';
  /** Information about the provider that triggered the error */
  instance?: Maybe<JiraIssueDevSummaryErrorProviderInstance>;
  /** A message describing the error */
  message?: Maybe<Scalars['String']>;
};

/** Basic information on a provider that triggered an error */
export type JiraIssueDevSummaryErrorProviderInstance = {
  __typename: 'JiraIssueDevSummaryErrorProviderInstance';
  /** Base URL of the provider's instance that failed */
  baseUrl?: Maybe<Scalars['String']>;
  /** Provider's name */
  name?: Maybe<Scalars['String']>;
  /** Provider's type */
  type?: Maybe<Scalars['String']>;
};

/** Container for the Dev Summary of an issue */
export type JiraIssueDevSummaryResult = {
  __typename: 'JiraIssueDevSummaryResult';
  /**
   * Returns "non-transient errors". That is, configuration errors that require admin intervention to be solved.
   * This returns an empty collection when called for users that are not administrators or system administrators.
   */
  configErrors?: Maybe<Array<JiraIssueDevSummaryError>>;
  /** Contains all available summaries for the issue */
  devSummary?: Maybe<JiraIssueDevSummary>;
  /**
   * Returns "transient errors". That is, errors that may be solved by retrying the fetch operation.
   * This excludes configuration errors that require admin intervention to be solved.
   */
  errors?: Maybe<Array<JiraIssueDevSummaryError>>;
};

/** An edge in a JiraIssue connection. */
export type JiraIssueEdge = {
  __typename: 'JiraIssueEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraIssue>;
};

/** Represents the common structure across Issue fields. */
export type JiraIssueField = {
  /**
   * The field ID alias.
   * Applies to managed or commonly known custom fields in Jira, which allow lookup without requiring the custom field ID.
   * E.g. rank or startdate.
   */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the entity. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. E.g. project, issuetype, com.pyxis.greenhopper.Jira:gh-epic-link. */
  type: Scalars['String'];
};

/** Represents the configurations associated with an Issue field. */
export type JiraIssueFieldConfiguration = {
  /** Attributes of an Issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
};

/** The connection type for JiraIssueField. */
export type JiraIssueFieldConnection = {
  __typename: 'JiraIssueFieldConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraIssueFieldEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraIssueField connection. */
export type JiraIssueFieldEdge = {
  __typename: 'JiraIssueFieldEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraIssueField>;
};

/**
 * The issue field grant type used to represent field of an issue.
 * Grant types such as ASSIGNEE, REPORTER, MULTI USER PICKER, and MULTI GROUP PICKER use this grant type value.
 */
export type JiraIssueFieldGrantTypeValue = Node & {
  __typename: 'JiraIssueFieldGrantTypeValue';
  /** The issue field information such as name, description, field id. */
  field: JiraIssueField;
  /**
   * The ARI to represent the issue field grant type value.
   * For example:
   * assignee field ARI is ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:issuefieldvalue/10000/assignee
   * reporter field ARI is ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:issuefieldvalue/10000/reporter
   * multi user picker field ARI is ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:issuefieldvalue/10000/customfield_10126
   */
  id: Scalars['ID'];
};

/** Represents a field set which contains a set of JiraIssueFields, otherwise commonly referred to as collapsed fields. */
export type JiraIssueFieldSet = {
  __typename: 'JiraIssueFieldSet';
  /** The identifer of the field set e.g. `assignee`, `reporter`, `checkbox_cf[Checkboxes]`. */
  fieldSetId?: Maybe<Scalars['String']>;
  /** Retrieves a connection of JiraIssueFields */
  fields?: Maybe<JiraIssueFieldConnection>;
  /** The field type key of the contained fields e.g: `project`, `issuetype`, `com.pyxis.greenhopper.jira:gh-epic-link`. */
  type?: Maybe<Scalars['String']>;
};


/** Represents a field set which contains a set of JiraIssueFields, otherwise commonly referred to as collapsed fields. */
export type JiraIssueFieldSetFieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for JiraIssueFieldSet. */
export type JiraIssueFieldSetConnection = {
  __typename: 'JiraIssueFieldSetConnection';
  /** The data for Edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraIssueFieldSetEdge>>>;
  /** The page info of the current page of results. */
  pageInfo?: Maybe<PageInfo>;
  /** The total number of JiraIssueFields matching the criteria. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraIssueFieldSet connection. */
export type JiraIssueFieldSetEdge = {
  __typename: 'JiraIssueFieldSetEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the the edge. */
  node?: Maybe<JiraIssueFieldSet>;
};

/**
 * Represents a single Issue link containing the link id, link type and destination Issue.
 *
 * For Issue create, JiraIssueLink will be populated with
 * the default IssueLink types in the relatedBy field.
 * The issueLinkId and Issue fields will be null.
 *
 * For Issue view, JiraIssueLink will be populated with
 * the Issue link data available on the Issue.
 * The Issue field will contain a nested JiraIssue that is atmost 1 level deep.
 * The nested JiraIssue will not contain fields that can contain further nesting.
 */
export type JiraIssueLink = {
  __typename: 'JiraIssueLink';
  /** Global identifier for the Issue Link. */
  id?: Maybe<Scalars['ID']>;
  /** The destination Issue to which this link is connected. */
  issue?: Maybe<JiraIssue>;
  /** Identifier for the Issue Link. Can be null to represent a link not yet created. */
  issueLinkId?: Maybe<Scalars['ID']>;
  /**
   * Issue link type relation through which the source Issue is connected to the
   * destination Issue. Source Issue is the Issue being created/queried.
   */
  relatedBy?: Maybe<JiraIssueLinkTypeRelation>;
};

/** The connection type for JiraIssueLink. */
export type JiraIssueLinkConnection = {
  __typename: 'JiraIssueLinkConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraIssueLinkEdge>>>;
  /** The page info of the current page of results. */
  pageInfo: PageInfo;
  /** The total number of JiraIssueLink matching the criteria. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Represents the possible linking directions between issues. */
export const JiraIssueLinkDirection = {
  /** Going from the other issue to this issue. */
  Inward: 'INWARD',
  /** Going from this issue to the other issue. */
  Outward: 'OUTWARD'
} as const;

export type JiraIssueLinkDirection = typeof JiraIssueLinkDirection[keyof typeof JiraIssueLinkDirection];
/** An edge in a JiraIssueLink connection. */
export type JiraIssueLinkEdge = {
  __typename: 'JiraIssueLinkEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraIssueLink>;
};

/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraIssueLinkField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /**
   * Paginated list of issue links selected on the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  issueLinkConnection?: Maybe<JiraIssueLinkConnection>;
  /**
   * Represents the different issue link type relations/desc which can be mapped/linked to the issue in context.
   * Issue in context is the one which is being created/ which is being queried.
   */
  issueLinkTypeRelations?: Maybe<JiraIssueLinkTypeRelationConnection>;
  /**
   * Represents all the issue links defined on a Jira Issue. Should be deprecated and replaced with issueLinksConnection.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use issueLinkConnection instead.
   */
  issueLinks?: Maybe<Array<Maybe<JiraIssueLink>>>;
  /** Paginated list of issues which can be related/linked with above issueLinkTypeRelations. */
  issues?: Maybe<JiraIssueConnection>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to list all available issues which can be related/linked with above issueLinkTypeRelations. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkFieldIssueLinkConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkFieldIssueLinkTypeRelationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkFieldIssuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

export type JiraIssueLinkTypeRelation = Node & {
  __typename: 'JiraIssueLinkTypeRelation';
  /** Represents the direction of Issue link type. E.g. INWARD, OUTWARD. */
  direction?: Maybe<JiraIssueLinkDirection>;
  /** Global identifier for the Issue Link Type Relation. */
  id: Scalars['ID'];
  /** Represents the IssueLinkType id to which this type belongs to. */
  linkTypeId: Scalars['String'];
  /** Display name of IssueLinkType to which this relation belongs to. E.g. Blocks, Duplicate, Cloners. */
  linkTypeName?: Maybe<Scalars['String']>;
  /**
   * Represents the description of the relation by which this link is identified.
   * This can be the inward or outward description of an IssueLinkType.
   * E.g. blocks, is blocked by, duplicates, is duplicated by, clones, is cloned by.
   */
  relationName?: Maybe<Scalars['String']>;
};

/** The connection type for JiraIssueLinkTypeRelation. */
export type JiraIssueLinkTypeRelationConnection = {
  __typename: 'JiraIssueLinkTypeRelationConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraIssueLinkTypeRelationEdge>>>;
  /** The page info of the current page of results. */
  pageInfo: PageInfo;
  /** The total number of JiraIssueLinkTypeRelation matching the criteria. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraIssueLinkType connection. */
export type JiraIssueLinkTypeRelationEdge = {
  __typename: 'JiraIssueLinkTypeRelationEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraIssueLinkTypeRelation>;
};

/** Extra page information to assist the Issue Navigator UI to display information about the current set of issues. */
export type JiraIssueNavigatorPageInfo = {
  __typename: 'JiraIssueNavigatorPageInfo';
  /** The issue key of the first node from the next page of issues. */
  firstIssueKeyFromNextPage?: Maybe<Scalars['String']>;
  /**
   * The position of the first issue in the current page, relative to the entire stable search.
   * The first issue's position will start at 1.
   * If there are no issues, the position returned is 0.
   * You can consider a position to effectively be a traditional index + 1.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  firstIssuePosition?: Maybe<Scalars['Int']>;
  /** The issue key of the last node from the previous page of issues. */
  lastIssueKeyFromPreviousPage?: Maybe<Scalars['String']>;
  /**
   * The position of the last issue in the current page, relative to the entire stable search.
   * If there is only 1 issue, the last position is 1.
   * If there are no issues, the position returned is 0.
   * You can consider a position to effectively be a traditional index + 1.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  lastIssuePosition?: Maybe<Scalars['Int']>;
};

/** Summary of the Pull Requests attached to the issue */
export type JiraIssuePullRequestDevSummary = {
  __typename: 'JiraIssuePullRequestDevSummary';
  /** Total number of Pull Requests for the issue */
  count?: Maybe<Scalars['Int']>;
  /** Date at which this summary was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the Pull Requests for the given state are open or not */
  open?: Maybe<Scalars['Boolean']>;
  /** State of the Pull Requests in the summary */
  state?: Maybe<JiraPullRequestState>;
  /** Number of Pull Requests for the state */
  stateCount?: Maybe<Scalars['Int']>;
};

/** Container for the summary of the Pull Requests attached to the issue */
export type JiraIssuePullRequestDevSummaryContainer = {
  __typename: 'JiraIssuePullRequestDevSummaryContainer';
  /** The actual summary of the Pull Requests attached to the issue */
  overall?: Maybe<JiraIssuePullRequestDevSummary>;
  /** Count of Pull Requests aggregated per provider */
  summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The container of SCM pull requests info associated with a Jira issue. */
export type JiraIssuePullRequests = {
  __typename: 'JiraIssuePullRequests';
  /**
   * A list of pull request details from the original SCM providers.
   * Maximum of 50 latest updated pull-requests will be returned.
   */
  details?: Maybe<Array<JiraDevOpsPullRequestDetails>>;
};

/** Represents issue restriction field on an issue for next gen projects. */
export type JiraIssueRestrictionField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraIssueRestrictionField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Paginated list of roles available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  roles?: Maybe<JiraRoleConnection>;
  /** Search URL to fetch all the roles options for the fields on an issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The roles selected on the Issue or default roles configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedRolesConnection instead.
   */
  selectedRoles?: Maybe<Array<Maybe<JiraRole>>>;
  /** The roles selected on the Issue or default roles configured for the field. */
  selectedRolesConnection?: Maybe<JiraRoleConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents issue restriction field on an issue for next gen projects. */
export type JiraIssueRestrictionFieldRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents issue restriction field on an issue for next gen projects. */
export type JiraIssueRestrictionFieldSelectedRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Summary of the Reviews attached to the issue */
export type JiraIssueReviewDevSummary = {
  __typename: 'JiraIssueReviewDevSummary';
  /** Total number of Reviews for the issue */
  count?: Maybe<Scalars['Int']>;
  /** Date at which this summary was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** State of the Reviews in the summary */
  state?: Maybe<JiraReviewState>;
  /** Number of Reviews for the state */
  stateCount?: Maybe<Scalars['Int']>;
};

/** Container for the summary of the Reviews attached to the issue */
export type JiraIssueReviewDevSummaryContainer = {
  __typename: 'JiraIssueReviewDevSummaryContainer';
  /** The actual summary of the Reviews attached to the issue */
  overall?: Maybe<JiraIssueReviewDevSummary>;
  /** Count of Reviews aggregated per provider */
  summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The possible errors that can occur during an issue search. */
export type JiraIssueSearchError = JiraInvalidJqlError | JiraInvalidSyntaxError;

/**
 * Represents a configurable field in Jira issue searches.
 * These fields can be used to update JiraIssueSearchViews or to directly query for issue fields.
 * This mirrors the concept of collapsed fields where all collapsible fields with the same `name` and `type` will be
 * collapsed into a single JiraIssueSearchFieldConfigSet with `fieldConfigSetId = name[type]`.
 * Non-collapsible and system fields cannot be collapsed but can still be represented as this type where `fieldConfigSetId = fieldId`.
 */
export type JiraIssueSearchFieldConfigSet = {
  __typename: 'JiraIssueSearchFieldConfigSet';
  /** The user-friendly name for a JiraIssueSearchFieldConfigSet, to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']>;
  /** The identifer of the field config set e.g. `assignee`, `reporter`, `checkbox_cf[Checkboxes]`. */
  fieldConfigSetId?: Maybe<Scalars['String']>;
  /**
   * The field-type of the current field config set.
   * E.g. `Short Text`, `Number`, `Version Picker`, `Team`.
   * Important note: This information only exists for collapsed fields.
   */
  fieldType?: Maybe<Scalars['String']>;
  /** Tracks whether or not the current field config set has been selected. */
  isSelected?: Maybe<Scalars['Boolean']>;
  /** Determines whether or not the current field config set is sortable. */
  isSortable?: Maybe<Scalars['Boolean']>;
};

/** A Connection of JiraIssueSearchFieldConfigSet. */
export type JiraIssueSearchFieldConfigSetConnection = {
  __typename: 'JiraIssueSearchFieldConfigSetConnection';
  /** The data for Edges in the current page */
  edges?: Maybe<Array<Maybe<JiraIssueSearchFieldConfigSetEdge>>>;
  /**
   * Indicates if any fields in the column configuration cannot be shown as they're currently unsupported
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  isWithholdingUnsupportedSelectedFields?: Maybe<Scalars['Boolean']>;
  /** The page info of the current page of results */
  pageInfo: PageInfo;
  /** The total number of JiraIssueSearchFieldConfigSet matching the criteria */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Represents a field-value edge for a JiraIssueSearchFieldConfigSet. */
export type JiraIssueSearchFieldConfigSetEdge = {
  __typename: 'JiraIssueSearchFieldConfigSetEdge';
  /** The cursor to this edge */
  cursor: Scalars['String'];
  /** The node at the the edge. */
  node?: Maybe<JiraIssueSearchFieldConfigSet>;
};

/** Specifies which field config sets should be returned. */
export const JiraIssueSearchFieldConfigSetSelectedState = {
  /** Both selected and non-selected field config sets. */
  All: 'ALL',
  /** Only the field config sets that have not been selected in the current view. */
  NonSelected: 'NON_SELECTED',
  /** Only the field config sets selected in the current view. */
  Selected: 'SELECTED'
} as const;

export type JiraIssueSearchFieldConfigSetSelectedState = typeof JiraIssueSearchFieldConfigSetSelectedState[keyof typeof JiraIssueSearchFieldConfigSetSelectedState];
/**
 * A filter for the JiraIssueSearchFieldConfigSet connections.
 * By default, if no fieldConfigSetSelectedState is specified, only SELECTED fields are returned.
 */
export type JiraIssueSearchFieldConfigSetsFilter = {
  /** An enum specifying which field config sets should be returned based on the selected status. */
  fieldConfigSetSelectedState?: InputMaybe<JiraIssueSearchFieldConfigSetSelectedState>;
  /** Only the fieldConfigSets that case-insensitively, contain this searchString in their displayName will be returned. */
  searchString?: InputMaybe<Scalars['String']>;
};

/**
 * Represents a grouping of search data to a particular UI behaviour.
 * Built-in views are automatically created for certain Jira pages and global Jira system filters.
 */
export type JiraIssueSearchView = Node & {
  __typename: 'JiraIssueSearchView';
  /** A connection of included fields' configurations, grouped where logical (e.g. collapsed fields). */
  fieldConfigSets?: Maybe<JiraIssueSearchFieldConfigSetConnection>;
  /** An ARI-format value that encodes both namespace and viewId. */
  id: Scalars['ID'];
  /** A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace. */
  namespace?: Maybe<Scalars['String']>;
  /** A unique identifier for this view within its namespace, or the global namespace if no namespace is defined. */
  viewId?: Maybe<Scalars['String']>;
};


/**
 * Represents a grouping of search data to a particular UI behaviour.
 * Built-in views are automatically created for certain Jira pages and global Jira system filters.
 */
export type JiraIssueSearchViewFieldConfigSetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<JiraIssueSearchFieldConfigSetsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents an Issue type, e.g. story, task, bug. */
export type JiraIssueType = Node & {
  __typename: 'JiraIssueType';
  /** Avatar of the Issue type. */
  avatar?: Maybe<JiraAvatar>;
  /** Description of the Issue type. */
  description?: Maybe<Scalars['String']>;
  /** The IssueType hierarchy level */
  hierarchy?: Maybe<JiraIssueTypeHierarchyLevel>;
  /** Global identifier of the Issue type. */
  id: Scalars['ID'];
  /** This is the internal id of the IssueType. */
  issueTypeId?: Maybe<Scalars['String']>;
  /** Name of the Issue type. */
  name: Scalars['String'];
};

/** The connection type for JiraIssueType. */
export type JiraIssueTypeConnection = {
  __typename: 'JiraIssueTypeConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraIssueTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraCommentConnection connection. */
export type JiraIssueTypeEdge = {
  __typename: 'JiraIssueTypeEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the the edge. */
  node?: Maybe<JiraIssueType>;
};

/** Represents an issue type field on a Jira Issue. */
export type JiraIssueTypeField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraIssueTypeField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /**
   * "
   * The issue type selected on the Issue or default issue type configured for the field.
   */
  issueType?: Maybe<JiraIssueType>;
  /**
   * List of issuetype options available to be selected for the field.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  issueTypes?: Maybe<JiraIssueTypeConnection>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
};


/** Represents an issue type field on a Jira Issue. */
export type JiraIssueTypeFieldIssueTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The Jira IssueType hierarchy level.
 * Hierarchy levels represent Issue parent-child relationships using an integer scale.
 */
export type JiraIssueTypeHierarchyLevel = {
  __typename: 'JiraIssueTypeHierarchyLevel';
  /**
   * The global hierarchy level of the IssueType.
   * E.g. -1 for subtask level, 0 for base level, 1 for epic level.
   */
  level?: Maybe<Scalars['Int']>;
  /** The name of the IssueType hierarchy level. */
  name?: Maybe<Scalars['String']>;
};

export const JiraJqlSyntaxError = {
  BadFieldId: 'BAD_FIELD_ID',
  BadFunctionArgument: 'BAD_FUNCTION_ARGUMENT',
  BadOperator: 'BAD_OPERATOR',
  BadPropertyId: 'BAD_PROPERTY_ID',
  EmptyField: 'EMPTY_FIELD',
  EmptyFunction: 'EMPTY_FUNCTION',
  EmptyFunctionArgument: 'EMPTY_FUNCTION_ARGUMENT',
  IllegalCharacter: 'ILLEGAL_CHARACTER',
  IllegalEscape: 'ILLEGAL_ESCAPE',
  IllegalNumber: 'ILLEGAL_NUMBER',
  MissingFieldName: 'MISSING_FIELD_NAME',
  MissingLogicalOperator: 'MISSING_LOGICAL_OPERATOR',
  NoOperator: 'NO_OPERATOR',
  NoOrder: 'NO_ORDER',
  OperandUnsupported: 'OPERAND_UNSUPPORTED',
  PredicateUnsupported: 'PREDICATE_UNSUPPORTED',
  ReservedCharacter: 'RESERVED_CHARACTER',
  ReservedWord: 'RESERVED_WORD',
  UnexpectedText: 'UNEXPECTED_TEXT',
  UnfinishedString: 'UNFINISHED_STRING',
  Unknown: 'UNKNOWN'
} as const;

export type JiraJqlSyntaxError = typeof JiraJqlSyntaxError[keyof typeof JiraJqlSyntaxError];
/** Represents the label of a custom label field. */
export type JiraLabel = {
  __typename: 'JiraLabel';
  /**
   * The identifier of the label.
   * Can be null when label is not yet created or label was returned without providing an Issue id.
   */
  labelId?: Maybe<Scalars['String']>;
  /** The name of the label. */
  name?: Maybe<Scalars['String']>;
};

/** The connection type for JiraLabel. */
export type JiraLabelConnection = {
  __typename: 'JiraLabelConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraLabelEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a Jiralabel connection. */
export type JiraLabelEdge = {
  __typename: 'JiraLabelEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraLabel>;
};

/** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */
export type JiraLabelsField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraLabelsField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /**
   * Paginated list of label options for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  labels?: Maybe<JiraLabelConnection>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available label options on a field or an Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The labels selected on the Issue or default labels configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedLabelsConnection instead.
   */
  selectedLabels?: Maybe<Array<Maybe<JiraLabel>>>;
  /** The labels selected on the Issue or default labels configured for the field. */
  selectedLabelsConnection?: Maybe<JiraLabelConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */
export type JiraLabelsFieldLabelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */
export type JiraLabelsFieldSelectedLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a media context used for file uploads. */
export type JiraMediaContext = {
  __typename: 'JiraMediaContext';
  /** Contains the token information for uploading a media content. */
  uploadToken?: Maybe<JiraMediaUploadTokenResult>;
};

/** Contains the information needed for uploading a media content in jira on issue create/view screens. */
export type JiraMediaUploadToken = {
  __typename: 'JiraMediaUploadToken';
  /** Registered client id of media API. */
  clientId?: Maybe<Scalars['String']>;
  /** Endpoint where the media content will be uploaded. */
  endpointUrl?: Maybe<Scalars['URL']>;
  /**
   * The collection in which to put the new files.
   * It can be user-scoped (such as upload-user-collection-*)
   * or project scoped (such as upload-project-*).
   */
  targetCollection?: Maybe<Scalars['String']>;
  /** token string value which can be used with Media API requests. */
  token?: Maybe<Scalars['String']>;
  /** Represents the duration (in minutes) for which token will be valid. */
  tokenDurationInMin?: Maybe<Scalars['Int']>;
};

/** Contains either the successful fetched media token information or an error. */
export type JiraMediaUploadTokenResult = JiraMediaUploadToken | QueryError;

/** Represents a multiple group picker field on a Jira Issue. */
export type JiraMultipleGroupPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraMultipleGroupPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of group options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  groups?: Maybe<JiraGroupConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch all group pickers of the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The groups selected on the Issue or default groups configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedGroupsConnection instead.
   */
  selectedGroups?: Maybe<Array<Maybe<JiraGroup>>>;
  /** The groups selected on the Issue or default groups configured for the field. */
  selectedGroupsConnection?: Maybe<JiraGroupConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a multiple group picker field on a Jira Issue. */
export type JiraMultipleGroupPickerFieldGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents a multiple group picker field on a Jira Issue. */
export type JiraMultipleGroupPickerFieldSelectedGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraMultipleSelectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldOptions?: Maybe<JiraOptionConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch all the teams options for the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The options selected on the Issue or default options configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedOptions instead.
   */
  selectedFieldOptions?: Maybe<Array<Maybe<JiraOption>>>;
  /** The options selected on the Issue or default options configured for the field. */
  selectedOptions?: Maybe<JiraOptionConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectFieldFieldOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};


/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectFieldSelectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */
export type JiraMultipleSelectUserPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraMultipleSelectUserPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the entity. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The users selected on the Issue or default users configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedUsersConnection instead.
   */
  selectedUsers?: Maybe<Array<Maybe<User>>>;
  /** The users selected on the Issue or default users configured for the field. */
  selectedUsersConnection?: Maybe<JiraUserConnection>;
  /** Field type key of the field. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */
export type JiraMultipleSelectUserPickerFieldSelectedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */
export type JiraMultipleSelectUserPickerFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraMultipleVersionPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * The versions selected on the Issue or default versions configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedVersionsConnection instead.
   */
  selectedVersions?: Maybe<Array<Maybe<JiraVersion>>>;
  /** The versions selected on the Issue or default versions configured for the field. */
  selectedVersionsConnection?: Maybe<JiraVersionConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of versions options for the field or on a Jira Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  versions?: Maybe<JiraVersionConnection>;
};


/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerFieldSelectedVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerFieldVersionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a number field on a Jira Issue. E.g. float, story points. */
export type JiraNumberField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraNumberField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The number selected on the Issue or default number configured for the field. */
  number?: Maybe<Scalars['Float']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a single option value in a select operation. */
export type JiraOption = Node & {
  __typename: 'JiraOption';
  /** Global Identifier of the option. */
  id: Scalars['ID'];
  /** Whether or not the option has been disabled by the user. Disabled options are typically not accessible in the UI. */
  isDisabled?: Maybe<Scalars['Boolean']>;
  /** Identifier of the option. */
  optionId: Scalars['String'];
  /** Value of the option. */
  value?: Maybe<Scalars['String']>;
};

/** The connection type for JiraOption. */
export type JiraOptionConnection = {
  __typename: 'JiraOptionConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraOptionEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraOption connection. */
export type JiraOptionEdge = {
  __typename: 'JiraOptionEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraOption>;
};

export type JiraOrderDirection = {
  id?: InputMaybe<Scalars['ID']>;
};

/** The base type cursor data necessary for random access pagination. */
export type JiraPageCursor = {
  __typename: 'JiraPageCursor';
  /** This is a Base64 encoded value containing the all the necessary data for retrieving the page items. */
  cursor?: Maybe<Scalars['String']>;
  /** Indicates if this page is the current page. Usually the current page is represented differently on the FE. */
  isCurrent?: Maybe<Scalars['Boolean']>;
  /** The number of the page it represents. First page is 1. */
  pageNumber?: Maybe<Scalars['Int']>;
};

/** This encapsulates all the necessary cursors for random access pagination. */
export type JiraPageCursors = {
  __typename: 'JiraPageCursors';
  /**
   * Represents a list of cursors around the current page.
   * Even if the list is not bounded, there are strict limits set on the server (MAX_SIZE <= 7).
   */
  around?: Maybe<Array<Maybe<JiraPageCursor>>>;
  /** Represents the cursor for the first page. */
  first?: Maybe<JiraPageCursor>;
  /** Represents the cursor for the last page. */
  last?: Maybe<JiraPageCursor>;
  /**
   * Represents the cursor for the previous page.
   * E.g. currentPage=2 => previousPage=1
   */
  previous?: Maybe<JiraPageCursor>;
};

/** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */
export type JiraParentIssueField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraParentIssueField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The parent selected on the Issue or default parent configured for the field. */
  parentIssue?: Maybe<JiraIssue>;
  /** Search url to fetch all available parents for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a people picker field on a Jira Issue. */
export type JiraPeopleField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraPeopleField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Whether the field is configured to act as single/multi select user(s) field. */
  isMulti?: Maybe<Scalars['Boolean']>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The people selected on the Issue or default people configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedUsersConnection instead.
   */
  selectedUsers?: Maybe<Array<Maybe<User>>>;
  /** The users selected on the Issue or default users configured for the field. */
  selectedUsersConnection?: Maybe<JiraUserConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Represents a people picker field on a Jira Issue. */
export type JiraPeopleFieldSelectedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents a people picker field on a Jira Issue. */
export type JiraPeopleFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Contains either the group or the projectRole associated with a comment/worklog, but not both.
 * If both are null, then the permission level is unspecified and the comment/worklog is public.
 */
export type JiraPermissionLevel = {
  __typename: 'JiraPermissionLevel';
  /** The Jira Group associated with the comment/worklog. */
  group?: Maybe<JiraGroup>;
  /** The Jira ProjectRole associated with the comment/worklog. */
  role?: Maybe<JiraRole>;
};

/** A permission scheme is a collection of permission grants. */
export type JiraPermissionScheme = Node & {
  __typename: 'JiraPermissionScheme';
  /** The description of the permission scheme. */
  description?: Maybe<Scalars['String']>;
  /** The ARI of the permission scheme. */
  id: Scalars['ID'];
  /** The display name of the permission scheme. */
  name: Scalars['String'];
};

/** Represents a Jira platform attachment. */
export type JiraPlatformAttachment = JiraAttachment & Node & {
  __typename: 'JiraPlatformAttachment';
  /** Identifier for the attachment. */
  attachmentId: Scalars['String'];
  /** User profile of the attachment author. */
  author?: Maybe<User>;
  /** Date the attachment was created in seconds since the epoch. */
  created: Scalars['DateTime'];
  /** Filename of the attachment. */
  fileName?: Maybe<Scalars['String']>;
  /** Size of the attachment in bytes. */
  fileSize?: Maybe<Scalars['Long']>;
  /** Global identifier for the attachment */
  id: Scalars['ID'];
  /** Media Services file id of this Attachment, May be absent if the attachment has not yet been migrated to Media Services. */
  mediaApiFileId?: Maybe<Scalars['String']>;
  /** The mimetype (also called content type) of the attachment. This may be {@code null}. */
  mimeType?: Maybe<Scalars['String']>;
  /** Parent id that this attachment is contained in. */
  parentId?: Maybe<Scalars['String']>;
  /** Parent name that this attachment is contained in e.g Issue, Field, Comment, Worklog. */
  parentName?: Maybe<Scalars['String']>;
};

/** Represents a Jira platform comment. */
export type JiraPlatformComment = JiraComment & Node & {
  __typename: 'JiraPlatformComment';
  /** User profile of the original comment author. */
  author?: Maybe<User>;
  /** Identifier for the comment. */
  commentId: Scalars['ID'];
  /** Time of comment creation. */
  created: Scalars['DateTime'];
  /** Global identifier for the comment */
  id: Scalars['ID'];
  /** The issue to which this comment is belonged. */
  issue?: Maybe<JiraIssue>;
  /**
   * Either the group or the project role associated with this comment, but not both.
   * Null means the permission level is unspecified, i.e. the comment is public.
   */
  permissionLevel?: Maybe<JiraPermissionLevel>;
  /** Comment body rich text. */
  richText?: Maybe<JiraRichText>;
  /** User profile of the author performing the comment update. */
  updateAuthor?: Maybe<User>;
  /** Time of last comment update. */
  updated?: Maybe<Scalars['DateTime']>;
  /** The browser clickable link of this comment. */
  webUrl?: Maybe<Scalars['URL']>;
};

/** Represents an issue's priority field */
export type JiraPriority = Node & {
  __typename: 'JiraPriority';
  /** The priority color. */
  color?: Maybe<Scalars['String']>;
  /** The priority icon URL. */
  iconUrl?: Maybe<Scalars['URL']>;
  /** Unique identifier referencing the priority ID. */
  id: Scalars['ID'];
  /** The priority name. */
  name?: Maybe<Scalars['String']>;
  /**
   * "
   * The priority ID. E.g. 10000.
   */
  priorityId: Scalars['String'];
};

/** The connection type for JiraPriority. */
export type JiraPriorityConnection = {
  __typename: 'JiraPriorityConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraPriorityEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraPriority connection. */
export type JiraPriorityEdge = {
  __typename: 'JiraPriorityEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraPriority>;
};

/** Represents a priority field on a Jira Issue. */
export type JiraPriorityField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraPriorityField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an Issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Paginated list of priority options for the field or on an Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  priorities?: Maybe<JiraPriorityConnection>;
  /** The priority selected on the Issue or default priority configured for the field. */
  priority?: Maybe<JiraPriority>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a priority field on a Jira Issue. */
export type JiraPriorityFieldPrioritiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents proforma-forms. */
export type JiraProformaForms = {
  __typename: 'JiraProformaForms';
  /** Indicates whether the issue has proforma-forms or not. */
  hasIssueForms?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the project has proforma-forms or not. */
  hasProjectForms?: Maybe<Scalars['Boolean']>;
};

/** Represents the proforma-forms field for an Issue. */
export type JiraProformaFormsField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraProformaFormsField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The proforma-forms selected on the Issue or default major incident configured for the field. */
  proformaForms?: Maybe<JiraProformaForms>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a Jira project. */
export type JiraProject = Node & {
  __typename: 'JiraProject';
  /** The avatar of the project. */
  avatar?: Maybe<JiraAvatar>;
  /** The category of the project. */
  category?: Maybe<JiraProjectCategory>;
  /** The cloudId associated with the project. */
  cloudId: Scalars['ID'];
  /**
   * The connection entity for Confluence space relationships for this Jira project, according to the specified
   * pagination, filtering.
   */
  confluenceSpaceRelationships?: Maybe<JiraProjectAndConfluenceSpaceRelationshipConnection>;
  /** The description of the project. */
  description?: Maybe<Scalars['String']>;
  /**
   * The connection entity for DevOps Service relationships for this Jira project, according to the specified
   * pagination, filtering.
   */
  devOpsServiceRelationships?: Maybe<DevOpsServiceAndJiraProjectRelationshipConnection>;
  /** Global identifier for the project. */
  id: Scalars['ID'];
  /** The key of the project. */
  key: Scalars['String'];
  /** The ID of the project lead. */
  leadId?: Maybe<Scalars['ID']>;
  /** The name of the project. */
  name: Scalars['String'];
  /**
   * The connection entity for Opsgenie Team relationships for this Jira project, according to the specified
   * pagination, filtering.
   */
  opsgenieTeamRelationships?: Maybe<JiraProjectAndOpsgenieTeamRelationshipConnection>;
  /** Opsgenie teams that are available to be linked with via createJiraProjectAndOpsgenieTeamRelationship */
  opsgenieTeamsAvailableToLinkWith?: Maybe<OpsgenieTeamConnection>;
  /** The project id of the project. e.g. 10000. Temporarily needed to support interoperability with REST. */
  projectId?: Maybe<Scalars['String']>;
  /**
   * Specifies if the project style is team or company managed.
   * The use of this field is discouraged. This field is subject to change, deviations between project styles are discouraged.
   * This field will change and/or be removed going forward as this data becomes available.
   *
   *
   * This field is **deprecated** and will be removed in the future
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: projectStyle` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   * @deprecated The `projectStyle` is a deprecated field.
   */
  projectStyle?: Maybe<JiraProjectStyle>;
  /** Specifies the type to which project belongs to ex:- software, service_desk, business etc. */
  projectType?: Maybe<JiraProjectType>;
  /** The URL associated with the project. */
  projectUrl?: Maybe<Scalars['String']>;
  /**
   * The connection entity for repository relationships for this Jira project, according to the specified
   * pagination, filtering and sorting.
   */
  repositoryRelationships?: Maybe<JiraProjectAndRepositoryRelationshipConnection>;
  /** Services that are available to be linked with via createDevOpsServiceAndJiraProjectRelationship */
  servicesAvailableToLinkWith?: Maybe<DevOpsServiceConnection>;
  /** Represents the SimilarIssues feature associated with this project. */
  similarIssues?: Maybe<JiraSimilarIssues>;
  /**
   * The Boards under the given project.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: softwareBoards` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  softwareBoards?: Maybe<BoardScopeConnection>;
  /** Specifies the status of the project e.g. archived, deleted. */
  status?: Maybe<JiraProjectStatus>;
};


/** Represents a Jira project. */
export type JiraProjectConfluenceSpaceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Represents a Jira project. */
export type JiraProjectDevOpsServiceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DevOpsServiceAndJiraProjectRelationshipFilter>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Represents a Jira project. */
export type JiraProjectOpsgenieTeamRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Represents a Jira project. */
export type JiraProjectOpsgenieTeamsAvailableToLinkWithArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Represents a Jira project. */
export type JiraProjectRepositoryRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<JiraProjectAndRepositoryRelationshipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<JiraProjectAndRepositoryRelationshipSort>;
};


/** Represents a Jira project. */
export type JiraProjectServicesAvailableToLinkWithArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DevOpsServicesFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
};

/** A relationship between a Jira Project and Confluence space */
export type JiraProjectAndConfluenceSpaceRelationship = {
  __typename: 'JiraProjectAndConfluenceSpaceRelationship';
  /** The Confluence space details related to the Jira Project. */
  confluenceSpace?: Maybe<ConfluenceSpace>;
  /** The Jira project related to the Confluence space. */
  jiraProject?: Maybe<JiraProject>;
};

/** #################### Pagination ##################### */
export type JiraProjectAndConfluenceSpaceRelationshipConnection = {
  __typename: 'JiraProjectAndConfluenceSpaceRelationshipConnection';
  edges?: Maybe<Array<Maybe<JiraProjectAndConfluenceSpaceRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<JiraProjectAndConfluenceSpaceRelationship>>>;
  pageInfo: PageInfo;
};

export type JiraProjectAndConfluenceSpaceRelationshipEdge = {
  __typename: 'JiraProjectAndConfluenceSpaceRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<JiraProjectAndConfluenceSpaceRelationship>;
};

/** A relationship between a Jira project and a DevOps tool */
export type JiraProjectAndDevOpsToolRelationship = Node & {
  __typename: 'JiraProjectAndDevOpsToolRelationship';
  /** The time when the relationship was created */
  createdAt: Scalars['DateTime'];
  /** The user (or system) who created the relationship */
  createdBy: Scalars['String'];
  /** An optional description of the relationship. */
  description?: Maybe<Scalars['String']>;
  /** The DevOps Tool */
  devOpsTool?: Maybe<DevOpsTool>;
  /** The ARI of the relationship */
  id: Scalars['ID'];
  /** The Jira project */
  jiraProject?: Maybe<JiraProject>;
  /** The time when the relationship was most recently updated */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The last user (or system) to update the relationship */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** Look up JSON properties of the relationship by keys. */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * The revision must be provided when updating a relationship to prevent
   * simultaneous updates from overwriting each other.
   */
  revision: Scalars['ID'];
};


/** A relationship between a Jira project and a DevOps tool */
export type JiraProjectAndDevOpsToolRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

/** A relationship between a Jira Project and Opsgenie Team */
export type JiraProjectAndOpsgenieTeamRelationship = Node & {
  __typename: 'JiraProjectAndOpsgenieTeamRelationship';
  /** When the relationship was created. */
  createdAt: Scalars['DateTime'];
  /** Who created the relationship. */
  createdBy: Scalars['String'];
  /** An optional description of the relationship. */
  description?: Maybe<Scalars['String']>;
  /** The ARI of this relationship. */
  id: Scalars['ID'];
  /** The Jira project related to the Opsgenie team. */
  jiraProject?: Maybe<JiraProject>;
  /** The type of Jira. */
  jiraProjectType?: Maybe<DevOpsJiraProjectType>;
  /** When the relationship was updated last.  Only present for relationships that have been updated. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Who updated the relationship last. Only present for relationships that have been updated. */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** The Opsgenie team details related to the Jira Project. */
  opsgenieTeam?: Maybe<OpsgenieTeam>;
  /** Look up JSON properties of the relationship by keys. */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * The revision must be provided when updating a relationship to prevent
   * simultaneous updates from overwriting each other.
   */
  revision: Scalars['ID'];
};


/** A relationship between a Jira Project and Opsgenie Team */
export type JiraProjectAndOpsgenieTeamRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

export type JiraProjectAndOpsgenieTeamRelationshipConnection = {
  __typename: 'JiraProjectAndOpsgenieTeamRelationshipConnection';
  edges?: Maybe<Array<Maybe<JiraProjectAndOpsgenieTeamRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<JiraProjectAndOpsgenieTeamRelationship>>>;
  pageInfo: PageInfo;
};

export type JiraProjectAndOpsgenieTeamRelationshipEdge = {
  __typename: 'JiraProjectAndOpsgenieTeamRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<JiraProjectAndOpsgenieTeamRelationship>;
};

/** A relationship between a Jira project and a repository (Bitbucket or third party). */
export type JiraProjectAndRepositoryRelationship = Node & {
  __typename: 'JiraProjectAndRepositoryRelationship';
  /**
   * If the repository provider is Bitbucket, this will contain the Bitbucket repository details,
   * otherwise null.
   */
  bitbucketRepository?: Maybe<BitbucketRepository>;
  /** Whether the relationship is explicit or inferred. */
  certainty: DevOpsRelationshipCertainty;
  /** When the relationship was created. */
  createdAt: Scalars['DateTime'];
  /** The AAID or system or system entity that created the relationship. */
  createdBy: Scalars['String'];
  /** An optional description of the relationship. */
  description?: Maybe<Scalars['String']>;
  /** The ARI of this relationship. */
  id: Scalars['ID'];
  /** The Jira project related to the repository. */
  jiraProject?: Maybe<JiraProject>;
  /** When the relationship was inferred last. Only present for implicit relationships. */
  lastInferredAt?: Maybe<Scalars['DateTime']>;
  /**
   * The system that inferred the relationship last.
   * Only present for implicit relationships.
   */
  lastInferredBy?: Maybe<Scalars['String']>;
  /** When the relationship was updated last.  Only present for relationships that have been updated. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The AAID or system or system entity that updated the relationship last.
   * Only present for relationships that have been updated.
   */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** Look up JSON properties of the relationship by keys. */
  properties?: Maybe<Scalars['JSON']>;
  /**
   * The revision must be provided when updating a relationship to prevent
   * simultaneous updates from overwriting each other.
   */
  revision: Scalars['ID'];
  /**
   * If the repository provider is a third party, this will contain the third party repository details,
   * otherwise null.
   */
  thirdPartyRepository?: Maybe<DevOpsThirdPartyRepository>;
};


/** A relationship between a Jira project and a repository (Bitbucket or third party). */
export type JiraProjectAndRepositoryRelationshipPropertiesArgs = {
  keys: Array<Scalars['String']>;
};

/** The connection object for a collection of Jira project and repository relationships. */
export type JiraProjectAndRepositoryRelationshipConnection = {
  __typename: 'JiraProjectAndRepositoryRelationshipConnection';
  edges?: Maybe<Array<Maybe<JiraProjectAndRepositoryRelationshipEdge>>>;
  nodes?: Maybe<Array<Maybe<JiraProjectAndRepositoryRelationship>>>;
  pageInfo: PageInfo;
};

export type JiraProjectAndRepositoryRelationshipEdge = {
  __typename: 'JiraProjectAndRepositoryRelationshipEdge';
  cursor: Scalars['String'];
  node?: Maybe<JiraProjectAndRepositoryRelationship>;
};

/** #################### Filtering and Sorting Inputs ##################### */
export type JiraProjectAndRepositoryRelationshipFilter = {
  /** Include only relationships with the specified certainty */
  certainty?: InputMaybe<DevOpsRelationshipCertaintyFilter>;
  /** Include only relationships with the specified repository hosting provider type */
  hostingProvider?: InputMaybe<DevOpsRepositoryHostingProviderFilter>;
  /**
   * Include only relationships with all of the specified property keys.
   * If this is omitted, no filtering by 'all property keys' is applied.
   */
  withAllPropertyKeys?: InputMaybe<Array<Scalars['String']>>;
};

export type JiraProjectAndRepositoryRelationshipSort = {
  /** The field to apply sorting on */
  by: JiraProjectAndRepositoryRelationshipSortBy;
  /** The direction of sorting */
  order?: SortDirection;
};

/** #################### Enums ##################### */
export const JiraProjectAndRepositoryRelationshipSortBy = {
  LastInferredAt: 'LAST_INFERRED_AT'
} as const;

export type JiraProjectAndRepositoryRelationshipSortBy = typeof JiraProjectAndRepositoryRelationshipSortBy[keyof typeof JiraProjectAndRepositoryRelationshipSortBy];
export type JiraProjectCategory = Node & {
  __typename: 'JiraProjectCategory';
  /** Description of the Project category. */
  description?: Maybe<Scalars['String']>;
  /** Global id of this project category. */
  id: Scalars['ID'];
  /** Display name of the Project category. */
  name?: Maybe<Scalars['String']>;
};

/** The connection type for JiraProject. */
export type JiraProjectConnection = {
  __typename: 'JiraProjectConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraProjectEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraProject connection. */
export type JiraProjectEdge = {
  __typename: 'JiraProjectEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraProject>;
};

/**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */
export type JiraProjectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraProjectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an Issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The ID of the project field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The project selected on the Issue or default project configured for the field. */
  project?: Maybe<JiraProject>;
  /**
   * List of project options available for this field to be selected.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  projects?: Maybe<JiraProjectConnection>;
  /**
   * Search url to fetch all available projects options on the field or an Issue.
   * To be deprecated once project connection is supported for custom project fields.
   */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */
export type JiraProjectFieldProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  recent?: InputMaybe<Scalars['Boolean']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** The project role grant type value having the project role information. */
export type JiraProjectRoleGrantTypeValue = Node & {
  __typename: 'JiraProjectRoleGrantTypeValue';
  /**
   * The ARI to represent the project role grant type value.
   * For example: ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:role/project-role/activation/bd0c43a9-a23a-4302-8ffa-ca04bde7c747/projectrole/b434089d-7f6d-476b-884b-7811661f91d2
   */
  id: Scalars['ID'];
  /** The project role information such as name, description. */
  role: JiraRole;
};

/** Jira Project statuses. */
export const JiraProjectStatus = {
  /** An active project. */
  Active: 'ACTIVE',
  /** An archived project. */
  Archived: 'ARCHIVED',
  /** A deleted project. */
  Deleted: 'DELETED'
} as const;

export type JiraProjectStatus = typeof JiraProjectStatus[keyof typeof JiraProjectStatus];
/** Jira Project Styles. */
export const JiraProjectStyle = {
  /** A company-managed project. */
  CompanyManagedProject: 'COMPANY_MANAGED_PROJECT',
  /** A team-managed project. */
  TeamManagedProject: 'TEAM_MANAGED_PROJECT'
} as const;

export type JiraProjectStyle = typeof JiraProjectStyle[keyof typeof JiraProjectStyle];
/** Jira Project types. */
export const JiraProjectType = {
  /** A business project. */
  Business: 'BUSINESS',
  /** A service desk project. */
  ServiceDesk: 'SERVICE_DESK',
  /** A software project. */
  Software: 'SOFTWARE'
} as const;

export type JiraProjectType = typeof JiraProjectType[keyof typeof JiraProjectType];
/** Basic person information who reviews a pull-request. */
export type JiraPullRequestReviewer = {
  __typename: 'JiraPullRequestReviewer';
  /** The reviewer's avatar. */
  avatar?: Maybe<JiraAvatar>;
  /** Represent the approval status from reviewer for the pull request. */
  hasApproved?: Maybe<Scalars['Boolean']>;
  /** Reviewer name. */
  name?: Maybe<Scalars['String']>;
};

/** Possible states for Pull Requests */
export const JiraPullRequestState = {
  /** Pull Request is Declined */
  Declined: 'DECLINED',
  /** Pull Request is Merged */
  Merged: 'MERGED',
  /** Pull Request is Open */
  Open: 'OPEN'
} as const;

export type JiraPullRequestState = typeof JiraPullRequestState[keyof typeof JiraPullRequestState];
/** Represents the radio select field on a Jira Issue. */
export type JiraRadioSelectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraRadioSelectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldOptions?: Maybe<JiraOptionConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The option selected on the Issue or default option configured for the field. */
  selectedOption?: Maybe<JiraOption>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the radio select field on a Jira Issue. */
export type JiraRadioSelectFieldFieldOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents the resolution field of an issue. */
export type JiraResolution = Node & {
  __typename: 'JiraResolution';
  /** Resolution description. */
  description?: Maybe<Scalars['String']>;
  /** Global identifier representing the resolution id. */
  id: Scalars['ID'];
  /** Resolution name. */
  name?: Maybe<Scalars['String']>;
  /** Resolution Id in the digital format. */
  resolutionId: Scalars['String'];
};

/** The connection type for JiraResolution. */
export type JiraResolutionConnection = {
  __typename: 'JiraResolutionConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraResolutionEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraResolution connection. */
export type JiraResolutionEdge = {
  __typename: 'JiraResolutionEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraResolution>;
};

/** Represents a resolution field on a Jira Issue. */
export type JiraResolutionField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraResolutionField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The resolution selected on the Issue or default resolution configured for the field. */
  resolution?: Maybe<JiraResolution>;
  /**
   * Paginated list of resolution options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  resolutions?: Maybe<JiraResolutionConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents a resolution field on a Jira Issue. */
export type JiraResolutionFieldResolutionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Possible states for Reviews */
export const JiraReviewState = {
  /** Review is in Require Approval state */
  Approval: 'APPROVAL',
  /** Review has been closed */
  Closed: 'CLOSED',
  /** Review is in Dead state */
  Dead: 'DEAD',
  /** Review is in Draft state */
  Draft: 'DRAFT',
  /** Review has been rejected */
  Rejected: 'REJECTED',
  /** Review is in Review state */
  Review: 'REVIEW',
  /** Review is in Summarize state */
  Summarize: 'SUMMARIZE',
  /** Review state is unknown */
  Unknown: 'UNKNOWN'
} as const;

export type JiraReviewState = typeof JiraReviewState[keyof typeof JiraReviewState];
/** Represents the rich text format of a rich text field. */
export type JiraRichText = {
  __typename: 'JiraRichText';
  /** Text in Atlassian Document Format. */
  adfValue?: Maybe<JiraAdf>;
  /**
   * Plain text version of the text.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated `plainText` is deprecated. Please use `adfValue` for all rich text in Jira.
   */
  plainText?: Maybe<Scalars['String']>;
  /**
   * Text in wiki format.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated `wikiValue` is deprecated. Please use `adfValue` for all rich text in Jira.
   */
  wikiValue?: Maybe<Scalars['String']>;
};

/** Represents a rich text field on a Jira Issue. E.g. description, environment. */
export type JiraRichTextField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraRichTextField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Contains the information needed to add media content to the field. */
  mediaContext?: Maybe<JiraMediaContext>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Determines what editor to render.
   * E.g. default text rendering or wiki text rendering.
   */
  renderer?: Maybe<Scalars['String']>;
  /** The rich text selected on the Issue or default rich text configured for the field. */
  richText?: Maybe<JiraRichText>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents a Jira ProjectRole. */
export type JiraRole = Node & {
  __typename: 'JiraRole';
  /** Description of the ProjectRole. */
  description?: Maybe<Scalars['String']>;
  /** Global identifier of the ProjectRole. */
  id: Scalars['ID'];
  /** Name of the ProjectRole. */
  name?: Maybe<Scalars['String']>;
  /** Id of the ProjectRole. */
  roleId: Scalars['String'];
};

/** The connection type for JiraRole. */
export type JiraRoleConnection = {
  __typename: 'JiraRoleConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraRoleEdge>>>;
  /** The page infor of the current page of results. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraRoleConnection connection. */
export type JiraRoleEdge = {
  __typename: 'JiraRoleEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraRole>;
};

/** Repository information provided by data-providers. */
export type JiraScmRepository = {
  __typename: 'JiraScmRepository';
  /** URL link to the repository in scm provider. */
  entityUrl?: Maybe<Scalars['URL']>;
  /** Repository name. */
  name?: Maybe<Scalars['String']>;
};

/** Represents the security levels on an Issue. */
export type JiraSecurityLevel = Node & {
  __typename: 'JiraSecurityLevel';
  /** Description of the security level. */
  description?: Maybe<Scalars['String']>;
  /** Global identifier for the security level. */
  id: Scalars['ID'];
  /** Name of the security level. */
  name?: Maybe<Scalars['String']>;
  /** identifier for the security level. */
  securityId: Scalars['String'];
};

/** The connection type for JiraSecurityLevel. */
export type JiraSecurityLevelConnection = {
  __typename: 'JiraSecurityLevelConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraSecurityLevelEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraSecurityLevel connection. */
export type JiraSecurityLevelEdge = {
  __typename: 'JiraSecurityLevelEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraSecurityLevel>;
};

/** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */
export type JiraSecurityLevelField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSecurityLevelField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The security level selected on the Issue or default security level configured for the field. */
  securityLevel?: Maybe<JiraSecurityLevel>;
  /**
   * Paginated list of security level options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  securityLevels?: Maybe<JiraSecurityLevelConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */
export type JiraSecurityLevelFieldSecurityLevelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApproval = Node & {
  __typename: 'JiraServiceManagementActiveApproval';
  /**
   * Approver principals can be a connection of users or groups that may decide on an approval.
   * The list includes undecided members.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  approverPrincipals?: Maybe<JiraServiceManagementApproverPrincipalConnection>;
  /**
   * Detailed list of the users who responded to the approval with a decision.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  approvers?: Maybe<JiraServiceManagementApproverConnection>;
  /** Indicates whether the user making the request is one of the approvers and can respond to the approval (true) or not (false). */
  canAnswerApproval?: Maybe<Scalars['Boolean']>;
  /**
   * Configurations of the approval including the approval condition and approvers configuration.
   * There is a maximum limit of how many configurations an active approval can have.
   */
  configurations?: Maybe<Array<Maybe<JiraServiceManagementApprovalConfiguration>>>;
  /** Date the approval was created. */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * List of the users' decisions. Does not include undecided users.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  decisions?: Maybe<JiraServiceManagementDecisionConnection>;
  /**
   * Detailed list of the users who are excluded to approve the approval.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  excludedApprovers?: Maybe<JiraUserConnection>;
  /** Outcome of the approval, based on the approvals provided by all approvers. */
  finalDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
  /** ID of the active approval. */
  id: Scalars['ID'];
  /** Name of the approval being sought. */
  name?: Maybe<Scalars['String']>;
  /** The number of approvals needed to complete. */
  pendingApprovalCount?: Maybe<Scalars['Int']>;
  /** Status details of the approval. */
  status?: Maybe<JiraServiceManagementApprovalStatus>;
};


/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalApproverPrincipalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalApproversArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalDecisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalExcludedApproversArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents the details of an approval condition. */
export type JiraServiceManagementApprovalCondition = {
  __typename: 'JiraServiceManagementApprovalCondition';
  /** Condition type for approval. */
  type?: Maybe<Scalars['String']>;
  /** Condition value for approval. */
  value?: Maybe<Scalars['String']>;
};

/** Represents the configuration details of an approval. */
export type JiraServiceManagementApprovalConfiguration = {
  __typename: 'JiraServiceManagementApprovalConfiguration';
  /**
   * Contains information about approvers configuration.
   * There is a maximum number of fields that can be set for the approvers configuration.
   */
  approversConfigurations?: Maybe<Array<Maybe<JiraServiceManagementApproversConfiguration>>>;
  /** Contains information about approval condition. */
  condition?: Maybe<JiraServiceManagementApprovalCondition>;
};

/** Represents the possible decisions that can be made by an approver. */
export const JiraServiceManagementApprovalDecisionResponseType = {
  /** Indicates that the decision is approved by the approver. */
  Approved: 'approved',
  /** Indicates that the decision is declined by the approver. */
  Declined: 'declined',
  /** Indicates that the decision is pending by the approver. */
  Pending: 'pending'
} as const;

export type JiraServiceManagementApprovalDecisionResponseType = typeof JiraServiceManagementApprovalDecisionResponseType[keyof typeof JiraServiceManagementApprovalDecisionResponseType];
/** Represents the Approval custom field on an Issue in a JSM project. */
export type JiraServiceManagementApprovalField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementApprovalField';
  /** The active approval is used to render the approval panel that the users can interact with to approve/decline the request or update approvers. */
  activeApproval?: Maybe<JiraServiceManagementActiveApproval>;
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /**
   * The completed approvals are used to render the approval history section and contains records for all previous approvals for that issue.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use completedApprovalsConnection instead.
   */
  completedApprovals?: Maybe<Array<Maybe<JiraServiceManagementCompletedApproval>>>;
  /** The completed approvals are used to render the approval history section and contains records for all previous approvals for that issue. */
  completedApprovalsConnection?: Maybe<JiraServiceManagementCompletedApprovalConnection>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. customfield_10001 or description. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the Approval custom field on an Issue in a JSM project. */
export type JiraServiceManagementApprovalFieldCompletedApprovalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents details of the approval status. */
export type JiraServiceManagementApprovalStatus = {
  __typename: 'JiraServiceManagementApprovalStatus';
  /** Status category Id of approval. */
  categoryId?: Maybe<Scalars['String']>;
  /** Status id of approval. */
  id?: Maybe<Scalars['String']>;
  /** Status name of approval. E.g. Waiting for approval. */
  name?: Maybe<Scalars['String']>;
};

/** The user and decision that approved the approval. */
export type JiraServiceManagementApprover = {
  __typename: 'JiraServiceManagementApprover';
  /** Details of the User who is providing approval. */
  approver?: Maybe<User>;
  /** Decision made by the approver. */
  approverDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
};

/** The connection type for JiraServiceManagementApprover. */
export type JiraServiceManagementApproverConnection = {
  __typename: 'JiraServiceManagementApproverConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementApproverEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementApprover connection. */
export type JiraServiceManagementApproverEdge = {
  __typename: 'JiraServiceManagementApproverEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementApprover>;
};

/** Approver principals are either users or groups that may decide on an approval. */
export type JiraServiceManagementApproverPrincipal = JiraServiceManagementGroupApproverPrincipal | JiraServiceManagementUserApproverPrincipal;

/** The connection type for JiraServiceManagementApproverPrincipal. */
export type JiraServiceManagementApproverPrincipalConnection = {
  __typename: 'JiraServiceManagementApproverPrincipalConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementApproverPrincipalEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementApproverPrincipal connection. */
export type JiraServiceManagementApproverPrincipalEdge = {
  __typename: 'JiraServiceManagementApproverPrincipalEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementApproverPrincipal>;
};

/** Represents the configuration details of the users providing approval. */
export type JiraServiceManagementApproversConfiguration = {
  __typename: 'JiraServiceManagementApproversConfiguration';
  /** The field's id configured for the approvers. */
  fieldId?: Maybe<Scalars['String']>;
  /** The field's name configured for the approvers. Only set for type "field". */
  fieldName?: Maybe<Scalars['String']>;
  /** Approvers configuration type. E.g. custom_field. */
  type?: Maybe<Scalars['String']>;
};

/** Represents an attachment within a JiraServiceManagement project. */
export type JiraServiceManagementAttachment = JiraAttachment & Node & {
  __typename: 'JiraServiceManagementAttachment';
  /** Identifier for the attachment. */
  attachmentId: Scalars['String'];
  /** User profile of the attachment author. */
  author?: Maybe<User>;
  /** Date the attachment was created in seconds since the epoch. */
  created: Scalars['DateTime'];
  /** Filename of the attachment. */
  fileName?: Maybe<Scalars['String']>;
  /** Size of the attachment in bytes. */
  fileSize?: Maybe<Scalars['Long']>;
  /** Global identifier for the attachment */
  id: Scalars['ID'];
  /** Media Services file id of this Attachment, May be absent if the attachment has not yet been migrated to Media Services. */
  mediaApiFileId?: Maybe<Scalars['String']>;
  /** The mimetype (also called content type) of the attachment. This may be {@code null}. */
  mimeType?: Maybe<Scalars['String']>;
  /** If the parent for the JSM attachment is a comment, this represents the JSM visibility property associated with this comment. */
  parentCommentVisibility?: Maybe<JiraServiceManagementCommentVisibility>;
  /** Parent id that this attachment is contained in. */
  parentId?: Maybe<Scalars['String']>;
  /** Parent name that this attachment is contained in e.g Issue, Field, Comment, Worklog. */
  parentName?: Maybe<Scalars['String']>;
};

/** Represents a comment within a JiraServiceManagement project. */
export type JiraServiceManagementComment = JiraComment & Node & {
  __typename: 'JiraServiceManagementComment';
  /** User profile of the original comment author. */
  author?: Maybe<User>;
  /** Indicates whether the comment author can see the request or not. */
  authorCanSeeRequest?: Maybe<Scalars['Boolean']>;
  /** Identifier for the comment. */
  commentId: Scalars['ID'];
  /** Time of comment creation. */
  created: Scalars['DateTime'];
  /** Global identifier for the comment */
  id: Scalars['ID'];
  /** The issue to which this comment is belonged. */
  issue?: Maybe<JiraIssue>;
  /**
   * Either the group or the project role associated with this comment, but not both.
   * Null means the permission level is unspecified, i.e. the comment is public.
   */
  permissionLevel?: Maybe<JiraPermissionLevel>;
  /** Comment body rich text. */
  richText?: Maybe<JiraRichText>;
  /** User profile of the author performing the comment update. */
  updateAuthor?: Maybe<User>;
  /** Time of last comment update. */
  updated?: Maybe<Scalars['DateTime']>;
  /** The JSM visibility property associated with this comment. */
  visibility?: Maybe<JiraServiceManagementCommentVisibility>;
  /** The browser clickable link of this comment. */
  webUrl?: Maybe<Scalars['URL']>;
};

/** The visibility property of a comment within a JSM project type. */
export const JiraServiceManagementCommentVisibility = {
  /** This comment will only appear in JIRA's issue view. Also called private. */
  Internal: 'INTERNAL',
  /** This comment will appear in the portal, visible to all customers. Also called public. */
  VisibleToHelpseeker: 'VISIBLE_TO_HELPSEEKER'
} as const;

export type JiraServiceManagementCommentVisibility = typeof JiraServiceManagementCommentVisibility[keyof typeof JiraServiceManagementCommentVisibility];
/** Represents an approval that is completed. */
export type JiraServiceManagementCompletedApproval = Node & {
  __typename: 'JiraServiceManagementCompletedApproval';
  /**
   * Detailed list of the users who responded to the approval.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  approvers?: Maybe<JiraServiceManagementApproverConnection>;
  /** Date the approval was completed. */
  completedDate?: Maybe<Scalars['DateTime']>;
  /** Date the approval was created. */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Outcome of the approval, based on the approvals provided by all approvers. */
  finalDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
  /** ID of the completed approval. */
  id: Scalars['ID'];
  /** Name of the approval that has been provided. */
  name?: Maybe<Scalars['String']>;
  /** Status details in which the approval is applicable. */
  status?: Maybe<JiraServiceManagementApprovalStatus>;
};


/** Represents an approval that is completed. */
export type JiraServiceManagementCompletedApprovalApproversArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for JiraServiceManagementCompletedApproval. */
export type JiraServiceManagementCompletedApprovalConnection = {
  __typename: 'JiraServiceManagementCompletedApprovalConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementCompletedApprovalEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementCompletedApproval connection. */
export type JiraServiceManagementCompletedApprovalEdge = {
  __typename: 'JiraServiceManagementCompletedApprovalEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementCompletedApproval>;
};

/**
 * Represents a datetime field on an Issue in a JSM project.
 * Deprecated: Please use `JiraDateTimePickerField`.
 */
export type JiraServiceManagementDateTimeField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementDateTimeField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** The datetime selected on the Issue or default datetime configured for the field. */
  dateTime?: Maybe<Scalars['DateTime']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents the user and decision details. */
export type JiraServiceManagementDecision = {
  __typename: 'JiraServiceManagementDecision';
  /** The user providing a decision. */
  approver?: Maybe<User>;
  /** The decision made by the approver. */
  approverDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
};

/** The connection type for JiraServiceManagementDecision. */
export type JiraServiceManagementDecisionConnection = {
  __typename: 'JiraServiceManagementDecisionConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementDecisionEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementDecision connection. */
export type JiraServiceManagementDecisionEdge = {
  __typename: 'JiraServiceManagementDecisionEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementDecision>;
};

/** Represents the JSM feedback rating. */
export type JiraServiceManagementFeedback = {
  __typename: 'JiraServiceManagementFeedback';
  /** Represents the integer rating value available on the issue. */
  rating?: Maybe<Scalars['Int']>;
};

/** Contains information about the approvers when approver is a group. */
export type JiraServiceManagementGroupApproverPrincipal = {
  __typename: 'JiraServiceManagementGroupApproverPrincipal';
  /** This contains the number of members that have approved a decision. */
  approvedCount?: Maybe<Scalars['Int']>;
  /**
   * A group identifier.
   * Note: Group identifiers are nullable.
   */
  groupId?: Maybe<Scalars['String']>;
  /** This contains the number of members. */
  memberCount?: Maybe<Scalars['Int']>;
  /** Display name for a group. */
  name?: Maybe<Scalars['String']>;
};

/** Represents the JSM incident. */
export type JiraServiceManagementIncident = {
  __typename: 'JiraServiceManagementIncident';
  /** Indicates whether any incident is linked to the issue or not. */
  hasLinkedIncidents?: Maybe<Scalars['Boolean']>;
};

/**
 * Represents the Incident Linking custom field on an Issue in a JSM project.
 * Deprecated: please use `JiraBooleanField` instead.
 */
export type JiraServiceManagementIncidentLinkingField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementIncidentLinkingField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Represents the JSM incident linked to the issue. */
  incident?: Maybe<JiraServiceManagementIncident>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
};

/** Represents the language that can be used for fields such as JSM Requested Language. */
export type JiraServiceManagementLanguage = {
  __typename: 'JiraServiceManagementLanguage';
  /** A readable common name for this language. */
  displayName?: Maybe<Scalars['String']>;
  /** A unique language code that represents the language. */
  languageCode?: Maybe<Scalars['String']>;
};

/** An enum representing possible values for Major Incident JSM field. */
export const JiraServiceManagementMajorIncident = {
  MajorIncident: 'MAJOR_INCIDENT'
} as const;

export type JiraServiceManagementMajorIncident = typeof JiraServiceManagementMajorIncident[keyof typeof JiraServiceManagementMajorIncident];
/** Represents the major incident field for an Issue in a JSM project. */
export type JiraServiceManagementMajorIncidentField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementMajorIncidentField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** The major incident selected on the Issue or default major incident configured for the field. */
  majorIncident?: Maybe<JiraServiceManagementMajorIncident>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Deprecated type. Please use `JiraMultipleSelectUserPickerField` instead. */
export type JiraServiceManagementMultipleSelectUserPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementMultipleSelectUserPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The users selected on the Issue or default users configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedUsersConnection instead.
   */
  selectedUsers?: Maybe<Array<Maybe<User>>>;
  /** The users selected on the Issue or default users configured for the field. */
  selectedUsersConnection?: Maybe<JiraUserConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Deprecated type. Please use `JiraMultipleSelectUserPickerField` instead. */
export type JiraServiceManagementMultipleSelectUserPickerFieldSelectedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Deprecated type. Please use `JiraMultipleSelectUserPickerField` instead. */
export type JiraServiceManagementMultipleSelectUserPickerFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents the customer organization on an Issue in a JiraServiceManagement project. */
export type JiraServiceManagementOrganization = {
  __typename: 'JiraServiceManagementOrganization';
  /** The organization's domain. */
  domain?: Maybe<Scalars['String']>;
  /** Globally unique id within this schema. */
  organizationId?: Maybe<Scalars['ID']>;
  /** The organization's name. */
  organizationName?: Maybe<Scalars['String']>;
};

/** The connection type for JiraServiceManagementOrganization. */
export type JiraServiceManagementOrganizationConnection = {
  __typename: 'JiraServiceManagementOrganizationConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementOrganizationEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementOrganization connection. */
export type JiraServiceManagementOrganizationEdge = {
  __typename: 'JiraServiceManagementOrganizationEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementOrganization>;
};

/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementOrganizationField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Paginated list of organization options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  organizations?: Maybe<JiraServiceManagementOrganizationConnection>;
  /** Search url to query for all Customer orgs when user interact with field. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The organizations selected on the Issue or default organizations configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedOrganizationsConnection instead.
   */
  selectedOrganizations?: Maybe<Array<Maybe<JiraServiceManagementOrganization>>>;
  /** The organizations selected on the Issue or default organizations configured for the field. */
  selectedOrganizationsConnection?: Maybe<JiraServiceManagementOrganizationConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationFieldOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};


/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationFieldSelectedOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Deprecated type. Please use `JiraPeopleField` instead. */
export type JiraServiceManagementPeopleField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementPeopleField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Whether the field is configured to act as single/multi select user(s) field. */
  isMulti?: Maybe<Scalars['Boolean']>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The people selected on the Issue or default people configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedUsersConnection instead.
   */
  selectedUsers?: Maybe<Array<Maybe<User>>>;
  /** The users selected on the Issue or default users configured for the field. */
  selectedUsersConnection?: Maybe<JiraUserConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Deprecated type. Please use `JiraPeopleField` instead. */
export type JiraServiceManagementPeopleFieldSelectedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Deprecated type. Please use `JiraPeopleField` instead. */
export type JiraServiceManagementPeopleFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** ITSM project practice categorization. */
export const JiraServiceManagementPractice = {
  /** Empower the IT operations teams with richer contextual information around changes from software development tools so they can make better decisions and minimize risk. */
  ChangeManagement: 'CHANGE_MANAGEMENT',
  /** Bring the development and IT operations teams together to rapidly respond to, resolve, and continuously learn from incidents. */
  IncidentManagement: 'INCIDENT_MANAGEMENT',
  /** Group incidents to problems, fast-track root cause analysis, and record workarounds to minimize the impact of incidents. */
  ProblemManagement: 'PROBLEM_MANAGEMENT',
  /** Manage work across teams with one platform so the employees and customers quickly get the help they need. */
  ServiceRequest: 'SERVICE_REQUEST'
} as const;

export type JiraServiceManagementPractice = typeof JiraServiceManagementPractice[keyof typeof JiraServiceManagementPractice];
/** Represents the Request Feedback custom field on an Issue in a JSM project. */
export type JiraServiceManagementRequestFeedbackField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementRequestFeedbackField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Represents the JSM feedback rating value selected on the Issue. */
  feedback?: Maybe<JiraServiceManagementFeedback>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents the Request Language field on an Issue in a JSM project. */
export type JiraServiceManagementRequestLanguageField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementRequestLanguageField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** The language selected on the Issue or default language configured for the field. */
  language?: Maybe<JiraServiceManagementLanguage>;
  /** List of languages available. */
  languages?: Maybe<Array<Maybe<JiraServiceManagementLanguage>>>;
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Requests the request type structure on an Issue. */
export type JiraServiceManagementRequestType = Node & {
  __typename: 'JiraServiceManagementRequestType';
  /** Avatar for the request type. */
  avatar?: Maybe<JiraAvatar>;
  /** Description of the request type if applicable. */
  description?: Maybe<Scalars['String']>;
  /** Help text for the request type. */
  helpText?: Maybe<Scalars['String']>;
  /** Global identifier representing the request type id. */
  id: Scalars['ID'];
  /** Issue type to which request type belongs to. */
  issueType?: Maybe<JiraIssueType>;
  /**
   * A deprecated unique identifier string for Request Types.
   * It is still necessary due to the lack of request-type-id in critical parts of JiraServiceManagement backend.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated The `key` field is deprecated. Please use the `requestTypeId` instead.
   */
  key?: Maybe<Scalars['String']>;
  /** Name of the request type. */
  name?: Maybe<Scalars['String']>;
  /** Id of the portal that this request type belongs to. */
  portalId?: Maybe<Scalars['String']>;
  /** Request type practice. E.g. incidents, service_request. */
  practices?: Maybe<Array<Maybe<JiraServiceManagementRequestTypePractice>>>;
  /** Identifier for the request type. */
  requestTypeId: Scalars['String'];
};

/** The connection type for JiraServiceManagementRequestType. */
export type JiraServiceManagementRequestTypeConnection = {
  __typename: 'JiraServiceManagementRequestTypeConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementRequestTypeEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementIssueType connection. */
export type JiraServiceManagementRequestTypeEdge = {
  __typename: 'JiraServiceManagementRequestTypeEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementRequestType>;
};

/** Represents the request type field for an Issue in a JSM project. */
export type JiraServiceManagementRequestTypeField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementRequestTypeField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The request type selected on the Issue or default request type configured for the field. */
  requestType?: Maybe<JiraServiceManagementRequestType>;
  /**
   * Paginated list of request type options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  requestTypes?: Maybe<JiraServiceManagementRequestTypeConnection>;
  /** Field type key. */
  type: Scalars['String'];
};


/** Represents the request type field for an Issue in a JSM project. */
export type JiraServiceManagementRequestTypeFieldRequestTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Defines grouping of the request types,currently only applicable for JiraServiceManagement ITSM projects. */
export type JiraServiceManagementRequestTypePractice = {
  __typename: 'JiraServiceManagementRequestTypePractice';
  /** Practice in which the request type is categorized. */
  key?: Maybe<JiraServiceManagementPractice>;
};

/** Responder field of a JSM issue, can be either a user or a team. */
export type JiraServiceManagementResponder = JiraServiceManagementTeamResponder | JiraServiceManagementUserResponder;

/** The connection type for JiraServiceManagementResponder. */
export type JiraServiceManagementResponderConnection = {
  __typename: 'JiraServiceManagementResponderConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraServiceManagementResponderEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraServiceManagementResponder connection. */
export type JiraServiceManagementResponderEdge = {
  __typename: 'JiraServiceManagementResponderEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraServiceManagementResponder>;
};

/** Represents the responders entity custom field on an Issue in a JSM project. */
export type JiraServiceManagementRespondersField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraServiceManagementRespondersField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Represents the list of responders.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use respondersConnection instead.
   */
  responders?: Maybe<Array<Maybe<JiraServiceManagementResponder>>>;
  /** Represents the list of responders. */
  respondersConnection?: Maybe<JiraServiceManagementResponderConnection>;
  /** Field type key. */
  type: Scalars['String'];
};


/** Represents the responders entity custom field on an Issue in a JSM project. */
export type JiraServiceManagementRespondersFieldRespondersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An Opsgenie team as a responder */
export type JiraServiceManagementTeamResponder = {
  __typename: 'JiraServiceManagementTeamResponder';
  /** Opsgenie team id. */
  teamId?: Maybe<Scalars['String']>;
  /** Opsgenie team name. */
  teamName?: Maybe<Scalars['String']>;
};

/** Contains information about the approvers when approver is a user. */
export type JiraServiceManagementUserApproverPrincipal = {
  __typename: 'JiraServiceManagementUserApproverPrincipal';
  /** URL for the principal. */
  jiraRest?: Maybe<Scalars['URL']>;
  /** A approver principal who's a user type */
  user?: Maybe<User>;
};

/** A user as a responder */
export type JiraServiceManagementUserResponder = {
  __typename: 'JiraServiceManagementUserResponder';
  user?: Maybe<User>;
};

/** Represents the SimilarIssues feature associated with a JiraProject. */
export type JiraSimilarIssues = {
  __typename: 'JiraSimilarIssues';
  /** Indicates whether the SimilarIssues feature is enabled or not. */
  featureEnabled: Scalars['Boolean'];
};

/** Represents single group picker field. Allows you to select single Jira group to be associated with an issue. */
export type JiraSingleGroupPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSingleGroupPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /**
   * Paginated list of group options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  groups?: Maybe<JiraGroupConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch group picker field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** The group selected on the Issue or default group configured for the field. */
  selectedGroup?: Maybe<JiraGroup>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents single group picker field. Allows you to select single Jira group to be associated with an issue. */
export type JiraSingleGroupPickerFieldGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents single line text field on a Jira Issue. E.g. summary, epic name, custom text field. */
export type JiraSingleLineTextField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSingleLineTextField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The text selected on the Issue or default text configured for the field. */
  text?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents single select field on a Jira Issue. */
export type JiraSingleSelectField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSingleSelectField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** The option selected on the Issue or default option configured for the field. */
  fieldOption?: Maybe<JiraOption>;
  /**
   * Paginated list of options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  fieldOptions?: Maybe<JiraOptionConnection>;
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch the select option for the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents single select field on a Jira Issue. */
export type JiraSingleSelectFieldFieldOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents a single select user field on a Jira Issue. E.g. assignee, reporter, custom user picker. */
export type JiraSingleSelectUserPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSingleSelectUserPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available users options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** Field type key. */
  type: Scalars['String'];
  /** The user selected on the Issue or default user configured for the field. */
  user?: Maybe<User>;
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Paginated list of user options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  users?: Maybe<JiraUserConnection>;
};


/** Represents a single select user field on a Jira Issue. E.g. assignee, reporter, custom user picker. */
export type JiraSingleSelectUserPickerFieldUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a version field on a Jira Issue. E.g. custom version picker field. */
export type JiraSingleVersionPickerField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSingleVersionPickerField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /** The version selected on the Issue or default version configured for the field. */
  version?: Maybe<JiraVersion>;
  /**
   * Paginated list of versions options for the field or on a Jira Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  versions?: Maybe<JiraVersionConnection>;
};


/** Represents a version field on a Jira Issue. E.g. custom version picker field. */
export type JiraSingleVersionPickerFieldVersionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  suggested?: InputMaybe<Scalars['Boolean']>;
};

/** Represents the sprint field of an issue. */
export type JiraSprint = Node & {
  __typename: 'JiraSprint';
  /** The board name that the sprint belongs to. */
  boardName?: Maybe<Scalars['String']>;
  /** Completion date of the sprint. */
  completionDate?: Maybe<Scalars['DateTime']>;
  /** End date of the sprint. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The goal of the sprint. */
  goal?: Maybe<Scalars['String']>;
  /** Global identifier for the sprint. */
  id: Scalars['ID'];
  /** Sprint name. */
  name?: Maybe<Scalars['String']>;
  /** Sprint id in the digital format. */
  sprintId: Scalars['String'];
  /** Start date of the sprint. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Current state of the sprint. */
  state?: Maybe<JiraSprintState>;
};

/** The connection type for JiraSprint. */
export type JiraSprintConnection = {
  __typename: 'JiraSprintConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraSprintEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraSprint connection. */
export type JiraSprintEdge = {
  __typename: 'JiraSprintEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraSprint>;
};

/** Represents sprint field on a Jira Issue. */
export type JiraSprintField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraSprintField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search url to fetch all available sprints options for the field or the Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /**
   * The sprints selected on the Issue or default sprints configured for the field.
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated Please use selectedSprintsConnection instead.
   */
  selectedSprints?: Maybe<Array<Maybe<JiraSprint>>>;
  /** The sprints selected on the Issue or default sprints configured for the field. */
  selectedSprintsConnection?: Maybe<JiraSprintConnection>;
  /**
   * Paginated list of sprint options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  sprints?: Maybe<JiraSprintConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Represents sprint field on a Jira Issue. */
export type JiraSprintFieldSelectedSprintsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents sprint field on a Jira Issue. */
export type JiraSprintFieldSprintsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<JiraSprintState>;
};

/** Represents the state of the sprint. */
export const JiraSprintState = {
  /** The sprint is in progress. */
  Active: 'ACTIVE',
  /** The sprint has been completed. */
  Closed: 'CLOSED',
  /** The sprint hasn't been started yet. */
  Future: 'FUTURE'
} as const;

export type JiraSprintState = typeof JiraSprintState[keyof typeof JiraSprintState];
/** Represents the status field of an issue. */
export type JiraStatus = Node & {
  __typename: 'JiraStatus';
  /** Optional description of the status. E.g. "This issue is actively being worked on by the assignee". */
  description?: Maybe<Scalars['String']>;
  /** Global identifier for the Status. */
  id: Scalars['ID'];
  /** Name of status. E.g. Backlog, Selected for Development, In Progress, Done. */
  name?: Maybe<Scalars['String']>;
  /** Represents a group of Jira statuses. */
  statusCategory?: Maybe<JiraStatusCategory>;
  /** Status id in the digital format. */
  statusId: Scalars['String'];
};

/** Represents the category of a status. */
export type JiraStatusCategory = Node & {
  __typename: 'JiraStatusCategory';
  /** Color of status category. */
  colorName?: Maybe<JiraStatusCategoryColor>;
  /** Global identifier for the Status Category. */
  id: Scalars['ID'];
  /** A unique key to identify this status category. E.g. new, indeterminate, done. */
  key?: Maybe<Scalars['String']>;
  /** Name of status category. E.g. New, In Progress, Complete. */
  name?: Maybe<Scalars['String']>;
  /** Status category id in the digital format. */
  statusCategoryId: Scalars['String'];
};

/** Color of the status category. */
export const JiraStatusCategoryColor = {
  /** #4a6785 */
  BlueGray: 'BLUE_GRAY',
  /** #815b3a */
  Brown: 'BROWN',
  /** #14892c */
  Green: 'GREEN',
  /** #707070 */
  MediumGray: 'MEDIUM_GRAY',
  /** #d04437 */
  WarmRed: 'WARM_RED',
  /** #f6c342 */
  Yellow: 'YELLOW'
} as const;

export type JiraStatusCategoryColor = typeof JiraStatusCategoryColor[keyof typeof JiraStatusCategoryColor];
/** Represents Status Category field. */
export type JiraStatusCategoryField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraStatusCategoryField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The status category for the issue or default status category configured for the field. */
  statusCategory: JiraStatusCategory;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents Status field. */
export type JiraStatusField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraStatusField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** The status selected on the Issue or default status configured for the field. */
  status: JiraStatus;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */
export type JiraSubtasksField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraSubtasksField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /**
   * Paginated list of subtasks on the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  subtasks?: Maybe<JiraIssueConnection>;
  /** Field type key. */
  type: Scalars['String'];
};


/** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */
export type JiraSubtasksFieldSubtasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Represents a pre-defined filter in Jira. */
export type JiraSystemFilter = JiraFilter & Node & {
  __typename: 'JiraSystemFilter';
  /** A tenant local filterId. For system filters the ID is in the range from -9 to -1. This value is used for interoperability with REST APIs (eg vendors). */
  filterId: Scalars['String'];
  /** An ARI value in the format `ari:cloud:jira:{siteId}:filter/activation/{activationId}/{filterId}`that encodes the filterId. */
  id: Scalars['ID'];
  /** Determines whether the filter is currently starred by the user viewing the filter. */
  isFavourite?: Maybe<Scalars['Boolean']>;
  /** JQL associated with the filter. */
  jql: Scalars['String'];
  /** A string representing the filter name. */
  name: Scalars['String'];
};

/** Represents a single team in Jira */
export type JiraTeam = Node & {
  __typename: 'JiraTeam';
  /** Avatar of the team */
  avatar?: Maybe<JiraAvatar>;
  /**
   * Description of the team
   *
   *
   * This field is **deprecated** and will be removed in the future
   * @deprecated JPO Team does not have a description field.
   */
  description?: Maybe<Scalars['String']>;
  /** Global identifier of team */
  id: Scalars['ID'];
  /** Members available in the team */
  members?: Maybe<JiraUserConnection>;
  /** Name of the team */
  name?: Maybe<Scalars['String']>;
  /** Team id in the digital format */
  teamId: Scalars['String'];
};

/** The connection type for JiraTeam. */
export type JiraTeamConnection = {
  __typename: 'JiraTeamConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraTeamEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraTeam connection. */
export type JiraTeamEdge = {
  __typename: 'JiraTeamEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraTeam>;
};

/** Deprecated type. Please use `JiraTeamViewField` instead. */
export type JiraTeamField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraTeamField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch all the teams options for the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** The team selected on the Issue or default team configured for the field. */
  selectedTeam?: Maybe<JiraTeam>;
  /**
   * Paginated list of team options available for the field or the Issue.
   * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
   */
  teams?: Maybe<JiraTeamConnection>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};


/** Deprecated type. Please use `JiraTeamViewField` instead. */
export type JiraTeamFieldTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchBy?: InputMaybe<Scalars['String']>;
};

/** Represents a view on a Team in Jira. */
export type JiraTeamView = {
  __typename: 'JiraTeamView';
  /** The full team entity. */
  fullTeam?: Maybe<Team>;
  /** The avatar of the team. */
  jiraSuppliedAvatar?: Maybe<JiraAvatar>;
  /** The ARI of the team. */
  jiraSuppliedId: Scalars['ID'];
  /** The name of the team. */
  jiraSuppliedName?: Maybe<Scalars['String']>;
  /** The unique identifier of the team. */
  jiraSuppliedTeamId: Scalars['String'];
};

/** Represents the Team field on a Jira Issue. Allows you to select a team to be associated with an Issue. */
export type JiraTeamViewField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraTeamViewField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Search URL to fetch all the teams options for the field on a Jira Issue. */
  searchUrl?: Maybe<Scalars['String']>;
  /** The team selected on the Issue or default team configured for the field. */
  selectedTeam?: Maybe<JiraTeamView>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Different time formats supported for entering & displaying time tracking related data. */
export const JiraTimeFormat = {
  /** E.g. 2d 4.5h */
  Days: 'DAYS',
  /** E.g. 52.5h */
  Hours: 'HOURS',
  /** E.g. 2 days, 4 hours, 30 minutes */
  Pretty: 'PRETTY'
} as const;

export type JiraTimeFormat = typeof JiraTimeFormat[keyof typeof JiraTimeFormat];
/** Represents the time tracking field on Jira issue screens. */
export type JiraTimeTrackingField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraTimeTrackingField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Original Estimate displays the amount of time originally anticipated to resolve the issue. */
  originalEstimate?: Maybe<JiraEstimate>;
  /** Time Remaining displays the amount of time currently anticipated to resolve the issue. */
  remainingEstimate?: Maybe<JiraEstimate>;
  /** Time Spent displays the amount of time that has been spent on resolving the issue. */
  timeSpent?: Maybe<JiraEstimate>;
  /** This represents the global time tracking settings configuration like working hours and days. */
  timeTrackingSettings?: Maybe<JiraTimeTrackingSettings>;
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Represents the type for representing global time tracking settings. */
export type JiraTimeTrackingSettings = {
  __typename: 'JiraTimeTrackingSettings';
  /** Format in which the time tracking details are presented to the user. */
  defaultFormat?: Maybe<JiraTimeFormat>;
  /** Default unit for time tracking wherever not specified. */
  defaultUnit?: Maybe<JiraTimeUnit>;
  /** Returns whether time tracking implementation is provided by Jira or some external providers. */
  isJiraConfiguredTimeTrackingEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of days in a working week. */
  workingDaysPerWeek?: Maybe<Scalars['Float']>;
  /** Number of hours in a working day. */
  workingHoursPerDay?: Maybe<Scalars['Float']>;
};

/**
 * Different time units supported for entering & displaying time tracking related data.
 * Get the currently configured default duration to use when parsing duration string for time tracking.
 */
export const JiraTimeUnit = {
  /** When the current duration is in days. */
  Day: 'DAY',
  /** When the current duration is in hours. */
  Hour: 'HOUR',
  /** When the current duration is in minutes. */
  Minute: 'MINUTE',
  /** When the current duration is in weeks. */
  Week: 'WEEK'
} as const;

export type JiraTimeUnit = typeof JiraTimeUnit[keyof typeof JiraTimeUnit];
/** Represents url field on a Jira Issue. */
export type JiraUrlField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraUrlField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** The url selected on the Issue or default url configured for the field. */
  url?: Maybe<Scalars['URL']>;
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** A connection to a list of users. */
export type JiraUserConnection = {
  __typename: 'JiraUserConnection';
  /** A list of User edges. */
  edges?: Maybe<Array<Maybe<JiraUserEdge>>>;
  /** The page info of the current page of results. */
  pageInfo: PageInfo;
  /** A count of filtered result set across all pages. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in an User connection object. */
export type JiraUserEdge = {
  __typename: 'JiraUserEdge';
  /** The cursor to this edge. */
  cursor?: Maybe<Scalars['String']>;
  /** The node at this edge. */
  node?: Maybe<User>;
};

/** Attributes of user made field configurations. */
export type JiraUserFieldConfig = {
  __typename: 'JiraUserFieldConfig';
  /** Defines whether a field has been pinned by the user. */
  isPinned?: Maybe<Scalars['Boolean']>;
  /** Defines if the user has preferred to check a field on Issue creation. */
  isSelected?: Maybe<Scalars['Boolean']>;
};

/** The USER grant type value where user data is provided by identity service. */
export type JiraUserGrantTypeValue = Node & {
  __typename: 'JiraUserGrantTypeValue';
  /**
   * The ARI to represent the grant user type value.
   * For example: ari:cloud:identity::user/123
   */
  id: Scalars['ID'];
  /** The GDPR compliant user profile information. */
  user?: Maybe<User>;
};

/** Represents user made configurations associated with an Issue field. */
export type JiraUserIssueFieldConfiguration = {
  /** Attributes of an Issue field configuration info from a user's customisation. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersion = Node & {
  __typename: 'JiraVersion';
  /**
   * Marketplace connect app iframe data for Version details page's top right corner extension point(location: atl.jira.releasereport.top.right.panels)
   * An empty array will be returned in case there isn't any marketplace apps installed.
   */
  connectAddonIframeData?: Maybe<Array<Maybe<JiraVersionConnectAddonIframeData>>>;
  /**
   * Version description.
   * This is a beta field and has not been implemented yet.
   */
  description?: Maybe<Scalars['String']>;
  /** Version icon URL. */
  iconUrl?: Maybe<Scalars['URL']>;
  id: Scalars['ID'];
  /** List of issues with the version. */
  issues?: Maybe<JiraIssueConnection>;
  /** Version name. */
  name?: Maybe<Scalars['String']>;
  /**
   * The date at which the version was released to customers. Must occur after startDate.
   * This is a beta field and has not been implemented yet.
   */
  releaseDate?: Maybe<Scalars['DateTime']>;
  /**
   * The date at which work on the version began.
   * This is a beta field and has not been implemented yet.
   */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Status to which version belongs to. */
  status?: Maybe<JiraVersionStatus>;
  /** Version Id. */
  versionId: Scalars['String'];
  /**
   * Warning config of the version. This is per project setting.
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: JiraVersionWarningConfig` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  warningConfig?: Maybe<JiraVersionWarningConfig>;
};


/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionIssuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<JiraVersionIssuesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Marketplace connect app iframe data for Version details page's top right corner extension point(location: atl.jira.releasereport.top.right.panels)
 * If options is null, parsing string json into json object failed while mapping.
 */
export type JiraVersionConnectAddonIframeData = {
  __typename: 'JiraVersionConnectAddonIframeData';
  appKey?: Maybe<Scalars['String']>;
  appName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  moduleKey?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSON']>;
};

/** The connection type for JiraVersion. */
export type JiraVersionConnection = {
  __typename: 'JiraVersionConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraVersionEdge>>>;
  /** Information about the current page. Used to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a JiraVersion connection. */
export type JiraVersionEdge = {
  __typename: 'JiraVersionEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the edge. */
  node?: Maybe<JiraVersion>;
};

/** The filter for a version's issues */
export const JiraVersionIssuesFilter = {
  All: 'ALL',
  Done: 'DONE',
  FailingBuild: 'FAILING_BUILD',
  InProgress: 'IN_PROGRESS',
  OpenPullRequest: 'OPEN_PULL_REQUEST',
  OpenReview: 'OPEN_REVIEW',
  Todo: 'TODO',
  UnreviewedCode: 'UNREVIEWED_CODE'
} as const;

export type JiraVersionIssuesFilter = typeof JiraVersionIssuesFilter[keyof typeof JiraVersionIssuesFilter];
/** The status of a version field. */
export const JiraVersionStatus = {
  /** Indicates the version is archived, no further changes can be made to this version unless it is un-archived */
  Archived: 'ARCHIVED',
  /** Indicates the version is available to public */
  Released: 'RELEASED',
  /** Indicates the version is not launched yet */
  Unreleased: 'UNRELEASED'
} as const;

export type JiraVersionStatus = typeof JiraVersionStatus[keyof typeof JiraVersionStatus];
/** The warning configuration to generate version details page warning report. */
export type JiraVersionWarningConfig = {
  __typename: 'JiraVersionWarningConfig';
  /** The warnings for issues that has failing build and in done issue status category. */
  failingBuild?: Maybe<JiraVersionWarningConfigState>;
  /** The warnings for issues that has open pull request and in done issue status category. */
  openPullRequest?: Maybe<JiraVersionWarningConfigState>;
  /** The warnings for issues that has open review and in done issue status category (only applicable for FishEye/Crucible integration to Jira). */
  openReview?: Maybe<JiraVersionWarningConfigState>;
  /** The warnings for issues that has unreviewed code and in done issue status category. */
  unreviewedCode?: Maybe<JiraVersionWarningConfigState>;
};

/** The warning config for version details page to generate warning report. Depending on tenant settings and providers installed, some warning config could be in NOT_APPLICABLE state. */
export const JiraVersionWarningConfigState = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED',
  NotApplicable: 'NOT_APPLICABLE'
} as const;

export type JiraVersionWarningConfigState = typeof JiraVersionWarningConfigState[keyof typeof JiraVersionWarningConfigState];
/** Represents the votes information of an Issue. */
export type JiraVote = {
  __typename: 'JiraVote';
  /** Count of users who have voted for this Issue. */
  count?: Maybe<Scalars['Long']>;
  /** Indicates whether the current user has voted for this Issue. */
  hasVoted?: Maybe<Scalars['Boolean']>;
};

/** Represents a votes field on a Jira Issue. */
export type JiraVotesField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraVotesField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Represents the vote value selected on the Issue.
   * Can be null when voting is disabled.
   */
  vote?: Maybe<JiraVote>;
};

/** Represents the watches information. */
export type JiraWatch = {
  __typename: 'JiraWatch';
  /** Count of users who are watching this issue. */
  count?: Maybe<Scalars['Long']>;
  /** Indicates whether the current user is watching this issue. */
  isWatching?: Maybe<Scalars['Boolean']>;
};

/** Represents the Watches system field. */
export type JiraWatchesField = JiraIssueField & JiraIssueFieldConfiguration & JiraUserIssueFieldConfiguration & Node & {
  __typename: 'JiraWatchesField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
  userFieldConfig?: Maybe<JiraUserFieldConfig>;
  /**
   * Represents the watch value selected on the Issue.
   * Can be null when watching is disabled.
   */
  watch?: Maybe<JiraWatch>;
};

/** Represents a WorkCategory. */
export type JiraWorkCategory = {
  __typename: 'JiraWorkCategory';
  /** The value of the WorkCategory. */
  value?: Maybe<Scalars['String']>;
};

/** Represents the WorkCategory field on an Issue. */
export type JiraWorkCategoryField = JiraIssueField & JiraIssueFieldConfiguration & Node & {
  __typename: 'JiraWorkCategoryField';
  /** The field ID alias (if applicable). */
  aliasFieldId?: Maybe<Scalars['ID']>;
  /** Description for the field (if present). */
  description?: Maybe<Scalars['String']>;
  /** Attributes of an issue field's configuration info. */
  fieldConfig?: Maybe<JiraFieldConfig>;
  /** The identifier of the field. E.g. summary, customfield_10001, etc. */
  fieldId: Scalars['String'];
  /** Unique identifier for the field. */
  id: Scalars['ID'];
  /** Translated name for the field (if applicable). */
  name: Scalars['String'];
  /** Field type key. */
  type: Scalars['String'];
  /** The WorkCategory selected on the Issue or default WorkCategory configured for the field. */
  workCategory?: Maybe<JiraWorkCategory>;
};

/** The connection type for JiraWorklog. */
export type JiraWorkLogConnection = {
  __typename: 'JiraWorkLogConnection';
  /** A list of edges in the current page. */
  edges?: Maybe<Array<Maybe<JiraWorkLogEdge>>>;
  /** The approximate count of items in the connection. */
  indicativeCount?: Maybe<Scalars['Int']>;
  /** The page info of the current page of results. */
  pageInfo: PageInfo;
};

/** An edge in a JiraWorkLog connection. */
export type JiraWorkLogEdge = {
  __typename: 'JiraWorkLogEdge';
  /** The cursor to this edge. */
  cursor: Scalars['String'];
  /** The node at the the edge. */
  node?: Maybe<JiraWorklog>;
};

/** Represents a Jira worklog. */
export type JiraWorklog = Node & {
  __typename: 'JiraWorklog';
  /** User profile of the original worklog author. */
  author?: Maybe<User>;
  /** Time of worklog creation. */
  created: Scalars['DateTime'];
  /** Global identifier for the worklog. */
  id: Scalars['ID'];
  /**
   * Either the group or the project role associated with this worklog, but not both.
   * Null means the permission level is unspecified, i.e. the worklog is public.
   */
  permissionLevel?: Maybe<JiraPermissionLevel>;
  /** Time Remaining displays the amount of time currently anticipated to resolve the issue. */
  remainingEstimate?: Maybe<JiraEstimate>;
  /** Date and time when this unit of work was started. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Time spent displays the amount of time logged working on the issue so far. */
  timeSpent?: Maybe<JiraEstimate>;
  /** User profile of the author performing the worklog update. */
  updateAuthor?: Maybe<User>;
  /** Time of last worklog update. */
  updated?: Maybe<Scalars['DateTime']>;
  /** Description related to the achieved work. */
  workDescription?: Maybe<JiraRichText>;
  /** Identifier for the worklog. */
  worklogId: Scalars['ID'];
};

/** Labels are defined per board, and can be applied to the cards on that board */
export type Label = {
  __typename: 'Label';
  /** The color of the label. */
  color?: Maybe<Label_Color>;
  /** The ID of the Label */
  id: Scalars['ID'];
  /** The ID of the board the label is on. */
  idBoard: Scalars['String'];
  /** The name of the label. */
  name: Scalars['String'];
};

export const Label_Color = {
  Black: 'black',
  Blue: 'blue',
  Green: 'green',
  Lime: 'lime',
  Orange: 'orange',
  Pink: 'pink',
  Purple: 'purple',
  Red: 'red',
  Sky: 'sky',
  Yellow: 'yellow'
} as const;

export type Label_Color = typeof Label_Color[keyof typeof Label_Color];
/** A filter for the Labels being requested */
export const Label_Filter = {
  /** Get all of the labels */
  All: 'all',
  /** Get none of the labels */
  None: 'none'
} as const;

export type Label_Filter = typeof Label_Filter[keyof typeof Label_Filter];
/** An object containing information about a Limit */
export type Limit = {
  __typename: 'Limit';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** The status of a Limit */
export const LimitStatus = {
  /** The limit is at the disabled threshold */
  Disabled: 'disabled',
  /** The limit is over the disabled thershold */
  MaxExceeded: 'maxExceeded',
  /** The limit is not within the warning range */
  Ok: 'ok',
  /** The limit is at/over the warning threshold */
  Warn: 'warn'
} as const;

export type LimitStatus = typeof LimitStatus[keyof typeof LimitStatus];
/** A Board is made up of vertical Lists which contain Cards */
export type List = {
  __typename: 'List';
  /** The Board that the List is on */
  board: Board;
  /** The Cards in the List */
  cards: Array<Card>;
  /** Whether the List is closed (archived) */
  closed: Scalars['Boolean'];
  /** How the List was created */
  creationMethod?: Maybe<CreationMethod>;
  /** The ID of the List */
  id: Scalars['String'];
  /** The ID of the Board the List is on */
  idBoard: Scalars['String'];
  /** The limits on the List */
  limits: List_Limits;
  /** The name of the List */
  name: Scalars['String'];
  /** The position of the List on the Board */
  pos: Scalars['Float'];
  /** The 'soft' limit of Cards in the List */
  softLimit?: Maybe<Scalars['Int']>;
  /** Whether the Member is subscribed to this List */
  subscribed: Scalars['Boolean'];
};


/** A Board is made up of vertical Lists which contain Cards */
export type ListCardsArgs = {
  filter?: InputMaybe<Card_Filter>;
};

/** List price quotes for a subscriber */
export type ListPriceQuoteInfo = {
  __typename: 'ListPriceQuoteInfo';
  /** The base price quote info */
  base: PriceQuoteInfo;
  /** The price quote info for the subscriber which might reflect a subscriber-specific discount */
  subscriber: PriceQuoteInfo;
};

/** A filter for the Lists being requested */
export const List_Filter = {
  /** Only closed (archived) Lists */
  Closed: 'closed',
  /** Only open Lists */
  Open: 'open'
} as const;

export type List_Filter = typeof List_Filter[keyof typeof List_Filter];
/** The limits on the List */
export type List_Limits = {
  __typename: 'List_Limits';
  /** The list-card limits */
  cards: List_Limits_Cards;
};

/** The list-card limits */
export type List_Limits_Cards = {
  __typename: 'List_Limits_Cards';
  /** Open Cards per List Limit */
  openPerList: Limit;
  /** Total Cards per List Limit */
  totalPerList: Limit;
};

/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */
export type LocalizationContext = {
  /** The locale of user in RFC5646 format. */
  locale?: Maybe<Scalars['String']>;
  /** The timezone of the user as defined in the tz database https://www.iana.org/time-zones. */
  zoneinfo?: Maybe<Scalars['String']>;
};

/** A Login method for a Member */
export type Login = {
  __typename: 'Login';
  /** Whether this email address can be claimed by an org */
  claimable: Scalars['Boolean'];
  /** The email address associated with this Login */
  email: Scalars['String'];
  /** The ID of the Login */
  id: Scalars['ID'];
  /** Whether this is the primary login for this user */
  primary: Scalars['Boolean'];
  /** The types of Login methods that can be used with this email */
  types: Array<Member_LoginType>;
};

/** Everyone with a Trello account is called a member. */
export type Member = {
  __typename: 'Member';
  /** Date profile syncing from Atlassian account to Trello will be unblocked on the member */
  aaBlockSyncUntil?: Maybe<Scalars['String']>;
  /** The Atlassian Account email of the member. */
  aaEmail?: Maybe<Scalars['String']>;
  /** The Atlassian Account ID of the member. */
  aaId?: Maybe<Scalars['String']>;
  /** Whether the member has been active recently */
  active?: Maybe<Scalars['Boolean']>;
  /** Whether activity has been blocked for this Member */
  activityBlocked: Scalars['Boolean'];
  /** The agreements made by the member. */
  agreements: Array<Member_Agreement>;
  /** Atlassian organizations the member belongs to. */
  atlassianOrganizations: Array<Member_Atlassian_Organization>;
  avatarHash?: Maybe<Scalars['String']>;
  /** The source of the user's avatar - either via 'upload' or 'gravatar'. */
  avatarSource?: Maybe<Member_AvatarSource>;
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Banners which might be visible to the member. */
  banners: Array<Member_Banner>;
  /** Optional bio for the member. */
  bio: Scalars['String'];
  /** If the bio includes custom emoji, this object will contain the information necessary to display them. */
  bioData?: Maybe<Scalars['JSONString']>;
  /** The Boards the Member has starred */
  boardStars: Array<BoardStar>;
  /** The boards the user is a member of */
  boards: Array<Board>;
  /** The ad campaigns the member is in */
  campaigns: Array<Campaign>;
  /** The cards the member is on */
  cards: Array<Card>;
  /** The information about the channel (stable/alpha) the Member is on and what they have access to */
  channels?: Maybe<Channels>;
  /** Whether the member has confirmed their email address after signing up. */
  confirmed: Scalars['Boolean'];
  credentials: Array<Member_Credential>;
  /** Count of any credentials removed in Atlassian onboarding process */
  credentialsRemovedCount?: Maybe<Scalars['String']>;
  /** The Credits owned by this Member */
  credits?: Maybe<Array<Credit>>;
  /** Date the member was domain claimed by an Atlassian organization */
  domainClaimed?: Maybe<Scalars['String']>;
  /** The primary email address for the member. You can only read your own. */
  email?: Maybe<Scalars['String']>;
  /** The Enterprise licenses granted to the member */
  enterpriseLicenses?: Maybe<Array<Member_EnterpriseLicense>>;
  /** This route returns an enterprise if the member is owned and licensed by an enterprise that has set a value for Enterprise.prefs.personalBoardsOwnership.ownDate. */
  enterpriseToExplicitlyOwnBoards?: Maybe<Member_EnterpriseToExplicitlyOwnBoards>;
  enterpriseWithRequiredConversion?: Maybe<Member_EnterpriseWithRequiredConversion>;
  /** The Enterprises this Member is a part of */
  enterprises: Array<Enterprise>;
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  /** Org id for where the gold promo free trial was activated */
  goldSunsetFreeTrialIdOrganization: Scalars['String'];
  /** Same as avatarUrl above; member profile images are hosted at: https://trello-members.s3.amazonaws.com/{idMember}/{gravatarHash}/{size}.png size can be 30, 50, or 170 string. */
  gravatarHash?: Maybe<Scalars['String']>;
  /** Guest organizations the member belongs to. */
  guestOrganizations: Array<GuestOrganization>;
  /** The ID of the member. */
  id: Scalars['ID'];
  /** An array of board IDs this member is on. */
  idBoards: Array<Scalars['String']>;
  /** The enterprise that 'owns' this Member (i.e this member is owned by a Trello Enterprise customer) */
  idEnterprise?: Maybe<Scalars['String']>;
  /** An array of enterprise IDs this member is an admin of. */
  idEnterprisesAdmin: Array<Scalars['String']>;
  /** Enterprises that have explicitly deactivated this member */
  idEnterprisesDeactivated: Array<Scalars['String']>;
  /** The id of the Member that referred this Member to Trello */
  idMemberReferrer?: Maybe<Scalars['String']>;
  /** An array of organization IDs this member is in. */
  idOrganizations: Array<Scalars['String']>;
  /** An array of organization IDs this member is an admin of. */
  idPremOrgsAdmin: Array<Scalars['String']>;
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>;
  /** Whether the member is 'mastered' by Atlassian Account */
  isAaMastered: Scalars['Boolean'];
  /** How many delta updates have been processed by this Member */
  ixUpdate: Scalars['String'];
  /** The limits on this Member */
  limits: Member_Limits;
  /** The types of logins a user can use: password, saml, google, android or atlassian */
  loginTypes?: Maybe<Array<Maybe<Member_LoginType>>>;
  /** The logins for the members. */
  logins: Array<Login>;
  /** Information about if/when the Member has opted in/out of marketing communication */
  marketingOptIn?: Maybe<Member_MarketingOptIn>;
  /** One of: 'normal', 'ghost'. A ghost is an individual who has been invited to join but has not yet created a Trello account. */
  memberType: Member_MemberType;
  /** Information about in-app messages that the Member has dismissed */
  messagesDismissed?: Maybe<Array<Member_MessageDismissed>>;
  /** The information the Member has chosen to be non-public */
  nonPublic?: Maybe<Member_NonPublic>;
  /** Whether non public information is available for the Member */
  nonPublicAvailable: Scalars['Boolean'];
  ofEnterprise?: Maybe<OfEnterprise>;
  /** A list of the 'one time messages' that have been dismissed by the member */
  oneTimeMessagesDismissed?: Maybe<Array<Scalars['String']>>;
  /** The organizations the user is a member of */
  organizations: Array<Organization>;
  /** Information about the paid account of Member */
  paidAccount?: Maybe<PaidAccount>;
  /** The PluginData on this Member */
  pluginData: Array<PluginData>;
  /** The preferences (settings) for this member */
  prefs?: Maybe<Member_Prefs>;
  /** The premium features allowed for this member */
  premiumFeatures: Array<PremiumFeatures>;
  /** 10 - member has Trello Gold as a result of being in a Business Class team. 37 - member has monthly Trello Gold. 38 - member has annual Trello Gold. */
  products: Array<Scalars['Int']>;
  /** Object that includes data necessary for Aa onboarding UI */
  requiresAaOnboarding?: Maybe<RequiresAaOnboarding>;
  /** The saved search queries for this Member */
  savedSearches: Array<SavedSearch>;
  sessions: Array<Member_Session>;
  status?: Maybe<Scalars['String']>;
  /** Values that monitor the progress of the automatic board migration into teams */
  teamify: Member_Teamify;
  tokenCount: Scalars['Int'];
  /** The users tokens */
  tokens?: Maybe<Array<Maybe<Token>>>;
  /** The trophies the Member has earned */
  trophies: Array<Scalars['String']>;
  uploadedAvatarHash?: Maybe<Scalars['String']>;
  /** The URL of the uploaded avatar if one has been uploaded. */
  uploadedAvatarUrl?: Maybe<Scalars['String']>;
  /** The URL to the member's profile page. */
  url: Scalars['String'];
  /** The username for the member. What is shown in @mentions for example. */
  username: Scalars['String'];
  /** indicates whether this member would be become a multi-board billable guest */
  wouldBecomeBillableGuest?: Maybe<Scalars['Boolean']>;
};


/** Everyone with a Trello account is called a member. */
export type MemberBoardsArgs = {
  filter?: InputMaybe<Array<InputMaybe<Board_Filter>>>;
};


/** Everyone with a Trello account is called a member. */
export type MemberCardsArgs = {
  filter?: InputMaybe<Card_Filter>;
};


/** Everyone with a Trello account is called a member. */
export type MemberCreditsArgs = {
  filter: Array<Credit_Type>;
};


/** Everyone with a Trello account is called a member. */
export type MemberEnterprisesArgs = {
  filter?: InputMaybe<Array<InputMaybe<Enterprise_Filter>>>;
};


/** Everyone with a Trello account is called a member. */
export type MemberOrganizationsArgs = {
  filter?: InputMaybe<Organization_Filter>;
};

export type MemberEntity = {
  __typename: 'MemberEntity';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Member as Input for adding a member to a team */
export type MemberOrEmail = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type MemberProfileFields = {
  bio?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** The agreements made by the member */
export type Member_Agreement = {
  __typename: 'Member_Agreement';
  agreementType: Scalars['String'];
  id: Scalars['ID'];
};

/** Atlassian Organizations the member is a part of */
export type Member_Atlassian_Organization = {
  __typename: 'Member_Atlassian_Organization';
  domains: Array<Scalars['String']>;
  flexAuthError: Scalars['Boolean'];
  id: Scalars['ID'];
  idEnterprise: Scalars['ID'];
  isIdentityAdmin: Scalars['Boolean'];
  linked: Scalars['Boolean'];
  name: Scalars['String'];
  ssoUrl: Scalars['String'];
};

/** The source of an avatar */
export const Member_AvatarSource = {
  /** The avatar has been sourced from Atlassian account */
  AtlassianAccount: 'atlassianAccount',
  /** The avatar is hosted by gravatar */
  Gravatar: 'gravatar',
  /** No avatar */
  None: 'none',
  /** The avatar has been uploaded */
  Upload: 'upload'
} as const;

export type Member_AvatarSource = typeof Member_AvatarSource[keyof typeof Member_AvatarSource];
/** Banners that a member may be able to interact with */
export type Member_Banner = {
  __typename: 'Member_Banner';
  dismissible: Scalars['Boolean'];
  id: Scalars['String'];
  message: Scalars['String'];
  meta?: Maybe<Member_BannerMeta>;
  url?: Maybe<Scalars['String']>;
};

export type Member_BannerMeta = {
  __typename: 'Member_BannerMeta';
  totalMembersInDomain?: Maybe<Scalars['Int']>;
  totalWorkspacesInDomain?: Maybe<Scalars['Int']>;
};

export type Member_Credential = {
  __typename: 'Member_Credential';
  email: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

/** An Enterprise license granted to a Member */
export type Member_EnterpriseLicense = {
  __typename: 'Member_EnterpriseLicense';
  /** The ID of the Enterprise that the license is for */
  idEnterprise: Scalars['ID'];
  /** The type of license granted */
  type: Member_EnterpriseLicenseType;
};

/** A type of Enterprise license */
export const Member_EnterpriseLicenseType = {
  /** A user who is a member of an Enterprise board, but has not previously been granted a 'team' license */
  Collaborator: 'collaborator',
  /** The standard enterprise license, designating a paid member of the enterprise */
  Team: 'team'
} as const;

export type Member_EnterpriseLicenseType = typeof Member_EnterpriseLicenseType[keyof typeof Member_EnterpriseLicenseType];
/**
 * This route returns an enterprise if the member is owned and licensed
 * by an enterprise that has set a value for
 * Enterprise.prefs.personalBoardsOwnership.ownDate.
 */
export type Member_EnterpriseToExplicitlyOwnBoards = {
  __typename: 'Member_EnterpriseToExplicitlyOwnBoards';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownDate?: Maybe<Scalars['String']>;
};

export type Member_EnterpriseWithRequiredConversion = {
  __typename: 'Member_EnterpriseWithRequiredConversion';
  displayName?: Maybe<Scalars['String']>;
  prefs?: Maybe<Member_EnterpriseWithRequiredConversionPrefs>;
};

export type Member_EnterpriseWithRequiredConversionPrefs = {
  __typename: 'Member_EnterpriseWithRequiredConversionPrefs';
  mandatoryTransferDate?: Maybe<Scalars['String']>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
};

/** A filter for the Members being requested */
export const Member_Filter = {
  /** Admin members of the Organization or Board */
  Admins: 'admins',
  /** All members of the Organization or Board */
  All: 'all',
  /** None members of the Organization or Board. Dont use with gql */
  None: 'none',
  /** Normal members of the Organization or Board */
  Normal: 'normal',
  /** Owners members of the Organization or Board */
  Owners: 'owners'
} as const;

export type Member_Filter = typeof Member_Filter[keyof typeof Member_Filter];
/** The limits on the Member */
export type Member_Limits = {
  __typename: 'Member_Limits';
  /** The member-board limits */
  boards: Member_Limits_Boards;
  /** The member-organization limits */
  orgs: Member_Limits_Orgs;
};

/** The member-board limits */
export type Member_Limits_Boards = {
  __typename: 'Member_Limits_Boards';
  /** The limit for the total boards per member */
  totalPerMember: Limit;
};

/** The member-organization limits */
export type Member_Limits_Orgs = {
  __typename: 'Member_Limits_Orgs';
  /** The limit for the total organizations per member */
  totalPerMember: Limit;
};

/** The types of logins a user can use */
export const Member_LoginType = {
  Android: 'android',
  Atlassian: 'atlassian',
  Google: 'google',
  Password: 'password',
  Saml: 'saml'
} as const;

export type Member_LoginType = typeof Member_LoginType[keyof typeof Member_LoginType];
/** Information about if/when the Member has opted in/out of marketing communication */
export type Member_MarketingOptIn = {
  __typename: 'Member_MarketingOptIn';
  /** When the Member last opted in/out of marketing communication */
  date: Scalars['String'];
  /** Whether the Member is opted in to marketing communication */
  optedIn: Scalars['Boolean'];
};

/**
 * Whether the member is a registered Trello user or a 'ghost' user
 * created by an email invite
 */
export const Member_MemberType = {
  Ghost: 'ghost',
  Normal: 'normal'
} as const;

export type Member_MemberType = typeof Member_MemberType[keyof typeof Member_MemberType];
/** Information about in-app messages that the Member has dismissed */
export type Member_MessageDismissed = {
  __typename: 'Member_MessageDismissed';
  /** The ID of the MessageDismissed record (not the id of the message itself) */
  _id: Scalars['ID'];
  /** The number of times the message has been dismissed */
  count: Scalars['Int'];
  /** The date the message was last dismissed */
  lastDismissed: Scalars['String'];
  /** The name of the message dismissed */
  name: Scalars['String'];
};

/** The information the Member has chosen to be non-public */
export type Member_NonPublic = {
  __typename: 'Member_NonPublic';
  avatarHash?: Maybe<Scalars['String']>;
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>;
};

/** The preferences for a Member */
export type Member_Prefs = {
  __typename: 'Member_Prefs';
  /** Whether the user has enabled color blind mode */
  colorBlind: Scalars['Boolean'];
  /** The user's locale preference */
  locale: Scalars['String'];
  /** The default minutes before a due date to send a notification */
  minutesBeforeDeadlineToNotify: Scalars['Int'];
  /** How often the user should receive email summaries */
  minutesBetweenSummaries: Scalars['Int'];
  /** Privacy settings for a user's details */
  privacy: Member_Prefs_Privacy;
  /** The users timezone preference */
  timezoneInfo: Member_Prefs_TimezoneInfo;
  /** The users twoFactor authentication info */
  twoFactor?: Maybe<Member_Prefs_TwoFactor>;
};

/** Privacy settings for a user's details */
export type Member_Prefs_Privacy = {
  __typename: 'Member_Prefs_Privacy';
  /** Privacy setting for displaying the user's avatar */
  avatar: Member_Prefs_PrivacyOption;
  /** Privacy setting for displaying the user's full name */
  fullName: Member_Prefs_PrivacyOption;
};

/** The visibility of a user detail */
export const Member_Prefs_PrivacyOption = {
  /** Visible to collaborators only */
  Collaborator: 'collaborator',
  /** Not visible to anyone */
  Private: 'private',
  /** Visible to everyone */
  Public: 'public'
} as const;

export type Member_Prefs_PrivacyOption = typeof Member_Prefs_PrivacyOption[keyof typeof Member_Prefs_PrivacyOption];
/** Information about a user's Timezone */
export type Member_Prefs_TimezoneInfo = {
  __typename: 'Member_Prefs_TimezoneInfo';
  dateNext: Scalars['String'];
  offsetCurrent: Scalars['Int'];
  offsetNext: Scalars['Int'];
  timezoneCurrent: Scalars['String'];
  timezoneNext: Scalars['String'];
};

/** Information about a user's 2-factor authentication */
export type Member_Prefs_TwoFactor = {
  __typename: 'Member_Prefs_TwoFactor';
  /** Whether 2-factor-auth is enabled for the user */
  enabled: Scalars['Boolean'];
  /** Whether new backup codes are needed for the user */
  needsNewBackups: Scalars['Boolean'];
};

export type Member_Session = {
  __typename: 'Member_Session';
  data: Member_Session_Data;
  dateCreated: Scalars['String'];
  dateExpires: Scalars['String'];
  dateLastUsed: Scalars['String'];
  id: Scalars['String'];
  ipAddress: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  isRecent: Scalars['Boolean'];
  type: Scalars['String'];
  userAgent: Scalars['String'];
};

export type Member_Session_Data = {
  __typename: 'Member_Session_Data';
  email: Scalars['String'];
};

/** Fields to monitor migrating all boards of a member into a team. */
export type Member_Teamify = {
  __typename: 'Member_Teamify';
  /** The date when auto-migration will run for this user */
  autoMigration?: Maybe<Scalars['String']>;
  /** Number of collaborative teamless boards for a member */
  collaborativeTeamlessBoards: Scalars['Int'];
  /** Whether we added a free trial of BC to the team above */
  createdOrgHasBcTrial?: Maybe<Scalars['Boolean']>;
  /** The id of the new team created to house all boards in the automatic migration */
  idOrgCreated?: Maybe<Scalars['String']>;
  /** The id of the existing team selected to house all boards in the automatic migration */
  idOrgSelected?: Maybe<Scalars['String']>;
  /** Whether a user will be very impacted, not impacted at all, or minorly impacted by the migration */
  impact?: Maybe<Member_Teamify_Impact>;
  /** Whether the user is in an org with at least one other user */
  inCollaborativeOrg?: Maybe<Scalars['Boolean']>;
  /** Number of solo teamless boards for a member */
  soloTeamlessBoards: Scalars['Int'];
  /** Whether migration has started, is running, or has finished */
  state: Member_Teamify_State;
  /** Whether the user has gone through voluntary migration at least once */
  voluntaryDone?: Maybe<Scalars['String']>;
};

export const Member_Teamify_Impact = {
  /** User is likely to be disrupted by us migrating their boards automatically */
  High: 'high',
  /** User is unlikely to be disrupted by us migrating their boards automatically */
  Low: 'low',
  /** User will not be disrupted by automatic migration of boards into teams */
  None: 'none'
} as const;

export type Member_Teamify_Impact = typeof Member_Teamify_Impact[keyof typeof Member_Teamify_Impact];
export const Member_Teamify_State = {
  /** Migration has finished */
  Done: 'done',
  /** Migration has not started */
  Nope: 'nope',
  /** Migration has started but has not finished */
  Pending: 'pending'
} as const;

export type Member_Teamify_State = typeof Member_Teamify_State[keyof typeof Member_Teamify_State];
/** Counts of various membership types on the Board */
export type MembershipCounts = {
  __typename: 'MembershipCounts';
  /** The count of active Members on the Board */
  active?: Maybe<Scalars['Int']>;
  /** The count of admin Members on the Board */
  admin?: Maybe<Scalars['Int']>;
  /** The count of deactivated Members on the Board */
  deactivated?: Maybe<Scalars['Int']>;
  /** 0 or 1 indicating whether you are a Member of the Board */
  me?: Maybe<Scalars['Int']>;
  /** The count of normal Members on the Board */
  normal?: Maybe<Scalars['Int']>;
};

/** Filters for only certain counts to be aggregated on MembershipCounts */
export const MembershipCounts_Filter = {
  Active: 'active',
  Admin: 'admin',
  Deactivated: 'deactivated',
  Me: 'me',
  Normal: 'normal'
} as const;

export type MembershipCounts_Filter = typeof MembershipCounts_Filter[keyof typeof MembershipCounts_Filter];
/** The roles that a member can have within a team */
export const MembershipRole = {
  /** A team member with administrative permissions */
  Admin: 'ADMIN',
  /** A regular team member */
  Regular: 'REGULAR'
} as const;

export type MembershipRole = typeof MembershipRole[keyof typeof MembershipRole];
/** The settings which a team can have describing how members are added to the team */
export const MembershipSetting = {
  /** Only admins may invite others to join the team */
  AdminInvite: 'ADMIN_INVITE',
  /** Members may invite others to join the team */
  MemberInvite: 'MEMBER_INVITE',
  /** Anyone may join */
  Open: 'OPEN'
} as const;

export type MembershipSetting = typeof MembershipSetting[keyof typeof MembershipSetting];
/** The states that a member can have within a team */
export const MembershipState = {
  /** A member who was previously a full member of the team, but has been removed or has left the team */
  Alumni: 'ALUMNI',
  /** A full member of the team */
  FullMember: 'FULL_MEMBER',
  /** A member who has been invited to the team but has not yet joined */
  Invited: 'INVITED',
  /** A member who has requested to join the team and is pending approval */
  RequestingToJoin: 'REQUESTING_TO_JOIN'
} as const;

export type MembershipState = typeof MembershipState[keyof typeof MembershipState];
/** An object representing the response from the migrateEnterpriseToAtlassian mutation */
export type MigrateEnterprise_Response = {
  __typename: 'MigrateEnterprise_Response';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Information on whether an entity is a member or organization, and its corresponding ID. */
export type ModelType = {
  __typename: 'ModelType';
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type MultipleEmailMember = {
  __typename: 'MultipleEmailMember';
  avatarUrl: Scalars['String'];
  deactivated: Scalars['Boolean'];
  emails: Array<MultipleEmailMemberEmails>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  initials: Scalars['String'];
  username: Scalars['String'];
};

/** Multiple Email Member Responses for Success and Failure */
export type MultipleEmailMemberArrayEntry = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type MultipleEmailMemberEmails = {
  __typename: 'MultipleEmailMemberEmails';
  email: Scalars['String'];
  offDomain?: Maybe<Scalars['Boolean']>;
  primary?: Maybe<Scalars['Boolean']>;
  recommended?: Maybe<Scalars['Boolean']>;
};

export type MultipleEmailMemberFailed_Response = {
  __typename: 'MultipleEmailMemberFailed_Response';
  error?: Maybe<Scalars['String']>;
  failedMembers?: Maybe<Array<MultipleEmailMember>>;
  success: Scalars['Boolean'];
};

export type MultipleEmailMember_Response = {
  __typename: 'MultipleEmailMember_Response';
  count: Scalars['Int'];
  members: Array<MultipleEmailMember>;
  totalCount: Scalars['Int'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Create an Agreement for developer terms */
  acceptDeveloperTerms?: Maybe<Member_Agreement>;
  /** Adds board star to the user */
  addBoardStar?: Maybe<BoardStar>;
  /** Add a Butler button */
  addButlerButton?: Maybe<ButlerButton>;
  /** Adds a campaign */
  addCampaign?: Maybe<Campaign>;
  /** Add a CheckItem to a checklist on a Card */
  addCheckItem?: Maybe<CheckItem>;
  /** Add a Checklist to a Card */
  addChecklist?: Maybe<Checklist>;
  /** Add a List Option to an existing Custom Field */
  addCustomFieldOption?: Maybe<CustomField_Option>;
  /** Adds free trial to an organization */
  addFreeTrial?: Maybe<Organization>;
  /** Adds Member to Board */
  addMemberToBoard?: Maybe<InviteMember_Response>;
  /** Adds Member to Organization */
  addMemberToOrg?: Maybe<InviteMember_Response>;
  /** Adds a message to oneTimeMessagesDismissed */
  addOneTimeMessagesDismissed?: Maybe<Member>;
  /** Add a member to a Plugin's collaborators */
  addPluginCollaborator?: Maybe<Plugin_Collaborators_UpdateResponse>;
  /** Add a saved search */
  addSavedSearch?: Maybe<SavedSearch>;
  /** Adds a tag for the organization */
  addTag?: Maybe<Scalars['Boolean']>;
  /** Applies 3 month bc discount to an organization */
  applyBCDiscount?: Maybe<Scalars['Boolean']>;
  /** Archives a card */
  archiveCard?: Maybe<Card>;
  /** Disable a Power-Up on all boards in a Workspace */
  bulkDisableWorkspacePowerUp?: Maybe<Scalars['Boolean']>;
  /** Cancel a Gold paid account */
  cancelGoldPaidAccount: Member;
  /** Cancel a Workspace paid account */
  cancelWorkspacePaidAccount: Organization;
  /** Change card due date */
  changeCardDueDate?: Maybe<Card>;
  /** Changes the current member's primary email */
  changeMemberEmail?: Maybe<Member>;
  /** Put a team under an Enterprise's ownership */
  claimOrganization: Organization;
  /** Close board */
  closeBoard?: Maybe<Board>;
  /** Copies a board to an organization's workspace */
  copyBoardToOrg?: Maybe<Board>;
  /** Copies a card */
  copyCard?: Maybe<Card>;
  /** Create a board invitation secret */
  createBoardInviteSecret?: Maybe<BoardInviteSecret>;
  /** Create a new card */
  createCard?: Maybe<Card>;
  /** Create a new template card */
  createCardTemplate?: Maybe<Card>;
  /** Create a new Custom Field */
  createCustomField?: Maybe<CustomField>;
  createDashboardViewTile: Board_DashboardViewTile;
  /** Create a new list in a board */
  createList?: Maybe<List>;
  /** Creates an organization */
  createOrganization?: Maybe<Organization>;
  /** Creates an organization invite secret to be included in the organization invitation link */
  createOrganizationInviteSecret?: Maybe<OrganizationInviteSecretResponse>;
  /** Add a new organization view */
  createOrganizationView?: Maybe<OrganizationView>;
  /** Create a Plugin */
  createPlugin?: Maybe<Plugin>;
  /** Create a Plugin listing */
  createPluginListing?: Maybe<Plugin_Listing>;
  /** Starts a self serve expansions request */
  createSelfServeExpansion?: Maybe<SelfServeExpansionResponse>;
  /** Sign up for Trello Business Class or Trello Standard */
  createWorkspacePaidAccount?: Maybe<Organization>;
  /** Delete all consent tokens issued by all managed members of the enterprise */
  deleteAllManagedMemberTokens: Enterprise_DeleteAllManagedMemberTokensResponse;
  /** Delete board */
  deleteBoard?: Maybe<Board>;
  /** Delete a Butler Button */
  deleteButlerButton?: Maybe<Scalars['Boolean']>;
  /** Delete a card */
  deleteCard?: Maybe<Card_DeleteResponse>;
  /** Delete a CheckItem from a Checklist on a Card */
  deleteCheckItem?: Maybe<CheckItem_DeleteResponse>;
  /** Delete a Checklist from a Card */
  deleteChecklist?: Maybe<Checklist_DeleteResponse>;
  /** Delete an existing Custom Field */
  deleteCustomField?: Maybe<CustomField>;
  /** Delete an existing Custom Field's List Option */
  deleteCustomFieldOption?: Maybe<CustomField_Option>;
  /** Delete a Tile from a Board's dashboardViewTiles */
  deleteDashboardViewTile?: Maybe<Scalars['Boolean']>;
  /** Delete all consent tokens issued by a single managed member of the enterprise */
  deleteManagedMemberTokens: Enterprise_DeleteManagedMemberTokensResponse;
  /** Internal endpoint for development and trelloinc members */
  deleteOneTimeMessagesDismissed?: Maybe<Member>;
  /** Deletes the organization */
  deleteOrganization?: Maybe<Scalars['Boolean']>;
  /** Deletes organization invite secret */
  deleteOrganizationInviteSecret?: Maybe<Scalars['Boolean']>;
  /** Deletes the logo for the organization */
  deleteOrganizationLogo?: Maybe<Organization>;
  /** Delete an organization view */
  deleteOrganizationView?: Maybe<Scalars['Boolean']>;
  /** Delete a Plugin */
  deletePlugin?: Maybe<Plugin_DeleteResponse>;
  /** Delete a Plugin's listing */
  deletePluginListing?: Maybe<Plugin_Listing_DeleteResponse>;
  /** Delete a saved search */
  deleteSavedSearch?: Maybe<SavedSearch>;
  /** Disable a board invitation secret */
  disableBoardInviteSecret?: Maybe<BoardInviteSecret_DeleteResponse>;
  /** Dismisses an Announcement */
  dismissAnnouncement?: Maybe<Announcement_DismissResponse>;
  /** Enable a Plugin on a Board */
  enablePlugin?: Maybe<Plugin_EnableResponse>;
  /** Link an Enterprise to an Atlassian organization */
  linkEnterpriseWithAtlassianOrganization?: Maybe<Enterprise_LinkAtlassianOrganizationResponse>;
  /** Migrate Enterprise to Atlassian Account */
  migrateEnterpriseToAtlassian?: Maybe<MigrateEnterprise_Response>;
  /** Set one login ID as the primary login, and delete all other logins */
  prepMemberForEmailHygiene?: Maybe<Member>;
  /** Reactivate a canceled Gold paid account */
  reactivateGoldPaidAccount: Member;
  /** Reactivate a canceled Business Class or Standard paid account */
  reactivateWorkspacePaidAccount: Organization;
  /** Redeem a promocode against a workspace */
  redeemPromoCode: Organization;
  /** Remove board star from the user */
  removeBoardStar?: Maybe<Scalars['Boolean']>;
  /** Remove member from board */
  removeMemberFromBoard?: Maybe<Board_Member_DeleteResponse>;
  /** Remove member from card */
  removeMemberFromCard?: Maybe<Card_Member_DeleteResponse>;
  /** Removes Member from a Workspace */
  removeMemberFromWorkspace?: Maybe<RemoveMembersFromWorkspace_Response>;
  /** Remove the logged in member's avatar */
  removeMyAvatar?: Maybe<Member>;
  /** Remove a member from a Plugin's collaborators */
  removePluginCollaborator?: Maybe<Plugin_Collaborators_UpdateResponse>;
  /** Reopen board */
  reopenBoard?: Maybe<Board>;
  /** Resend verification email */
  resendVerificationEmail?: Maybe<Member>;
  /** Sent board access request */
  sendBoardAccessRequest?: Maybe<BoardAccessRequest_Response>;
  /** Mark all notifications as read */
  setAllNotificationsRead?: Maybe<Notifications_ReadResponse>;
  /** Mark notifications as read/unread by the list of ids */
  setNotificationsRead?: Maybe<Notifications_ReadResponse>;
  /** Start board export */
  startBoardExport?: Maybe<Export>;
  /** Start enterprise export */
  startEnterpriseExport?: Maybe<Export>;
  /** Toggle the auto upgrade for product override */
  toggleAutoUpgrade?: Maybe<Organization>;
  /** Unarchives a card */
  unarchiveCard?: Maybe<Card>;
  /** Set aaBlockSyncUntil to one day in the future */
  unblockMemberProfileSync?: Maybe<Member>;
  /** Updates a board's card covers preference */
  updateBoardCardCoversPref?: Maybe<Board>;
  /** Update board member permission */
  updateBoardMemberPermission?: Maybe<UpdateBoardMemberPermission_Response>;
  /** Updates a board's org. If no boardId is given, the board becomes a personal board. */
  updateBoardOrg?: Maybe<Board>;
  /** Updates board star for the user */
  updateBoardStar?: Maybe<BoardStar>;
  /** Updates a board's visibility. If an orgId is given, the board is also moved into the org. */
  updateBoardVisibility?: Maybe<Board>;
  /** Updates a collection of board's org */
  updateBoardsOrg: Array<Maybe<Board>>;
  /** Update invoice details for a Business Class paid account */
  updateBusinessClassBillingContactDetails: Organization;
  /** Update invoice details for a Business Class paid account */
  updateBusinessClassBillingInvoiceDetails: Organization;
  /** Update the Credit Card on file for a Business Class paid account */
  updateBusinessClassCreditCard: Organization;
  /** Update product associated with a Business Class paid account */
  updateBusinessClassPaidProduct: Organization;
  /** Update the 'calendarFeedEnabled' state of the board */
  updateCalendarFeedEnabledPref?: Maybe<Board>;
  /** Generate a new calendarKey for the board */
  updateCalendarKey?: Maybe<Board>;
  /** Updates a campaign */
  updateCampaign?: Maybe<Campaign>;
  /** Update a card cover */
  updateCardCover?: Maybe<Card>;
  /** Update card start and due date */
  updateCardDates?: Maybe<Card>;
  /** Update a card dueComplete */
  updateCardDueComplete?: Maybe<Card>;
  /** Change a card's list */
  updateCardList?: Maybe<Card>;
  /** Change a card's name */
  updateCardName?: Maybe<Card>;
  /** Update the role of a card (board, separator, regular) */
  updateCardRole: Card;
  /** Update the due date of a CheckItem */
  updateCheckItemDueDate?: Maybe<CheckItem>;
  /** Update the name of a CheckItem */
  updateCheckItemName?: Maybe<CheckItem>;
  /** Update the vertical position of a CheckItem in its Checklist */
  updateCheckItemPos?: Maybe<CheckItem>;
  /** Update the 'checked' state of a CheckItem */
  updateCheckItemState?: Maybe<CheckItem>;
  /** Update the name of a Checklist */
  updateChecklistName?: Maybe<Checklist>;
  /** Update the position of a Checklist */
  updateChecklistPos?: Maybe<Checklist>;
  /** Update an existing Custom Field */
  updateCustomField?: Maybe<CustomField>;
  /** Update card custom field items value */
  updateCustomFieldItem?: Maybe<CustomFieldItem>;
  /** Update an existing List Option on an existing Custom Field */
  updateCustomFieldOption?: Maybe<CustomField_Option>;
  updateDashboardViewTile: Board_DashboardViewTile;
  /** Update a member's email address */
  updateEmailForMemberLogin?: Maybe<UpdateEmailForMemberLogin>;
  /** Update the setting that determines whether or not managed members can issue consent tokens to third-party apps */
  updateEnterpriseApiTokenCreationPermission?: Maybe<Enterprise>;
  /** Update multiple emails uses primary email */
  updateEnterpriseMultipleEmailMembersPrimaryEmail?: Maybe<MultipleEmailMemberFailed_Response>;
  /** Update invoice details for a Gold paid account */
  updateGoldBillingContactDetails: Member;
  /** Update invoice details for a Gold paid account */
  updateGoldBillingInvoiceDetails: Member;
  /** Update product associated with a Gold paid account */
  updateGoldPaidProduct: Member;
  /** Update to show or hide a plugins board buttons on the main header */
  updateHiddenPluginBoardButtonShortcuts?: Maybe<Board>;
  /** Updates the member's active channel */
  updateMemberActiveChannel?: Maybe<Member>;
  /** Update a member's avatar source */
  updateMemberAvatarSource?: Maybe<Member>;
  /** Update a member's profile information */
  updateMemberProfile?: Maybe<Member>;
  /** Updates the organization */
  updateOrganization?: Maybe<Organization>;
  /** Update an organization view */
  updateOrganizationView?: Maybe<OrganizationView>;
  /** Update a Plugin */
  updatePlugin?: Maybe<Plugin>;
  /** Set the value for enabling header shortcuts */
  updatePluginHeaderShortcutsEnabled?: Maybe<Board>;
  /** Update a Plugin's listing */
  updatePluginListing?: Maybe<Plugin_Listing>;
  /** Set the teamifyVoluntaryDone field */
  updateTeamifyVoluntaryDone?: Maybe<Member>;
  /** Update the locale of the user */
  updateUserLocale?: Maybe<Member>;
  /** Update a single view within an organizationView */
  updateViewInOrganizationView?: Maybe<OrganizationView>;
  /** Upload a card cover */
  uploadCardCover?: Maybe<Attachment>;
  /** Upload a new avatar */
  uploadMemberAvatar?: Maybe<Member>;
  /** Upload a organization profile image */
  uploadOrganizationImage?: Maybe<Organization>;
};


export type MutationAcceptDeveloperTermsArgs = {
  memberId: Scalars['ID'];
};


export type MutationAddBoardStarArgs = {
  boardId: Scalars['ID'];
  memberId: Scalars['ID'];
  pos: Scalars['Int'];
};


export type MutationAddButlerButtonArgs = {
  butlerButton: InputButlerButton;
  idScope: Scalars['ID'];
  scope: Scalars['String'];
};


export type MutationAddCampaignArgs = {
  currentStep: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddCheckItemArgs = {
  cardId: Scalars['ID'];
  checklistId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  temporaryId: Scalars['String'];
};


export type MutationAddChecklistArgs = {
  boardId: Scalars['ID'];
  cardId: Scalars['ID'];
  checklistSourceId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  temporaryId: Scalars['String'];
};


export type MutationAddCustomFieldOptionArgs = {
  idCustomField: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddFreeTrialArgs = {
  count?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  via?: InputMaybe<Scalars['String']>;
};


export type MutationAddMemberToBoardArgs = {
  acceptUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  allowBillableGuest?: InputMaybe<Scalars['Boolean']>;
  boardId: Scalars['ID'];
  invitationMessage?: InputMaybe<Scalars['String']>;
  member: MemberOrEmail;
  traceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationAddMemberToOrgArgs = {
  invitationMessage: Scalars['String'];
  orgId: Scalars['ID'];
  traceId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user: MemberOrEmail;
};


export type MutationAddOneTimeMessagesDismissedArgs = {
  memberId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type MutationAddPluginCollaboratorArgs = {
  memberId: Scalars['ID'];
  pluginId: Scalars['ID'];
};


export type MutationAddSavedSearchArgs = {
  memberId?: InputMaybe<Scalars['ID']>;
  savedSearch: InputSavedSearch;
};


export type MutationAddTagArgs = {
  orgId: Scalars['ID'];
  tag: Scalars['String'];
};


export type MutationApplyBcDiscountArgs = {
  orgId: Scalars['ID'];
};


export type MutationArchiveCardArgs = {
  idCard: Scalars['ID'];
};


export type MutationBulkDisableWorkspacePowerUpArgs = {
  orgId: Scalars['ID'];
  pluginId: Scalars['ID'];
};


export type MutationCancelGoldPaidAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationCancelWorkspacePaidAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationChangeCardDueDateArgs = {
  due?: InputMaybe<Scalars['String']>;
  dueReminder?: InputMaybe<Scalars['String']>;
  idCard: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationChangeMemberEmailArgs = {
  dismissMessage?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  loginId: Scalars['ID'];
  primary?: InputMaybe<Scalars['Boolean']>;
};


export type MutationClaimOrganizationArgs = {
  idEnterprise: Scalars['ID'];
  idOrganization: Scalars['ID'];
};


export type MutationCloseBoardArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCopyBoardToOrgArgs = {
  boardId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type MutationCopyCardArgs = {
  idCardSource: Scalars['ID'];
  idList: Scalars['ID'];
  keepFromSource?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
};


export type MutationCreateBoardInviteSecretArgs = {
  idBoard: Scalars['ID'];
  type?: InputMaybe<Board_Invite_MemberType>;
};


export type MutationCreateCardArgs = {
  closed?: InputMaybe<Scalars['Boolean']>;
  due?: InputMaybe<Scalars['String']>;
  idLabels?: InputMaybe<Array<Scalars['ID']>>;
  idList: Scalars['ID'];
  idMembers?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  pos?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
};


export type MutationCreateCardTemplateArgs = {
  closed?: InputMaybe<Scalars['Boolean']>;
  listId: Scalars['ID'];
  name: Scalars['String'];
  traceId: Scalars['String'];
};


export type MutationCreateCustomFieldArgs = {
  display: CreateCustomField_Display;
  idModel: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
  options?: InputMaybe<Array<CreateCustomField_Option>>;
  type: Scalars['String'];
};


export type MutationCreateDashboardViewTileArgs = {
  idBoard: Scalars['ID'];
  tile: CreateDashboardViewTile;
};


export type MutationCreateListArgs = {
  idBoard: Scalars['ID'];
  name: Scalars['String'];
  pos?: InputMaybe<Scalars['Float']>;
  traceId: Scalars['String'];
};


export type MutationCreateOrganizationArgs = {
  creationMethod?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  enterprise?: InputMaybe<Scalars['String']>;
  teamType?: InputMaybe<Scalars['String']>;
  traceId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type MutationCreateOrganizationInviteSecretArgs = {
  idOrganization: Scalars['ID'];
};


export type MutationCreateOrganizationViewArgs = {
  idOrganization: Scalars['ID'];
  name: Scalars['String'];
  prefs: InputOrganizationView_Prefs;
  traceId: Scalars['String'];
  views?: InputMaybe<Array<InputMaybe<InputOrganizationView_View>>>;
};


export type MutationCreatePluginArgs = {
  agreementId: Scalars['ID'];
  author?: InputMaybe<Scalars['String']>;
  iframeConnectorUrl: Scalars['String'];
  listings: Array<InputPluginListing>;
  organizationId: Scalars['ID'];
};


export type MutationCreatePluginListingArgs = {
  description: Scalars['String'];
  locale: Scalars['String'];
  name: Scalars['String'];
  overview: Scalars['String'];
  pluginId: Scalars['ID'];
};


export type MutationCreateSelfServeExpansionArgs = {
  idEnterprise: Scalars['String'];
  seats: Scalars['Int'];
};


export type MutationCreateWorkspacePaidAccountArgs = {
  acceptTOS: Scalars['Boolean'];
  country: Scalars['String'];
  discountCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  freeTrial?: InputMaybe<Scalars['Boolean']>;
  idOrganization: Scalars['ID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  nonce: Scalars['String'];
  products: Array<Scalars['Int']>;
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAllManagedMemberTokensArgs = {
  filter?: InputMaybe<Scalars['String']>;
  idEnterprise: Scalars['ID'];
};


export type MutationDeleteBoardArgs = {
  boardId: Scalars['ID'];
};


export type MutationDeleteButlerButtonArgs = {
  idBoard: Scalars['ID'];
  idButton: Scalars['ID'];
  idOrganization: Scalars['ID'];
  scope: Scalars['String'];
};


export type MutationDeleteCardArgs = {
  idCard: Scalars['ID'];
};


export type MutationDeleteCheckItemArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
};


export type MutationDeleteChecklistArgs = {
  checklistId: Scalars['ID'];
};


export type MutationDeleteCustomFieldArgs = {
  idCustomField: Scalars['String'];
};


export type MutationDeleteCustomFieldOptionArgs = {
  idCustomField: Scalars['String'];
  idCustomFieldOption: Scalars['String'];
};


export type MutationDeleteDashboardViewTileArgs = {
  idBoard: Scalars['ID'];
  idTile: Scalars['ID'];
};


export type MutationDeleteManagedMemberTokensArgs = {
  filter?: InputMaybe<Scalars['String']>;
  idEnterprise: Scalars['ID'];
  idMember: Scalars['ID'];
};


export type MutationDeleteOneTimeMessagesDismissedArgs = {
  memberId: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationDeleteOrganizationArgs = {
  idOrganization: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteOrganizationInviteSecretArgs = {
  idOrganization: Scalars['ID'];
};


export type MutationDeleteOrganizationLogoArgs = {
  orgId: Scalars['ID'];
};


export type MutationDeleteOrganizationViewArgs = {
  idOrganizationView: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationDeletePluginArgs = {
  pluginId: Scalars['ID'];
};


export type MutationDeletePluginListingArgs = {
  pluginId: Scalars['ID'];
  pluginListingId: Scalars['ID'];
};


export type MutationDeleteSavedSearchArgs = {
  memberId?: InputMaybe<Scalars['ID']>;
  savedSearchId: Scalars['ID'];
};


export type MutationDisableBoardInviteSecretArgs = {
  idBoard: Scalars['ID'];
};


export type MutationDismissAnnouncementArgs = {
  announcementId: Scalars['ID'];
};


export type MutationEnablePluginArgs = {
  boardId: Scalars['ID'];
  pluginId: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationLinkEnterpriseWithAtlassianOrganizationArgs = {
  atlOrgId: Scalars['ID'];
  idEnterprise: Scalars['ID'];
};


export type MutationMigrateEnterpriseToAtlassianArgs = {
  idEnterprise: Scalars['ID'];
};


export type MutationPrepMemberForEmailHygieneArgs = {
  dismissMessage?: InputMaybe<Scalars['String']>;
  memberId: Scalars['ID'];
  primaryLoginId: Scalars['ID'];
  removeLoginIds: Array<Scalars['ID']>;
};


export type MutationReactivateGoldPaidAccountArgs = {
  idMember: Scalars['ID'];
  product: Scalars['Int'];
  traceId: Scalars['String'];
};


export type MutationReactivateWorkspacePaidAccountArgs = {
  acceptTOS: Scalars['Boolean'];
  country: Scalars['String'];
  discountCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  idOrganization: Scalars['ID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  nonce: Scalars['String'];
  products: Array<Scalars['Int']>;
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationRedeemPromoCodeArgs = {
  accountId: Scalars['ID'];
  promoCode: Scalars['String'];
};


export type MutationRemoveBoardStarArgs = {
  boardStarId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationRemoveMemberFromBoardArgs = {
  idBoard: Scalars['ID'];
  idMember: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveMemberFromCardArgs = {
  idCard: Scalars['ID'];
  idMember: Scalars['ID'];
};


export type MutationRemoveMemberFromWorkspaceArgs = {
  orgId: Scalars['ID'];
  traceId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user: MemberOrEmail;
};


export type MutationRemovePluginCollaboratorArgs = {
  memberId: Scalars['ID'];
  pluginId: Scalars['ID'];
};


export type MutationReopenBoardArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendBoardAccessRequestArgs = {
  id: Scalars['ID'];
  modelType: RequestAccessModelType;
  traceId: Scalars['String'];
};


export type MutationSetNotificationsReadArgs = {
  ids: Array<Scalars['String']>;
  read: Scalars['Boolean'];
};


export type MutationStartBoardExportArgs = {
  id: Scalars['ID'];
};


export type MutationStartEnterpriseExportArgs = {
  enterpriseAssociationType: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationToggleAutoUpgradeArgs = {
  orgId: Scalars['ID'];
  upgrade?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUnarchiveCardArgs = {
  idCard: Scalars['ID'];
};


export type MutationUnblockMemberProfileSyncArgs = {
  memberId: Scalars['ID'];
};


export type MutationUpdateBoardCardCoversPrefArgs = {
  boardId: Scalars['ID'];
  cardCovers: Scalars['Boolean'];
};


export type MutationUpdateBoardMemberPermissionArgs = {
  boardId: Scalars['ID'];
  memberId: Scalars['ID'];
  traceId: Scalars['String'];
  type: Board_Membership_MemberType;
};


export type MutationUpdateBoardOrgArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['ID']>;
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBoardStarArgs = {
  boardStarId: Scalars['ID'];
  memberId: Scalars['ID'];
  pos: Scalars['Int'];
};


export type MutationUpdateBoardVisibilityArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['ID']>;
  visibility: Board_Prefs_PermissionLevel;
};


export type MutationUpdateBoardsOrgArgs = {
  boardIds: Array<InputMaybe<Scalars['ID']>>;
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['ID']>;
  staggerRequests?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateBusinessClassBillingContactDetailsArgs = {
  accountId: Scalars['ID'];
  contactEmail: Scalars['String'];
  contactLocale: Scalars['String'];
  contactName: Scalars['String'];
};


export type MutationUpdateBusinessClassBillingInvoiceDetailsArgs = {
  accountId: Scalars['ID'];
  invoiceDetails: Scalars['String'];
};


export type MutationUpdateBusinessClassCreditCardArgs = {
  accountId: Scalars['ID'];
  country: Scalars['String'];
  nonce: Scalars['String'];
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBusinessClassPaidProductArgs = {
  accountId: Scalars['ID'];
  products: Array<Scalars['Int']>;
};


export type MutationUpdateCalendarFeedEnabledPrefArgs = {
  boardId: Scalars['ID'];
  calendarFeedEnabled: Scalars['Boolean'];
};


export type MutationUpdateCalendarKeyArgs = {
  boardId: Scalars['ID'];
};


export type MutationUpdateCampaignArgs = {
  campaignId: Scalars['ID'];
  currentStep?: InputMaybe<Scalars['String']>;
  dateDismissed?: InputMaybe<Scalars['String']>;
  isDismissed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCardCoverArgs = {
  cardId: Scalars['ID'];
  cover?: InputMaybe<InputCover>;
  traceId: Scalars['String'];
};


export type MutationUpdateCardDatesArgs = {
  due?: InputMaybe<Scalars['String']>;
  dueReminder?: InputMaybe<Scalars['String']>;
  idCard: Scalars['ID'];
  start?: InputMaybe<Scalars['String']>;
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCardDueCompleteArgs = {
  cardId: Scalars['ID'];
  dueComplete: Scalars['Boolean'];
  traceId: Scalars['String'];
};


export type MutationUpdateCardListArgs = {
  idCard: Scalars['ID'];
  idList: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCardNameArgs = {
  idCard: Scalars['ID'];
  name: Scalars['String'];
  traceId: Scalars['String'];
};


export type MutationUpdateCardRoleArgs = {
  cardRole?: InputMaybe<CardRole>;
  idCard: Scalars['ID'];
};


export type MutationUpdateCheckItemDueDateArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  due: Scalars['String'];
};


export type MutationUpdateCheckItemNameArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateCheckItemPosArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  pos: Scalars['Float'];
};


export type MutationUpdateCheckItemStateArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  state: CheckItem_State;
  traceId: Scalars['String'];
};


export type MutationUpdateChecklistNameArgs = {
  checklistId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateChecklistPosArgs = {
  checklistId: Scalars['ID'];
  pos: Scalars['Float'];
};


export type MutationUpdateCustomFieldArgs = {
  display?: InputMaybe<CreateCustomField_Display>;
  idCustomField: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  pos?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateCustomFieldItemArgs = {
  idCard: Scalars['ID'];
  idCustomField: Scalars['ID'];
  idValue: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCustomFieldOptionArgs = {
  color?: InputMaybe<Scalars['String']>;
  idCustomField: Scalars['String'];
  idCustomFieldOption: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  pos?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateDashboardViewTileArgs = {
  idBoard: Scalars['ID'];
  tile: UpdateDashboardViewTile;
};


export type MutationUpdateEmailForMemberLoginArgs = {
  email: Scalars['String'];
  loginId: Scalars['ID'];
};


export type MutationUpdateEnterpriseApiTokenCreationPermissionArgs = {
  idEnterprise: Scalars['ID'];
  isAllowed: Scalars['Boolean'];
};


export type MutationUpdateEnterpriseMultipleEmailMembersPrimaryEmailArgs = {
  idEnterprise: Scalars['ID'];
  members: Array<MultipleEmailMemberArrayEntry>;
};


export type MutationUpdateGoldBillingContactDetailsArgs = {
  accountId: Scalars['ID'];
  contactEmail: Scalars['String'];
  contactLocale: Scalars['String'];
  contactName: Scalars['String'];
};


export type MutationUpdateGoldBillingInvoiceDetailsArgs = {
  accountId: Scalars['ID'];
  invoiceDetails: Scalars['String'];
};


export type MutationUpdateGoldPaidProductArgs = {
  accountId: Scalars['ID'];
  products: Array<Scalars['Int']>;
};


export type MutationUpdateHiddenPluginBoardButtonShortcutsArgs = {
  addPlugin: Scalars['Boolean'];
  boardId: Scalars['ID'];
  pluginId: Scalars['String'];
};


export type MutationUpdateMemberActiveChannelArgs = {
  channel: Scalars['String'];
  memberId: Scalars['ID'];
};


export type MutationUpdateMemberAvatarSourceArgs = {
  avatarSource: Member_AvatarSource;
};


export type MutationUpdateMemberProfileArgs = {
  profile: MemberProfileFields;
};


export type MutationUpdateOrganizationArgs = {
  desc?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orgId: Scalars['ID'];
  teamType?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Organization_Prefs_PermissionLevel>;
  website?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationViewArgs = {
  idOrganizationView: Scalars['ID'];
  organizationView: InputOrganizationView;
  traceId: Scalars['String'];
};


export type MutationUpdatePluginArgs = {
  fields?: InputMaybe<UpdatePluginFields>;
  pluginId: Scalars['ID'];
};


export type MutationUpdatePluginHeaderShortcutsEnabledArgs = {
  boardId: Scalars['ID'];
  defaultEnabled: Scalars['Boolean'];
};


export type MutationUpdatePluginListingArgs = {
  description?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overview?: InputMaybe<Scalars['String']>;
  pluginId: Scalars['ID'];
  pluginListingId: Scalars['ID'];
};


export type MutationUpdateTeamifyVoluntaryDoneArgs = {
  memberId: Scalars['ID'];
};


export type MutationUpdateUserLocaleArgs = {
  locale: Scalars['String'];
  memberId: Scalars['ID'];
};


export type MutationUpdateViewInOrganizationViewArgs = {
  idOrganizationView: Scalars['ID'];
  idView: Scalars['ID'];
  traceId: Scalars['String'];
  view: InputOrganizationView_View;
};


export type MutationUploadCardCoverArgs = {
  cardId: Scalars['ID'];
  file: Scalars['FileUpload'];
  traceId: Scalars['String'];
};


export type MutationUploadMemberAvatarArgs = {
  file: Scalars['FileUpload'];
  uploadProgressCallback?: InputMaybe<Scalars['FileUploadProgressCallback']>;
};


export type MutationUploadOrganizationImageArgs = {
  file: Scalars['FileUpload'];
  orgId: Scalars['ID'];
};

export type MyActivities = {
  __typename: 'MyActivities';
  /**
   * get all activity for the currently logged in user
   * - filters - query filters for the activity stream
   * - first - show 1st <N> items of the response
   */
  all?: Maybe<ActivitiesConnection>;
  /**
   * get "viewed" activity for the currently logged in user
   * - filters - query filters for the activity stream
   * - first - show 1st <N> items of the response
   */
  viewed?: Maybe<ActivitiesConnection>;
  /**
   * get "worked on" activity for the currently logged in user
   * - filters - query filters for the activity stream
   * - first - show 1st <N> items of the response
   */
  workedOn?: Maybe<ActivitiesConnection>;
};


export type MyActivitiesAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ActivitiesFilter>>;
  first?: InputMaybe<Scalars['Int']>;
};


export type MyActivitiesViewedArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ActivitiesFilter>>;
  first?: InputMaybe<Scalars['Int']>;
};


export type MyActivitiesWorkedOnArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ActivitiesFilter>>;
  first?: InputMaybe<Scalars['Int']>;
};

/** The Board preferences specific to the current Member */
export type MyPrefs = {
  __typename: 'MyPrefs';
  /** Allows for generating a calendar from url */
  calendarKey: Scalars['String'];
  /** The generated key used in the email address for the Board */
  emailKey?: Maybe<Scalars['String']>;
  /** The position in the List to add cards to when the Board is emailed */
  emailPosition?: Maybe<MyPrefs_EmailPosition>;
  /** The id of the List to add cards to when the Board is emailed */
  idEmailList?: Maybe<Scalars['String']>;
  /** Whether the sidebar should be shown */
  showSidebar: Scalars['Boolean'];
};

/** The position in the List to add cards to when the Board is emailed */
export const MyPrefs_EmailPosition = {
  /** The bottom of the List */
  Bottom: 'bottom',
  /** The top of the List */
  Top: 'top'
} as const;

export type MyPrefs_EmailPosition = typeof MyPrefs_EmailPosition[keyof typeof MyPrefs_EmailPosition];
/**
 * From the [relay Node specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface)
 *
 * The server must provide an interface called `Node`. That interface must include exactly one field, called `id` that returns a non-null `ID`.
 *
 * This `id` should be a globally unique identifier for this object, and given just this `id`, the server should be able to refetch the object.
 */
export type Node = {
  id: Scalars['ID'];
};

export type Notification = {
  __typename: 'Notification';
  appCreator?: Maybe<AppCreator>;
  data?: Maybe<NotificationData>;
  date: Scalars['String'];
  dateRead?: Maybe<Scalars['String']>;
  display?: Maybe<NotificationDisplay>;
  id: Scalars['String'];
  idAction: Scalars['String'];
  idMemberCreator: Scalars['String'];
  isReactable?: Maybe<Scalars['Boolean']>;
  memberCreator: Member;
  reactions: Array<Reaction>;
  type: Scalars['String'];
  unread?: Maybe<Scalars['Boolean']>;
};

export type NotificationData = {
  __typename: 'NotificationData';
  board?: Maybe<BoardNotificationData>;
  card?: Maybe<CardNotificationData>;
  text?: Maybe<Scalars['String']>;
};

export type NotificationDisplay = {
  __typename: 'NotificationDisplay';
  entities?: Maybe<NotificationDisplayEntity>;
  translationKey?: Maybe<Scalars['String']>;
};

export type NotificationDisplayEntity = {
  __typename: 'NotificationDisplayEntity';
  board?: Maybe<BoardEntity>;
  card?: Maybe<CardEntity>;
  comment?: Maybe<CommentEntity>;
  due?: Maybe<DueEntity>;
  memberCreator?: Maybe<MemberEntity>;
  organization?: Maybe<OrganizationEntity>;
};

export type NotificationGroup = {
  __typename: 'NotificationGroup';
  card?: Maybe<Card>;
  id: Scalars['String'];
  notifications: Array<Notification>;
};

/** An object representing the response from the setNotificationsRead and setAllNotificationsRead mutations */
export type Notifications_ReadResponse = {
  __typename: 'Notifications_ReadResponse';
  /** Whether marking as read was successful */
  success: Scalars['Boolean'];
};

/**
 * A member's "ofEnterprise" represents the real-world Organization
 * that owns this member's account. While called "enterprise", this concept
 * is distinct from the other "enteprise" fields in that a member's "ofEnterprise"
 * does not necessarily subscribe to the Trello Enteprise product.
 *
 * See: https://hello.atlassian.net/wiki/spaces/TRELLO/pages/1205542256/Orgment+Trello
 */
export type OfEnterprise = {
  __typename: 'OfEnterprise';
  /** The number of boards in the Enterprise */
  boardsCount?: Maybe<Scalars['Int']>;
  /** The number of boards a member is a part of */
  boardsMemberOfCount?: Maybe<Scalars['Int']>;
  /**
   * The Enterprise's displayName. If the Enterprise is backed by an
   * actual Enterprise entity in Mongo, this will be an actual Organization
   * name like "Nike". If the Enterprise is not represented by an actual DB
   * entity, it will be a domain, like "nike.com".
   */
  displayName: Scalars['String'];
  /** The number of members in the Enterprise */
  memberCount?: Maybe<Scalars['Int']>;
  /** What kind of Organization the Enterprise is (e.g. implicit via domain, explicit via a Trello Enterprise entity) */
  source: Scalars['String'];
  /** The number of workspaces in the Enterprise */
  workspacesCount?: Maybe<Scalars['Int']>;
  /** The number of workspaces a member is a part of */
  workspacesMemberOfCount?: Maybe<Scalars['Int']>;
};

export type OpsgenieAlertCountByPriority = {
  __typename: 'OpsgenieAlertCountByPriority';
  countPerDay?: Maybe<Array<Maybe<OpsgenieAlertCountPerDay>>>;
  priority?: Maybe<Scalars['String']>;
};

export type OpsgenieAlertCountPerDay = {
  __typename: 'OpsgenieAlertCountPerDay';
  count?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['String']>;
};

export type OpsgenieSchedule = {
  __typename: 'OpsgenieSchedule';
  enabled?: Maybe<Scalars['Boolean']>;
  finalTimeline?: Maybe<OpsgenieScheduleTimeline>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


export type OpsgenieScheduleFinalTimelineArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};

export type OpsgenieSchedulePeriod = {
  __typename: 'OpsgenieSchedulePeriod';
  endDate?: Maybe<Scalars['DateTime']>;
  /** Enum? */
  recipient?: Maybe<OpsgenieSchedulePeriodRecipient>;
  startDate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type OpsgenieSchedulePeriodRecipient = {
  __typename: 'OpsgenieSchedulePeriodRecipient';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type OpsgenieScheduleRotation = {
  __typename: 'OpsgenieScheduleRotation';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  periods?: Maybe<Array<Maybe<OpsgenieSchedulePeriod>>>;
};

export type OpsgenieScheduleTimeline = {
  __typename: 'OpsgenieScheduleTimeline';
  endDate?: Maybe<Scalars['DateTime']>;
  rotations?: Maybe<Array<Maybe<OpsgenieScheduleRotation>>>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type OpsgenieTeam = Node & {
  __typename: 'OpsgenieTeam';
  alertCounts?: Maybe<Array<Maybe<OpsgenieAlertCountByPriority>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** The connection entity for DevOps Service relationships for this Opsgenie team. */
  devOpsServiceRelationships?: Maybe<DevOpsServiceAndOpsgenieTeamRelationshipConnection>;
  id: Scalars['ID'];
  /** The connection entity for Jira project relationships for this Opsgenie team. */
  jiraProjectRelationships?: Maybe<JiraProjectAndOpsgenieTeamRelationshipConnection>;
  members?: Maybe<OpsgenieTeamMemberConnection>;
  /** ARI */
  name?: Maybe<Scalars['String']>;
  schedules?: Maybe<Array<Maybe<OpsgenieSchedule>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};


export type OpsgenieTeamAlertCountsArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type OpsgenieTeamDevOpsServiceRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type OpsgenieTeamJiraProjectRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type OpsgenieTeamMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OpsgenieTeamConnection = {
  __typename: 'OpsgenieTeamConnection';
  edges?: Maybe<Array<Maybe<OpsgenieTeamEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OpsgenieTeamEdge = {
  __typename: 'OpsgenieTeamEdge';
  cursor: Scalars['String'];
  node?: Maybe<OpsgenieTeam>;
};

export type OpsgenieTeamMember = {
  __typename: 'OpsgenieTeamMember';
  user?: Maybe<User>;
};

export type OpsgenieTeamMemberConnection = {
  __typename: 'OpsgenieTeamMemberConnection';
  edges?: Maybe<Array<Maybe<OpsgenieTeamMemberEdge>>>;
  pageInfo: PageInfo;
};

export type OpsgenieTeamMemberEdge = {
  __typename: 'OpsgenieTeamMemberEdge';
  cursor: Scalars['String'];
  node?: Maybe<OpsgenieTeamMember>;
};

/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type Organization = {
  __typename: 'Organization';
  /** The count of active billable members in the organization. Used if the organization is build only for active members. */
  activeBillableMemberCount?: Maybe<Scalars['Int']>;
  /** The count of available licenses in the organization */
  availableLicenseCount?: Maybe<Scalars['Int']>;
  /** The count of billable collaborators (board guests) */
  billableCollaboratorCount?: Maybe<Scalars['Int']>;
  /** The count of billable members in the organization. */
  billableMemberCount?: Maybe<Scalars['Int']>;
  /**
   * The boards belonging to the Organization that are visible to the user. Note that arguments you use here need to match
   * the ones in the type Query { organization... } so that parseQuery can grab the argument for nestedResources. Right now
   * thats boardIds, boardsStartIndex, and boardsCount, since those are ones you might programmatically input to a query.
   */
  boards: Array<Board>;
  /** The cards given a list of board IDs for Multi-Board Views. */
  cards: OrganizationCards;
  /** How the Organization was created */
  creationMethod?: Maybe<Scalars['String']>;
  /** The Credits owned by this Organization */
  credits: Array<Credit>;
  /** The description of the team */
  desc: Scalars['String'];
  /** If the bio includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONString']>;
  /** The name for the team. For example: Trello Inc */
  displayName: Scalars['String'];
  /** The domain of the workspace is the mapping of the workspace to its organization */
  domain?: Maybe<Scalars['String']>;
  /** The Enterprise this Organization belongs to */
  enterprise?: Maybe<Enterprise>;
  /** Exports created from this Organization */
  exports?: Maybe<Array<Export>>;
  /** The ID of the organization. */
  id: Scalars['ID'];
  /** The list of board ids belonging to the Organization that are visible to the user */
  idBoards: Array<Scalars['String']>;
  /** The list of the most active boards in the Organization */
  idBoardsMostActive?: Maybe<Array<Scalars['String']>>;
  /** The ID of the Enterprise this Organization belongs to */
  idEnterprise?: Maybe<Scalars['String']>;
  /** The ID of the member that created the organization */
  idMemberCreator?: Maybe<Scalars['String']>;
  /** The limits on the Organization */
  limits: Organization_Limits;
  /** Hash for the organization's logo */
  logoHash?: Maybe<Scalars['String']>;
  /** The Members in the Organization */
  members: Array<Member>;
  /** The Memberships of the Organization */
  memberships: Array<Organization_Membership>;
  /** The programmatic name for the team. For example: trelloinc */
  name: Scalars['String'];
  /** The new billable guests that would be added as a result of adding this board to the organization */
  newBillableGuests: Array<Organization_NewBillableGuest>;
  ofEnterprise?: Maybe<OfEnterprise>;
  /** The organization views that belong to an organization */
  organizationViews: Array<OrganizationView>;
  /** The Plugins owned by the Organization */
  ownedPlugins: Array<Plugin>;
  /** Information about the paid account of an organization */
  paidAccount?: Maybe<PaidAccount>;
  /** Whether not the organization currently has a pending product */
  pendingProduct?: Maybe<Scalars['Int']>;
  /** The PluginData for this Organization */
  pluginData: Array<PluginData>;
  /** The Plugins associated with this Organization */
  plugins: Array<Plugin>;
  /** The preferences (settings) for the team */
  prefs: Organization_Prefs;
  /** The premium features allowed for this team */
  premiumFeatures: Array<PremiumFeatures>;
  /** The Butler Buttons the organization owns */
  privateButlerButtons: Array<ButlerButton>;
  /** The list of product SKUs belonging to this Organization */
  products: Array<Scalars['Int']>;
  /** The promotions used for this Organization */
  promotions: Array<Scalars['String']>;
  sharedButlerButtons: Array<ButlerButton>;
  standardVariation?: Maybe<Scalars['String']>;
  /** The Stats of the Organization used for reporting */
  stats: Organization_Stats;
  /** The Collections(Tags) belonging to the Organization */
  tags: Array<Tag>;
  /** Defines the intent of the team */
  teamType?: Maybe<Scalars['String']>;
  /** The URL to the team page on Trello */
  url: Scalars['String'];
  /** The URL for the organization */
  website?: Maybe<Scalars['String']>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationBoardsArgs = {
  boardIds?: InputMaybe<Array<Scalars['ID']>>;
  boardsCount?: InputMaybe<Scalars['Int']>;
  boardsStartIndex?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Board_Filter>;
  sortBy?: InputMaybe<Boards_SortBy>;
  sortOrder?: InputMaybe<Boards_SortOrder>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationCardsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<Scalars['String']>;
  dueComplete?: InputMaybe<Scalars['Boolean']>;
  idBoards: Array<Scalars['ID']>;
  idLists?: InputMaybe<Array<Scalars['ID']>>;
  idMembers?: InputMaybe<Array<Scalars['ID']>>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationCreditsArgs = {
  filter?: InputMaybe<Array<Credit_Type>>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationMembersArgs = {
  filter?: InputMaybe<Member_Filter>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationMembershipsArgs = {
  filter?: InputMaybe<Organization_Memberships_Filter>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationNewBillableGuestsArgs = {
  boardId: Scalars['ID'];
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationOrganizationViewsArgs = {
  organizationViewsFilter?: InputMaybe<Array<OrganizationView_Filters>>;
  sortBy?: InputMaybe<OrganizationView_SortBy>;
  sortOrder?: InputMaybe<OrganizationView_SortOrder>;
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationPluginsArgs = {
  filter?: InputMaybe<Plugin_Filter>;
};

export type OrganizationCards = {
  __typename: 'OrganizationCards';
  cards: Array<Card>;
  cursor: Scalars['String'];
  total: Scalars['Int'];
};

export type OrganizationEntity = {
  __typename: 'OrganizationEntity';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrganizationInviteSecretResponse = {
  __typename: 'OrganizationInviteSecretResponse';
  secret: Scalars['String'];
  type: Scalars['String'];
};

/** Details of an organization view, referred to as a Workspace View in the app. */
export type OrganizationView = {
  __typename: 'OrganizationView';
  /** The id of an organization view */
  id: Scalars['ID'];
  /** The id of the enterprise the view belongs to */
  idEnterprise: Scalars['String'];
  /** The id of the member that created the organization view */
  idMemberCreator: Scalars['ID'];
  /** The id of the organization the view belongs to */
  idOrganization: Scalars['ID'];
  /** The name of the organization view */
  name: Scalars['String'];
  /** The organization that the organization view belongs to */
  organization: Organization;
  /** An object that describes the permission level of the organization view */
  prefs: OrganizationView_Prefs;
  /** The slug of the organization view */
  shortLink: Scalars['String'];
  /** The set of views within an organization view */
  views: Array<OrganizationView_View>;
};

/**
 * The filters for an organization views request. For example, used when
 * requesting all the OrganizationViews within a particular Organization
 */
export const OrganizationView_Filters = {
  /** Returns all organization views that exist in the organization. Can only be yused by team admins. */
  All: 'all',
  /** Returns all organization views that your user created. */
  Created: 'created',
  /** Returns the private organization views that only your user can see. */
  Private: 'private',
  /** Returns all organization views you can see within your team */
  Team: 'team'
} as const;

export type OrganizationView_Filters = typeof OrganizationView_Filters[keyof typeof OrganizationView_Filters];
/** Permission level of an organization view */
export type OrganizationView_Prefs = {
  __typename: 'OrganizationView_Prefs';
  /** The permission level for the organizaiton view. Currently we support 'team' and 'private' */
  permissionLevel: Scalars['String'];
};

export const OrganizationView_Prefs_PermissionLevel = {
  Private: 'private',
  Team: 'team'
} as const;

export type OrganizationView_Prefs_PermissionLevel = typeof OrganizationView_Prefs_PermissionLevel[keyof typeof OrganizationView_Prefs_PermissionLevel];
/**
 * The sorting criteria for an organization view request. For example, used when
 * requesting all the OrganizationViews within a particular Organization
 */
export const OrganizationView_SortBy = {
  /** Sorts returned organization views by their creation date */
  DateCreated: 'dateCreated',
  /** Sorts returned organization views by their name */
  Name: 'name'
} as const;

export type OrganizationView_SortBy = typeof OrganizationView_SortBy[keyof typeof OrganizationView_SortBy];
/**
 * The sort order for an organization view request. For example, used when
 * requesting all the OrganizationViews within a particular Organization
 */
export const OrganizationView_SortOrder = {
  /** Sorts returned organization views in ascending order */
  Asc: 'asc',
  /** Sorts returned organization views in ascending order */
  Ascending: 'ascending',
  /** Sorts returned organization views in descending order */
  Desc: 'desc',
  /** Sorts returned organization views in descending order */
  Descending: 'descending'
} as const;

export type OrganizationView_SortOrder = typeof OrganizationView_SortOrder[keyof typeof OrganizationView_SortOrder];
/**
 * Details of one view within an organization view. (This object is similar to a
 * single tab in a spreadsheet, where OrganizationView is the whole spreadsheet)
 */
export type OrganizationView_View = {
  __typename: 'OrganizationView_View';
  /** An object specifying which cards to include in the view */
  cardFilter: OrganizationView_View_CardFilter;
  /** The type of visualization this view uses, such as 'table' or 'timeline' */
  defaultViewType: Scalars['String'];
  /** The ID for this view */
  id: Scalars['ID'];
  viewOptions?: Maybe<OrganizationView_View_ViewOptions>;
};

/** CardFilter model, specifying which cards are included in the view. */
export type OrganizationView_View_CardFilter = {
  __typename: 'OrganizationView_View_CardFilter';
  /** An object specifying the criteria that determines which cards are included in the view */
  criteria: Array<OrganizationView_View_CardFilter_Criteria>;
};

/**
 * CardFilter_Criteria model, specifying the criteria that decides which cards are
 * included in the view.
 */
export type OrganizationView_View_CardFilter_Criteria = {
  __typename: 'OrganizationView_View_CardFilter_Criteria';
  due?: Maybe<CardFilter_Criteria_DateRange>;
  dueComplete?: Maybe<Scalars['Boolean']>;
  /** A list of board IDs whose cards will be included in the view */
  idBoards?: Maybe<Array<Scalars['ID']>>;
  idLists?: Maybe<Array<Scalars['ID']>>;
  idMembers?: Maybe<Array<Scalars['String']>>;
  labels?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<Array<Scalars['String']>>;
  start?: Maybe<CardFilter_Criteria_DateRange>;
};

export type OrganizationView_View_ViewOptions = {
  __typename: 'OrganizationView_View_ViewOptions';
  Calendar?: Maybe<OrganizationView_View_ViewOptions_Calendar>;
};

export type OrganizationView_View_ViewOptions_Calendar = {
  __typename: 'OrganizationView_View_ViewOptions_Calendar';
  timeHorizon?: Maybe<CalendarView_TimeHorizons>;
};

/** A filter for the Organizations being requested */
export const Organization_Filter = {
  /** Returns all Organizations that have visibility set to Private */
  Members: 'members',
  /** Returns all Organizations that have visibility set to Public */
  Public: 'public'
} as const;

export type Organization_Filter = typeof Organization_Filter[keyof typeof Organization_Filter];
/** The limits on the Organization */
export type Organization_Limits = {
  __typename: 'Organization_Limits';
  /** The org limits */
  orgs: Organization_Limits_Orgs;
};

export type Organization_Limits_Orgs = {
  __typename: 'Organization_Limits_Orgs';
  /** The free Boards per Organization limit */
  freeBoardsPerOrg: Limit;
  /** The total Members per Organization limit */
  totalMembersPerOrg: Limit;
};

/** An association between a Member and an Organization */
export type Organization_Membership = {
  __typename: 'Organization_Membership';
  /** Whether the Member has been deactivated */
  deactivated: Scalars['Boolean'];
  /** The ID of the Membership */
  id: Scalars['String'];
  /** The ID of the Member */
  idMember: Scalars['String'];
  /** The Member this membership is for */
  member: Member;
  /** The type of Membership this is */
  memberType: Organization_Membership_MemberType;
  /** Whether the Member has confirmed their email address */
  unconfirmed: Scalars['Boolean'];
};

/** The type of membership a member has on an Organization */
export const Organization_Membership_MemberType = {
  /** An admin */
  Admin: 'admin',
  /** A normal member */
  Normal: 'normal'
} as const;

export type Organization_Membership_MemberType = typeof Organization_Membership_MemberType[keyof typeof Organization_Membership_MemberType];
/** Filter for the memberships of an organization */
export const Organization_Memberships_Filter = {
  /** Get the active memberships */
  Active: 'active',
  /** Get the memberships with memberType admin */
  Admin: 'admin',
  /** Get the deactivated memberships */
  Deactivated: 'deactivated',
  /** Get only my memberships */
  Me: 'me',
  /** Get the memberships with memberType normal */
  Normal: 'normal'
} as const;

export type Organization_Memberships_Filter = typeof Organization_Memberships_Filter[keyof typeof Organization_Memberships_Filter];
/** Information about a member that would become a billable guest */
export type Organization_NewBillableGuest = {
  __typename: 'Organization_NewBillableGuest';
  /** Whether the member has confirmed their email address after signing up. */
  confirmed: Scalars['Boolean'];
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the Member */
  id: Scalars['ID'];
  /** The member's initials, used for display when there isn't an avatar set. */
  initials: Scalars['String'];
  /** The username for the member. What is shown in @mentions for example. */
  username: Scalars['String'];
};

/** The preferences for an Organization */
export type Organization_Prefs = {
  __typename: 'Organization_Prefs';
  /** The associated google apps domain */
  associatedDomain?: Maybe<Scalars['String']>;
  /** An array of attachment types. Will always include 'trello' */
  attachmentRestrictions?: Maybe<Array<Scalars['String']>>;
  /** The restrictions on who can delete a Board */
  boardDeleteRestrict?: Maybe<Organization_Prefs_BoardDeleteRestrict>;
  /** Restrictions on emails allowed to invite to the Organization */
  boardInviteRestrict?: Maybe<Scalars['String']>;
  /** The restrictions on who can view a Board */
  boardVisibilityRestrict?: Maybe<Organization_Prefs_BoardVisibilityRestrict>;
  /** Whether external members can be added to an Organization's boards */
  externalMembersDisabled?: Maybe<Scalars['Boolean']>;
  /** Restrictions on emails allowed to invite to the Organization */
  orgInviteRestrict?: Maybe<Array<Scalars['String']>>;
  /** The visibility of the Organization */
  permissionLevel?: Maybe<Organization_Prefs_PermissionLevel>;
};

/** An object that represents a set of restrictions for a Board deletion */
export type Organization_Prefs_BoardDeleteRestrict = {
  __typename: 'Organization_Prefs_BoardDeleteRestrict';
  /** How enterprise boards should be restricted */
  enterprise: Organization_Prefs_RestrictionType;
  /** How organization boards should be restricted */
  org: Organization_Prefs_RestrictionType;
  /** How private boards should be restricted */
  private: Organization_Prefs_RestrictionType;
  /** How public boards should be restricted */
  public: Organization_Prefs_RestrictionType;
};

/** An object that represents a set of restrictions for a Board visibility */
export type Organization_Prefs_BoardVisibilityRestrict = {
  __typename: 'Organization_Prefs_BoardVisibilityRestrict';
  /** How enterprise boards should be restricted */
  enterprise: Organization_Prefs_RestrictionType;
  /** How organization boards should be restricted */
  org: Organization_Prefs_RestrictionType;
  /** How private boards should be restricted */
  private: Organization_Prefs_RestrictionType;
  /** How public boards should be restricted */
  public: Organization_Prefs_RestrictionType;
};

/** The permission level (visibility) of an Organization */
export const Organization_Prefs_PermissionLevel = {
  /** enterprise visible */
  Enterprise: 'enterprise',
  /** Only visible to Members of the Organization */
  Private: 'private',
  /** Publicly visible */
  Public: 'public'
} as const;

export type Organization_Prefs_PermissionLevel = typeof Organization_Prefs_PermissionLevel[keyof typeof Organization_Prefs_PermissionLevel];
/** A permission level for a board restriction */
export const Organization_Prefs_RestrictionType = {
  /** Only admins */
  Admin: 'admin',
  /** No one */
  None: 'none',
  /** Anyone in the Organization */
  Org: 'org'
} as const;

export type Organization_Prefs_RestrictionType = typeof Organization_Prefs_RestrictionType[keyof typeof Organization_Prefs_RestrictionType];
/** Stats reported on at the organization level */
export type Organization_Stats = {
  __typename: 'Organization_Stats';
  /** The cards stats for the organization. */
  cards: Organization_Stats_Cards;
  /** The id of the organization the stats are for. */
  id: Scalars['ID'];
  /** The labelNames used on boards in the organization. */
  labelNames: Organization_Stats_LabelNames;
};


/** Stats reported on at the organization level */
export type Organization_StatsCardsArgs = {
  dueDateSince?: InputMaybe<Scalars['String']>;
  dueDateUntil?: InputMaybe<Scalars['String']>;
  groupBy?: InputMaybe<Organization_Stats_Cards_GroupBy>;
  idBoards?: InputMaybe<Array<Scalars['ID']>>;
  idLabels?: InputMaybe<Array<Scalars['ID']>>;
  idMembers?: InputMaybe<Array<Scalars['ID']>>;
  refreshTime?: InputMaybe<Scalars['Int']>;
};

/** Cards stats reported on at the organization level */
export type Organization_Stats_Cards = {
  __typename: 'Organization_Stats_Cards';
  /** Whether the stats are complete or not  */
  incomplete: Scalars['Boolean'];
  /** The cards stats */
  stats: Array<Organization_Stats_Cards_Stat>;
};

/** The possible options for grouping an organization's card stats */
export const Organization_Stats_Cards_GroupBy = {
  Label: 'label',
  LabelName: 'labelName',
  Member: 'member'
} as const;

export type Organization_Stats_Cards_GroupBy = typeof Organization_Stats_Cards_GroupBy[keyof typeof Organization_Stats_Cards_GroupBy];
/**
 * A stat on the number of cards in an organization
 * with a certain property, potentially grouped and filtered
 */
export type Organization_Stats_Cards_Stat = {
  __typename: 'Organization_Stats_Cards_Stat';
  /** The number and ids of done cards. */
  done: Organization_Stats_Cards_Stat_Done;
  /** The id of the label that the stat is grouped by. */
  idLabel?: Maybe<Scalars['ID']>;
  /** The id of the member that the stat is grouped by. */
  idMember?: Maybe<Scalars['ID']>;
  /** The name of the label that the stat is grouped by. */
  labelName?: Maybe<Scalars['String']>;
  /** The number and ids of cards with no due date. */
  noDueDate: Organization_Stats_Cards_Stat_NoDueDate;
  /** The number and ids of overdue cards. */
  overdue: Organization_Stats_Cards_Stat_Overdue;
  /** The number and ids of upcoming cards. */
  upcoming: Organization_Stats_Cards_Stat_Upcoming;
};

export type Organization_Stats_Cards_Stat_Done = {
  __typename: 'Organization_Stats_Cards_Stat_Done';
  /** The number of done cards */
  count: Scalars['Int'];
  /** The IDs of the done cards */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Organization_Stats_Cards_Stat_NoDueDate = {
  __typename: 'Organization_Stats_Cards_Stat_NoDueDate';
  /** The number of cards with no due date */
  count: Scalars['Int'];
  /** The IDs of the cards with no due date */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Organization_Stats_Cards_Stat_Overdue = {
  __typename: 'Organization_Stats_Cards_Stat_Overdue';
  /** The number of overdue cards */
  count: Scalars['Int'];
  /** The IDs of the overdue cards */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Organization_Stats_Cards_Stat_Upcoming = {
  __typename: 'Organization_Stats_Cards_Stat_Upcoming';
  /** The number of upcoming cards */
  count: Scalars['Int'];
  /** The IDs of the upcoming cards */
  ids?: Maybe<Array<Scalars['ID']>>;
};

/** Grouped labels with the same name at the organization level */
export type Organization_Stats_LabelName_Stat = {
  __typename: 'Organization_Stats_LabelName_Stat';
  /** Number of unique labels with this name */
  count: Scalars['Int'];
  /** The IDs of each label within this group */
  ids: Array<Scalars['ID']>;
  /** The name of the label */
  name: Scalars['String'];
  /** The number of times a label with this name has been used */
  totalUses: Scalars['Int'];
};

/** LabelNames stats reported at the organization level */
export type Organization_Stats_LabelNames = {
  __typename: 'Organization_Stats_LabelNames';
  /** Whether the stats are complete or not  */
  incomplete: Scalars['Boolean'];
  /** The labelName stats */
  stats: Array<Organization_Stats_LabelName_Stat>;
};

export type OriginalEstimate = {
  __typename: 'OriginalEstimate';
  value?: Maybe<Scalars['Float']>;
  valueAsText?: Maybe<Scalars['String']>;
};

/**
 * Relay-style PageInfo type.
 *
 * See [PageInfo specification](https://relay.dev/assets/files/connections-932f4f2cdffd79724ac76373deb30dc8.htm#sec-undefined.PageInfo)
 */
export type PageInfo = {
  __typename: 'PageInfo';
  /** endCursor must be the cursor corresponding to the last node in `edges`. */
  endCursor?: Maybe<Scalars['String']>;
  /**
   * `hasNextPage` is used to indicate whether more edges exist following the set defined by the clients arguments. If the client is paginating
   * with `first` / `after`, then the server must return true if further edges exist, otherwise false. If the client is paginating with `last` / `before`,
   * then the client may return true if edges further from before exist, if it can do so efficiently, otherwise may return false.
   */
  hasNextPage: Scalars['Boolean'];
  /**
   * `hasPreviousPage` is used to indicate whether more edges exist prior to the set defined by the clients arguments. If the client is paginating
   * with `last` / `before`, then the server must return true if prior edges exist, otherwise false. If the client is paginating with `first` / `after`,
   * then the client may return true if edges prior to after exist, if it can do so efficiently, otherwise may return false.
   */
  hasPreviousPage: Scalars['Boolean'];
  /** startCursor must be the cursor corresponding to the first node in `edges`. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Details of a paid account */
export type PaidAccount = {
  __typename: 'PaidAccount';
  /** The billing dates of the account's products */
  billingDates: Scalars['JSONString'];
  /** Product can renew based on CC information on file */
  canRenew: Scalars['Boolean'];
  /** The last 4 digits of the account's credit card */
  cardLast4: Scalars['String'];
  /** The type of the credit card used for the account */
  cardType: Scalars['String'];
  /** The email of the account's contact */
  contactEmail: Scalars['String'];
  /** The full name of the account's contact */
  contactFullName: Scalars['String'];
  /** The locale of the account's contact */
  contactLocale: Scalars['String'];
  /** Billing address: Country */
  country?: Maybe<Scalars['String']>;
  /** The date when the account's paidAccount was initialized */
  dateFirstSubscription: Scalars['String'];
  /** Date the subscription will be disabled */
  datePendingDisabled?: Maybe<Scalars['String']>;
  /** The expiration dates of the account's products */
  expirationDates: Scalars['JSONString'];
  /** Details about the account's invoice */
  invoiceDetails?: Maybe<Scalars['String']>;
  /** The subscriber ID of the account */
  ixSubscriber: Scalars['Int'];
  needsCreditCardUpdate?: Maybe<Scalars['Boolean']>;
  /** The current paid product */
  paidProduct: Scalars['Int'];
  /** Previous subscription data for cancelled or expired accounts */
  previousSubscription?: Maybe<PreviousSubscription>;
  /** The free trial product data on a paid workspace */
  productOverride?: Maybe<ProductOverride>;
  /** The product codes associated with this account */
  products: Array<Scalars['Int']>;
  /** Object containing product code and date for next subscribed product */
  scheduledChange?: Maybe<ScheduledChange>;
  /** The standing of the account */
  standing: Scalars['Int'];
  /** The state taxId for this account */
  stateTaxId?: Maybe<Scalars['String']>;
  /** The federal taxId for this account */
  taxId?: Maybe<Scalars['String']>;
  /** The expiration date for the account's free trial */
  trialExpiration?: Maybe<Scalars['String']>;
  /** The type of trial credits on the account. Either 'promocode' or 'freeTrial' */
  trialType?: Maybe<Scalars['String']>;
  /** Billing address: Zip/Postal code */
  zip?: Maybe<Scalars['String']>;
};

export const PaidAccountType = {
  Members: 'members',
  Organizations: 'organizations'
} as const;

export type PaidAccountType = typeof PaidAccountType[keyof typeof PaidAccountType];
export type PermissibleEstimationType = {
  __typename: 'PermissibleEstimationType';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Possible estimation type values: STORY_POINTS, ORIGINAL_ESTIMATE, ISSUE_COUNT (Issue count is not supported yet) */
  value?: Maybe<Scalars['String']>;
};

export type Plugin = {
  __typename: 'Plugin';
  /** API Key associated with this plugin. */
  apiKey?: Maybe<Scalars['String']>;
  /** The name of the plugin's author. */
  author: Scalars['String'];
  /** Capabilities represent areas of the UX that a plugin can hook into. */
  capabilities: Array<Scalars['String']>;
  /** Options that modify the way capabilities are called and responded to. */
  capabilitiesOptions: Array<Scalars['String']>;
  /** A list of categories which the plugin will be listed under. */
  categories: Array<Scalars['String']>;
  /** The plugin collaborators who can edit the plugin */
  collaborators: Array<Member>;
  /** The compliance information of the plugin. */
  compliance?: Maybe<Plugin_Compliance>;
  /** The email address of the plugin author. */
  email?: Maybe<Scalars['String']>;
  /** The boards that have the plugin enabled for a specific Workspace */
  enabledBoards: Array<Board>;
  /** Urls to the hero image of a plugin. */
  heroImageUrl?: Maybe<Scalars['JSONString']>;
  /** The icon of the plugin. */
  icon: Plugin_Icon;
  /** The ID of the plugin. */
  id: Scalars['ID'];
  /** The ID of the organization the plugin belongs to. */
  idOrganizationOwner: Scalars['String'];
  /** The URL to the main iframe of the plugin. */
  iframeConnectorUrl: Scalars['String'];
  /** If the plugin is compliant with privacy standards. */
  isCompliantWithPrivacyStandards?: Maybe<Scalars['Boolean']>;
  /** Listing information of the plugin. */
  listing?: Maybe<Plugin_Listing>;
  /** A list of listing information of the plugin in different locales. */
  listings?: Maybe<Array<Plugin_Listings>>;
  /** The moderated state of a plugin. Used to hide or turn off problematic plugins. */
  moderatedState?: Maybe<Plugin_ModeratedState>;
  /** Deprecated name of the plugin. */
  name?: Maybe<Scalars['String']>;
  /** The URL to the privacy policy of the plugin. */
  privacyUrl?: Maybe<Scalars['String']>;
  /** Whether the plugin is available to the public. */
  public: Scalars['Boolean'];
  /** Daily statistics about the plugin. */
  stats: Array<Plugin_Stat>;
  /** The support email of a plugin. */
  supportEmail?: Maybe<Scalars['String']>;
  /** A list of tags used to make a plugin featued. */
  tags: Array<Scalars['String']>;
  /** Usage bracket information of the plugin. */
  usageBrackets: Plugin_UsageBrackets;
};

/** Data stored by a plugin */
export type PluginData = {
  __typename: 'PluginData';
  /** Whether the PluginData is private or shared */
  access: PluginData_Access;
  /** The id of the PluginData */
  id: Scalars['ID'];
  /** The id of the model the data is scoped to */
  idModel: Scalars['String'];
  /** The id of the Plugin */
  idPlugin: Scalars['String'];
  /** The model type the data is scoped to */
  scope: PluginData_Scope;
  /** The data being stored */
  value: Scalars['String'];
};

/** Whether the PluginData is private or shared */
export const PluginData_Access = {
  Private: 'private',
  Shared: 'shared'
} as const;

export type PluginData_Access = typeof PluginData_Access[keyof typeof PluginData_Access];
/** The model type the data is scoped to */
export const PluginData_Scope = {
  Board: 'board',
  Card: 'card',
  Member: 'member',
  Organization: 'organization'
} as const;

export type PluginData_Scope = typeof PluginData_Scope[keyof typeof PluginData_Scope];
/** An object representing the response of the updatePluginCollaborator mutation. */
export type Plugin_Collaborators_UpdateResponse = {
  __typename: 'Plugin_Collaborators_UpdateResponse';
  /** Whether or not the update was successful */
  success: Scalars['Boolean'];
};

/** The compliance information of the plugin. */
export type Plugin_Compliance = {
  __typename: 'Plugin_Compliance';
  /** The timestamp of when the storesPersonalData property was changed. */
  dateUpdatedStoresPersonalData: Scalars['String'];
  /** The timestamps of when the plugin last polled the compliance URLs. */
  lastPolled: Plugin_Compliance_LastPolled;
  /** Whether the plugin stores personal data. */
  storesPersonalData: Scalars['Boolean'];
};

/** The timestamps of when the plugin last polled the compliance URLs. */
export type Plugin_Compliance_LastPolled = {
  __typename: 'Plugin_Compliance_LastPolled';
  /** When it last hit the member privacy polling URL. */
  memberPrivacy: Scalars['String'];
};

/** An object representing the response from the deletePlugin mutation. */
export type Plugin_DeleteResponse = {
  __typename: 'Plugin_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

export type Plugin_EnableResponse = {
  __typename: 'Plugin_EnableResponse';
  /** Error message for why enablement failed. */
  error?: Maybe<Scalars['String']>;
  /** Whether the enablement was successful. */
  success: Scalars['Boolean'];
};

export const Plugin_Filter = {
  All: 'all',
  Available: 'available',
  Editable: 'editable',
  Enabled: 'enabled',
  HasClaimedDomains: 'hasClaimedDomains',
  None: 'none',
  Owned: 'owned'
} as const;

export type Plugin_Filter = typeof Plugin_Filter[keyof typeof Plugin_Filter];
/** The icon of a Organization Owned Plugin. */
export type Plugin_Icon = {
  __typename: 'Plugin_Icon';
  /** The URL to the icon. */
  url: Scalars['String'];
};

/** Localized listing information of a Plugin. */
export type Plugin_Listing = {
  __typename: 'Plugin_Listing';
  /** The description of the plugin. */
  description: Scalars['String'];
  /** id of the plugin listing. */
  id?: Maybe<Scalars['ID']>;
  /** The locale of the listing. */
  locale: Scalars['String'];
  /** The name of the plugin. */
  name: Scalars['String'];
  /** The overview of the plugin. */
  overview: Scalars['String'];
};

/** An object representing the response from the deletePluginListing mutation. */
export type Plugin_Listing_DeleteResponse = {
  __typename: 'Plugin_Listing_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Array of Localized listing information of a Plugin. */
export type Plugin_Listings = {
  __typename: 'Plugin_Listings';
  /** The description of the plugin. */
  description: Scalars['String'];
  /** id of the plugin listing. */
  id: Scalars['ID'];
  /** The locale of the listing. */
  locale: Scalars['String'];
  /** The name of the plugin. */
  name: Scalars['String'];
  /** The overview of the plugin. */
  overview: Scalars['String'];
};

/** The moderated state of a plugin. Used to hide or turn off problematic plugins. */
export const Plugin_ModeratedState = {
  /** The plugin is hidden from listings but still functional on boards that have it enabled. */
  Hidden: 'hidden',
  /** The plugin is hidden from listings and boards. */
  Moderated: 'moderated'
} as const;

export type Plugin_ModeratedState = typeof Plugin_ModeratedState[keyof typeof Plugin_ModeratedState];
/** A record of daily statistics about the plugin. */
export type Plugin_Stat = {
  __typename: 'Plugin_Stat';
  /** The number of boards using this plugin. */
  boardCount: Scalars['Int'];
  /** The date the stat was captured. */
  date: Scalars['String'];
};

/** Usage bracket information of the plugin. */
export type Plugin_UsageBrackets = {
  __typename: 'Plugin_UsageBrackets';
  /** The number of boards the plugin is enabled on. */
  boards: Scalars['Int'];
};

/**
 * All premium features associated with a given product returned by server
 * Should be synchronized with: https://bitbucket.org/trello/server/src/main/app/data/features.js
 */
export const PremiumFeatures = {
  Activity: 'activity',
  AdditionalBoardBackgrounds: 'additionalBoardBackgrounds',
  AdditionalStickers: 'additionalStickers',
  AdvancedChecklists: 'advancedChecklists',
  BoardExport: 'boardExport',
  Butler: 'butler',
  ButlerBc: 'butlerBC',
  ButlerEnterprise: 'butlerEnterprise',
  ButlerPremium: 'butlerPremium',
  ButlerStandard: 'butlerStandard',
  Crown: 'crown',
  CsvExport: 'csvExport',
  CustomBoardBackgrounds: 'customBoardBackgrounds',
  CustomEmoji: 'customEmoji',
  CustomStickers: 'customStickers',
  Deactivated: 'deactivated',
  EnterpriseUi: 'enterpriseUI',
  Export: 'export',
  GoldMembers: 'goldMembers',
  GoogleApps: 'googleApps',
  InfinitePlugins: 'infinitePlugins',
  InviteBoard: 'inviteBoard',
  InviteOrg: 'inviteOrg',
  IsBc: 'isBC',
  IsPremium: 'isPremium',
  IsStandard: 'isStandard',
  LargeAttachments: 'largeAttachments',
  MultiBoardGuests: 'multiBoardGuests',
  Observers: 'observers',
  PaidCorePlugins: 'paidCorePlugins',
  Plugins: 'plugins',
  PrivateTemplates: 'privateTemplates',
  ReadSecrets: 'readSecrets',
  Removal: 'removal',
  RestrictVis: 'restrictVis',
  SavedSearches: 'savedSearches',
  ShortExportHistory: 'shortExportHistory',
  StarCounts: 'starCounts',
  Stats: 'stats',
  SuperAdmins: 'superAdmins',
  Tags: 'tags',
  ThreePlugins: 'threePlugins',
  Views: 'views'
} as const;

export type PremiumFeatures = typeof PremiumFeatures[keyof typeof PremiumFeatures];
/** Previous subscription data for cancelled or expired accounts */
export type PreviousSubscription = {
  __typename: 'PreviousSubscription';
  /** The date that the previous product was cancelled */
  dtCancelled: Scalars['String'];
  /** The previous product on the account */
  ixSubscriptionProductId: Scalars['Int'];
};

/** Price quote for a subscription */
export type PriceQuote = {
  __typename: 'PriceQuote';
  /** The number of billable collaborators being converted */
  cBillableCollaboratorConversions: Scalars['Int'];
  /** The number of billable collaborators being quoted */
  cBillableCollaborators: Scalars['Int'];
  /** The number of team members being quoted */
  cTeamMembers: Scalars['Int'];
  /** The billing date for the price quote */
  dtBilling: Scalars['String'];
  /** The expiration date of the pricing adjustment for the quote, or null */
  dtPricingAdjustmentExpiration?: Maybe<Scalars['String']>;
  /** The subscription discount type for the quote */
  ixSubscriptionDiscountType: Scalars['Int'];
  /** The product code for the product being quoted */
  ixSubscriptionProduct: Scalars['Int'];
  /** The pricing adjustment (discount multiplier) for the quote */
  nPricingAdjustment: Scalars['Float'];
  /** The subscription period in months (1 or 12) */
  nSubscriptionPeriodMonths: Scalars['Int'];
  /** The pre-tax subtotal of the quote */
  nSubtotal: Scalars['Float'];
  /** The per-user pre-tax subtotal of the quote */
  nSubtotalPerUser: Scalars['Float'];
  /** The tax for the quote, null if tax info is unavailable */
  nTax?: Maybe<Scalars['Float']>;
  /** The per-user tax for the quote, null if tax info is unavailable */
  nTaxPerUser?: Maybe<Scalars['Float']>;
  /** The tax rate for the quote, null if tax info is unavailable */
  nTaxRate?: Maybe<Scalars['Float']>;
  /** The total for the quote, null if tax info is unavailable */
  nTotal?: Maybe<Scalars['Float']>;
  /** The per-user total for the quote, null if tax info is unavailable */
  nTotalPerUser?: Maybe<Scalars['Float']>;
  /** The abbreviation for the region the tax is applied from (such as the state), null if tax info is unavailable */
  sTaxRegion?: Maybe<Scalars['String']>;
};

/** Price quotes for a subscription */
export type PriceQuoteInfo = {
  __typename: 'PriceQuoteInfo';
  /** The price quote for an annual subscription */
  annual?: Maybe<PriceQuote>;
  /** The price quote for a monthly subscription */
  monthly?: Maybe<PriceQuote>;
  /** The percentage savings for choosing an annual subscription */
  nAnnualPercentageSavings?: Maybe<Scalars['Float']>;
  /** The annual savings for choosing an annual subscription */
  nAnnualSavings?: Maybe<Scalars['Float']>;
};

/** The free trial product data on a paid workspace */
export type ProductOverride = {
  __typename: 'ProductOverride';
  /** Whether the workspace will upgrade to a new product at the end of the free trial */
  autoUpgrade: Scalars['Boolean'];
  /** The date that the free trial product will end */
  dateEnd: Scalars['String'];
  /** The date that the free trial product was started */
  dateStart: Scalars['String'];
  /** The free trial product */
  product: Scalars['Int'];
};

export type ProfileSyncResponse = {
  __typename: 'ProfileSyncResponse';
  emailVerificationRequired: Scalars['Boolean'];
  redirect_url: Scalars['String'];
};

/** Base64 encoded image data for the QR code. */
export type QrCode = {
  __typename: 'QrCode';
  imageData: Scalars['String'];
};

export type Query = {
  __typename: 'Query';
  action?: Maybe<Action>;
  /**
   * API v2
   * Get user activities.
   *
   * ### OAuth Scopes
   *
   * The following scopes will need to be present on OAuth requests to get data from this field
   *
   * * __confluence:atlassian-external__
   * * __jira:atlassian-external__
   */
  activities?: Maybe<Activities>;
  addMembersPriceQuotes: AddMembersPriceQuotes;
  announcements: Array<Announcement>;
  atlassianAccounts: Array<AtlassianAccount>;
  board?: Maybe<Board>;
  boardAccessRequest: BoardAccessRequest;
  boardAccessVerificationRequest: BoardAccessVerificationRequest;
  boards: Array<Board>;
  boardsSearch: Array<Maybe<Board>>;
  card?: Maybe<Card>;
  cards: Array<Card>;
  certCaptureToken: CertCaptureToken;
  checkDomainClaim?: Maybe<CheckDomainClaim_Response>;
  checklist?: Maybe<Checklist>;
  checklists: Array<Checklist>;
  customField: CustomField;
  domain: DomainOrganization;
  /** This field will echo back the word `echo`.  Its only useful for testing */
  echo?: Maybe<Scalars['String']>;
  emailProvider: EmailProvider;
  enterprise?: Maybe<Enterprise>;
  enterpriseMultipleEmailMembers?: Maybe<MultipleEmailMember_Response>;
  enterprises: Array<Enterprise>;
  invitationSecret?: Maybe<BoardInviteSecret>;
  label?: Maybe<Label>;
  labels: Array<Label>;
  list?: Maybe<List>;
  lists: Array<List>;
  member?: Maybe<Member>;
  memberCards: Array<Card>;
  memberSearch: Array<Maybe<Member>>;
  members: Array<Member>;
  modelType: ModelType;
  newSubscriptionListPriceQuotes: ListPriceQuoteInfo;
  newSubscriptionPriceQuotes: PriceQuoteInfo;
  notificationGroups?: Maybe<Array<Maybe<NotificationGroup>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsCount?: Maybe<Scalars['JSONString']>;
  organization?: Maybe<Organization>;
  organizationInviteSecret?: Maybe<OrganizationInviteSecretResponse>;
  organizationMemberCards: Array<Card>;
  organizationView?: Maybe<OrganizationView>;
  organizationViews: Array<OrganizationView>;
  organizations: Array<Organization>;
  plugin?: Maybe<Plugin>;
  pluginCategories: Array<Scalars['String']>;
  plugins: Array<Plugin>;
  publicPlugins: Array<Plugin>;
  qrCode: QrCode;
  renewalPriceQuotes: PriceQuoteInfo;
  search: Search;
  selfServeExpansionEstimate: ExpansionPriceEstimate;
  statements: Array<Statement>;
  templateCategories: Array<TemplateCategory>;
  templateGallery: Array<Board>;
  templateLanguages: Array<TemplateLanguage>;
  unsplashPhotos: Array<UnsplashPhoto>;
  upgradePriceQuotes: UpgradePriceQuoteInfo;
};


export type QueryActionArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryAddMembersPriceQuotesArgs = {
  accountId: Scalars['ID'];
  members: Array<Scalars['String']>;
};


export type QueryAnnouncementsArgs = {
  filter?: InputMaybe<Scalars['String']>;
};


export type QueryBoardArgs = {
  id: Scalars['ID'];
  organizationDisableMock?: InputMaybe<Scalars['Boolean']>;
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryBoardAccessRequestArgs = {
  id: Scalars['ID'];
  modelType: RequestAccessModelType;
  traceId?: InputMaybe<Scalars['String']>;
};


export type QueryBoardAccessVerificationRequestArgs = {
  idBoard: Scalars['ID'];
  idInvitedMember: Scalars['ID'];
  signature?: InputMaybe<Scalars['String']>;
  traceId?: InputMaybe<Scalars['String']>;
};


export type QueryBoardsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryBoardsSearchArgs = {
  limit: Scalars['Int'];
  query: Scalars['String'];
};


export type QueryCardArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryCardsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCertCaptureTokenArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
};


export type QueryCheckDomainClaimArgs = {
  email: Scalars['String'];
};


export type QueryChecklistArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryChecklistsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCustomFieldArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryDomainArgs = {
  id: Scalars['String'];
};


export type QueryEmailProviderArgs = {
  email: Scalars['String'];
};


export type QueryEnterpriseArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryEnterpriseMultipleEmailMembersArgs = {
  count: Scalars['Int'];
  idEnterprise: Scalars['ID'];
  offset: Scalars['Int'];
};


export type QueryEnterprisesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryInvitationSecretArgs = {
  idBoard: Scalars['ID'];
};


export type QueryLabelArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryLabelsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryListArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryListsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryMemberArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryMemberCardsArgs = {
  before?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  modifiedSince?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryMemberSearchArgs = {
  idBoard?: InputMaybe<Scalars['ID']>;
  idOrganization?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyOrgMembers?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


export type QueryMembersArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryModelTypeArgs = {
  idOrName: Scalars['String'];
};


export type QueryNewSubscriptionListPriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
  includeUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  product: Scalars['Int'];
};


export type QueryNewSubscriptionPriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
  country: Scalars['String'];
  includeUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  product: Scalars['Int'];
  promoCode?: InputMaybe<Scalars['String']>;
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};


export type QueryNotificationGroupsArgs = {
  idCards?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  readFilter?: InputMaybe<Scalars['String']>;
};


export type QueryNotificationsCountArgs = {
  filter?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrganizationArgs = {
  boardIds?: InputMaybe<Array<Scalars['ID']>>;
  boardsCount?: InputMaybe<Scalars['Int']>;
  boardsStartIndex?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  organizationViewsFilter?: InputMaybe<Array<OrganizationView_Filters>>;
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryOrganizationInviteSecretArgs = {
  idOrganization: Scalars['ID'];
};


export type QueryOrganizationMemberCardsArgs = {
  id: Scalars['ID'];
  idMember: Scalars['ID'];
};


export type QueryOrganizationViewArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationViewsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryOrganizationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPluginArgs = {
  id: Scalars['ID'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryPluginsArgs = {
  id: Array<Scalars['ID']>;
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QueryPublicPluginsArgs = {
  preferredLocales?: InputMaybe<Scalars['String']>;
};


export type QueryQrCodeArgs = {
  url: Scalars['String'];
};


export type QueryRenewalPriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
};


export type QuerySearchArgs = {
  idBoards?: InputMaybe<Array<Scalars['ID']>>;
  idCards?: InputMaybe<Array<Scalars['ID']>>;
  idOrganizations?: InputMaybe<Array<Scalars['ID']>>;
  partial?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  waitOn: Array<InputMaybe<WaitOnQuickLoads>>;
};


export type QuerySelfServeExpansionEstimateArgs = {
  idEnterprise: Scalars['String'];
  seats: Scalars['Int'];
};


export type QueryStatementsArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
};


export type QueryTemplateGalleryArgs = {
  locale: Scalars['String'];
};


export type QueryUnsplashPhotosArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUpgradePriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
  product: Scalars['Int'];
};

export type QueryError = {
  __typename: 'QueryError';
  /** Contains extra data describing the error. */
  extensions?: Maybe<Array<QueryErrorExtension>>;
  /** The ID of the requested object, or null when the ID is not available. */
  identifier?: Maybe<Scalars['ID']>;
  /** A message describing the error. */
  message?: Maybe<Scalars['String']>;
};

export type QueryErrorExtension = {
  /** A code representing the type of error. See the CompassErrorType enum for possible values. */
  errorType?: Maybe<Scalars['String']>;
  /** A numerical code (such as an HTTP status code) representing the error category. */
  statusCode?: Maybe<Scalars['Int']>;
};

/** Represents a status object from a workflow in Jira without any calculcated fields */
export type RawStatus = {
  __typename: 'RawStatus';
  /** Which status category this statue belongs to */
  category?: Maybe<Scalars['String']>;
  /** Unique identifier of the status, in UUID type */
  id?: Maybe<Scalars['ID']>;
  /** Jira's Id of the status */
  jiraId?: Maybe<Scalars['ID']>;
  /** Name of the status */
  name?: Maybe<Scalars['String']>;
};

/** Reactions give Members the option to add an emoji to an Action. */
export type Reaction = {
  __typename: 'Reaction';
  /** The Emoji used on the Reaction */
  emoji: Reaction_Emoji;
  /** The ID of the Reaction */
  id: Scalars['ID'];
  /** The ID of the emoji used in the Reaction */
  idEmoji: Scalars['String'];
  /** The ID of the Member who added the Reaction */
  idMember: Scalars['String'];
  /** The ID of the entity this Reaction is on */
  idModel: Scalars['String'];
  /** The Member who added the Reaction */
  member: Member;
};

/** The emoji used on the Reaction */
export type Reaction_Emoji = {
  __typename: 'Reaction_Emoji';
  /** The name of the Emoji */
  name: Scalars['String'];
  /** The native Emoji */
  native: Scalars['String'];
  /** The short name for the Emoji */
  shortName: Scalars['String'];
  /** The skin variation of the Emoji */
  skinVariation?: Maybe<Scalars['String']>;
  /** The ID of the Emoji */
  unified: Scalars['String'];
};

/** Response from removing a member from a Workspace */
export type RemoveMembersFromWorkspace_Response = {
  __typename: 'RemoveMembersFromWorkspace_Response';
  success: Scalars['Boolean'];
};

/** Data for the reports overview page */
export type ReportsOverview = {
  __typename: 'ReportsOverview';
  metadata: Array<Maybe<SoftwareReport>>;
};

/** Request Access to cards/boards */
export const RequestAccessModelType = {
  Board: 'board',
  Card: 'card'
} as const;

export type RequestAccessModelType = typeof RequestAccessModelType[keyof typeof RequestAccessModelType];
/** The data necessary to render Aa onboarding UI */
export type RequiresAaOnboarding = {
  __typename: 'RequiresAaOnboarding';
  /** The user's Trello Enterprise data */
  enterprise?: Maybe<Enterprise>;
  /** The user's Aa profile data */
  profile?: Maybe<AaOnboardingProfile>;
  /**
   * The Aa onboarding UI to render
   * values: domainClaim | inactive | enterprise
   */
  template?: Maybe<Scalars['String']>;
};

/** A saved search query belonging to a Member */
export type SavedSearch = {
  __typename: 'SavedSearch';
  /** The ID of the saved search */
  id: Scalars['ID'];
  /** The name of the saved search */
  name: Scalars['String'];
  /** The position of the saved search in the UI */
  pos: Scalars['Int'];
  /** The query of the saved search */
  query: Scalars['String'];
};

/** An object representing the product code and dates for the next product subscribed */
export type ScheduledChange = {
  __typename: 'ScheduledChange';
  ixSubscriptionProduct: Scalars['Int'];
  nextChangeTimestamp: Scalars['String'];
};

export const Scope = {
  /** outbound-auth */
  AdminContainer: 'ADMIN_CONTAINER',
  AuthConfluenceUser: 'AUTH_CONFLUENCE_USER',
  /** confluence */
  ConfluenceAtlassianExternal: 'CONFLUENCE_ATLASSIAN_EXTERNAL',
  DeleteConfluenceAttachment: 'DELETE_CONFLUENCE_ATTACHMENT',
  DeleteConfluenceBlogpost: 'DELETE_CONFLUENCE_BLOGPOST',
  DeleteConfluenceComment: 'DELETE_CONFLUENCE_COMMENT',
  DeleteConfluenceCustomContent: 'DELETE_CONFLUENCE_CUSTOM_CONTENT',
  DeleteConfluencePage: 'DELETE_CONFLUENCE_PAGE',
  DeleteConfluenceSpace: 'DELETE_CONFLUENCE_SPACE',
  IdentityAtlassianExternal: 'IDENTITY_ATLASSIAN_EXTERNAL',
  JiraAtlassianExternal: 'JIRA_ATLASSIAN_EXTERNAL',
  /** ecosystem */
  ManageApp: 'MANAGE_APP',
  ManageDirectory: 'MANAGE_DIRECTORY',
  ManageJiraConfiguration: 'MANAGE_JIRA_CONFIGURATION',
  ManageJiraDataProvider: 'MANAGE_JIRA_DATA_PROVIDER',
  ManageJiraProject: 'MANAGE_JIRA_PROJECT',
  /** identity */
  ManageOrg: 'MANAGE_ORG',
  ManageServicedeskCustomer: 'MANAGE_SERVICEDESK_CUSTOMER',
  /** platform */
  MigrateConfluence: 'MIGRATE_CONFLUENCE',
  ReadAccount: 'READ_ACCOUNT',
  /** compass */
  ReadCompassComponent: 'READ_COMPASS_COMPONENT',
  ReadCompassEvent: 'READ_COMPASS_EVENT',
  ReadCompassMetric: 'READ_COMPASS_METRIC',
  ReadCompassScorecard: 'READ_COMPASS_SCORECARD',
  ReadConfluenceAttachment: 'READ_CONFLUENCE_ATTACHMENT',
  ReadConfluenceAuditLog: 'READ_CONFLUENCE_AUDIT_LOG',
  ReadConfluenceBlogpost: 'READ_CONFLUENCE_BLOGPOST',
  ReadConfluenceComment: 'READ_CONFLUENCE_COMMENT',
  ReadConfluenceConfiguration: 'READ_CONFLUENCE_CONFIGURATION',
  ReadConfluenceContentAnalytics: 'READ_CONFLUENCE_CONTENT_ANALYTICS',
  ReadConfluenceContentMetadata: 'READ_CONFLUENCE_CONTENT_METADATA',
  ReadConfluenceContentPermission: 'READ_CONFLUENCE_CONTENT_PERMISSION',
  ReadConfluenceContentProperty: 'READ_CONFLUENCE_CONTENT_PROPERTY',
  ReadConfluenceContentRestriction: 'READ_CONFLUENCE_CONTENT_RESTRICTION',
  ReadConfluenceCustomContent: 'READ_CONFLUENCE_CUSTOM_CONTENT',
  ReadConfluenceGroup: 'READ_CONFLUENCE_GROUP',
  ReadConfluenceInlineTask: 'READ_CONFLUENCE_INLINE_TASK',
  ReadConfluenceLabel: 'READ_CONFLUENCE_LABEL',
  ReadConfluencePage: 'READ_CONFLUENCE_PAGE',
  ReadConfluenceRelation: 'READ_CONFLUENCE_RELATION',
  ReadConfluenceSpace: 'READ_CONFLUENCE_SPACE',
  ReadConfluenceSpacePermission: 'READ_CONFLUENCE_SPACE_PERMISSION',
  ReadConfluenceSpaceProperty: 'READ_CONFLUENCE_SPACE_PROPERTY',
  ReadConfluenceSpaceSetting: 'READ_CONFLUENCE_SPACE_SETTING',
  ReadConfluenceTemplate: 'READ_CONFLUENCE_TEMPLATE',
  ReadConfluenceUser: 'READ_CONFLUENCE_USER',
  ReadConfluenceUserProperty: 'READ_CONFLUENCE_USER_PROPERTY',
  ReadConfluenceWatcher: 'READ_CONFLUENCE_WATCHER',
  ReadContainer: 'READ_CONTAINER',
  /** jira */
  ReadJiraUser: 'READ_JIRA_USER',
  ReadJiraWork: 'READ_JIRA_WORK',
  ReadMe: 'READ_ME',
  /** notification-log */
  ReadNotifications: 'READ_NOTIFICATIONS',
  /** jira-servicedesk */
  ReadServicedeskRequest: 'READ_SERVICEDESK_REQUEST',
  StorageApp: 'STORAGE_APP',
  ViewUserprofile: 'VIEW_USERPROFILE',
  WriteCompassComponent: 'WRITE_COMPASS_COMPONENT',
  WriteCompassEvent: 'WRITE_COMPASS_EVENT',
  WriteCompassMetric: 'WRITE_COMPASS_METRIC',
  WriteCompassScorecard: 'WRITE_COMPASS_SCORECARD',
  WriteConfluenceAttachment: 'WRITE_CONFLUENCE_ATTACHMENT',
  WriteConfluenceAuditLog: 'WRITE_CONFLUENCE_AUDIT_LOG',
  WriteConfluenceBlogpost: 'WRITE_CONFLUENCE_BLOGPOST',
  WriteConfluenceComment: 'WRITE_CONFLUENCE_COMMENT',
  WriteConfluenceConfiguration: 'WRITE_CONFLUENCE_CONFIGURATION',
  WriteConfluenceContentProperty: 'WRITE_CONFLUENCE_CONTENT_PROPERTY',
  WriteConfluenceContentRestriction: 'WRITE_CONFLUENCE_CONTENT_RESTRICTION',
  WriteConfluenceCustomContent: 'WRITE_CONFLUENCE_CUSTOM_CONTENT',
  WriteConfluenceGroup: 'WRITE_CONFLUENCE_GROUP',
  WriteConfluenceInlineTask: 'WRITE_CONFLUENCE_INLINE_TASK',
  WriteConfluenceLabel: 'WRITE_CONFLUENCE_LABEL',
  WriteConfluencePage: 'WRITE_CONFLUENCE_PAGE',
  WriteConfluenceRelation: 'WRITE_CONFLUENCE_RELATION',
  WriteConfluenceSpace: 'WRITE_CONFLUENCE_SPACE',
  WriteConfluenceSpacePermission: 'WRITE_CONFLUENCE_SPACE_PERMISSION',
  WriteConfluenceSpaceProperty: 'WRITE_CONFLUENCE_SPACE_PROPERTY',
  WriteConfluenceSpaceSetting: 'WRITE_CONFLUENCE_SPACE_SETTING',
  WriteConfluenceTemplate: 'WRITE_CONFLUENCE_TEMPLATE',
  WriteConfluenceUserProperty: 'WRITE_CONFLUENCE_USER_PROPERTY',
  WriteConfluenceWatcher: 'WRITE_CONFLUENCE_WATCHER',
  WriteContainer: 'WRITE_CONTAINER',
  WriteJiraWork: 'WRITE_JIRA_WORK',
  WriteNotifications: 'WRITE_NOTIFICATIONS',
  WriteServicedeskRequest: 'WRITE_SERVICEDESK_REQUEST'
} as const;

export type Scope = typeof Scope[keyof typeof Scope];
export type ScopeSprintIssue = {
  __typename: 'ScopeSprintIssue';
  /** the estimate on the issue */
  estimate: Scalars['Float'];
  /** issue key */
  issueKey: Scalars['String'];
  /** issue description */
  issueSummary: Scalars['String'];
};

/** The result returned from a search query */
export type Search = {
  __typename: 'Search';
  /** Board results from the search */
  boards: Array<Board>;
  /** Card results from the search */
  cards: Array<Card>;
  /**
   * There is currently a server bug where the `members` field
   * won't be present if there are no member results. `members`
   * should be non-nullable when that bug is fixed.
   *
   * Member results from the search
   */
  members?: Maybe<Array<Member>>;
  /** Info about the search performed */
  options?: Maybe<Search_Options>;
  /** Organization results from the search */
  organizations: Array<Organization>;
};


/** The result returned from a search query */
export type SearchBoardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** The result returned from a search query */
export type SearchCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


/** The result returned from a search query */
export type SearchMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** The result returned from a search query */
export type SearchOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Info about the options passed to the performed search */
export type Search_Options = {
  __typename: 'Search_Options';
  /** The modelTypes requested */
  modelTypes?: Maybe<Array<Scalars['String']>>;
  /** The modifiers used to perform the search (parsed from the passed in query) */
  modifiers?: Maybe<Array<Search_Options_Modifier>>;
  /**
   * Whether or not the partial flag was set for the search.
   *
   * By default, search will match the words in your query exactly. Setting the `partial`
   * flag to true means that search will look for content that starts with any of the
   * words in your query.
   */
  partial?: Maybe<Scalars['Boolean']>;
  /** The terms used to perform the search (parsed from the passed in query) */
  terms?: Maybe<Array<Search_Options_Term>>;
};

/**
 * A modifier used in a search query
 * e.g. In the query "is:open sort:created development",
 * `is:open` and `sort:created` are the modifiers
 */
export type Search_Options_Modifier = {
  __typename: 'Search_Options_Modifier';
  /** The text of the modifier */
  text?: Maybe<Scalars['String']>;
};

/**
 * A term used in a search query
 * e.g. In the query "is:open sort:created development",
 * `development` is the only term
 */
export type Search_Options_Term = {
  __typename: 'Search_Options_Term';
  text?: Maybe<Scalars['String']>;
};

export type SelfServeExpansionResponse = {
  __typename: 'SelfServeExpansionResponse';
  ok: Scalars['Boolean'];
};

export type ShepherdGenericQueryErrorExtension = QueryErrorExtension & {
  __typename: 'ShepherdGenericQueryErrorExtension';
  /** A code representing the type of error. String form of ShepherdQueryErrorType. */
  errorType?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  /** A code representing the type of error. See the ShepherdQueryErrorType enum for possible values. */
  type?: Maybe<ShepherdQueryErrorType>;
};

/** #### Types: Query ##### */
export const ShepherdQueryErrorType = {
  NoProductAccess: 'NO_PRODUCT_ACCESS',
  Unauthorized: 'UNAUTHORIZED'
} as const;

export type ShepherdQueryErrorType = typeof ShepherdQueryErrorType[keyof typeof ShepherdQueryErrorType];
export type SoftwareBoard = {
  __typename: 'SoftwareBoard';
  /** List of the assignees of all cards currently displayed on the board */
  assignees?: Maybe<Array<Maybe<User>>>;
  /** All issue children which are linked to the cards on the board */
  cardChildren?: Maybe<Array<Maybe<SoftwareCard>>>;
  /** Configuration for showing media previews on cards */
  cardMedia?: Maybe<CardMediaConfig>;
  /** [CardType]s which can be created in this column _outside of a swimlane_ (if any) */
  cardTypes: Array<Maybe<CardType>>;
  /** All cards on the board, optionally filtered by ID */
  cards?: Maybe<Array<Maybe<SoftwareCard>>>;
  /**
   *  Column status mapping
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: columnConfigs` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  columnConfigs?: Maybe<ColumnsConfig>;
  /** The list of columns on the board */
  columns?: Maybe<Array<Maybe<Column>>>;
  /** Board edit config. Contains properties which dictate how to mutate the board data, e.g support for inline issue or column creation */
  editConfig?: Maybe<BoardEditConfig>;
  /** Whether any cards on the board are hidden due to board clearing logic (e.g. old cards in the done column are hidden) */
  hasClearedCards?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  /** Configuration for showing inline card create */
  inlineCardCreate?: Maybe<InlineCardCreateConfig>;
  /** List of all labels on all cards current displayed on the board */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of the board */
  name?: Maybe<Scalars['String']>;
  /** Temporarily needed to support legacy write API */
  rankCustomFieldId?: Maybe<Scalars['String']>;
  /**
   * The current swimlane strategy for the board.  This is a board (not user) property.
   * All users of the board get the same strategy.
   */
  swimlaneStrategy?: Maybe<SwimlaneStrategy>;
  /**
   * Swimlanes on the board.  If swimlanes are set to "NONE" then this there will be a single swimlane object containing
   * all cards on the board.
   */
  swimlanes: Array<Maybe<Swimlane>>;
  /**
   * User Swimlanes on the board.  If swimlanes are set to "NONE" then this there will be a single swimlane object containing
   * all cards on the board.
   */
  userSwimlanes: Array<Maybe<Swimlane>>;
};


export type SoftwareBoardCardsArgs = {
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customFilterIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** A card on the board */
export type SoftwareCard = {
  __typename: 'SoftwareCard';
  assignee?: Maybe<User>;
  /** Child cards metadata */
  childCardsMetadata?: Maybe<ChildCardsMetadata>;
  /** List of children IDs for a card */
  childrenIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Details of the media to show on this card, null if the card has no media */
  coverMedia?: Maybe<CardCoverMedia>;
  /** Dev Status information for the card */
  devStatus?: Maybe<DevStatus>;
  /** Whether or not this card is considered done */
  done?: Maybe<Scalars['Boolean']>;
  /** Due date */
  dueDate?: Maybe<Scalars['String']>;
  /** Estimate of size of a card */
  estimate?: Maybe<Estimate>;
  /** IDs of the fix versions that this issue is related to */
  fixVersionsIds: Array<Scalars['ID']>;
  /** Whether or not this card is flagged */
  flagged?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** ID of parent card */
  parentId?: Maybe<Scalars['ID']>;
  /** Card priority */
  priority?: Maybe<CardPriority>;
  status?: Maybe<CardStatus>;
  summary?: Maybe<Scalars['String']>;
  type?: Maybe<CardType>;
};

export type SoftwareCardChildrenInfo = {
  __typename: 'SoftwareCardChildrenInfo';
  doneStats?: Maybe<SoftwareCardChildrenInfoStats>;
  inProgressStats?: Maybe<SoftwareCardChildrenInfoStats>;
  lastColumnIssueStats?: Maybe<SoftwareCardChildrenInfoStats>;
  todoStats?: Maybe<SoftwareCardChildrenInfoStats>;
};

export type SoftwareCardChildrenInfoStats = {
  __typename: 'SoftwareCardChildrenInfoStats';
  cardCount?: Maybe<Scalars['Int']>;
};

/** Represents a specific transition between statuses that a card can make. */
export type SoftwareCardTransition = {
  __typename: 'SoftwareCardTransition';
  /** Card type that this transition applies to */
  cardType: CardType;
  /** true if the transition has conditions */
  hasConditions?: Maybe<Scalars['Boolean']>;
  /** Identifier for the card's column in swimlane position, to be used as a target for card transitions */
  id?: Maybe<Scalars['ID']>;
  /** true if global transition (anything status can move to this location). */
  isGlobal?: Maybe<Scalars['Boolean']>;
  /** true if the transition is initial */
  isInitial?: Maybe<Scalars['Boolean']>;
  /** Name of the transition, as set in the workflow editor */
  name: Scalars['String'];
  /** statuses which can move to this location, null if global transition. */
  originStatus?: Maybe<CardStatus>;
  /** The status the card's issue will end up in after executing this CardTransition */
  status?: Maybe<CardStatus>;
};

export type SoftwareCardTypeTransition = {
  __typename: 'SoftwareCardTypeTransition';
  /** Card type that this transition applies to */
  cardType: CardType;
  /** true if the transition has conditions */
  hasConditions?: Maybe<Scalars['Boolean']>;
  /** true if global transition (anything status can move to this location). */
  isGlobal?: Maybe<Scalars['Boolean']>;
  /** true if the transition is initial */
  isInitial?: Maybe<Scalars['Boolean']>;
  /** Name of the transition, as set in the workflow editor */
  name: Scalars['String'];
  /** statuses which can move to this location, null if global transition. */
  originStatus?: Maybe<CardStatus>;
  /** The status the card's issue will end up in after executing this SoftwareCardTypeTransition */
  status?: Maybe<CardStatus>;
  /** Non unique ID of the transition used as a target for card transitions */
  transitionId?: Maybe<Scalars['ID']>;
};

export type SoftwareOperation = {
  __typename: 'SoftwareOperation';
  icon?: Maybe<Icon>;
  name?: Maybe<Scalars['String']>;
  styleClass?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SoftwareProject = {
  __typename: 'SoftwareProject';
  /**
   * List of card types available in the project
   * When on the board, these will NOT include Epics or Subtasks, but when in boardScope they will
   */
  cardTypes?: Maybe<Array<Maybe<CardType>>>;
  /** Project id */
  id?: Maybe<Scalars['ID']>;
  /** Project key */
  key?: Maybe<Scalars['String']>;
  /** Project name */
  name?: Maybe<Scalars['String']>;
};


export type SoftwareProjectCardTypesArgs = {
  hierarchyLevelType?: InputMaybe<CardHierarchyLevelEnumType>;
};

export type SoftwareReport = {
  __typename: 'SoftwareReport';
  /** Which group this report should be shown in */
  group: Scalars['String'];
  id: Scalars['ID'];
  /** uri of the report's icon */
  imageUri: Scalars['String'];
  /** if not applicable - localised text as to why */
  inapplicableDescription?: Maybe<Scalars['String']>;
  /** if not applicable - localised text as to why */
  inapplicableReason?: Maybe<Scalars['String']>;
  /** whether or not this report is applicable (is enabled for) this board */
  isApplicable: Scalars['Boolean'];
  /** unique key identifying the report */
  key: Scalars['String'];
  /** the name of the report in the user's language */
  localisedDescription: Scalars['String'];
  /** the name of the report in the user's language */
  localisedName: Scalars['String'];
  /**
   * suffix to apply to the reports url to load this report.
   * e.g. https://tenant.com/secure/RapidBoard.jspa?rapidView=*boardId*&view=reports&report=*urlName*
   */
  urlName: Scalars['String'];
};

/** Node for querying any report page's data */
export type SoftwareReports = {
  __typename: 'SoftwareReports';
  /** Data for the burndown chart report */
  burndownChart: BurndownChart;
  /** Data for the cumulative flow diagram report */
  cumulativeFlowDiagram?: Maybe<CumulativeFlowDiagram>;
  /** Data for the reports list overview */
  overview?: Maybe<ReportsOverview>;
};

export type SoftwareSprintMetadata = {
  __typename: 'SoftwareSprintMetadata';
  /** Number of Completed Issues in Sprint */
  numCompletedIssues?: Maybe<Scalars['Int']>;
  /** Number of Open Issues in Sprint */
  numOpenIssues?: Maybe<Scalars['Int']>;
  /** Keys of Unresolved Cards */
  top100CompletedCardKeysWithIncompleteChildren?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The sort direction of the collection */
export const SortDirection = {
  /** Sort in ascending order */
  Asc: 'ASC',
  /** Sort in descending order */
  Desc: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export type Sprint = {
  __typename: 'Sprint';
  cards: Array<Maybe<SoftwareCard>>;
  /** The number of days remaining */
  daysRemaining?: Maybe<Scalars['Int']>;
  /** The end date of the sprint, in ISO 8601 format */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The sprint's goal, null if no goal is set */
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** The sprint's name */
  name?: Maybe<Scalars['String']>;
  sprintMetadata?: Maybe<SoftwareSprintMetadata>;
  sprintState: SprintState;
  /** The start date of the sprint, in ISO 8601 format */
  startDate?: Maybe<Scalars['DateTime']>;
};


export type SprintCardsArgs = {
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customFilterIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SprintEndData = {
  __typename: 'SprintEndData';
  /** list of all issues that are in the sprint with their estimates */
  issueList: Array<Maybe<ScopeSprintIssue>>;
  /** scope remaining at the end of the sprint */
  remainingEstimate: Scalars['Float'];
  /** timestamp of when sprint was completed */
  timestamp: Scalars['DateTime'];
};

export const SprintReportsEstimationStatisticType = {
  IssueCount: 'ISSUE_COUNT',
  OriginalEstimate: 'ORIGINAL_ESTIMATE',
  StoryPoints: 'STORY_POINTS'
} as const;

export type SprintReportsEstimationStatisticType = typeof SprintReportsEstimationStatisticType[keyof typeof SprintReportsEstimationStatisticType];
export type SprintReportsFilters = {
  __typename: 'SprintReportsFilters';
  /** Possible statistic that we want to track */
  estimationStatistic: Array<Maybe<SprintReportsEstimationStatisticType>>;
  /** List of sprints to select from */
  sprints: Array<Maybe<Sprint>>;
};

export type SprintScopeChangeData = {
  __typename: 'SprintScopeChangeData';
  /** amount completed of the esimtation statistic */
  completion: Scalars['Float'];
  /** estimation of the issue after this change */
  estimate?: Maybe<Scalars['Float']>;
  /** type of event */
  eventType: Scalars['SprintScopeChangeEventType'];
  /** the issue involved in the change */
  issueKey: Scalars['String'];
  /** the issue description */
  issueSummary: Scalars['String'];
  /** the previous completed amount before this change */
  prevCompletion: Scalars['Float'];
  /** the previous estimation before this change */
  prevEstimate?: Maybe<Scalars['Float']>;
  /** the previous remaining amount before this change */
  prevRemaining: Scalars['Float'];
  /** the sprint scope before the change */
  prevScope: Scalars['Float'];
  /** amount remaining of the estimation statistic */
  remaining: Scalars['Float'];
  /** sprint scope after this change */
  scope: Scalars['Float'];
  /** timestamp of change */
  timestamp: Scalars['DateTime'];
};

export type SprintStartData = {
  __typename: 'SprintStartData';
  /** list of all issues that are in the sprint with their estimates */
  issueList: Array<Maybe<ScopeSprintIssue>>;
  /** scope estimate for start of sprint */
  scopeEstimate: Scalars['Float'];
  timestamp: Scalars['DateTime'];
};

export const SprintState = {
  Active: 'ACTIVE',
  Closed: 'CLOSED',
  Future: 'FUTURE'
} as const;

export type SprintState = typeof SprintState[keyof typeof SprintState];
/** The counts for a Board being starred */
export type StarCounts = {
  __typename: 'StarCounts';
  /** The number of Organization Members who have starred this Board */
  organization: Scalars['Int'];
};

/** Items in your Billing History */
export type Statement = {
  __typename: 'Statement';
  /** Dollar amount credited or debited */
  amount: Scalars['Float'];
  /** Date payment or credit was applied */
  date: Scalars['String'];
  /** Id for this statement. Same as the statementToken */
  id: Scalars['ID'];
  /** Description of the statement */
  item: Scalars['String'];
  /** Id for this statement */
  statementToken: Scalars['ID'];
  /** URL to the meta page to view the receipt/invoice */
  statementUrl: Scalars['String'];
  /** Translation key used for localizing the item description */
  translationKey: Scalars['String'];
  /** Translation substitutions */
  translationSubstitutions?: Maybe<TranslationSubstitutions>;
};

/** An instance of a sticker on a card */
export type Sticker = {
  __typename: 'Sticker';
  /** ID of the card sticker */
  id: Scalars['ID'];
  /** ID of the image used for the sticker */
  image: Scalars['String'];
  /** List of different scalings of the sticker image */
  imageScaled: Array<Sticker_ImageScaled>;
  /** URL of the image used for the sticker */
  imageUrl: Scalars['String'];
  /** Left position of the sticker on the card */
  left: Scalars['Int'];
  /** Rotations of the sticker on the card */
  rotate: Scalars['Int'];
  /** Top position of the sticker on the card */
  top: Scalars['Int'];
  /** z-index of the sticker on the card */
  zIndex: Scalars['Int'];
};

/** A scaled version of a cards sticker image */
export type Sticker_ImageScaled = {
  __typename: 'Sticker_ImageScaled';
  /** Size of the image in bytes. (only present for custom stickers) */
  bytes?: Maybe<Scalars['Int']>;
  /** Height of the image */
  height: Scalars['Int'];
  /** ID of the sticker image scaled */
  id: Scalars['ID'];
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'];
  /** URL of the image */
  url: Scalars['String'];
  /** Width of the image */
  width: Scalars['Int'];
};

export type Swimlane = {
  __typename: 'Swimlane';
  /** The set of card types allowed in the swimlane */
  allowedCardTypes?: Maybe<Array<CardType>>;
  /** The column data */
  columnsInSwimlane?: Maybe<Array<Maybe<ColumnInSwimlane>>>;
  /** The icon to show for the swimlane */
  iconUrl?: Maybe<Scalars['String']>;
  /**
   * The swimlane ID.  This will match the id of the object the swimlane is grouping by.  e.g. Epic's it will be the
   * epic's issue Id.  For assignees it will be the assignee's atlassian account id.   For swimlanes which do not
   * represent a object (e.g. "Issues without assignee's" swimlane) the value will be "0".
   */
  id?: Maybe<Scalars['ID']>;
  /** The name of the swimlane */
  name?: Maybe<Scalars['String']>;
};

/** How to group cards on the board into swimlanes */
export const SwimlaneStrategy = {
  Assignee: 'ASSIGNEE',
  Issuechildren: 'ISSUECHILDREN',
  Issueparent: 'ISSUEPARENT',
  None: 'NONE'
} as const;

export type SwimlaneStrategy = typeof SwimlaneStrategy[keyof typeof SwimlaneStrategy];
/** A Tag (or Collection as it is known in-app) is a 'category' that can be applied to Boards */
export type Tag = {
  __typename: 'Tag';
  /** ID of the Tag */
  id: Scalars['ID'];
  /** name of the Tag */
  name: Scalars['String'];
};

/** Returns the details of the queried team */
export type Team = Node & {
  __typename: 'Team';
  /** The user details of the member who created the team */
  creator?: Maybe<User>;
  /** Description of the team */
  description?: Maybe<Scalars['String']>;
  /** Display name of the team */
  displayName?: Maybe<Scalars['String']>;
  /** ID of the team */
  id: Scalars['ID'];
  /** URL to the large size image of the team avatar image */
  largeAvatarImageUrl?: Maybe<Scalars['String']>;
  /** URL to the large size image of the team header image */
  largeHeaderImageUrl?: Maybe<Scalars['String']>;
  /**
   * Returns member data for the 'first' number of members after a cursor denoted by 'after' with membership state 'state'
   * If 'after' is null, member data will return from the top of the list of members.
   * 'first' must be greater than 0 and not null.
   * 'state' must take at least one membership state value and will include all members with those membership states
   *
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: team-members-beta` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  members?: Maybe<TeamMemberConnection>;
  /** How members are able to be added to the team, enum of one of the following: OPEN, MEMBER_INVITE, ADMIN_INVITE */
  membershipSetting?: Maybe<MembershipSetting>;
  /** Organisation ID of the team */
  organizationId?: Maybe<Scalars['String']>;
  /** URL to the small size image of the team avatar image */
  smallAvatarImageUrl?: Maybe<Scalars['String']>;
  /** URL to the small size image of the team header image */
  smallHeaderImageUrl?: Maybe<Scalars['String']>;
  /** The state of the team, enum of one of the following: ACTIVE, DISBANDED, PURGED */
  state?: Maybe<TeamState>;
};


/** Returns the details of the queried team */
export type TeamMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  state?: Array<MembershipState>;
};

/** Returns the details of the team member and details about their membership within a team */
export type TeamMember = {
  __typename: 'TeamMember';
  /** The user details of the team member */
  member?: Maybe<User>;
  /** Member's role in the team, enum of one of the following: REGULAR, ADMIN */
  role?: Maybe<MembershipRole>;
  /** Membership state, enum of one of the following: FULL_MEMBER, ALUMNI, INVITED, REQUESTING_TO_JOIN */
  state?: Maybe<MembershipState>;
};

/** The connection entity for the members of a team for pagination */
export type TeamMemberConnection = {
  __typename: 'TeamMemberConnection';
  edges?: Maybe<Array<Maybe<TeamMemberEdge>>>;
  nodes?: Maybe<Array<Maybe<TeamMember>>>;
  pageInfo: PageInfo;
};

export type TeamMemberEdge = {
  __typename: 'TeamMemberEdge';
  cursor: Scalars['String'];
  node?: Maybe<TeamMember>;
};

/** The states that a team can have */
export const TeamState = {
  /** The team is currently active */
  Active: 'ACTIVE',
  /** The team has been disbanded and is currently inactive */
  Disbanded: 'DISBANDED',
  /** All members of the team have been deleted */
  Purged: 'PURGED'
} as const;

export type TeamState = typeof TeamState[keyof typeof TeamState];
/** Category for template gallery returned from /resources/templates/categories */
export type TemplateCategory = {
  __typename: 'TemplateCategory';
  /** Translations key for template category */
  key: Scalars['String'];
};

/** An object containing information about a the gallery listing */
export type TemplateGallery = {
  __typename: 'TemplateGallery';
  /** The shape the avatar should be */
  avatarShape: Scalars['String'];
  /** The url for the listing's avatar */
  avatarUrl: Scalars['String'];
  /** The blurb for the template's gallery listing */
  blurb: Scalars['String'];
  /** The authors name */
  byline: Scalars['String'];
  /** The category the template is in */
  category: Scalars['String'];
  /** The featured status of the board */
  featured: Scalars['Boolean'];
  /** The precedence the template has for ordering */
  precedence: Scalars['Int'];
  /** The view and copy counts of the board */
  stats: Board_Stats;
};

/** Language for template gallery returned from /resources/templates/languages */
export type TemplateLanguage = {
  __typename: 'TemplateLanguage';
  /** The english user-readable description of the language */
  description: Scalars['String'];
  /** Flag to determine if language is currently enabled */
  enabled: Scalars['Boolean'];
  /** The language key */
  language: Scalars['String'];
  /** The language's locale code */
  locale: Scalars['String'];
  /** The localized user-readable description of the language */
  localizedDescription: Scalars['String'];
};

export type TenantContext = {
  __typename: 'TenantContext';
  /** The cloud id of a tenanted Jira or Confluence instance */
  cloudId?: Maybe<Scalars['ID']>;
  /** The host URL of a tenanted Jira or Confluence instance */
  cloudUrl?: Maybe<Scalars['URL']>;
  /** The host name of a tenanted Jira or Confluence instance */
  hostName?: Maybe<Scalars['String']>;
  /** The organization id for this tenant */
  orgId?: Maybe<Scalars['ID']>;
};

export type TestingActivityContributor = {
  __typename: 'TestingActivityContributor';
  profile?: Maybe<TestingActivityUser>;
};

export const TestingActivityEventType = {
  Assigned: 'ASSIGNED',
  Commented: 'COMMENTED',
  Created: 'CREATED',
  Edited: 'EDITED',
  Liked: 'LIKED',
  Published: 'PUBLISHED',
  Transitioned: 'TRANSITIONED',
  Unassigned: 'UNASSIGNED',
  Updated: 'UPDATED',
  Viewed: 'VIEWED'
} as const;

export type TestingActivityEventType = typeof TestingActivityEventType[keyof typeof TestingActivityEventType];
export type TestingActivityItem = Node & {
  __typename: 'TestingActivityItem';
  containers?: Maybe<Array<Maybe<TestingActivityObject>>>;
  contributors?: Maybe<Array<Maybe<TestingActivityContributor>>>;
  eventType?: Maybe<TestingActivityEventType>;
  id: Scalars['ID'];
  object?: Maybe<TestingActivityObject>;
  timestamp?: Maybe<Scalars['String']>;
};

export type TestingActivityObject = Node & {
  __typename: 'TestingActivityObject';
  cloudID?: Maybe<Scalars['String']>;
  iconURL?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/**
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:jira-work__
 */
export type TestingActivityUser = {
  __typename: 'TestingActivityUser';
  accountId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

/**
 * General Report Types
 * ====================
 */
export type TimeSeriesPoint = {
  __typename: 'TimeSeriesPoint';
  id: Scalars['ID'];
  x: Scalars['DateTime'];
  y: Scalars['Int'];
};

/** Token model */
export type Token = {
  __typename: 'Token';
  dateCreated: Scalars['String'];
  dateExpires?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idMember: Scalars['String'];
  identifier: Scalars['String'];
  permissions: Array<Maybe<TokenPermission>>;
};

/** The permissions for a specific token */
export type TokenPermission = {
  __typename: 'TokenPermission';
  idModel: Scalars['String'];
  modelType: Scalars['String'];
  read?: Maybe<Scalars['Boolean']>;
  write?: Maybe<Scalars['Boolean']>;
};

export type TownsquareComment = Node & {
  __typename: 'TownsquareComment';
  creator?: Maybe<User>;
  id: Scalars['ID'];
  object?: Maybe<TownsquareCommentObject>;
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type TownsquareCommentObject = {
  __typename: 'TownsquareCommentObject';
  ari?: Maybe<Scalars['String']>;
  iconData?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TownsquareGoal = Node & {
  __typename: 'TownsquareGoal';
  archived: Scalars['Boolean'];
  iconData?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<User>;
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TownsquareHelpPointer = Node & {
  __typename: 'TownsquareHelpPointer';
  cloudId?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  creatorAaid?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconData?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<TownsquareHelpPointerOwner>;
  tags?: Maybe<TownsquareTagConnection>;
  teamId?: Maybe<Scalars['String']>;
  type?: Maybe<TownsquareHelpPointerType>;
};


export type TownsquareHelpPointerTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type TownsquareHelpPointerOwner = {
  __typename: 'TownsquareHelpPointerOwner';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  largeAvatarImageUrl?: Maybe<Scalars['String']>;
  smallAvatarImageUrl?: Maybe<Scalars['String']>;
};

export const TownsquareHelpPointerType = {
  Action: 'ACTION',
  Information: 'INFORMATION'
} as const;

export type TownsquareHelpPointerType = typeof TownsquareHelpPointerType[keyof typeof TownsquareHelpPointerType];
export type TownsquareProject = Node & {
  __typename: 'TownsquareProject';
  archived: Scalars['Boolean'];
  iconData?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<User>;
  /**
   * ### Beta Field
   *
   * This field is currently in a beta phase and may change without notice.
   *
   * To use this field you must set a `X-ExperimentalApi: TownsquareProjectState` HTTP header.
   *
   * Use of this header indicates that they are opting into the experimental preview of this field.
   *
   * If you do not set this header then request will be rejected outright.
   *
   * Once the field moves out of the beta phase, then the header will no longer be required or checked.
   */
  state?: Maybe<TownsquareProjectState>;
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TownsquareProjectState = {
  __typename: 'TownsquareProjectState';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<TownsquareProjectStateValue>;
};

export const TownsquareProjectStateValue = {
  Archived: 'archived',
  AtRisk: 'at_risk',
  Done: 'done',
  OffTrack: 'off_track',
  OnTrack: 'on_track',
  Paused: 'paused',
  Pending: 'pending'
} as const;

export type TownsquareProjectStateValue = typeof TownsquareProjectStateValue[keyof typeof TownsquareProjectStateValue];
export type TownsquareTag = Node & {
  __typename: 'TownsquareTag';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type TownsquareTagConnection = {
  __typename: 'TownsquareTagConnection';
  count: Scalars['Int'];
  /** a list of edges */
  edges?: Maybe<Array<Maybe<TownsquareTagEdge>>>;
  /** details about this specific page */
  pageInfo: PageInfo;
};

/** An edge in a connection */
export type TownsquareTagEdge = {
  __typename: 'TownsquareTagEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TownsquareTag>;
};

export type TownsquareTeam = Node & {
  __typename: 'TownsquareTeam';
  avatarUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Data which represents the effects of transferring a team to an enterprise. */
export type TransferrableData = {
  __typename: 'TransferrableData';
  /** A list of members who will be counted towards billing upon transferring the team */
  newBillableMembers: Array<TransferrableDataMember>;
  /** A list of members who will be removed from the team upon transfering it to the enterprise */
  restrictedMembers: Array<TransferrableDataMember>;
  /** Whether the team is transferrable */
  transferrable?: Maybe<Scalars['Boolean']>;
};

/**
 * Either a billable member of a restricted member (see TransferrableData). It is not a model,
 * but rather just a set of fields of a Member that is solely used for the enteprise dashboard.
 */
export type TransferrableDataMember = {
  __typename: 'TransferrableDataMember';
  avatarUrl?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  initials: Scalars['String'];
  username: Scalars['String'];
};

export type TranslationSubstitutions = {
  __typename: 'TranslationSubstitutions';
  productName?: Maybe<Scalars['String']>;
};

/**
 * A photo returned from the Unsplash API
 * https://unsplash.com/documentation
 */
export type UnsplashPhoto = {
  __typename: 'UnsplashPhoto';
  /** List of categories associated with the photo */
  categories: Array<Scalars['String']>;
  /** A color associated with the image, in html hex format (e.g., #DCDBE1) */
  color: Scalars['String'];
  /** Date and time of when the photo was created, in ISO 8601 format (e.g., 2019-08-21T19:58:40-04:00) */
  created_at: Scalars['String'];
  /** Text describing what is shown in the photo */
  description?: Maybe<Scalars['String']>;
  /** Height of the full size image in pixels */
  height: Scalars['Int'];
  /** ID of the UnsplashPhoto */
  id: Scalars['ID'];
  /** Number of users that have liked this photo */
  likes: Scalars['Int'];
  /** Links to various ways of accessing this photo (through the API or in a web browser) */
  links: UnsplashPhoto_Links;
  /** Date and time of when the photo was last updated, in ISO 8601 format (e.g., 2019-08-21T19:58:40-04:00) */
  updated_at: Scalars['String'];
  /** Urls pointing to various sizes of the image */
  urls: UnsplashPhoto_Urls;
  /** Information about the Unsplash user who created this photo */
  user: UnsplashPhoto_User;
  /** Width of the full size image in pixels */
  width: Scalars['Int'];
};

/**
 * Links to various ways of accessing an Unsplash photo (through the API or in a web browser)
 * https://unsplash.com/documentation#photos
 */
export type UnsplashPhoto_Links = {
  __typename: 'UnsplashPhoto_Links';
  /** Url of the image file on Unsplash's website */
  download: Scalars['String'];
  /** Url of the image file on Unsplash's API */
  download_location: Scalars['String'];
  /** Url of the html page for viewing this photo on Unsplash's website */
  html: Scalars['String'];
  /** The Unsplash API url for this photo */
  self: Scalars['String'];
};

/**
 * Urls pointing to various sizes of the UnsplashPhoto image
 * https://unsplash.com/documentation#example-image-use
 */
export type UnsplashPhoto_Urls = {
  __typename: 'UnsplashPhoto_Urls';
  /** The photo in jpg format with its maximum dimensions. For performance purposes, we don’t recommend using this as the photos will load slowly for your users. */
  full: Scalars['String'];
  /** A base image URL with just the photo path and the ixid parameter for your API application. Use this to easily add additional image parameters to construct your own image URL. */
  raw: Scalars['String'];
  /** The photo in jpg format with a width of 1080 pixels */
  regular: Scalars['String'];
  /** The photo in jpg format with a width of 400 pixels */
  small: Scalars['String'];
  /** The photo in jpg format with a width of 200 pixels */
  thumb: Scalars['String'];
};

/**
 * Information about an Unsplash user's public profile
 * https://unsplash.com/documentation#get-a-users-public-profile
 */
export type UnsplashPhoto_User = {
  __typename: 'UnsplashPhoto_User';
  /** ID of the UnsplashPhoto_user */
  id: Scalars['ID'];
  /** Links to various ways of accessing this user's info (through the API or through a web browser) */
  links: UnsplashPhoto_User_Links;
  /** The user's full name */
  name: Scalars['String'];
};

/**
 * Links to various ways of accessing an Unsplash user's public profile info (through the API or through a web browser)
 * https://unsplash.com/documentation#get-a-users-public-profile
 */
export type UnsplashPhoto_User_Links = {
  __typename: 'UnsplashPhoto_User_Links';
  /** Url of the user's html profile page on Unsplash's website */
  html: Scalars['String'];
};

/** Object that represents the response of the updateBoardMemberPermission mutation */
export type UpdateBoardMemberPermission_Response = {
  __typename: 'UpdateBoardMemberPermission_Response';
  /** Board id */
  id: Scalars['ID'];
  members: Array<Member>;
  memberships: Array<Board_Membership>;
};

export type UpdateDashboardViewTile = {
  from?: InputMaybe<UpdateDashboardViewTile_From>;
  graph?: InputMaybe<UpdateDashboardViewTile_Graph>;
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateDashboardViewTile_From = {
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

export type UpdateDashboardViewTile_Graph = {
  type: Scalars['String'];
};

export type UpdateEmailForMemberLogin = {
  __typename: 'UpdateEmailForMemberLogin';
  /** Whether updating an email for a member was successful */
  success: Scalars['Boolean'];
};

export type UpdatePluginFields = {
  /** API Key associated with this plugin. */
  apiKey?: InputMaybe<Scalars['String']>;
  /** The name of the plugin's author. */
  author?: InputMaybe<Scalars['String']>;
  /** Capabilities represent areas of the UX that a plugin can hook into. */
  capabilities?: InputMaybe<Array<Scalars['String']>>;
  /** Capabilities Options represent areas of capabilities that can be customized. */
  capabilitiesOptions?: InputMaybe<Array<Scalars['String']>>;
  /** A list of categories which the plugin will be listed under. */
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The email address of the plugin author. */
  email?: InputMaybe<Scalars['String']>;
  /** The icon of the plugin. */
  icon?: InputMaybe<Scalars['String']>;
  /** The URL to the main iframe of the plugin. */
  iframeConnectorUrl?: InputMaybe<Scalars['String']>;
  /** The URL to the privacy policy of the plugin. */
  privacyUrl?: InputMaybe<Scalars['String']>;
  /** Whether the plugin stores personal data. */
  storesPersonalData?: InputMaybe<Scalars['Boolean']>;
  /** The support email of a plugin. */
  supportEmail?: InputMaybe<Scalars['String']>;
};

/** Price quotes for upgrading from Standard to BC */
export type UpgradePriceQuoteInfo = {
  __typename: 'UpgradePriceQuoteInfo';
  /** The price quote for the prorated amount */
  immediate?: Maybe<PriceQuote>;
  /** The dollar amount in account credits available */
  nAccountCreditsTotal?: Maybe<Scalars['Float']>;
  /** The total of the quote, minus any account credits */
  nImmediateTotalLessAccountCredits?: Maybe<Scalars['Float']>;
  /** The price quote for the new subscription */
  renewal?: Maybe<PriceQuote>;
};

/**
 * There are 3 types of accounts :
 *
 * * AtlassianAccountUser
 * * this represents a real person that has an account in a wide range of Atlassian products
 *
 * * CustomerUser
 * * This represents a real person who is a customer of an organisation who uses an Atlassian product to provide service to their customers.
 * Currently, this isused within Jira Service Desk for external service desks.
 *
 * * AppUser
 * * this does not represent a real person but rather the identity that backs an installed application
 *
 * ### OAuth Scopes
 *
 * The following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */
export type User = {
  /** The account ID for the user. */
  accountId: Scalars['ID'];
  /** The lifecycle status of the account */
  accountStatus: AccountStatus;
  /** The canonical account ID for the user. */
  canonicalAccountId: Scalars['ID'];
  /**
   * The display name of the user. This should be used when rendering a user textually within content.
   * If the user has restricted visibility of their name, their nickname will be
   * displayed as a substitute value.
   */
  name: Scalars['String'];
  /**
   * The absolute URI (RFC3986) to the avatar name of the user. This should be used when rendering a user graphically within content.
   * If the user has restricted visibility of their avatar or has not set
   * an avatar, an alternative URI will be provided as a substitute value.
   */
  picture: Scalars['URL'];
};

export const WaitOnQuickLoads = {
  CurrentBoardActions: 'CurrentBoardActions',
  CurrentBoardFull: 'CurrentBoardFull',
  MemberBoards: 'MemberBoards',
  MemberHeader: 'MemberHeader',
  MemberQuickBoards: 'MemberQuickBoards',
  None: 'None',
  PreloadCard: 'PreloadCard',
  QuickBoardsSearch: 'QuickBoardsSearch',
  WorkspaceBoardsPageMinimal: 'WorkspaceBoardsPageMinimal',
  WorkspaceHomePageMinimal: 'WorkspaceHomePageMinimal'
} as const;

export type WaitOnQuickLoads = typeof WaitOnQuickLoads[keyof typeof WaitOnQuickLoads];
export type WebTriggerUrl = Node & {
  __typename: 'WebTriggerUrl';
  appId: Scalars['ID'];
  contextId: Scalars['ID'];
  envId: Scalars['ID'];
  extensionId: Scalars['ID'];
  id: Scalars['ID'];
  /** Product extracted from the context id (e.g. jira, confulence). Only populated if context id is a valid cloud context. */
  product?: Maybe<Scalars['String']>;
  /** The tenant context for the cloud id. Only populated if context id is a valid cloud context. */
  tenantContext?: Maybe<TenantContext>;
  triggerKey: Scalars['String'];
  url: Scalars['URL'];
};
